import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** DateTime custom scalar type */
  Date: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type AdminBrandsPaginationOrdersInput = {
  created_at?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  title_en?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type AdminBrandsPaginationOrdersOutput = {
  __typename?: 'AdminBrandsPaginationOrdersOutput';
  created_at?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  title_en?: Maybe<SortOrder>;
  updated_at?: Maybe<SortOrder>;
};

export type AdminDiscountsPaginationFiltersInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminDiscountsPaginationFiltersOutput = {
  __typename?: 'AdminDiscountsPaginationFiltersOutput';
  isActive?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminDiscountsPaginationOrdersInput = {
  created_at?: InputMaybe<SortOrder>;
  discountAmount?: InputMaybe<SortOrder>;
  discountCode?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  minimumPurchase?: InputMaybe<SortOrder>;
  remainingUses?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
  user_firstName?: InputMaybe<SortOrder>;
  user_lastName?: InputMaybe<SortOrder>;
  user_phoneNumber?: InputMaybe<SortOrder>;
};

export type AdminDiscountsPaginationOrdersOutput = {
  __typename?: 'AdminDiscountsPaginationOrdersOutput';
  created_at?: Maybe<SortOrder>;
  discountAmount?: Maybe<SortOrder>;
  discountCode?: Maybe<SortOrder>;
  endDate?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  minimumPurchase?: Maybe<SortOrder>;
  remainingUses?: Maybe<SortOrder>;
  startDate?: Maybe<SortOrder>;
  updated_at?: Maybe<SortOrder>;
  user_firstName?: Maybe<SortOrder>;
  user_lastName?: Maybe<SortOrder>;
  user_phoneNumber?: Maybe<SortOrder>;
};

export type AdminGalleryProductImage = {
  __typename?: 'AdminGalleryProductImage';
  address: Scalars['String']['output'];
  aiGenerated: Scalars['Boolean']['output'];
  alt?: Maybe<Scalars['String']['output']>;
  basalamImageId?: Maybe<Scalars['Float']['output']>;
  created_at: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  imageId: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isMain: Scalars['Boolean']['output'];
  local: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  productActive?: Maybe<Scalars['Boolean']['output']>;
  productCode?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productImageId: Scalars['String']['output'];
  productTitle?: Maybe<Scalars['String']['output']>;
  sort: Scalars['Float']['output'];
  syncWithExternal: Scalars['Boolean']['output'];
  updated_at: Scalars['Date']['output'];
};

export type AdminGuaranteesPaginationOrdersInput = {
  created_at?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type AdminGuaranteesPaginationOrdersOutput = {
  __typename?: 'AdminGuaranteesPaginationOrdersOutput';
  created_at?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updated_at?: Maybe<SortOrder>;
};

export type AdminOfferTypesPaginationOrdersInput = {
  created_at?: InputMaybe<SortOrder>;
  discount?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type AdminOfferTypesPaginationOrdersOutput = {
  __typename?: 'AdminOfferTypesPaginationOrdersOutput';
  created_at?: Maybe<SortOrder>;
  discount?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updated_at?: Maybe<SortOrder>;
};

export type AdminOffersPaginationOrdersInput = {
  active?: InputMaybe<SortOrder>;
  created_at?: InputMaybe<SortOrder>;
  end_at?: InputMaybe<SortOrder>;
  percentage?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  product_code?: InputMaybe<SortOrder>;
  product_title?: InputMaybe<SortOrder>;
  start_at?: InputMaybe<SortOrder>;
  stock?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
  variant_id?: InputMaybe<SortOrder>;
  variant_price?: InputMaybe<SortOrder>;
};

export type AdminOffersPaginationOrdersOutput = {
  __typename?: 'AdminOffersPaginationOrdersOutput';
  active?: Maybe<SortOrder>;
  created_at?: Maybe<SortOrder>;
  end_at?: Maybe<SortOrder>;
  percentage?: Maybe<SortOrder>;
  price?: Maybe<SortOrder>;
  product_code?: Maybe<SortOrder>;
  product_title?: Maybe<SortOrder>;
  start_at?: Maybe<SortOrder>;
  stock?: Maybe<SortOrder>;
  updated_at?: Maybe<SortOrder>;
  variant_id?: Maybe<SortOrder>;
  variant_price?: Maybe<SortOrder>;
};

export type AdminOrderDto = {
  __typename?: 'AdminOrderDto';
  cart?: Maybe<CartDto>;
  created_at: Scalars['Date']['output'];
  deliveryTrackingCode?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<DiscountDto>;
  /** مجموع تمامی تخفیف ها  */
  discountPrice?: Maybe<Scalars['Float']['output']>;
  history: Array<OrderHistoryDto>;
  id: Scalars['Float']['output'];
  initialDate?: Maybe<Scalars['Date']['output']>;
  /** سفارش حضوری/آفلاین */
  isOffline: Scalars['Boolean']['output'];
  items: Array<OrderItemDto>;
  itemsWarehouse?: Maybe<Scalars['String']['output']>;
  memo?: Maybe<Scalars['String']['output']>;
  orderItemActions: Array<OrderItemActionDto>;
  paymentGateway?: Maybe<PaymentGatewayDto>;
  /** درصد کارمزد درگاه در زمان ثبت سفارش */
  paymentGatewayFee?: Maybe<Scalars['Float']['output']>;
  paymentMethod?: Maybe<PaymentMethodDto>;
  paymentSeen: Scalars['Boolean']['output'];
  payments: Array<PaymentDto>;
  pricingMode?: Maybe<CartPricingMode>;
  shipments?: Maybe<Array<OrderShipmentDto>>;
  shippingAddress?: Maybe<ShippingAddressDto>;
  shippingMethod?: Maybe<ShippingMethodDto>;
  shippingPrice?: Maybe<Scalars['Float']['output']>;
  status: OrderStatusEnum;
  totalPrice: Scalars['Float']['output'];
  updated_at: Scalars['Date']['output'];
  user?: Maybe<AdminUserDto>;
};

export type AdminOrderProfitDto = {
  __typename?: 'AdminOrderProfitDto';
  couponDiscount: Scalars['Float']['output'];
  /** مبلغ کارمزد درگاه: درصد ضربدر مبلغ کل سفارش */
  gatewayFeeAmount: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  initialDate?: Maybe<Scalars['Date']['output']>;
  itemsWithoutPurchasePrice: Scalars['Float']['output'];
  paymentGateway?: Maybe<AdminOrderProfitGatewayDto>;
  /** درصد کارمزد درگاه در زمان ثبت سفارش */
  paymentGatewayFee?: Maybe<Scalars['Float']['output']>;
  productRevenue: Scalars['Float']['output'];
  /** اگر حتی یک آیتم قیمت خرید نداشته باشد null است. در غیر این صورت: درآمد کالا منهای هزینه خرید، کد تخفیف و کارمزد درصدی درگاه از مبلغ کل سفارش */
  profit?: Maybe<Scalars['Float']['output']>;
  profitMargin?: Maybe<Scalars['Float']['output']>;
  purchaseCost: Scalars['Float']['output'];
  shippingPrice?: Maybe<Scalars['Float']['output']>;
  status: OrderStatusEnum;
  totalPrice: Scalars['Float']['output'];
};

export type AdminOrderProfitGatewayDto = {
  __typename?: 'AdminOrderProfitGatewayDto';
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** وضعیت‌های گزارش سود: ثبت‌شده، در حال پردازش، بسته‌بندی، آماده ارسال، ارسال‌شده و تحویل‌شده */
export enum AdminOrderProfitStatusEnum {
  Delivered = 'DELIVERED',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  Packed = 'PACKED',
  Paid = 'PAID',
  Processing = 'PROCESSING',
  Shipped = 'SHIPPED'
}

export type AdminOrdersCityDistributionDto = {
  __typename?: 'AdminOrdersCityDistributionDto';
  name: Scalars['String']['output'];
  orderCount: Scalars['Int']['output'];
  totalSale: Scalars['Float']['output'];
};

export type AdminOrdersCountDto = {
  __typename?: 'AdminOrdersCountDto';
  awaitingPaymentConfirmationCount: Scalars['Float']['output'];
  cancelledCount: Scalars['Float']['output'];
  deliveredCount: Scalars['Float']['output'];
  failedCount: Scalars['Float']['output'];
  onHoldCount: Scalars['Float']['output'];
  outForDeliveryCount: Scalars['Float']['output'];
  packedCount: Scalars['Float']['output'];
  paidCount: Scalars['Float']['output'];
  pendingCount: Scalars['Float']['output'];
  processingCount: Scalars['Float']['output'];
  refundedCount: Scalars['Float']['output'];
  returnRequestedCount: Scalars['Float']['output'];
  returnedCount: Scalars['Float']['output'];
  shippedCount: Scalars['Float']['output'];
  totalCancelledCount: Scalars['Float']['output'];
  totalCancelledPrice: Scalars['Float']['output'];
  totalCount: Scalars['Float']['output'];
  totalPaidCount: Scalars['Float']['output'];
  totalPaidPrice: Scalars['Float']['output'];
  totalPendingCount: Scalars['Float']['output'];
  totalPendingPrice: Scalars['Float']['output'];
};

export type AdminOrdersLocationDistributionDto = {
  __typename?: 'AdminOrdersLocationDistributionDto';
  provinces: Array<AdminOrdersProvinceDistributionDto>;
  totalOrders: Scalars['Int']['output'];
  totalSale: Scalars['Float']['output'];
  unknownLocationOrders: Scalars['Int']['output'];
};

export type AdminOrdersPaginationFilterInput = {
  /** فیلتر سفارش آفلاین/حضوری */
  isOffline?: InputMaybe<Scalars['Boolean']['input']>;
  maxInitialDate?: InputMaybe<Scalars['Date']['input']>;
  minInitialDate?: InputMaybe<Scalars['Date']['input']>;
  paymentGateway_code?: InputMaybe<Scalars['String']['input']>;
  paymentGateway_installment?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethod?: InputMaybe<PaymentMethodEnum>;
  status?: InputMaybe<OrderStatusEnum>;
};

export type AdminOrdersPaginationFilterOutput = {
  __typename?: 'AdminOrdersPaginationFilterOutput';
  /** فیلتر سفارش آفلاین/حضوری */
  isOffline?: Maybe<Scalars['Boolean']['output']>;
  maxInitialDate?: Maybe<Scalars['Date']['output']>;
  minInitialDate?: Maybe<Scalars['Date']['output']>;
  paymentGateway_code?: Maybe<Scalars['String']['output']>;
  paymentGateway_installment?: Maybe<Scalars['Boolean']['output']>;
  paymentMethod?: Maybe<PaymentMethodEnum>;
  status?: Maybe<OrderStatusEnum>;
};

export type AdminOrdersPaginationOrdersInput = {
  created_at?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  initialDate?: InputMaybe<SortOrder>;
  paymentGateway_installment?: InputMaybe<SortOrder>;
  paymentGateway_name?: InputMaybe<SortOrder>;
  paymentMethod_name?: InputMaybe<SortOrder>;
  shippingAddresses_city_name?: InputMaybe<SortOrder>;
  shippingAddresses_province_name?: InputMaybe<SortOrder>;
  shippingAddresses_recipient_fullName?: InputMaybe<SortOrder>;
  shippingAddresses_recipient_phoneNumber?: InputMaybe<SortOrder>;
  shippingMethod_name?: InputMaybe<SortOrder>;
  shippingPrice?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  totalPrice?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
  user_fullname?: InputMaybe<SortOrder>;
  user_phoneNumber?: InputMaybe<SortOrder>;
};

export type AdminOrdersPaginationOrdersOutput = {
  __typename?: 'AdminOrdersPaginationOrdersOutput';
  created_at?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  initialDate?: Maybe<SortOrder>;
  paymentGateway_installment?: Maybe<SortOrder>;
  paymentGateway_name?: Maybe<SortOrder>;
  paymentMethod_name?: Maybe<SortOrder>;
  shippingAddresses_city_name?: Maybe<SortOrder>;
  shippingAddresses_province_name?: Maybe<SortOrder>;
  shippingAddresses_recipient_fullName?: Maybe<SortOrder>;
  shippingAddresses_recipient_phoneNumber?: Maybe<SortOrder>;
  shippingMethod_name?: Maybe<SortOrder>;
  shippingPrice?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  totalPrice?: Maybe<SortOrder>;
  updated_at?: Maybe<SortOrder>;
  user_fullname?: Maybe<SortOrder>;
  user_phoneNumber?: Maybe<SortOrder>;
};

export type AdminOrdersPaymentGatewayChartDto = {
  __typename?: 'AdminOrdersPaymentGatewayChartDto';
  code?: Maybe<Scalars['String']['output']>;
  date: Scalars['String']['output'];
  totalItems?: Maybe<Scalars['Float']['output']>;
  totalOrders?: Maybe<Scalars['Float']['output']>;
  totalSale?: Maybe<Scalars['Float']['output']>;
};

export type AdminOrdersProfitFilterInput = {
  maxInitialDate?: InputMaybe<Scalars['Date']['input']>;
  maxProfit?: InputMaybe<Scalars['Float']['input']>;
  minInitialDate?: InputMaybe<Scalars['Date']['input']>;
  minProfit?: InputMaybe<Scalars['Float']['input']>;
  /** true: فقط سفارش‌هایی که حداقل یک آیتم بدون قیمت خرید دارند. false: فقط سفارش‌هایی که قیمت خرید همه آیتم‌ها ثبت شده */
  missingPurchasePrice?: InputMaybe<Scalars['Boolean']['input']>;
  paymentGateway_code?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AdminOrderProfitStatusEnum>;
};

export type AdminOrdersProfitFilterOutput = {
  __typename?: 'AdminOrdersProfitFilterOutput';
  maxInitialDate?: Maybe<Scalars['Date']['output']>;
  maxProfit?: Maybe<Scalars['Float']['output']>;
  minInitialDate?: Maybe<Scalars['Date']['output']>;
  minProfit?: Maybe<Scalars['Float']['output']>;
  /** true: فقط سفارش‌هایی که حداقل یک آیتم بدون قیمت خرید دارند. false: فقط سفارش‌هایی که قیمت خرید همه آیتم‌ها ثبت شده */
  missingPurchasePrice?: Maybe<Scalars['Boolean']['output']>;
  paymentGateway_code?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AdminOrderProfitStatusEnum>;
};

export type AdminOrdersProfitOrderByInput = {
  id?: InputMaybe<SortOrder>;
  initialDate?: InputMaybe<SortOrder>;
  paymentGatewayFee?: InputMaybe<SortOrder>;
  paymentGateway_name?: InputMaybe<SortOrder>;
  profit?: InputMaybe<SortOrder>;
  profitMargin?: InputMaybe<SortOrder>;
  purchaseCost?: InputMaybe<SortOrder>;
  totalPrice?: InputMaybe<SortOrder>;
};

export type AdminOrdersProfitOrderByOutput = {
  __typename?: 'AdminOrdersProfitOrderByOutput';
  id?: Maybe<SortOrder>;
  initialDate?: Maybe<SortOrder>;
  paymentGatewayFee?: Maybe<SortOrder>;
  paymentGateway_name?: Maybe<SortOrder>;
  profit?: Maybe<SortOrder>;
  profitMargin?: Maybe<SortOrder>;
  purchaseCost?: Maybe<SortOrder>;
  totalPrice?: Maybe<SortOrder>;
};

export type AdminOrdersProfitSummaryDto = {
  __typename?: 'AdminOrdersProfitSummaryDto';
  /** تعداد سفارش‌هایی که سودشان قابل محاسبه است */
  calculatedOrderCount: Scalars['Float']['output'];
  /** جمع مبلغ کارمزد درگاه‌ها، نه جمع درصدها */
  gatewayFee: Scalars['Float']['output'];
  orderCount: Scalars['Float']['output'];
  /** جمع سود سفارش‌های قابل محاسبه. اگر هیچ سفارشی قیمت خرید کامل نداشته باشد null است */
  profit?: Maybe<Scalars['Float']['output']>;
  profitMargin?: Maybe<Scalars['Float']['output']>;
  /** جمع هزینه خرید سفارش‌هایی که قیمت خرید همه آیتم‌هایشان ثبت شده */
  purchaseCost: Scalars['Float']['output'];
  salesAmount: Scalars['Float']['output'];
  /** تعداد سفارش‌هایی که حداقل یک آیتم بدون قیمت خرید دارند */
  unknownOrderCount: Scalars['Float']['output'];
  /** مبلغ فروش سفارش‌هایی که سودشان نامشخص است */
  unknownSalesAmount: Scalars['Float']['output'];
};

export type AdminOrdersProvinceDistributionDto = {
  __typename?: 'AdminOrdersProvinceDistributionDto';
  cities: Array<AdminOrdersCityDistributionDto>;
  name: Scalars['String']['output'];
  orderCount: Scalars['Int']['output'];
  totalSale: Scalars['Float']['output'];
};

export type AdminOrdersSaleChart = {
  __typename?: 'AdminOrdersSaleChart';
  gateways: Array<Array<AdminOrdersPaymentGatewayChartDto>>;
  sales: Array<AdminOrdersSaleChartDto>;
};

export type AdminOrdersSaleChartDto = {
  __typename?: 'AdminOrdersSaleChartDto';
  date: Scalars['String']['output'];
  totalItems?: Maybe<Scalars['Float']['output']>;
  totalOrders?: Maybe<Scalars['Float']['output']>;
  totalSale?: Maybe<Scalars['Float']['output']>;
};

export type AdminPaymentsPaginationOrdersInput = {
  amount?: InputMaybe<SortOrder>;
  created_at?: InputMaybe<SortOrder>;
  failedDate?: InputMaybe<SortOrder>;
  failedReason?: InputMaybe<SortOrder>;
  gatewayEntryTime?: InputMaybe<SortOrder>;
  gateway_name?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  paymentDate?: InputMaybe<SortOrder>;
  paymentMethod_name?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  transactionId?: InputMaybe<SortOrder>;
};

export type AdminPaymentsPaginationOrdersOutput = {
  __typename?: 'AdminPaymentsPaginationOrdersOutput';
  amount?: Maybe<SortOrder>;
  created_at?: Maybe<SortOrder>;
  failedDate?: Maybe<SortOrder>;
  failedReason?: Maybe<SortOrder>;
  gatewayEntryTime?: Maybe<SortOrder>;
  gateway_name?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  orderId?: Maybe<SortOrder>;
  paymentDate?: Maybe<SortOrder>;
  paymentMethod_name?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  transactionId?: Maybe<SortOrder>;
};

export type AdminPost = {
  __typename?: 'AdminPost';
  active: Scalars['Boolean']['output'];
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  categoryId?: Maybe<Scalars['Float']['output']>;
  categoryName?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  coverImage?: Maybe<ImageDto>;
  coverImageId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  excerpt?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  indexable: Scalars['Boolean']['output'];
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  productBrands: Array<AdminPostLabeledIdDto>;
  productCategories: Array<AdminPostLabeledIdDto>;
  productPicks: Array<AdminPostProductPickDto>;
  productSettings?: Maybe<PostProductSettingsDto>;
  productTags: Array<AdminPostLabeledIdDto>;
  publishedAt?: Maybe<Scalars['Date']['output']>;
  readingTime: Scalars['Float']['output'];
  seoKeywords?: Maybe<Array<Scalars['String']['output']>>;
  slug: Scalars['String']['output'];
  sortOrder: Scalars['Float']['output'];
  status: PostStatus;
  tags: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  titleEn?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  viewCount: Scalars['Float']['output'];
};

export type AdminPostCategoryDto = {
  __typename?: 'AdminPostCategoryDto';
  active: Scalars['Boolean']['output'];
  created_at: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  postCount: Scalars['Int']['output'];
  seo_url: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sort?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  title_en: Scalars['String']['output'];
  updated_at: Scalars['Date']['output'];
};

export type AdminPostLabeledIdDto = {
  __typename?: 'AdminPostLabeledIdDto';
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type AdminPostProductPickDto = {
  __typename?: 'AdminPostProductPickDto';
  active: Scalars['Boolean']['output'];
  code: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  inStock: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

/** A lightweight representation of a post for admin data tables. */
export type AdminPostRowDto = {
  __typename?: 'AdminPostRowDto';
  active: Scalars['Boolean']['output'];
  categoryName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  publishedAt?: Maybe<Scalars['Date']['output']>;
  slug: Scalars['String']['output'];
  status: PostStatus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  viewCount?: Maybe<Scalars['Int']['output']>;
};

export type AdminPostsPaginationFiltersInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<PostStatus>;
};

export type AdminPostsPaginationFiltersOutput = {
  __typename?: 'AdminPostsPaginationFiltersOutput';
  active?: Maybe<Scalars['Boolean']['output']>;
  categoryId?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<PostStatus>;
};

export type AdminPostsPaginationOrdersInput = {
  category_title?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  publishedAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  viewCount?: InputMaybe<SortOrder>;
};

export type AdminPostsPaginationOrdersOutput = {
  __typename?: 'AdminPostsPaginationOrdersOutput';
  category_title?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  publishedAt?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  viewCount?: Maybe<SortOrder>;
};

export type AdminProductImagesPaginationFiltersInput = {
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  brandId?: InputMaybe<Scalars['Float']['input']>;
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  local?: InputMaybe<Scalars['Boolean']['input']>;
  productActive?: InputMaybe<Scalars['Boolean']['input']>;
  productHasStock?: InputMaybe<Scalars['Boolean']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  syncWithExternal?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminProductImagesPaginationFiltersOutput = {
  __typename?: 'AdminProductImagesPaginationFiltersOutput';
  aiGenerated?: Maybe<Scalars['Boolean']['output']>;
  brandId?: Maybe<Scalars['Float']['output']>;
  categoryId?: Maybe<Scalars['Float']['output']>;
  hasAlt?: Maybe<Scalars['Boolean']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isMain?: Maybe<Scalars['Boolean']['output']>;
  local?: Maybe<Scalars['Boolean']['output']>;
  productActive?: Maybe<Scalars['Boolean']['output']>;
  productHasStock?: Maybe<Scalars['Boolean']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  syncWithExternal?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminProductImagesPaginationOrdersInput = {
  created_at?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  isMain?: InputMaybe<SortOrder>;
  product_code?: InputMaybe<SortOrder>;
  product_title?: InputMaybe<SortOrder>;
  sort?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type AdminProductImagesPaginationOrdersOutput = {
  __typename?: 'AdminProductImagesPaginationOrdersOutput';
  created_at?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isMain?: Maybe<SortOrder>;
  product_code?: Maybe<SortOrder>;
  product_title?: Maybe<SortOrder>;
  sort?: Maybe<SortOrder>;
  updated_at?: Maybe<SortOrder>;
};

export type AdminProductReferrerStatDto = {
  __typename?: 'AdminProductReferrerStatDto';
  kind: Scalars['String']['output'];
  source: Scalars['String']['output'];
  viewCount: Scalars['Int']['output'];
};

export type AdminProductStatsDto = {
  __typename?: 'AdminProductStatsDto';
  pageViewCount: Scalars['Int']['output'];
  referrers: Array<AdminProductReferrerStatDto>;
  soldQuantity: Scalars['Int']['output'];
  viewCount: Scalars['Int']['output'];
};

export type AdminProductSummaryDto = {
  __typename?: 'AdminProductSummaryDto';
  active: Scalars['Boolean']['output'];
  /** code field */
  code: Scalars['Float']['output'];
  created_at: Scalars['Date']['output'];
  /** id field */
  id: Scalars['String']['output'];
  mainImage?: Maybe<ProductImage>;
  /** title field */
  title: Scalars['String']['output'];
  /** title_en field */
  title_en?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Date']['output'];
};

export type AdminProductsCountDto = {
  __typename?: 'AdminProductsCountDto';
  activeCount: Scalars['Float']['output'];
  notActiveCount: Scalars['Float']['output'];
  totalCount: Scalars['Float']['output'];
};

export type AdminProductsPaginationFiltersInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  aiContentGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  hasStock?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseId?: InputMaybe<Scalars['Float']['input']>;
};

export type AdminProductsPaginationFiltersOutput = {
  __typename?: 'AdminProductsPaginationFiltersOutput';
  active?: Maybe<Scalars['Boolean']['output']>;
  aiContentGenerated?: Maybe<Scalars['Boolean']['output']>;
  categoryId?: Maybe<Scalars['Float']['output']>;
  hasStock?: Maybe<Scalars['Boolean']['output']>;
  warehouseId?: Maybe<Scalars['Float']['output']>;
};

export type AdminProductsPaginationOrdersInput = {
  active?: InputMaybe<SortOrder>;
  brand_title?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  created_at?: InputMaybe<SortOrder>;
  sales_count?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  title_en?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type AdminProductsPaginationOrdersOutput = {
  __typename?: 'AdminProductsPaginationOrdersOutput';
  active?: Maybe<SortOrder>;
  brand_title?: Maybe<SortOrder>;
  code?: Maybe<SortOrder>;
  created_at?: Maybe<SortOrder>;
  sales_count?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  title_en?: Maybe<SortOrder>;
  updated_at?: Maybe<SortOrder>;
};

export type AdminProductsViewsReportDto = {
  __typename?: 'AdminProductsViewsReportDto';
  lessViewedProducts: Array<AdminReportProductViewDto>;
  mostViewedProducts: Array<AdminReportProductViewDto>;
};

export type AdminPromptsPaginationOrdersInput = {
  created_at?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type AdminPromptsPaginationOrdersOutput = {
  __typename?: 'AdminPromptsPaginationOrdersOutput';
  created_at?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updated_at?: Maybe<SortOrder>;
};

export type AdminReportProductViewDto = {
  __typename?: 'AdminReportProductViewDto';
  /** code field */
  code: Scalars['Float']['output'];
  /** id field */
  id: Scalars['String']['output'];
  imageAddress?: Maybe<Scalars['String']['output']>;
  /** title field */
  title: Scalars['String']['output'];
  viewsCount: Scalars['Float']['output'];
};

export type AdminTagsPaginationOrdersInput = {
  created_at?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type AdminTagsPaginationOrdersOutput = {
  __typename?: 'AdminTagsPaginationOrdersOutput';
  created_at?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updated_at?: Maybe<SortOrder>;
};

export type AdminUpdateOrderInput = {
  deliveryTrackingCode?: InputMaybe<Scalars['String']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUpdateOrderStatusInput = {
  deliveryTrackingCode?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  status: OrderStatusEnum;
};

export type AdminUpdateOrderStatusToCancelledInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  returnToStock?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminUserAddressDto = {
  __typename?: 'AdminUserAddressDto';
  address: Scalars['String']['output'];
  city: CityDto;
  cityId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province: ProvinceDto;
  provinceId: Scalars['String']['output'];
  recipientFirstName: Scalars['String']['output'];
  recipientLastName: Scalars['String']['output'];
  recipientPhoneNumber: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type AdminUserDetailsDto = {
  __typename?: 'AdminUserDetailsDto';
  birth_date?: Maybe<Scalars['Date']['output']>;
  created_at: Scalars['Date']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  /** id field  */
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  locked: Scalars['Boolean']['output'];
  orderCounts: AdminUserOrdersCountDto;
  /** phoneNumber field */
  phoneNumber: Scalars['String']['output'];
  phoneNumberValidate: Scalars['Boolean']['output'];
  roles: Array<Roles>;
  updated_at: Scalars['Date']['output'];
  userAddressesCount: Scalars['Float']['output'];
  wallet: AdminWalletDto;
};

export type AdminUserDto = {
  __typename?: 'AdminUserDto';
  birth_date?: Maybe<Scalars['Date']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** id field  */
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  /** phoneNumber field */
  phoneNumber: Scalars['String']['output'];
};

export type AdminUserOrdersCountDto = {
  __typename?: 'AdminUserOrdersCountDto';
  awaiting_payment_confirmation_count: Scalars['Float']['output'];
  cancelled_count: Scalars['Float']['output'];
  delivered_count: Scalars['Float']['output'];
  failed_count: Scalars['Float']['output'];
  on_hold_count: Scalars['Float']['output'];
  out_for_delivery_count: Scalars['Float']['output'];
  packed_count: Scalars['Float']['output'];
  paid_count: Scalars['Float']['output'];
  pending_count: Scalars['Float']['output'];
  processing_count: Scalars['Float']['output'];
  refunded_count: Scalars['Float']['output'];
  return_requested_count: Scalars['Float']['output'];
  returned_count: Scalars['Float']['output'];
  shipped_count: Scalars['Float']['output'];
};

export type AdminUserTokenDto = {
  __typename?: 'AdminUserTokenDto';
  created_at?: Maybe<Scalars['Date']['output']>;
  /** id field */
  id: Scalars['Int']['output'];
  locked?: Maybe<Scalars['Boolean']['output']>;
  refreshTokenHash?: Maybe<Scalars['String']['output']>;
};

export type AdminUsersPaginationFiltersInput = {
  locked?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminUsersPaginationOrdersInput = {
  birth_date?: InputMaybe<SortOrder>;
  created_at?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  locked?: InputMaybe<SortOrder>;
  ordersCount?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
};

export type AdminUsersPaginationOrdersOutput = {
  __typename?: 'AdminUsersPaginationOrdersOutput';
  birth_date?: Maybe<SortOrder>;
  created_at?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  locked?: Maybe<SortOrder>;
  ordersCount?: Maybe<SortOrder>;
  phoneNumber?: Maybe<SortOrder>;
  updated_at?: Maybe<SortOrder>;
};

export type AdminVariantsCountDto = {
  __typename?: 'AdminVariantsCountDto';
  activeWithStockCount: Scalars['Float']['output'];
  activeWithoutStockCount: Scalars['Float']['output'];
  notActiveCount: Scalars['Float']['output'];
  totalActiveItems: Scalars['Float']['output'];
  totalCount: Scalars['Float']['output'];
  totalVariantsPriceWithoutOffers: Scalars['Float']['output'];
};

export type AdminVariantsPaginationFiltersInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminVariantsPaginationFiltersOutput = {
  __typename?: 'AdminVariantsPaginationFiltersOutput';
  active?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminVariantsPaginationOrdersInput = {
  active?: InputMaybe<SortOrder>;
  created_at?: InputMaybe<SortOrder>;
  guarantee_title?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  product_code?: InputMaybe<SortOrder>;
  product_title?: InputMaybe<SortOrder>;
  stock?: InputMaybe<SortOrder>;
  updated_at?: InputMaybe<SortOrder>;
  warehouse_title?: InputMaybe<SortOrder>;
};

export type AdminVariantsPaginationOrdersOutput = {
  __typename?: 'AdminVariantsPaginationOrdersOutput';
  active?: Maybe<SortOrder>;
  created_at?: Maybe<SortOrder>;
  guarantee_title?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  price?: Maybe<SortOrder>;
  product_code?: Maybe<SortOrder>;
  product_title?: Maybe<SortOrder>;
  stock?: Maybe<SortOrder>;
  updated_at?: Maybe<SortOrder>;
  warehouse_title?: Maybe<SortOrder>;
};

export type AdminWalletDto = {
  __typename?: 'AdminWalletDto';
  balance: Scalars['Float']['output'];
};

export type AiImageGenerationJobDto = {
  __typename?: 'AiImageGenerationJobDto';
  createdAt: Scalars['Date']['output'];
  error?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  estimatedCostUsd?: Maybe<Scalars['Float']['output']>;
  generatedImageIds?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  imageIds?: Maybe<Array<Scalars['String']['output']>>;
  imageUrls?: Maybe<Array<Scalars['String']['output']>>;
  inputImageTokens?: Maybe<Scalars['Int']['output']>;
  inputTextTokens?: Maybe<Scalars['Int']['output']>;
  inputTokens?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
  productId: Scalars['String']['output'];
  progress: Scalars['Int']['output'];
  prompt: Scalars['String']['output'];
  status: AiImageGenerationJobStatus;
  totalTokens?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export enum AiImageGenerationJobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  GeneratingImages = 'GENERATING_IMAGES',
  GettingReady = 'GETTING_READY',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  SentToAi = 'SENT_TO_AI'
}

export type ApoloanInstallmentEligibilityDetails = {
  __typename?: 'ApoloanInstallmentEligibilityDetails';
  description: Scalars['String']['output'];
  eligible: Scalars['Boolean']['output'];
  title_message: Scalars['String']['output'];
};

export type AppMessage = {
  __typename?: 'AppMessage';
  /** code field */
  code?: Maybe<Scalars['Float']['output']>;
  /** message field */
  message?: Maybe<Scalars['String']['output']>;
  /** success field */
  success: Scalars['Boolean']['output'];
};

export type AuthResultUnion = CodeSentResult | TokenResult;

export type BarcodeLabelDto = {
  __typename?: 'BarcodeLabelDto';
  count: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  productCode: Scalars['Float']['output'];
  variantId: Scalars['Float']['output'];
};

export type BarcodeLabelInput = {
  count: Scalars['Float']['input'];
  varinatId: Scalars['Float']['input'];
};

/** Response wrapper containing a list of level 1 and 2 categories */
export type BasalamCategoriesResponse = {
  __typename?: 'BasalamCategoriesResponse';
  /** Array of top-level and secondary category trees */
  data: Array<BasalamCategoryLv12Response>;
};

/** Category response model representing hierarchical level 1 and level 2 categories */
export type BasalamCategoryLv12Response = {
  __typename?: 'BasalamCategoryLV12Response';
  /** List of sub-categories or child category nodes */
  children?: Maybe<Array<BasalamCategoryLv12Response>>;
  /** Unique category identifier ID */
  id: Scalars['Int']['output'];
  /** Maximum allowable preparation and processing days for items in this category */
  max_preparation_days?: Maybe<Scalars['Int']['output']>;
  /** Category title / display name */
  title: Scalars['String']['output'];
  /** Unit type configuration for products in this category */
  unit_type?: Maybe<BasalamUnitTypeResponse>;
};

/** City response model representing geographic location information */
export type BasalamCityResponse = {
  __typename?: 'BasalamCityResponse';
  /** The localized name of the city */
  name: Scalars['String']['output'];
  /** The parent province/state information */
  province?: Maybe<BasalamEnumResponse>;
  /** The unique numeric identifier/code for the city */
  value: Scalars['Int']['output'];
};

/** Generic key-value enum model for status codes, categories, and options */
export type BasalamEnumResponse = {
  __typename?: 'BasalamEnumResponse';
  /** Optional descriptive note or context about the enum item */
  description?: Maybe<Scalars['String']['output']>;
  /** Human-readable label or title of the enum item */
  name: Scalars['String']['output'];
  /** Underlying raw value of the enum item (number, string, or boolean) */
  value: Scalars['JSON']['output'];
};

/** Photo image response containing multiple responsive resolution variants */
export type BasalamPhotoResponse = {
  __typename?: 'BasalamPhotoResponse';
  /** Unique identifier of the photo asset */
  id: Scalars['Int']['output'];
  /** URL to the large (lg) resolution variant */
  lg: Scalars['String']['output'];
  /** URL to the medium (md) resolution variant */
  md: Scalars['String']['output'];
  /** Direct URL to the original full-resolution image */
  original: Scalars['String']['output'];
  /** URL to the small (sm) resolution variant */
  sm: Scalars['String']['output'];
  /** URL to the extra-small (xs) thumbnail variant */
  xs: Scalars['String']['output'];
};

/** Private user profile response model containing personal and financial information */
export type BasalamPrivateUserResponse = {
  __typename?: 'BasalamPrivateUserResponse';
  /** User profile avatar photo */
  avatar?: Maybe<BasalamPhotoResponse>;
  /** Detailed metadata regarding ban status */
  ban_user?: Maybe<Scalars['JSON']['output']>;
  /** Bank name or account details */
  bank_information?: Maybe<Scalars['String']['output']>;
  /** Bank account registered owner name */
  bank_information_owner?: Maybe<Scalars['String']['output']>;
  /** Short bio/about description */
  bio?: Maybe<Scalars['String']['output']>;
  /** User birthday */
  birthday?: Maybe<Scalars['String']['output']>;
  /** User location city details */
  city?: Maybe<BasalamCityResponse>;
  /** ISO date string of profile registration/creation */
  created_at?: Maybe<Scalars['String']['output']>;
  /** 16-digit debit/credit card number */
  credit_card_number?: Maybe<Scalars['String']['output']>;
  /** Full legal name of the credit card owner */
  credit_card_owner?: Maybe<Scalars['String']['output']>;
  /** User email address */
  email?: Maybe<Scalars['String']['output']>;
  /** Foreign citizen identification code */
  foreign_citizen_code?: Maybe<Scalars['String']['output']>;
  /** User gender classification */
  gender?: Maybe<BasalamEnumResponse>;
  /** Hashed string identifier for public reference */
  hash_id: Scalars['String']['output'];
  /** Unique user identifier ID */
  id: Scalars['Int']['output'];
  /** Identity and personal information verification status */
  info_verification_status?: Maybe<BasalamEnumResponse>;
  /** Indicates whether the user is restricted in social activities */
  is_banned_in_social?: Maybe<Scalars['Boolean']['output']>;
  /** ISO date string of last active session */
  last_activity?: Maybe<Scalars['String']['output']>;
  /** User badge or trust distinction type */
  marked_type?: Maybe<BasalamEnumResponse>;
  /** Mobile phone number */
  mobile?: Maybe<Scalars['String']['output']>;
  /** Full display name of the user */
  name: Scalars['String']['output'];
  /** Iranian national identification code */
  national_code?: Maybe<Scalars['String']['output']>;
  /** Referral source journey status */
  referral_journey_enum?: Maybe<BasalamEnumResponse>;
  /** Unique user ID of the inviter/referrer */
  referrer_user_id?: Maybe<Scalars['Int']['output']>;
  /** Total count of followers */
  user_follower_count?: Maybe<Scalars['Int']['output']>;
  /** Total count of followed profiles */
  user_following_count?: Maybe<Scalars['Int']['output']>;
  /** Iranian IBAN/Sheba number */
  user_sheba_number?: Maybe<Scalars['String']['output']>;
  /** Legal account holder name of the Sheba number */
  user_sheba_owner?: Maybe<Scalars['String']['output']>;
  /** User account username */
  username?: Maybe<Scalars['String']['output']>;
  /** Associated vendor profile if the user owns a store */
  vendor?: Maybe<BasalamVendorOfUserResponse>;
};

/** Public profile response model for a Basalam user */
export type BasalamPublicUserResponse = {
  __typename?: 'BasalamPublicUserResponse';
  /** User profile avatar photo object */
  avatar?: Maybe<BasalamPhotoResponse>;
  /** Detailed metadata regarding ban status */
  ban_user?: Maybe<Scalars['JSON']['output']>;
  /** Short bio/about description */
  bio?: Maybe<Scalars['String']['output']>;
  /** User location city details */
  city?: Maybe<BasalamCityResponse>;
  /** ISO date string of profile creation date */
  created_at?: Maybe<Scalars['String']['output']>;
  /** User gender classification */
  gender?: Maybe<BasalamEnumResponse>;
  /** Hashed string identifier for public security */
  hash_id: Scalars['String']['output'];
  /** Unique user identifier ID */
  id: Scalars['Int']['output'];
  /** Indicates whether the user is restricted/banned in social features */
  is_banned_in_social?: Maybe<Scalars['Boolean']['output']>;
  /** ISO date string of last active session */
  last_activity?: Maybe<Scalars['String']['output']>;
  /** User trust/badge distinction type */
  marked_type?: Maybe<BasalamEnumResponse>;
  /** Full display name of the user */
  name: Scalars['String']['output'];
  /** Referral source journey status */
  referral_journey_enum?: Maybe<BasalamEnumResponse>;
  /** Total count of followers */
  user_follower_count?: Maybe<Scalars['Int']['output']>;
  /** Total count of followed profiles */
  user_following_count?: Maybe<Scalars['Int']['output']>;
  /** User account username */
  username?: Maybe<Scalars['String']['output']>;
  /** Associated vendor profile if the user owns a shop */
  vendor?: Maybe<BasalamVendorOfUserResponse>;
};

/** Public vendor details response model for Basalam */
export type BasalamPublicVendorResponse = {
  __typename?: 'BasalamPublicVendorResponse';
  /** Story: About your life */
  about_your_life?: Maybe<Scalars['String']['output']>;
  /** Story: About your workshop/place */
  about_your_place?: Maybe<Scalars['String']['output']>;
  /** List of cities available for service/shipping */
  available_cities?: Maybe<Array<BasalamCityResponse>>;
  /** Category type classification tags/enums */
  category_type?: Maybe<Array<BasalamEnumResponse>>;
  /** Vendor home base city */
  city: BasalamCityResponse;
  /** Header cover photos */
  covers?: Maybe<Array<BasalamPhotoResponse>>;
  /** ISO date string of registration/creation date */
  created_at: Scalars['String']['output'];
  /** Vendor Eitaa channel handle */
  eitaa?: Maybe<Scalars['String']['output']>;
  /** Human-readable elapsed time since creation */
  elapsed_time_from_creation?: Maybe<Scalars['String']['output']>;
  /** Threshold amount for nationwide free shipping */
  free_shipping_to_iran?: Maybe<Scalars['Float']['output']>;
  /** Threshold amount for same-city free shipping */
  free_shipping_to_same_city?: Maybe<Scalars['Float']['output']>;
  /** Vendor showcase gallery photos */
  gallery?: Maybe<Array<BasalamPhotoResponse>>;
  /** Custom home tab layout configuration */
  home_tab_settings?: Maybe<Array<BasalamVendorSettingResponse>>;
  /** Unique vendor identifier ID */
  id: Scalars['Int']['output'];
  /** Vendor slug/handle identifier */
  identifier: Scalars['String']['output'];
  /** Vendor Instagram account username */
  instagram?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the vendor shop is actively visible and selling */
  is_active: Scalars['Boolean']['output'];
  /** ISO date string of last vendor activity */
  last_activity?: Maybe<Scalars['String']['output']>;
  /** Vendor logo photo object */
  logo?: Maybe<BasalamPhotoResponse>;
  /** Special vendor notice or announcement */
  notice?: Maybe<Scalars['String']['output']>;
  /** Total completed order count */
  order_count?: Maybe<Scalars['Int']['output']>;
  /** Total number of active products */
  product_count?: Maybe<Scalars['Int']['output']>;
  /** Default sorting order of products */
  product_sort_type?: Maybe<BasalamEnumResponse>;
  /** Vendor review rating score */
  score?: Maybe<Scalars['Float']['output']>;
  /** Supported delivery/shipping methods */
  shipping_methods?: Maybe<Array<BasalamEnumResponse>>;
  /** Active shipping module version */
  shipping_version?: Maybe<Scalars['Int']['output']>;
  /** Current vendor account status */
  status: BasalamEnumResponse;
  /** Short summary or bio of the vendor */
  summary?: Maybe<Scalars['String']['output']>;
  /** Vendor Telegram channel handle */
  telegram_channel?: Maybe<Scalars['String']['output']>;
  /** Vendor Telegram username or ID */
  telegram_id?: Maybe<Scalars['String']['output']>;
  /** Vendor shop title */
  title: Scalars['String']['output'];
  /** Public profile of the vendor owner */
  user: BasalamPublicUserResponse;
  /** Introduction or promotional video */
  video?: Maybe<BasalamVideoResponse>;
  /** Why buyers should choose this shop */
  worth_buy?: Maybe<Scalars['String']['output']>;
};

/** Unit type response representing the unit of measurement for products (e.g., piece, kilogram) */
export type BasalamUnitTypeResponse = {
  __typename?: 'BasalamUnitTypeResponse';
  /** Unique identifier for the unit type */
  id: Scalars['Int']['output'];
  /** System identifier or machine-readable key name of the unit */
  name?: Maybe<Scalars['String']['output']>;
  /** Display title of the unit of measurement */
  title: Scalars['String']['output'];
  /** Numeric value or multiplier associated with the unit */
  value?: Maybe<Scalars['Int']['output']>;
};

export type BasalamVariantDto = {
  __typename?: 'BasalamVariantDto';
  attrs?: Maybe<Array<SVariantAttributeDto>>;
  creditPrice: Scalars['Float']['output'];
  guarantee: SGuaranteeDto;
  guaranteeId: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  maxBasketCount: Scalars['Float']['output'];
  offer?: Maybe<SOfferDto>;
  price: Scalars['Float']['output'];
  stock?: Maybe<Scalars['Float']['output']>;
};

/** Summary response model representing a vendor associated with a specific user profile */
export type BasalamVendorOfUserResponse = {
  __typename?: 'BasalamVendorOfUserResponse';
  /** ISO 8601 timestamp string when the store was activated */
  activated_at?: Maybe<Scalars['String']['output']>;
  /** ISO 8601 timestamp string of store creation date */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Detailed description of the vendor shop */
  description?: Maybe<Scalars['String']['output']>;
  /** Minimum purchase amount threshold for nationwide free shipping */
  free_shipping_to_iran?: Maybe<Scalars['Float']['output']>;
  /** Minimum purchase amount threshold for same-city free shipping */
  free_shipping_to_same_city?: Maybe<Scalars['Float']['output']>;
  /** Unique identifier of the vendor shop */
  id: Scalars['Int']['output'];
  /** Vendor unique slug or handle identifier */
  identifier: Scalars['String']['output'];
  /** Indicates whether the vendor store is currently active */
  is_active?: Maybe<Scalars['Boolean']['output']>;
  /** Total number of completed orders for this vendor */
  order_count?: Maybe<Scalars['Int']['output']>;
  /** Numeric status code representing vendor account status */
  status?: Maybe<Scalars['Int']['output']>;
  /** Title or store name of the vendor */
  title: Scalars['String']['output'];
  /** Key selling proposition / Reason to buy from this store */
  worth_buy?: Maybe<Scalars['String']['output']>;
};

/** Configuration and settings response model for a vendor store */
export type BasalamVendorSettingResponse = {
  __typename?: 'BasalamVendorSettingResponse';
  /** Arbitrary key-value metadata object for extra setting attributes */
  extra_data?: Maybe<Scalars['JSON']['output']>;
  /** Indicates whether this specific setting toggle is active */
  is_active: Scalars['Boolean']['output'];
  /** Unique key or identifier name of the vendor setting */
  name: Scalars['String']['output'];
  /** Display order or priority sequence index of the setting */
  order: Scalars['Int']['output'];
};

/** Video media asset response model containing stream links and dimensions */
export type BasalamVideoResponse = {
  __typename?: 'BasalamVideoResponse';
  /** Total video duration measured in seconds */
  duration?: Maybe<Scalars['Float']['output']>;
  /** Pixel height dimension of the video frame */
  height?: Maybe<Scalars['Int']['output']>;
  /** HTTP Live Streaming (HLS) playlist URL (.m3u8) */
  hls?: Maybe<Scalars['String']['output']>;
  /** Unique video asset identifier ID */
  id: Scalars['Int']['output'];
  /** URL of the uncompressed/raw original video file */
  original?: Maybe<Scalars['String']['output']>;
  /** URL of the video thumbnail poster image */
  thumbnail?: Maybe<Scalars['String']['output']>;
  /** Primary playable or public stream URL of the video */
  url: Scalars['String']['output'];
  /** Pixel width dimension of the video frame */
  width?: Maybe<Scalars['Int']['output']>;
};

export type BlogDashboardCategoryDto = {
  __typename?: 'BlogDashboardCategoryDto';
  id: Scalars['Int']['output'];
  postCount: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  viewCount: Scalars['Int']['output'];
};

export type BlogDashboardDayDto = {
  __typename?: 'BlogDashboardDayDto';
  date: Scalars['String']['output'];
  published: Scalars['Int']['output'];
  uniqueVisitors: Scalars['Int']['output'];
  views: Scalars['Int']['output'];
};

export type BlogDashboardDto = {
  __typename?: 'BlogDashboardDto';
  categories: Array<BlogDashboardCategoryDto>;
  daily: Array<BlogDashboardDayDto>;
  days: Scalars['Int']['output'];
  hourly: Array<BlogDashboardHourDto>;
  overview: BlogDashboardOverviewDto;
  recentPosts: Array<BlogDashboardRecentPostDto>;
  seo: BlogDashboardSeoDto;
  topPosts: Array<BlogDashboardTopPostDto>;
  topTags: Array<BlogDashboardTagDto>;
  traffic: BlogDashboardTrafficDto;
};

export type BlogDashboardHourDto = {
  __typename?: 'BlogDashboardHourDto';
  hour: Scalars['Int']['output'];
  views: Scalars['Int']['output'];
};

export type BlogDashboardOverviewDto = {
  __typename?: 'BlogDashboardOverviewDto';
  activePosts: Scalars['Int']['output'];
  archivedPosts: Scalars['Int']['output'];
  avgReadingTime: Scalars['Int']['output'];
  categoryCount: Scalars['Int']['output'];
  createdInRange: Scalars['Int']['output'];
  draftPosts: Scalars['Int']['output'];
  guestViews: Scalars['Int']['output'];
  loggedInViews: Scalars['Int']['output'];
  publishedInRange: Scalars['Int']['output'];
  publishedPosts: Scalars['Int']['output'];
  taggedPosts: Scalars['Int']['output'];
  totalPosts: Scalars['Int']['output'];
  totalViews: Scalars['Int']['output'];
  uncategorizedPosts: Scalars['Int']['output'];
  uniqueVisitors: Scalars['Int']['output'];
  viewsInRange: Scalars['Int']['output'];
  viewsToday: Scalars['Int']['output'];
  viewsYesterday: Scalars['Int']['output'];
};

export type BlogDashboardRecentPostDto = {
  __typename?: 'BlogDashboardRecentPostDto';
  id: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  status: PostStatus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  viewCount: Scalars['Int']['output'];
};

export type BlogDashboardSeoDto = {
  __typename?: 'BlogDashboardSeoDto';
  healthyPosts: Scalars['Int']['output'];
  missingCover: Scalars['Int']['output'];
  missingExcerpt: Scalars['Int']['output'];
  missingKeywords: Scalars['Int']['output'];
  missingMetaDescription: Scalars['Int']['output'];
  missingMetaTitle: Scalars['Int']['output'];
  notIndexable: Scalars['Int']['output'];
};

export type BlogDashboardSourceDto = {
  __typename?: 'BlogDashboardSourceDto';
  kind: Scalars['String']['output'];
  source: Scalars['String']['output'];
  uniqueVisitors: Scalars['Int']['output'];
  visits: Scalars['Int']['output'];
};

export type BlogDashboardTagDto = {
  __typename?: 'BlogDashboardTagDto';
  postCount: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type BlogDashboardTopPostDto = {
  __typename?: 'BlogDashboardTopPostDto';
  categoryName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  publishedAt?: Maybe<Scalars['Date']['output']>;
  readingTime: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  status: PostStatus;
  title: Scalars['String']['output'];
  viewCount: Scalars['Int']['output'];
  viewsInRange: Scalars['Int']['output'];
};

export type BlogDashboardTrafficDto = {
  __typename?: 'BlogDashboardTrafficDto';
  sources: Array<BlogDashboardSourceDto>;
  uniqueVisitors: Scalars['Int']['output'];
  visits: Scalars['Int']['output'];
};

export type BrandDto = {
  __typename?: 'BrandDto';
  created_at: Scalars['Date']['output'];
  id: Scalars['Float']['output'];
  image?: Maybe<ImageDto>;
  imageId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  title_en: Scalars['String']['output'];
  updated_at: Scalars['Date']['output'];
};

export type CartDto = {
  __typename?: 'CartDto';
  cartItems: Array<CartItemDto>;
  discountAmount: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  pricingMode?: Maybe<CartPricingMode>;
  subtotal: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
};

export type CartItemDto = {
  __typename?: 'CartItemDto';
  discountPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  offer?: Maybe<OfferDto>;
  offerId?: Maybe<Scalars['Float']['output']>;
  product: SimpleProductDto;
  productId: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  variant: VariantDto;
  variantId: Scalars['Float']['output'];
};

/** Cash vs credit pricing mode for cart and order */
export enum CartPricingMode {
  Cash = 'CASH',
  Credit = 'CREDIT'
}

export type CartRecommendationSeedInput = {
  /** Product code in cart */
  code: Scalars['Float']['input'];
  /** Cart line total (quantity * unit price) for seed weighting */
  lineTotal?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type CartRecommendationsDto = {
  __typename?: 'CartRecommendationsDto';
  /** Complementary products diversified across cart categories */
  completeTheLook: Array<SProduct>;
  /** Special offers excluding cart + completeTheLook items */
  offers: Array<SProduct>;
};

export type CartRecommendationsInput = {
  /** Max products in completeTheLook (1-24) */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Max offer products (1-24) */
  offersLimit?: InputMaybe<Scalars['Int']['input']>;
  seeds: Array<CartRecommendationSeedInput>;
};

export type CategoryDto = {
  __typename?: 'CategoryDto';
  active: Scalars['Boolean']['output'];
  basalamCategoryId?: Maybe<Scalars['Float']['output']>;
  bgColor?: Maybe<Scalars['String']['output']>;
  /** children field */
  children?: Maybe<Array<CategoryDto>>;
  description?: Maybe<Scalars['String']['output']>;
  /** guideContent field */
  guideContent?: Maybe<Scalars['String']['output']>;
  /** guideTitle field */
  guideTitle?: Maybe<Scalars['String']['output']>;
  /** id field */
  id: Scalars['Int']['output'];
  image?: Maybe<ImageDto>;
  imageId?: Maybe<Scalars['String']['output']>;
  keywords: Array<Scalars['String']['output']>;
  parent?: Maybe<CategoryDto>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  snappCommissionType?: Maybe<Scalars['Float']['output']>;
  /** sort field */
  sort?: Maybe<Scalars['Int']['output']>;
  /** svg icon */
  svg?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  title_en: Scalars['String']['output'];
};

export type CityDto = {
  __typename?: 'CityDto';
  id: Scalars['String']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  zoom?: Maybe<Scalars['Float']['output']>;
};

export type CodeSentResult = {
  __typename?: 'CodeSentResult';
  deadline: Scalars['Float']['output'];
  phoneNumber: Scalars['String']['output'];
  sent: Scalars['Boolean']['output'];
};

export type Color = {
  __typename?: 'Color';
  /** hex field */
  hex: Scalars['String']['output'];
  /** id field */
  id: Scalars['Int']['output'];
  /** title field */
  title: Scalars['String']['output'];
};

export type CreateAdminOfflineOrderInput = {
  customerFirstName?: InputMaybe<Scalars['String']['input']>;
  customerLastName?: InputMaybe<Scalars['String']['input']>;
  /** کسر از موجودی — پیش‌فرض true */
  deductStock?: InputMaybe<Scalars['Boolean']['input']>;
  items: Array<CreateAdminOfflineOrderItemInput>;
  memo?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** پیش‌فرض: تحویل‌شده */
  status?: InputMaybe<OrderStatusEnum>;
};

export type CreateAdminOfflineOrderItemInput = {
  quantity: Scalars['Int']['input'];
  variantId: Scalars['Float']['input'];
};

export type CreateAiImageGenerationJobInput = {
  imageIds?: InputMaybe<Array<Scalars['String']['input']>>;
  imageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  productId: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
};

export type CreateBrandInput = {
  imageId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  title_en: Scalars['String']['input'];
};

export type CreateCartInput = {
  pricingMode?: InputMaybe<CartPricingMode>;
  productCode?: InputMaybe<Scalars['Float']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Float']['input'];
  variantId: Scalars['Float']['input'];
};

export type CreateCategoryInput = {
  active: Scalars['Boolean']['input'];
  basalamCategoryId?: InputMaybe<Scalars['Float']['input']>;
  bgColor?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** guideContent field */
  guideContent?: InputMaybe<Scalars['String']['input']>;
  /** guideTitle field */
  guideTitle?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['String']['input']>;
  keywords: Array<Scalars['String']['input']>;
  /** sort field */
  parentId?: InputMaybe<Scalars['Int']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  snappCommissionType?: InputMaybe<Scalars['Float']['input']>;
  /** sort field */
  sort?: InputMaybe<Scalars['Int']['input']>;
  /** svg icon */
  svg?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  title_en: Scalars['String']['input'];
};

export type CreateColorInput = {
  /** hex field  */
  hex: Scalars['String']['input'];
  /** title field  */
  title: Scalars['String']['input'];
};

export type CreateDiscountInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  discountAmount: Scalars['Float']['input'];
  discountCode: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  isActive?: Scalars['Boolean']['input'];
  minimumPurchase?: InputMaybe<Scalars['Float']['input']>;
  remainingUses?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateGuaranteeInput = {
  title: Scalars['String']['input'];
};

export type CreateImageInput = {
  alt?: InputMaybe<Scalars['String']['input']>;
  image: Scalars['Upload']['input'];
};

export type CreateOfferInput = {
  cashPrice: Scalars['Float']['input'];
  creditPrice: Scalars['Float']['input'];
  end_at: Scalars['Date']['input'];
  maxBasketCount: Scalars['Float']['input'];
  start_at: Scalars['Date']['input'];
  stock: Scalars['Float']['input'];
  variantId: Scalars['Float']['input'];
};

export type CreateOfferRangeInput = {
  items: Array<CreateOfferInput>;
};

export type CreateOfferTypeInput = {
  discount: Scalars['Float']['input'];
  title: Scalars['String']['input'];
};

export type CreatePostCategoryInput = {
  /** Status indicating if the category is active */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ordering sequence number */
  sort?: InputMaybe<Scalars['Int']['input']>;
  /** The Persian title of the category */
  title: Scalars['String']['input'];
  /** The English title of the category */
  title_en: Scalars['String']['input'];
};

/** Data required to create a new blog post. */
export type CreatePostInput = {
  /** Soft-switch to toggle display on the live site. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Canonical URL to prevent duplicate content indexing issues. */
  canonicalUrl?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the category this post belongs to. */
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  /** The full body of the blog post. */
  content: Scalars['String']['input'];
  /** The ID of the cover image from the central media library. */
  coverImageId?: InputMaybe<Scalars['String']['input']>;
  /** A short summary displayed in search results and blog listings. */
  excerpt?: InputMaybe<Scalars['String']['input']>;
  /** Controls whether this page appears in search engine indexes. */
  indexable?: InputMaybe<Scalars['Boolean']['input']>;
  /** SEO description meta tag (max 160 chars). */
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  /** SEO title meta tag (max 70 chars). */
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  /** Which products to show beside this post, and how to order them. */
  productSettings?: InputMaybe<PostProductSettingsInput>;
  /** The date the post was officially made public. */
  publishedAt?: InputMaybe<Scalars['Date']['input']>;
  /** A list of SEO keywords injected into the meta tags. */
  seoKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The URL-friendly version of the title. Must be unique for SEO/routing. */
  slug: Scalars['String']['input'];
  /** Used for manual sorting in admin dashboards. */
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  /** Workflow status of the post. */
  status?: InputMaybe<PostStatus>;
  /** An array of tag names or slugs to be associated with this post. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Title shown to the user on the website. */
  title: Scalars['String']['input'];
  /** English title used for internal admin organization or unique identification. */
  titleEn?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProductInput = {
  active: Scalars['Boolean']['input'];
  brandId: Scalars['Float']['input'];
  categoryId: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  features: Array<Scalars['String']['input']>;
  images?: InputMaybe<Array<ProductImageInput>>;
  keywords: Array<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<Array<CreateSpecificationInput>>;
  title: Scalars['String']['input'];
  title_en?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePromptInput = {
  content: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateReduceOrderItemActionInput = {
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['Float']['input'];
  orderItemId: Scalars['Float']['input'];
  reduceBy: Scalars['Int']['input'];
};

export type CreateSpecificationInput = {
  checked?: InputMaybe<Scalars['Boolean']['input']>;
  sort: Scalars['Int']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: SpecificationType;
};

export type CreateSpecificationRangeInput = {
  items: Array<CreateSpecificationInput>;
};

export type CreateTagInput = {
  id?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['String']['input'];
};

export type CreateUserAddressInput = {
  address: Scalars['String']['input'];
  cityId: Scalars['String']['input'];
  isDefault: Scalars['Boolean']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  long?: InputMaybe<Scalars['Float']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId: Scalars['String']['input'];
  recipientFirstName: Scalars['String']['input'];
  recipientLastName: Scalars['String']['input'];
  recipientPhoneNumber: Scalars['String']['input'];
};

export type CreateUserLogInput = {
  currentPath: Scalars['String']['input'];
  referer?: InputMaybe<Scalars['String']['input']>;
};

export type CreateVariantAttrInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type CreateVariantInput = {
  active: Scalars['Boolean']['input'];
  affiliatePrice?: InputMaybe<Scalars['Float']['input']>;
  allowAutoOffer: Scalars['Boolean']['input'];
  attrs?: InputMaybe<Array<CreateVariantAttrInput>>;
  cashPrice: Scalars['Float']['input'];
  creditPrice: Scalars['Float']['input'];
  guaranteeId: Scalars['Float']['input'];
  maxBasketCount: Scalars['Float']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
  productId: Scalars['String']['input'];
  purchasePrice?: InputMaybe<Scalars['Float']['input']>;
  salesChannel: Array<SalesChannelEnum>;
  stock: Scalars['Float']['input'];
  warehouseId: Scalars['Float']['input'];
  warehouseTargetDescription?: InputMaybe<Scalars['String']['input']>;
  warehouseTargetProductId?: InputMaybe<Scalars['String']['input']>;
  warehouseTargetProductVariantId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateVideoInput = {
  productId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['Float']['input']>;
  video: Scalars['Upload']['input'];
};

export type CreateWarehouseShippingMethodInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  cashOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  cashPrice: Scalars['Float']['input'];
  cities?: InputMaybe<Array<Scalars['String']['input']>>;
  creditPrice: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  warehouseId: Scalars['Float']['input'];
};

export type DashboardDataDto = {
  __typename?: 'DashboardDataDto';
  kpis: KpiDataDto;
  referrers: Array<RefererChartDto>;
  timeSeries: Array<TimeSeriesDto>;
};

export type DiscountDto = {
  __typename?: 'DiscountDto';
  created_at: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discountAmount: Scalars['Float']['output'];
  discountCode: Scalars['String']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  minimumPurchase?: Maybe<Scalars['Float']['output']>;
  remainingUses?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  updated_at: Scalars['Date']['output'];
  user?: Maybe<AdminUserDto>;
  userId?: Maybe<Scalars['Float']['output']>;
};

export type GatewaySourcePolicyDto = {
  __typename?: 'GatewaySourcePolicyDto';
  allowGatewayCodes?: Maybe<Array<Scalars['String']['output']>>;
  allowNonInstallment: Scalars['Boolean']['output'];
  allowOtherInstallment: Scalars['Boolean']['output'];
  allowSelf: Scalars['Boolean']['output'];
  denyGatewayCodes?: Maybe<Array<Scalars['String']['output']>>;
  detectEnabled: Scalars['Boolean']['output'];
  matchKeys: Array<Scalars['String']['output']>;
  restrictionEnabled: Scalars['Boolean']['output'];
  /** Lower number wins when several detectors match. Blank is treated as 100. */
  sourcePriority?: Maybe<Scalars['Int']['output']>;
  /** public is shown on direct traffic. source_only is hidden unless the active source is this gateway. */
  visibility: GatewayVisibility;
};

export type GatewaySourcePolicyInput = {
  allowGatewayCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  allowNonInstallment: Scalars['Boolean']['input'];
  allowOtherInstallment: Scalars['Boolean']['input'];
  allowSelf: Scalars['Boolean']['input'];
  denyGatewayCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  detectEnabled: Scalars['Boolean']['input'];
  matchKeys: Array<Scalars['String']['input']>;
  restrictionEnabled: Scalars['Boolean']['input'];
  sourcePriority?: InputMaybe<Scalars['Int']['input']>;
  visibility: GatewayVisibility;
};

/** public: eligible on direct traffic. source_only: hidden unless the active source is this gateway code. */
export enum GatewayVisibility {
  Public = 'public',
  SourceOnly = 'source_only'
}

export type GuaranteeDto = {
  __typename?: 'GuaranteeDto';
  created_at: Scalars['Date']['output'];
  id: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['Date']['output'];
};

export type Guest = {
  __typename?: 'Guest';
  created_at: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  ip?: Maybe<Scalars['String']['output']>;
  userAgent: Scalars['String']['output'];
};

export type HomePageDataDto = {
  __typename?: 'HomePageDataDto';
  categoryFilteredProducts: Array<SProduct>;
  mostOfferProducts: Array<SProduct>;
  mostSaleProducts: Array<SProduct>;
};

export type ImageDto = {
  __typename?: 'ImageDto';
  address: Scalars['String']['output'];
  aiGenerated: Scalars['Boolean']['output'];
  alt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  local: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export enum IntervalEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Year = 'YEAR'
}

export type KpiDataDto = {
  __typename?: 'KpiDataDto';
  /** کل بازدیدها */
  totalViews: Scalars['Int']['output'];
  /** کاربران یکتا بر اساس IP یا Guest ID */
  uniqueVisitors: Scalars['Int']['output'];
};

export type LoginUserInput = {
  /** code field */
  code?: InputMaybe<Scalars['String']['input']>;
  /** phoneNumber field */
  phoneNumber: Scalars['String']['input'];
};

export type MeliPayampakMsg = {
  __typename?: 'MeliPayampakMsg';
  Body: Scalars['String']['output'];
  Credit: Scalars['Float']['output'];
  CurrentLocation: Scalars['Float']['output'];
  DeliveryStatus?: Maybe<Scalars['String']['output']>;
  FirstLocation: Scalars['Float']['output'];
  IsFlash: Scalars['Boolean']['output'];
  IsMoneyBack: Scalars['Boolean']['output'];
  IsRead: Scalars['Boolean']['output'];
  IsUnicode: Scalars['Boolean']['output'];
  LinkID: Scalars['Float']['output'];
  Module: Scalars['Float']['output'];
  MoneyBackCount: Scalars['Float']['output'];
  MoneyBackLevel: Scalars['Float']['output'];
  MsgID: Scalars['String']['output'];
  MsgType: Scalars['String']['output'];
  NumberID: Scalars['Float']['output'];
  Parts: Scalars['Float']['output'];
  RecCount: Scalars['Float']['output'];
  RecFailed: Scalars['Float']['output'];
  RecID?: Maybe<Scalars['String']['output']>;
  RecStatus?: Maybe<Scalars['String']['output']>;
  RecSuccess: Scalars['Float']['output'];
  Receiver: Scalars['String']['output'];
  SendDate: Scalars['Date']['output'];
  Sender: Scalars['String']['output'];
  StatusCode?: Maybe<Scalars['Float']['output']>;
  StatusText?: Maybe<Scalars['String']['output']>;
  Tariff: Scalars['Float']['output'];
  Udh: Scalars['String']['output'];
  UserID: Scalars['Float']['output'];
  UserMaster: Scalars['Float']['output'];
  UserStepedMaster: Scalars['Float']['output'];
};

export type MeliPayampakMsgInput = {
  body: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type MoveCategoryInput = {
  categoryId: Scalars['Float']['input'];
  parentId?: InputMaybe<Scalars['Float']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addDiscountToUserCurrentOrder: SCurrentOrderDto;
  addToCart: SCartDto;
  addVarinatToBarcodePerPrintList: BarcodeLabelDto;
  /** Creates a new post category with server-side slug generation. */
  adminCreatePostCategory: AdminPostCategoryDto;
  /** Deletes a category if it has no posts. Returns true on success. */
  adminDeletePostCategory: Scalars['Boolean']['output'];
  /** Updates a category; regenerates slug if title_en changed. */
  adminUpdatePostCategory: AdminPostCategoryDto;
  convertCartPricingMode: SCartDto;
  convertCurrentOrderPricingMode: SCurrentOrderDto;
  /** ثبت سفارش حضوری/آفلاین توسط ادمین */
  createAdminOfflineOrder: AdminOrderDto;
  createAiImageGenerationJob: AiImageGenerationJobDto;
  createBrand: BrandDto;
  createCategory: CategoryDto;
  createColor: Color;
  createDiscount: DiscountDto;
  createGuarantee: GuaranteeDto;
  createImage: ImageDto;
  createOffer: OfferDto;
  createOfferType: OfferTypeDto;
  createPost: AdminPost;
  createProduct: Product;
  createProductImage: ProductImage;
  createPrompt: PromptDto;
  createRangeOffer: Array<OfferDto>;
  createSpecification: Specification;
  createSpecificationRange: Array<Specification>;
  createTag: TagDto;
  createUserAddress: UserAddressDto;
  createUserLog: Scalars['String']['output'];
  createVariant: VariantDto;
  createVideo: VideoDto;
  createWarehouseShippingMethod: WarehouseShippingMethodDto;
  createWheelPrize: WheelPrizeAdminDto;
  deleteVideo: VideoDto;
  deleteWheelPrize: Scalars['Boolean']['output'];
  login: AuthResultUnion;
  loginCollab: AuthResultUnion;
  moveCategory: CategoryDto;
  pay: PaymentRequest;
  processOrderItemPartialCancellation: SimpleOrderItemDto;
  refreshToken: TokenResult;
  reloadAiImageGenerationJob: Scalars['Boolean']['output'];
  removeAiImageGenerationJob: Scalars['Boolean']['output'];
  removeAllBarcodeLabels: Array<BarcodeLabelDto>;
  removeBrand: BrandDto;
  removeCategory: AppMessage;
  removeColor: RemoveColorOutput;
  removeDiscount: DiscountDto;
  removeDiscountFromUserCurrentOrder: SCurrentOrderDto;
  removeGuarantee: GuaranteeDto;
  removeOffer: OfferDto;
  removeOfferType: OfferTypeDto;
  removeProduct: Product;
  removeProductImage: ProductImage;
  removePrompt: PromptDto;
  removeSpecification: AppMessage;
  removeTag: TagDto;
  removeUserAddress: UserAddressDto;
  removeVariant: VariantDto;
  sendSmsByMeliPayamak: AppMessage;
  setSettingItem: SettingItemDto;
  spinWheel: WheelSpinResultDto;
  toggleUserAddressIsDefault: UserAddressDto;
  updateAdminOrder: AdminOrderDto;
  updateAdminOrderStatus: AppMessage;
  updateAdminOrderStatusToCancelled: AppMessage;
  updateBrand: BrandDto;
  updateCategory: CategoryDto;
  updateColor: Color;
  updateDiscount: DiscountDto;
  updateGuarantee: GuaranteeDto;
  updateImage: ImageDto;
  updateMe: User;
  updateOffer: OfferDto;
  updateOfferType: OfferTypeDto;
  updateOrderItemPartialCancellation: OrderItemActionDto;
  updateOrderShipmentStatus: OrderShipmentDto;
  updatePaymentGateway: PaymentGatewayDto;
  updatePost: AdminPost;
  updateProduct: Product;
  updateProductImage: ProductImage;
  updateProductImageSort: AppMessage;
  updatePrompt: PromptDto;
  updateShippingAddresses: ShippingAddressDto;
  updateShippingMethod: ShippingMethodDto;
  updateSpecification: Specification;
  updateSpecificationSorts: AppMessage;
  updateTag: TagDto;
  updateTopBanner: TopBannerAdminDto;
  updateUserAddress: UserAddressDto;
  updateUserCurrentOrder: SCurrentOrderDto;
  updateVariant: VariantDto;
  updateVideo: VideoDto;
  updateWarehouse: WarehouseDto;
  updateWarehouseShippingMethod: WarehouseShippingMethodDto;
  updateWheelPrize: WheelPrizeAdminDto;
  updateWheelSettings: WheelSettingsAdminDto;
  uploadTopBannerGif: TopBannerGifUploadDto;
};


export type MutationAddDiscountToUserCurrentOrderArgs = {
  code: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
};


export type MutationAddToCartArgs = {
  createCartInput: CreateCartInput;
};


export type MutationAddVarinatToBarcodePerPrintListArgs = {
  input: BarcodeLabelInput;
};


export type MutationAdminCreatePostCategoryArgs = {
  input: CreatePostCategoryInput;
};


export type MutationAdminDeletePostCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationAdminUpdatePostCategoryArgs = {
  input: UpdatePostCategoryInput;
};


export type MutationConvertCartPricingModeArgs = {
  pricingMode: CartPricingMode;
};


export type MutationConvertCurrentOrderPricingModeArgs = {
  pricingMode: CartPricingMode;
};


export type MutationCreateAdminOfflineOrderArgs = {
  input: CreateAdminOfflineOrderInput;
};


export type MutationCreateAiImageGenerationJobArgs = {
  input: CreateAiImageGenerationJobInput;
};


export type MutationCreateBrandArgs = {
  createBrandInput: CreateBrandInput;
};


export type MutationCreateCategoryArgs = {
  createCategoryInput: CreateCategoryInput;
};


export type MutationCreateColorArgs = {
  createColorInput: CreateColorInput;
};


export type MutationCreateDiscountArgs = {
  createDiscountInput: CreateDiscountInput;
};


export type MutationCreateGuaranteeArgs = {
  createGuaranteeInput: CreateGuaranteeInput;
};


export type MutationCreateImageArgs = {
  createImageInput: CreateImageInput;
};


export type MutationCreateOfferArgs = {
  createOfferInput: CreateOfferInput;
};


export type MutationCreateOfferTypeArgs = {
  createOfferTypeInput: CreateOfferTypeInput;
};


export type MutationCreatePostArgs = {
  createPostInput: CreatePostInput;
};


export type MutationCreateProductArgs = {
  createProductInput: CreateProductInput;
};


export type MutationCreateProductImageArgs = {
  createProductImageInput: ProductImageInput;
  productId: Scalars['String']['input'];
};


export type MutationCreatePromptArgs = {
  createPromptInput: CreatePromptInput;
};


export type MutationCreateRangeOfferArgs = {
  createOfferRangeInput: CreateOfferRangeInput;
};


export type MutationCreateSpecificationArgs = {
  createSpecificationInput: CreateSpecificationInput;
  productId: Scalars['String']['input'];
};


export type MutationCreateSpecificationRangeArgs = {
  createSpecificationInput: CreateSpecificationRangeInput;
  productId: Scalars['String']['input'];
};


export type MutationCreateTagArgs = {
  createTagInput: CreateTagInput;
};


export type MutationCreateUserAddressArgs = {
  createUserAddressInput: CreateUserAddressInput;
};


export type MutationCreateUserLogArgs = {
  createUserLogInput: CreateUserLogInput;
};


export type MutationCreateVariantArgs = {
  createVariantInput: CreateVariantInput;
};


export type MutationCreateVideoArgs = {
  createVideoInput: CreateVideoInput;
};


export type MutationCreateWarehouseShippingMethodArgs = {
  input: CreateWarehouseShippingMethodInput;
};


export type MutationCreateWheelPrizeArgs = {
  input: UpsertWheelPrizeInput;
};


export type MutationDeleteVideoArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteWheelPrizeArgs = {
  id: Scalars['Int']['input'];
};


export type MutationLoginArgs = {
  loginUserInput: LoginUserInput;
};


export type MutationLoginCollabArgs = {
  loginUserInput: LoginUserInput;
};


export type MutationMoveCategoryArgs = {
  moveCategoryInput: MoveCategoryInput;
};


export type MutationPayArgs = {
  orderPayInput: OrderPayInput;
};


export type MutationProcessOrderItemPartialCancellationArgs = {
  input: CreateReduceOrderItemActionInput;
};


export type MutationReloadAiImageGenerationJobArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveAiImageGenerationJobArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveBrandArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveColorArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveDiscountArgs = {
  id: Scalars['Float']['input'];
};


export type MutationRemoveDiscountFromUserCurrentOrderArgs = {
  orderId: Scalars['Float']['input'];
};


export type MutationRemoveGuaranteeArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveOfferArgs = {
  id: Scalars['Float']['input'];
};


export type MutationRemoveOfferTypeArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveProductArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveProductImageArgs = {
  id: Scalars['String']['input'];
  imageId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type MutationRemovePromptArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveSpecificationArgs = {
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type MutationRemoveTagArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveUserAddressArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveVariantArgs = {
  id: Scalars['Float']['input'];
};


export type MutationSendSmsByMeliPayamakArgs = {
  MeliPayampakMsgInput: MeliPayampakMsgInput;
};


export type MutationSetSettingItemArgs = {
  id: Scalars['Float']['input'];
  updateSettingInput: UpdateSettingInput;
};


export type MutationToggleUserAddressIsDefaultArgs = {
  id: Scalars['String']['input'];
};


export type MutationUpdateAdminOrderArgs = {
  id: Scalars['Float']['input'];
  input: AdminUpdateOrderInput;
};


export type MutationUpdateAdminOrderStatusArgs = {
  id: Scalars['Float']['input'];
  input: AdminUpdateOrderStatusInput;
};


export type MutationUpdateAdminOrderStatusToCancelledArgs = {
  id: Scalars['Float']['input'];
  input: AdminUpdateOrderStatusToCancelledInput;
};


export type MutationUpdateBrandArgs = {
  id: Scalars['Int']['input'];
  updateBrandInput: UpdateBrandInput;
};


export type MutationUpdateCategoryArgs = {
  updateCategoryInput: UpdateCategoryInput;
};


export type MutationUpdateColorArgs = {
  updateColorInput: UpdateColorInput;
};


export type MutationUpdateDiscountArgs = {
  id: Scalars['Float']['input'];
  updateDiscountInput: UpdateDiscountInput;
};


export type MutationUpdateGuaranteeArgs = {
  id: Scalars['Int']['input'];
  updateGuaranteeInput: UpdateGuaranteeInput;
};


export type MutationUpdateImageArgs = {
  id: Scalars['String']['input'];
  updateImageInput: UpdateImageInput;
};


export type MutationUpdateMeArgs = {
  updateUserInput: UpdateUserInput;
};


export type MutationUpdateOfferArgs = {
  id: Scalars['Float']['input'];
  updateOfferInput: UpdateOfferInput;
};


export type MutationUpdateOfferTypeArgs = {
  id: Scalars['Int']['input'];
  updateOfferTypeInput: UpdateOfferTypeInput;
};


export type MutationUpdateOrderItemPartialCancellationArgs = {
  input: UpdateReduceOrderItemActionInput;
};


export type MutationUpdateOrderShipmentStatusArgs = {
  id: Scalars['Int']['input'];
  input: UpdateOrderShipmentStatusInput;
};


export type MutationUpdatePaymentGatewayArgs = {
  id: Scalars['String']['input'];
  updatePaymentGatewayInput: UpdatePaymentGatewayInput;
};


export type MutationUpdatePostArgs = {
  updatePostInput: UpdatePostInput;
};


export type MutationUpdateProductArgs = {
  id: Scalars['String']['input'];
  updateProductInput: UpdateProductInput;
};


export type MutationUpdateProductImageArgs = {
  id: Scalars['String']['input'];
  imageId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  updateProductImageInput: UpdateProductImageInput;
};


export type MutationUpdateProductImageSortArgs = {
  updateProductImageSortInput: UpdateProductImageSortInput;
};


export type MutationUpdatePromptArgs = {
  id: Scalars['Int']['input'];
  updatePromptInput: UpdatePromptInput;
};


export type MutationUpdateShippingAddressesArgs = {
  id: Scalars['String']['input'];
  input: UpdateShippingAddressInput;
};


export type MutationUpdateShippingMethodArgs = {
  id: Scalars['Int']['input'];
  input: UpdateShippingMethodInput;
};


export type MutationUpdateSpecificationArgs = {
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  updateSpecificationInput: UpdateSpecificationInput;
};


export type MutationUpdateSpecificationSortsArgs = {
  productId: Scalars['String']['input'];
  updateSpecificationSortInput: UpdateSpecificationSortInput;
};


export type MutationUpdateTagArgs = {
  id: Scalars['Int']['input'];
  updateTagInput: UpdateTagInput;
};


export type MutationUpdateTopBannerArgs = {
  input: UpdateTopBannerInput;
};


export type MutationUpdateUserAddressArgs = {
  id: Scalars['String']['input'];
  updateUserAddressInput: UpdateUserAddressInput;
};


export type MutationUpdateUserCurrentOrderArgs = {
  id: Scalars['Float']['input'];
  updateOrderInput: UpdateOrderInput;
};


export type MutationUpdateVariantArgs = {
  id: Scalars['Float']['input'];
  updateVariantInput: UpdateVariantInput;
};


export type MutationUpdateVideoArgs = {
  id: Scalars['String']['input'];
  updateVideoInput: UpdateVideoInput;
};


export type MutationUpdateWarehouseArgs = {
  id: Scalars['Float']['input'];
  input: UpdateWarehouseInput;
};


export type MutationUpdateWarehouseShippingMethodArgs = {
  id: Scalars['Int']['input'];
  input: UpdateWarehouseShippingMethodInput;
};


export type MutationUpdateWheelPrizeArgs = {
  id: Scalars['Int']['input'];
  input: UpsertWheelPrizeInput;
};


export type MutationUpdateWheelSettingsArgs = {
  input: UpdateWheelSettingsInput;
};


export type MutationUploadTopBannerGifArgs = {
  file: Scalars['Upload']['input'];
};

export type OfferDto = {
  __typename?: 'OfferDto';
  active: Scalars['Boolean']['output'];
  cashPrice?: Maybe<Scalars['Float']['output']>;
  created_at: Scalars['Date']['output'];
  creditPrice?: Maybe<Scalars['Float']['output']>;
  end_at: Scalars['Date']['output'];
  id: Scalars['Float']['output'];
  maxBasketCount: Scalars['Float']['output'];
  offerType: OfferTypeDto;
  offerTypeId: Scalars['Float']['output'];
  percentage: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  start_at: Scalars['Date']['output'];
  stock: Scalars['Float']['output'];
  updated_at: Scalars['Date']['output'];
  variant: VariantDto;
  variantId: Scalars['Float']['output'];
};

export type OfferTypeDto = {
  __typename?: 'OfferTypeDto';
  created_at: Scalars['Date']['output'];
  discount: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['Date']['output'];
};

export type OrderDto = {
  __typename?: 'OrderDto';
  created_at: Scalars['Date']['output'];
  deliveryTrackingCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  initialDate?: Maybe<Scalars['Date']['output']>;
  isOffline: Scalars['Boolean']['output'];
  itemsWarehouse?: Maybe<Scalars['String']['output']>;
  paymentGateway?: Maybe<PaymentGatewayDto>;
  paymentMethod?: Maybe<PaymentMethodDto>;
  shippingAddress?: Maybe<ShippingAddressDto>;
  shippingMethod?: Maybe<ShippingMethodDto>;
  shippingPrice?: Maybe<Scalars['Float']['output']>;
  status: OrderStatusEnum;
  totalPrice: Scalars['Float']['output'];
  updated_at: Scalars['Date']['output'];
  user_fullname?: Maybe<Scalars['String']['output']>;
  user_phoneNumber?: Maybe<Scalars['String']['output']>;
};

export enum OrderFilterStatusEnum {
  Cancelled = 'cancelled',
  Delivered = 'delivered',
  Inprogress = 'inprogress',
  Returned = 'returned'
}

export type OrderHistoryDto = {
  __typename?: 'OrderHistoryDto';
  created_at: Scalars['Date']['output'];
  id: Scalars['Float']['output'];
  newStatus: OrderStatusEnum;
  note?: Maybe<Scalars['String']['output']>;
  oldStatus: OrderStatusEnum;
};

export type OrderItemActionDto = {
  __typename?: 'OrderItemActionDto';
  additionReason?: Maybe<Scalars['String']['output']>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['Date']['output'];
  id: Scalars['Float']['output'];
  isRefundProcessed?: Maybe<Scalars['Boolean']['output']>;
  newQuantity: Scalars['Float']['output'];
  oldQuantity: Scalars['Float']['output'];
  orderItem: OrderItemDto;
  orderItemActionType: OrderItemActionTypeEnum;
  orderItemId: Scalars['Float']['output'];
  refundAmount?: Maybe<Scalars['Float']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Date']['output'];
};

export enum OrderItemActionTypeEnum {
  Add = 'Add',
  Cancel = 'Cancel'
}

export type OrderItemDto = {
  __typename?: 'OrderItemDto';
  discountPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  product: SimpleProductDto;
  productTitle: Scalars['String']['output'];
  productTitleEn?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  unitPurchasePrice?: Maybe<Scalars['Float']['output']>;
  variantAttrs?: Maybe<Array<VariantAttrDto>>;
  variantGuaranteeId?: Maybe<Scalars['Float']['output']>;
  variantGuaranteeTitle?: Maybe<Scalars['String']['output']>;
  variantId: Scalars['Float']['output'];
  warehouse: WarehouseDto;
  warehouseId: Scalars['Float']['output'];
  warehouseTargetDescription?: Maybe<Scalars['String']['output']>;
  warehouseTargetProductId?: Maybe<Scalars['String']['output']>;
  warehouseTargetProductVariantId?: Maybe<Scalars['String']['output']>;
};

export type OrderPayInput = {
  callback: Scalars['String']['input'];
  memo?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['Float']['input'];
  /** Installment gateway id. Ignored for cash — server picks a random cash IPG. */
  paymentGatewayId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['String']['input'];
  /** Active payment source: gateway code from the payment_gateway_session cookie. Same value passed to getPaymentGateways(source). */
  source?: InputMaybe<Scalars['String']['input']>;
};

export type OrderShipmentDto = {
  __typename?: 'OrderShipmentDto';
  created_at: Scalars['Date']['output'];
  id: Scalars['Float']['output'];
  orderId: Scalars['Float']['output'];
  shippingPrice?: Maybe<Scalars['Float']['output']>;
  status: OrderShipmentStatusEnum;
  trackingCode?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Date']['output'];
  warehouse?: Maybe<WarehouseDto>;
  warehouseId: Scalars['Float']['output'];
  warehouseShippingMethod?: Maybe<WarehouseShippingMethodDto>;
  warehouseShippingMethodId?: Maybe<Scalars['Float']['output']>;
};

export type OrderShipmentMethodSelectionInput = {
  warehouseId: Scalars['Int']['input'];
  warehouseShippingMethodId: Scalars['Int']['input'];
};

/** Status of an individual order shipment (per warehouse) */
export enum OrderShipmentStatusEnum {
  Cancelled = 'CANCELLED',
  Delivered = 'DELIVERED',
  Failed = 'FAILED',
  OnHold = 'ON_HOLD',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  Packed = 'PACKED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Shipped = 'SHIPPED'
}

/** Represents the different statuses that an order can have. */
export enum OrderStatusEnum {
  AwaitingPaymentConfirmation = 'AWAITING_PAYMENT_CONFIRMATION',
  Cancelled = 'CANCELLED',
  Delivered = 'DELIVERED',
  Failed = 'FAILED',
  OnHold = 'ON_HOLD',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  Packed = 'PACKED',
  Paid = 'PAID',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Refunded = 'REFUNDED',
  Returned = 'RETURNED',
  ReturnRequested = 'RETURN_REQUESTED',
  Shipped = 'SHIPPED'
}

export type PaginatedAdminAiImageGenerationJobsDto = {
  __typename?: 'PaginatedAdminAiImageGenerationJobsDto';
  hasNextPage: Scalars['Boolean']['output'];
  items: Array<AiImageGenerationJobDto>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminBrandsDto = {
  __typename?: 'PaginatedAdminBrandsDto';
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<BrandDto>>;
  limit: Scalars['Int']['output'];
  orderBy?: Maybe<AdminBrandsPaginationOrdersOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminDiscountsDto = {
  __typename?: 'PaginatedAdminDiscountsDto';
  filter?: Maybe<AdminDiscountsPaginationFiltersOutput>;
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<DiscountDto>>;
  limit: Scalars['Int']['output'];
  orderBy?: Maybe<AdminDiscountsPaginationOrdersOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminGuaranteesDto = {
  __typename?: 'PaginatedAdminGuaranteesDto';
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<GuaranteeDto>>;
  limit: Scalars['Int']['output'];
  orderBy?: Maybe<AdminGuaranteesPaginationOrdersOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminOfferTypesDto = {
  __typename?: 'PaginatedAdminOfferTypesDto';
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<OfferTypeDto>>;
  limit: Scalars['Int']['output'];
  orderBy?: Maybe<AdminOfferTypesPaginationOrdersOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminOffersDto = {
  __typename?: 'PaginatedAdminOffersDto';
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<OfferDto>>;
  limit: Scalars['Int']['output'];
  orderBy?: Maybe<AdminOffersPaginationOrdersOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminOrdersDto = {
  __typename?: 'PaginatedAdminOrdersDto';
  filter?: Maybe<AdminOrdersPaginationFilterOutput>;
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<OrderDto>>;
  limit: Scalars['Int']['output'];
  orderBy?: Maybe<AdminOrdersPaginationOrdersOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminOrdersProfitDto = {
  __typename?: 'PaginatedAdminOrdersProfitDto';
  filter?: Maybe<AdminOrdersProfitFilterOutput>;
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<AdminOrderProfitDto>>;
  limit: Scalars['Int']['output'];
  orderBy?: Maybe<AdminOrdersProfitOrderByOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  summary: AdminOrdersProfitSummaryDto;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminPaymentsDto = {
  __typename?: 'PaginatedAdminPaymentsDto';
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<PaymentDto>>;
  limit: Scalars['Int']['output'];
  orderBy?: Maybe<AdminPaymentsPaginationOrdersOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminPostsDto = {
  __typename?: 'PaginatedAdminPostsDto';
  filter?: Maybe<AdminPostsPaginationFiltersOutput>;
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<AdminPostRowDto>>;
  limit: Scalars['Int']['output'];
  orderBy?: Maybe<AdminPostsPaginationOrdersOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminProductImagesDto = {
  __typename?: 'PaginatedAdminProductImagesDto';
  filter?: Maybe<AdminProductImagesPaginationFiltersOutput>;
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<AdminGalleryProductImage>>;
  limit: Scalars['Int']['output'];
  orderBy?: Maybe<AdminProductImagesPaginationOrdersOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminProductsDto = {
  __typename?: 'PaginatedAdminProductsDto';
  filter?: Maybe<AdminProductsPaginationFiltersOutput>;
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<SingleRowProductDto>>;
  limit: Scalars['Int']['output'];
  orderBy?: Maybe<AdminProductsPaginationOrdersOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminPromptsDto = {
  __typename?: 'PaginatedAdminPromptsDto';
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<PromptDto>>;
  limit: Scalars['Int']['output'];
  orderBy?: Maybe<AdminPromptsPaginationOrdersOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminTagsDto = {
  __typename?: 'PaginatedAdminTagsDto';
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<TagDto>>;
  limit: Scalars['Int']['output'];
  orderBy?: Maybe<AdminTagsPaginationOrdersOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminUsersDto = {
  __typename?: 'PaginatedAdminUsersDto';
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<User>>;
  limit: Scalars['Int']['output'];
  orderBy?: Maybe<AdminUsersPaginationOrdersOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedAdminVariantsDto = {
  __typename?: 'PaginatedAdminVariantsDto';
  filter?: Maybe<AdminVariantsPaginationFiltersOutput>;
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<VariantDto>>;
  limit: Scalars['Int']['output'];
  orderBy?: Maybe<AdminVariantsPaginationOrdersOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedCollabProductsDto = {
  __typename?: 'PaginatedCollabProductsDto';
  filter?: Maybe<ProductsPaginationFiltersOutput>;
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<SCollabProduct>>;
  limit: Scalars['Int']['output'];
  meta?: Maybe<ProductsPaginationMetaOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  sort?: Maybe<SearchSort>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedPostsDto = {
  __typename?: 'PaginatedPostsDto';
  filter?: Maybe<PostsPaginationFiltersOutput>;
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<PostSummaryDto>>;
  limit: Scalars['Int']['output'];
  meta?: Maybe<PostPaginationMetaOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  sort?: Maybe<PostSearchSort>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedProductsDto = {
  __typename?: 'PaginatedProductsDto';
  filter?: Maybe<ProductsPaginationFiltersOutput>;
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<SProduct>>;
  limit: Scalars['Int']['output'];
  meta?: Maybe<ProductsPaginationMetaOutput>;
  page: Scalars['Int']['output'];
  search?: Maybe<Scalars['String']['output']>;
  sort?: Maybe<SearchSort>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedSOrdersDto = {
  __typename?: 'PaginatedSOrdersDto';
  filter?: Maybe<SOrdersPaginationFiltersOutput>;
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<SOrderDto>>;
  limit: Scalars['Int']['output'];
  meta: SOrdersPaginationMeta;
  page: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedUserProductViewsDto = {
  __typename?: 'PaginatedUserProductViewsDto';
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<SProduct>>;
  limit: Scalars['Int']['output'];
  orderBy?: Maybe<UserProductViewsPaginationOrdersOutput>;
  page: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedWheelSpinsDto = {
  __typename?: 'PaginatedWheelSpinsDto';
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<WheelSpinAdminDto>>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaymentDto = {
  __typename?: 'PaymentDto';
  amount: Scalars['Float']['output'];
  bankName?: Maybe<Scalars['String']['output']>;
  cardNumber?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['Date']['output'];
  failedDate?: Maybe<Scalars['Date']['output']>;
  failedReason?: Maybe<Scalars['String']['output']>;
  gateWayPayStatus?: Maybe<Scalars['String']['output']>;
  gateway?: Maybe<PaymentGatewayDto>;
  gatewayEntryTime?: Maybe<Scalars['Date']['output']>;
  gatewayId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  orderId: Scalars['Float']['output'];
  paymentDate?: Maybe<Scalars['Date']['output']>;
  paymentMethod?: Maybe<PaymentMethodDto>;
  paymentMethodId?: Maybe<Scalars['String']['output']>;
  paymentToken?: Maybe<Scalars['String']['output']>;
  refNumber?: Maybe<Scalars['String']['output']>;
  status: PaymentStatusEnum;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type PaymentGatewayDto = {
  __typename?: 'PaymentGatewayDto';
  active: Scalars['Boolean']['output'];
  clientId?: Maybe<Scalars['String']['output']>;
  clientOAuthUrl?: Maybe<Scalars['String']['output']>;
  clientPassword?: Maybe<Scalars['String']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  clientUsername?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  created_at: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  installment: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  logo?: Maybe<ImageDto>;
  logoId?: Maybe<Scalars['String']['output']>;
  maxAmountToPayment?: Maybe<Scalars['Float']['output']>;
  minAmountToPayment?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  sourcePolicy?: Maybe<GatewaySourcePolicyDto>;
  updated_at: Scalars['Date']['output'];
};

export type PaymentMethodDto = {
  __typename?: 'PaymentMethodDto';
  code: PaymentMethodEnum;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum PaymentMethodEnum {
  CardToCard = 'CARD_TO_CARD',
  Installment = 'INSTALLMENT',
  OnlinePayment = 'ONLINE_PAYMENT',
  ThirdPartyPayment = 'THIRD_PARTY_PAYMENT'
}

export type PaymentRequest = {
  __typename?: 'PaymentRequest';
  payUrl: Scalars['String']['output'];
};

export type PaymentResultStatusDto = {
  __typename?: 'PaymentResultStatusDto';
  canRetry: Scalars['Boolean']['output'];
  order?: Maybe<UserOrderDto>;
  orderId: Scalars['Float']['output'];
  refNumber?: Maybe<Scalars['String']['output']>;
  seen: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  trackId: Scalars['String']['output'];
};

/** Public traffic detector. Contains no credentials and no restriction rules. */
export type PaymentSourceDetectorDto = {
  __typename?: 'PaymentSourceDetectorDto';
  code: Scalars['String']['output'];
  matchKeys: Array<Scalars['String']['output']>;
  sourcePriority: Scalars['Int']['output'];
};

export enum PaymentStatusEnum {
  Completed = 'COMPLETED',
  Edited = 'EDITED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type PostCategoryDto = {
  __typename?: 'PostCategoryDto';
  id: Scalars['Int']['output'];
  seo_url: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  title_en: Scalars['String']['output'];
};

export type PostPaginationMetaOutput = {
  __typename?: 'PostPaginationMetaOutput';
  categories: Array<PostCategoryDto>;
};

export type PostProductSettingsDto = {
  __typename?: 'PostProductSettingsDto';
  brandIds: Array<Scalars['Int']['output']>;
  categoryIds: Array<Scalars['Int']['output']>;
  enabled: Scalars['Boolean']['output'];
  hasOfferOnly: Scalars['Boolean']['output'];
  includeChildCategories: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  productCodes: Array<Scalars['Int']['output']>;
  sectionTitle?: Maybe<Scalars['String']['output']>;
  sort: PostProductSort;
  tagIds: Array<Scalars['Int']['output']>;
  usePostTags: Scalars['Boolean']['output'];
};

export type PostProductSettingsInput = {
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  enabled: Scalars['Boolean']['input'];
  hasOfferOnly?: InputMaybe<Scalars['Boolean']['input']>;
  includeChildCategories?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  productCodes?: InputMaybe<Array<Scalars['Int']['input']>>;
  sectionTitle?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<PostProductSort>;
  tagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  usePostTags?: InputMaybe<Scalars['Boolean']['input']>;
};

/** How products beside a blog post are ordered. */
export enum PostProductSort {
  Bestseller = 'BESTSELLER',
  Cheapest = 'CHEAPEST',
  HighestDiscount = 'HIGHEST_DISCOUNT',
  ManualOrder = 'MANUAL_ORDER',
  MostExpensive = 'MOST_EXPENSIVE',
  MostViewed = 'MOST_VIEWED',
  Newest = 'NEWEST',
  Score = 'SCORE'
}

export enum PostSearchSort {
  New = 'new',
  Old = 'old',
  View = 'view'
}

export type PostSiteMapDto = {
  __typename?: 'PostSiteMapDto';
  slug: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum PostStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type PostSummaryDto = {
  __typename?: 'PostSummaryDto';
  category: SinglePostCategoryDto;
  coverImage?: Maybe<ImageDto>;
  id: Scalars['Float']['output'];
  publishedAt?: Maybe<Scalars['Date']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  titleEn?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type PostsPaginationFiltersInput = {
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PostsPaginationFiltersOutput = {
  __typename?: 'PostsPaginationFiltersOutput';
  categorySlug?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type PriceProfitDetailsDto = {
  __typename?: 'PriceProfitDetailsDto';
  bankFee: Scalars['Float']['output'];
  /** قیمت نقد (رند تومان) */
  cashPrice?: Maybe<Scalars['Float']['output']>;
  /** قیمت اعتباری = نقد × (۱ + creditUpliftPercent/۱۰۰) */
  creditPrice?: Maybe<Scalars['Float']['output']>;
  /** درصد افزایش اعتبار نسبت به نقد */
  creditUpliftPercent?: Maybe<Scalars['Float']['output']>;
  finalAmount: Scalars['Float']['output'];
  grossProfit: Scalars['Float']['output'];
  netProfit: Scalars['Float']['output'];
  purchaseCost: Scalars['Float']['output'];
  /** قیمت اعتباری (لیست) — همان creditPrice در مسیر کانال */
  sellingPrice: Scalars['Float']['output'];
  snapFee: Scalars['Float']['output'];
  tax: Scalars['Float']['output'];
  torobFee: Scalars['Float']['output'];
};

export type Product = {
  __typename?: 'Product';
  active: Scalars['Boolean']['output'];
  aiContentGenerated: Scalars['Boolean']['output'];
  basedOnExternalProductId?: Maybe<Scalars['String']['output']>;
  basedOnExternalProductUrl?: Maybe<Scalars['String']['output']>;
  brand: BrandDto;
  brandId: Scalars['Float']['output'];
  category: CategoryDto;
  /** code field */
  code: Scalars['Float']['output'];
  created_at: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  features: Array<Scalars['String']['output']>;
  hasStock?: Maybe<Scalars['Boolean']['output']>;
  /** id field */
  id: Scalars['String']['output'];
  images: Array<Maybe<ProductImage>>;
  keywords: Array<Scalars['String']['output']>;
  mainImage?: Maybe<ProductImage>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  specifications: Array<Specification>;
  tags: Array<Maybe<TagDto>>;
  /** title field */
  title: Scalars['String']['output'];
  /** title_en field */
  title_en?: Maybe<Scalars['String']['output']>;
  totalSales?: Maybe<Scalars['Float']['output']>;
  updated_at: Scalars['Date']['output'];
  videos: Array<Maybe<VideoDto>>;
  warehouse?: Maybe<WarehouseDto>;
};

export type ProductImage = {
  __typename?: 'ProductImage';
  address: Scalars['String']['output'];
  aiGenerated: Scalars['Boolean']['output'];
  alt?: Maybe<Scalars['String']['output']>;
  basalamImageId?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  imageId: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isMain: Scalars['Boolean']['output'];
  local: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sort: Scalars['Float']['output'];
  syncWithExternal: Scalars['Boolean']['output'];
};

export type ProductImageInput = {
  imageId: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isMain: Scalars['Boolean']['input'];
  sort: Scalars['Float']['input'];
};

export type ProductSiteMapDto = {
  __typename?: 'ProductSiteMapDto';
  /** code field */
  code: Scalars['Float']['output'];
  /** title field */
  title: Scalars['String']['output'];
  updated_at: Scalars['Date']['output'];
};

export type ProductsPaginationFiltersInput = {
  brands?: InputMaybe<Array<Scalars['Int']['input']>>;
  categorySlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  colors?: InputMaybe<Array<Scalars['Float']['input']>>;
  hasOffer?: InputMaybe<Scalars['Boolean']['input']>;
  inStock?: InputMaybe<Scalars['Boolean']['input']>;
  maxPrice?: InputMaybe<Scalars['Float']['input']>;
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProductsPaginationFiltersOutput = {
  __typename?: 'ProductsPaginationFiltersOutput';
  brands?: Maybe<Array<Scalars['Int']['output']>>;
  categorySlugs?: Maybe<Array<Scalars['String']['output']>>;
  colors?: Maybe<Array<Scalars['Float']['output']>>;
  hasOffer?: Maybe<Scalars['Boolean']['output']>;
  inStock?: Maybe<Scalars['Boolean']['output']>;
  maxPrice?: Maybe<Scalars['Float']['output']>;
  minPrice?: Maybe<Scalars['Float']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type ProductsPaginationMetaOutput = {
  __typename?: 'ProductsPaginationMetaOutput';
  brands?: Maybe<Array<SBrandDto>>;
  categoriesInPath?: Maybe<Array<SimpleCategoryDto>>;
  colors?: Maybe<Array<Color>>;
  oneLevelUpCategories?: Maybe<Array<CategoryDto>>;
  targetCategory?: Maybe<CategoryDto>;
};

export type ProfitRangeDto = {
  __typename?: 'ProfitRangeDto';
  min: Scalars['Float']['output'];
  profit: Scalars['Float']['output'];
};

export type ProfitRangeInput = {
  min: Scalars['Float']['input'];
  profit: Scalars['Float']['input'];
};

export type PromptDto = {
  __typename?: 'PromptDto';
  content: Scalars['String']['output'];
  created_at: Scalars['Date']['output'];
  id: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['Date']['output'];
};

export type ProvinceDto = {
  __typename?: 'ProvinceDto';
  id: Scalars['String']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  zoom?: Maybe<Scalars['Float']['output']>;
};

export type Query = {
  __typename?: 'Query';
  OfferType: OfferTypeDto;
  adminBlogDashboard: BlogDashboardDto;
  adminOrdersLocationDistribution: AdminOrdersLocationDistributionDto;
  /** سود سفارش‌های ارسال‌شده و تحویل‌شده. جمع هر سفارش در دیتابیس حساب می‌شود. */
  adminOrdersProfit: PaginatedAdminOrdersProfitDto;
  adminPostById: AdminPost;
  adminPostBySlug: AdminPost;
  /** Returns ALL categories with postCount for the admin panel. */
  adminPostCategories: Array<AdminPostCategoryDto>;
  /** Returns a single category by id (including posts). */
  adminPostCategory: AdminPostCategoryDto;
  adminPosts: PaginatedAdminPostsDto;
  adminProductStats: AdminProductStatsDto;
  adminTopBanner: TopBannerAdminDto;
  adminUserAddresses: Array<AdminUserAddressDto>;
  adminWheelPrizes: Array<WheelPrizeAdminDto>;
  adminWheelSettings: WheelSettingsAdminDto;
  adminWheelSpins: PaginatedWheelSpinsDto;
  adminWheelStats: WheelStatsDto;
  aiImageGenerationJob?: Maybe<AiImageGenerationJobDto>;
  aiImageGenerationJobByProductId?: Maybe<AiImageGenerationJobDto>;
  aiImageGenerationJobs: PaginatedAdminAiImageGenerationJobsDto;
  allTags: Array<TagDto>;
  brand: BrandDto;
  brands: PaginatedAdminBrandsDto;
  brandsForFilter: Array<SBrandDto>;
  cartRecommendations: CartRecommendationsDto;
  categories: Array<CategoryDto>;
  category: CategoryDto;
  cities: Array<CityDto>;
  city: CityDto;
  color: Color;
  colors: Array<Color>;
  discount: DiscountDto;
  discounts: PaginatedAdminDiscountsDto;
  getAdminShippingMethods: Array<ShippingMethodDto>;
  getAdminWarehouseShippingMethods: Array<WarehouseShippingMethodDto>;
  getAllBarcodeLabels: Array<BarcodeLabelDto>;
  getAllSettingItems: Array<SettingItemDto>;
  getAllVideos: Array<VideoDto>;
  getApoloanEligibility: ApoloanInstallmentEligibilityDetails;
  getBasalamCategories: BasalamCategoriesResponse;
  getBasalamMe: BasalamPrivateUserResponse;
  /** Returns public vendor profile data from Basalam (public information only). */
  getBasalamVendor: BasalamPublicVendorResponse;
  getCart: SCartDto;
  getDashboardData: DashboardDataDto;
  getMeliPayamakCredit: Scalars['Float']['output'];
  getMeliPayamakSmsList: Array<MeliPayampakMsg>;
  getOrderHistoryByOrderId: Array<OrderHistoryDto>;
  getOrderItemActionsByOrderId: Array<OrderItemActionDto>;
  getOrderPaymentsByOrderId: Array<PaymentDto>;
  /** Active shown gateways after source policy. Pass source (gateway code from payment_gateway_session, max-age 3600). The pay mutation must send the same value as OrderPayInput.source. */
  getPaymentGateways: Array<SPaymentGatewayDto>;
  getPaymentMethods: Array<SPaymentMethodDto>;
  /** Public partner detectors used to set the payment_gateway_session cookie. Returns code, match keys, and priority only. */
  getPaymentSourceDetectors: Array<PaymentSourceDetectorDto>;
  getShippingMethods: Array<SShippingMethodDto>;
  getSnapPayEligibility: SnappInstallmentEligibilityDetails;
  getTorobPayEligibility: TorobPayInstallmentEligibilityDetails;
  getUserAuthTokens: Array<AdminUserTokenDto>;
  getUserByPhoneNumber: User;
  getUserCurrentOrder: SCurrentOrderDto;
  getUsersByHint: Array<AdminUserDto>;
  getWarehouseShippingMethods: Array<SWarehouseShippingMethodDto>;
  getWarehouses: Array<WarehouseDto>;
  guarantee: GuaranteeDto;
  guarantees: PaginatedAdminGuaranteesDto;
  homePageData: HomePageDataDto;
  images: Array<ImageDto>;
  logout: User;
  me: User;
  menu: Array<CategoryDto>;
  myWheelStatus: WheelStatusDto;
  offerTypes: PaginatedAdminOfferTypesDto;
  offers: PaginatedAdminOffersDto;
  order: AdminOrderDto;
  orderCart?: Maybe<CartDto>;
  orderItem: SimpleOrderItemDto;
  orderItems: Array<SimpleOrderItemDto>;
  orderV2: AdminOrderDto;
  orders: PaginatedAdminOrdersDto;
  ordersCount: AdminOrdersCountDto;
  ordersSaleChart: AdminOrdersSaleChart;
  paymentGateways: Array<PaymentGatewayDto>;
  paymentResult: PaymentResultStatusDto;
  payments: PaginatedAdminPaymentsDto;
  ping: Scalars['String']['output'];
  postWithSlug: SinglePost;
  postsSiteMap: Array<PostSiteMapDto>;
  postsSiteMapCount: Scalars['Float']['output'];
  product: Product;
  productImages: PaginatedAdminProductImagesDto;
  productSummaryById: AdminProductSummaryDto;
  productVariants: PaginatedAdminVariantsDto;
  productWithCode: SingleProduct;
  products: PaginatedAdminProductsDto;
  productsCount: AdminProductsCountDto;
  productsSiteMap: Array<ProductSiteMapDto>;
  productsSiteMapCount: Scalars['Float']['output'];
  productsViewsReport: AdminProductsViewsReportDto;
  prompt: PromptDto;
  prompts: PaginatedAdminPromptsDto;
  province: ProvinceDto;
  provinces: Array<ProvinceDto>;
  rankedTerms: Array<TfIdfTermDto>;
  refererChartData: Array<RefererChartDto>;
  salePriceCalculator: PriceProfitDetailsDto;
  search: PaginatedProductsDto;
  searchByCategoryId: Array<SProduct>;
  searchCollab: PaginatedCollabProductsDto;
  searchMostOffer: Array<SProduct>;
  searchMostSale: Array<SProduct>;
  searchPosts: PaginatedPostsDto;
  searchRelatedProducts: Array<SProduct>;
  searchRelatedProductsByCode: Array<SProduct>;
  searchTerm: SearchTermResultDto;
  specifications: Array<Specification>;
  tag: TagDto;
  tags: PaginatedAdminTagsDto;
  topBanner?: Maybe<TopBannerPublicDto>;
  userAddress: UserAddressDto;
  userAddresses: Array<UserAddressDto>;
  userDetails: AdminUserDetailsDto;
  userOrder: UserOrderDto;
  userOrders: PaginatedSOrdersDto;
  userOrdersMeta: SOrdersPaginationMeta;
  userProductViews: PaginatedUserProductViewsDto;
  users: PaginatedAdminUsersDto;
  variant: VariantDto;
  variants: PaginatedAdminVariantsDto;
  variantsByIds: Array<VariantDto>;
  variantsCount: AdminVariantsCountDto;
  websitePostCategories: Array<PostCategoryDto>;
  wheelCampaign: WheelCampaignDto;
  wheelVariantOptions: Array<WheelVariantOptionDto>;
};


export type QueryOfferTypeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAdminBlogDashboardArgs = {
  days?: Scalars['Int']['input'];
};


export type QueryAdminOrdersLocationDistributionArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAdminOrdersProfitArgs = {
  filter?: InputMaybe<AdminOrdersProfitFilterInput>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminOrdersProfitOrderByInput>;
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminPostByIdArgs = {
  id: Scalars['Float']['input'];
};


export type QueryAdminPostBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryAdminPostCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAdminPostsArgs = {
  filter?: InputMaybe<AdminPostsPaginationFiltersInput>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminPostsPaginationOrdersInput>;
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminProductStatsArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdminUserAddressesArgs = {
  userId: Scalars['Float']['input'];
};


export type QueryAdminWheelSpinsArgs = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAiImageGenerationJobArgs = {
  id: Scalars['String']['input'];
};


export type QueryAiImageGenerationJobByProductIdArgs = {
  productId: Scalars['String']['input'];
};


export type QueryAiImageGenerationJobsArgs = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBrandArgs = {
  id: Scalars['Int']['input'];
};


export type QueryBrandsArgs = {
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminBrandsPaginationOrdersInput>;
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCartRecommendationsArgs = {
  input: CartRecommendationsInput;
};


export type QueryCategoriesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCitiesArgs = {
  provinceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCityArgs = {
  id: Scalars['String']['input'];
};


export type QueryColorArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDiscountArgs = {
  id: Scalars['Float']['input'];
};


export type QueryDiscountsArgs = {
  filter?: InputMaybe<AdminDiscountsPaginationFiltersInput>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminDiscountsPaginationOrdersInput>;
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAdminWarehouseShippingMethodsArgs = {
  warehouseId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetApoloanEligibilityArgs = {
  amount: Scalars['Float']['input'];
};


export type QueryGetDashboardDataArgs = {
  days?: Scalars['Int']['input'];
};


export type QueryGetOrderHistoryByOrderIdArgs = {
  id: Scalars['Float']['input'];
};


export type QueryGetOrderItemActionsByOrderIdArgs = {
  id: Scalars['Float']['input'];
};


export type QueryGetOrderPaymentsByOrderIdArgs = {
  id: Scalars['Float']['input'];
};


export type QueryGetPaymentGatewaysArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSnapPayEligibilityArgs = {
  amount: Scalars['Float']['input'];
};


export type QueryGetTorobPayEligibilityArgs = {
  amount: Scalars['Float']['input'];
};


export type QueryGetUserAuthTokensArgs = {
  id: Scalars['Float']['input'];
};


export type QueryGetUserByPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type QueryGetUsersByHintArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetWarehouseShippingMethodsArgs = {
  cityId?: InputMaybe<Scalars['String']['input']>;
  pricingMode?: InputMaybe<CartPricingMode>;
  warehouseId: Scalars['Int']['input'];
};


export type QueryGuaranteeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGuaranteesArgs = {
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminGuaranteesPaginationOrdersInput>;
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHomePageDataArgs = {
  categoryId: Scalars['Int']['input'];
};


export type QueryOfferTypesArgs = {
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminOfferTypesPaginationOrdersInput>;
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOffersArgs = {
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminOffersPaginationOrdersInput>;
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrderArgs = {
  id: Scalars['Float']['input'];
};


export type QueryOrderCartArgs = {
  id: Scalars['Float']['input'];
};


export type QueryOrderItemArgs = {
  id: Scalars['Float']['input'];
  orderId: Scalars['Float']['input'];
};


export type QueryOrderItemsArgs = {
  orderId: Scalars['Float']['input'];
};


export type QueryOrderV2Args = {
  id: Scalars['Float']['input'];
};


export type QueryOrdersArgs = {
  filter?: InputMaybe<AdminOrdersPaginationFilterInput>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminOrdersPaginationOrdersInput>;
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrdersSaleChartArgs = {
  from: Scalars['Date']['input'];
  interval?: IntervalEnum;
  to: Scalars['Date']['input'];
};


export type QueryPaymentResultArgs = {
  orderId: Scalars['Float']['input'];
  trackId: Scalars['String']['input'];
};


export type QueryPaymentsArgs = {
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminPaymentsPaginationOrdersInput>;
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPostWithSlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPostsSiteMapArgs = {
  limit: Scalars['Float']['input'];
  skip: Scalars['Float']['input'];
};


export type QueryProductArgs = {
  id: Scalars['String']['input'];
};


export type QueryProductImagesArgs = {
  filter?: InputMaybe<AdminProductImagesPaginationFiltersInput>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminProductImagesPaginationOrdersInput>;
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductSummaryByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryProductVariantsArgs = {
  filter?: InputMaybe<AdminVariantsPaginationFiltersInput>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminVariantsPaginationOrdersInput>;
  page?: Scalars['Int']['input'];
  productId: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductWithCodeArgs = {
  code: Scalars['Float']['input'];
};


export type QueryProductsArgs = {
  filter?: InputMaybe<AdminProductsPaginationFiltersInput>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminProductsPaginationOrdersInput>;
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductsSiteMapArgs = {
  limit: Scalars['Float']['input'];
  skip: Scalars['Float']['input'];
};


export type QueryProductsViewsReportArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  top?: Scalars['Int']['input'];
};


export type QueryPromptArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPromptsArgs = {
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminPromptsPaginationOrdersInput>;
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProvinceArgs = {
  id: Scalars['String']['input'];
};


export type QuerySalePriceCalculatorArgs = {
  input: SalePriceCalculatorInput;
};


export type QuerySearchArgs = {
  filter?: InputMaybe<ProductsPaginationFiltersInput>;
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SearchSort>;
};


export type QuerySearchByCategoryIdArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySearchCollabArgs = {
  filter?: InputMaybe<ProductsPaginationFiltersInput>;
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SearchSort>;
};


export type QuerySearchPostsArgs = {
  filter?: InputMaybe<PostsPaginationFiltersInput>;
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<PostSearchSort>;
};


export type QuerySearchRelatedProductsArgs = {
  id: Scalars['String']['input'];
};


export type QuerySearchRelatedProductsByCodeArgs = {
  code: Scalars['Float']['input'];
};


export type QuerySearchTermArgs = {
  input: SearchTermRequestInput;
};


export type QueryTagArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTagsArgs = {
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminTagsPaginationOrdersInput>;
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserAddressArgs = {
  id: Scalars['String']['input'];
};


export type QueryUserDetailsArgs = {
  userId: Scalars['Float']['input'];
};


export type QueryUserOrderArgs = {
  id: Scalars['Float']['input'];
};


export type QueryUserOrdersArgs = {
  filter?: InputMaybe<SOrdersPaginationFiltersInput>;
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};


export type QueryUserProductViewsArgs = {
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<UserProductViewsPaginationOrdersInput>;
  page?: Scalars['Int']['input'];
};


export type QueryUsersArgs = {
  filter?: InputMaybe<AdminUsersPaginationFiltersInput>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminUsersPaginationOrdersInput>;
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVariantArgs = {
  productId: Scalars['String']['input'];
  variantId: Scalars['String']['input'];
};


export type QueryVariantsArgs = {
  filter?: InputMaybe<AdminVariantsPaginationFiltersInput>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminVariantsPaginationOrdersInput>;
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVariantsByIdsArgs = {
  variantIdsArgs: VariantIdsArgs;
};


export type QueryVariantsCountArgs = {
  warehouseId?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryWheelVariantOptionsArgs = {
  search: Scalars['String']['input'];
};

export type RefererChartDto = {
  __typename?: 'RefererChartDto';
  name: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RemoveColorOutput = {
  __typename?: 'RemoveColorOutput';
  /** hex field */
  hex: Scalars['String']['output'];
  /** title field */
  title: Scalars['String']['output'];
};

export enum Roles {
  Admin = 'ADMIN',
  Collab = 'COLLAB',
  User = 'USER'
}

export type SBrandDto = {
  __typename?: 'SBrandDto';
  id: Scalars['Float']['output'];
  image?: Maybe<SImageDto>;
  title: Scalars['String']['output'];
  title_en: Scalars['String']['output'];
};

export type SCartDto = {
  __typename?: 'SCartDto';
  cartItems: Array<SCartItemDto>;
  discountAmount: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  pricingMode: CartPricingMode;
  subtotal: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
};

export type SCartItemChangeHistoryDto = {
  __typename?: 'SCartItemChangeHistoryDto';
  available?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Float']['output'];
  newDiscountPrice?: Maybe<Scalars['Float']['output']>;
  newOfferId?: Maybe<Scalars['Float']['output']>;
  newQuantity?: Maybe<Scalars['Float']['output']>;
  newUnitPrice?: Maybe<Scalars['Float']['output']>;
  oldDiscountPrice?: Maybe<Scalars['Float']['output']>;
  oldOfferId?: Maybe<Scalars['Float']['output']>;
  oldQuantity?: Maybe<Scalars['Float']['output']>;
  oldUnitPrice?: Maybe<Scalars['Float']['output']>;
};

export type SCartItemDto = {
  __typename?: 'SCartItemDto';
  changeHistories?: Maybe<Array<SCartItemChangeHistoryDto>>;
  discountPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  offer?: Maybe<SOfferDto>;
  offerId?: Maybe<Scalars['Float']['output']>;
  product: SimpleProductDto;
  productId: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  variant: SVariantDto;
  variantId: Scalars['Float']['output'];
};

export type SCollabProduct = {
  __typename?: 'SCollabProduct';
  /** code field */
  code: Scalars['Float']['output'];
  colors: Array<Color>;
  id: Scalars['String']['output'];
  mainImage?: Maybe<SImageDto>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  /** title field */
  title: Scalars['String']['output'];
  /** title_en field */
  title_en?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<SCollabVariantDto>;
};

export type SCollabVariantDto = {
  __typename?: 'SCollabVariantDto';
  affiliatePrice: Scalars['Float']['output'];
  guarantee: SGuaranteeDto;
  guaranteeId: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  maxBasketCount: Scalars['Float']['output'];
  stock?: Maybe<Scalars['Float']['output']>;
};

export type SCurrentOrderDto = {
  __typename?: 'SCurrentOrderDto';
  cart: SCartDto;
  cashOnDelivery: Scalars['Boolean']['output'];
  discount?: Maybe<SDiscountDto>;
  discountId?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  memo?: Maybe<Scalars['String']['output']>;
  paymentGatewayId?: Maybe<Scalars['String']['output']>;
  paymentMethodId: Scalars['String']['output'];
  pricingMode?: Maybe<CartPricingMode>;
  shipments?: Maybe<Array<SOrderShipmentDto>>;
  shippingMethodId?: Maybe<Scalars['Float']['output']>;
  shippingPrice?: Maybe<Scalars['Float']['output']>;
  totalPrice: Scalars['Float']['output'];
  userAddressId?: Maybe<Scalars['String']['output']>;
};

export type SDiscountDto = {
  __typename?: 'SDiscountDto';
  discountAmount: Scalars['Float']['output'];
  discountCode: Scalars['String']['output'];
  id: Scalars['Float']['output'];
};

export type SGuaranteeDto = {
  __typename?: 'SGuaranteeDto';
  id: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type SImageDto = {
  __typename?: 'SImageDto';
  address: Scalars['String']['output'];
  aiGenerated: Scalars['Boolean']['output'];
  alt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SOfferDto = {
  __typename?: 'SOfferDto';
  cashPrice?: Maybe<Scalars['Float']['output']>;
  creditPrice?: Maybe<Scalars['Float']['output']>;
  end_at: Scalars['Date']['output'];
  id: Scalars['Float']['output'];
  maxBasketCount: Scalars['Float']['output'];
  offerType: SOfferTypeDto;
  offerTypeId: Scalars['Float']['output'];
  percentage: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  stock?: Maybe<Scalars['Float']['output']>;
};

export type SOfferTypeDto = {
  __typename?: 'SOfferTypeDto';
  id: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type SOrderDto = {
  __typename?: 'SOrderDto';
  created_at: Scalars['Date']['output'];
  id: Scalars['Float']['output'];
  initialDate?: Maybe<Scalars['Date']['output']>;
  items: Array<SOrderItemDto>;
  status: OrderStatusEnum;
  totalPrice: Scalars['Float']['output'];
};

export type SOrderHistoryDto = {
  __typename?: 'SOrderHistoryDto';
  created_at: Scalars['Date']['output'];
  id: Scalars['Float']['output'];
  newStatus: OrderStatusEnum;
  oldStatus: OrderStatusEnum;
};

export type SOrderItemDto = {
  __typename?: 'SOrderItemDto';
  id: Scalars['Float']['output'];
  product: SimpleProductDto;
  productTitle: Scalars['String']['output'];
  productTitleEn?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
};

export type SOrderShipmentDto = {
  __typename?: 'SOrderShipmentDto';
  id: Scalars['Float']['output'];
  shippingPrice?: Maybe<Scalars['Float']['output']>;
  status: OrderShipmentStatusEnum;
  trackingCode?: Maybe<Scalars['String']['output']>;
  warehouseId: Scalars['Float']['output'];
  warehouseShippingMethod?: Maybe<SWarehouseShippingMethodDto>;
  warehouseShippingMethodId?: Maybe<Scalars['Float']['output']>;
};

export type SOrdersPaginationFiltersInput = {
  status?: InputMaybe<OrderFilterStatusEnum>;
};

export type SOrdersPaginationFiltersOutput = {
  __typename?: 'SOrdersPaginationFiltersOutput';
  status?: Maybe<OrderFilterStatusEnum>;
};

export type SOrdersPaginationMeta = {
  __typename?: 'SOrdersPaginationMeta';
  cancelled: Scalars['Float']['output'];
  delivered: Scalars['Float']['output'];
  inprogress: Scalars['Float']['output'];
  returned: Scalars['Float']['output'];
};

export type SPaymentGatewayDto = {
  __typename?: 'SPaymentGatewayDto';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  installment: Scalars['Boolean']['output'];
  logo?: Maybe<ImageDto>;
  logoId?: Maybe<Scalars['String']['output']>;
  maxAmountToPayment?: Maybe<Scalars['Float']['output']>;
  minAmountToPayment?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
};

export type SPaymentMethodDto = {
  __typename?: 'SPaymentMethodDto';
  code: PaymentMethodEnum;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SProduct = {
  __typename?: 'SProduct';
  /** code field */
  code: Scalars['Float']['output'];
  colors: Array<Color>;
  id: Scalars['String']['output'];
  mainImage?: Maybe<SImageDto>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  /** title field */
  title: Scalars['String']['output'];
  /** title_en field */
  title_en?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<SVariantDto>;
  video?: Maybe<Scalars['String']['output']>;
};

export type SShippingAddressDto = {
  __typename?: 'SShippingAddressDto';
  address: Scalars['String']['output'];
  city?: Maybe<CityDto>;
  cityName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<ProvinceDto>;
  provinceName?: Maybe<Scalars['String']['output']>;
  recipientFirstName: Scalars['String']['output'];
  recipientLastName: Scalars['String']['output'];
  recipientPhoneNumber: Scalars['String']['output'];
};

export type SShippingMethodDto = {
  __typename?: 'SShippingMethodDto';
  cashOnDelivery: Scalars['Boolean']['output'];
  cities?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  warehouses?: Maybe<Array<Scalars['Float']['output']>>;
};

export type SSpecificationDto = {
  __typename?: 'SSpecificationDto';
  checked?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
  text?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: SpecificationType;
};

export type STagDto = {
  __typename?: 'STagDto';
  id: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type SUserOrderItemDto = {
  __typename?: 'SUserOrderItemDto';
  discountPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  product: SimpleProductDto;
  productTitle: Scalars['String']['output'];
  productTitleEn?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  variantAttrs?: Maybe<Array<VariantAttrDto>>;
  variantGuaranteeId?: Maybe<Scalars['Float']['output']>;
  variantGuaranteeTitle?: Maybe<Scalars['String']['output']>;
  warehouseId: Scalars['Float']['output'];
};

export type SVariantAttributeDto = {
  __typename?: 'SVariantAttributeDto';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SVariantDto = {
  __typename?: 'SVariantDto';
  attrs?: Maybe<Array<SVariantAttributeDto>>;
  cashPrice?: Maybe<Scalars['Float']['output']>;
  creditPrice?: Maybe<Scalars['Float']['output']>;
  guarantee: SGuaranteeDto;
  guaranteeId: Scalars['Float']['output'];
  hasStock: Scalars['Boolean']['output'];
  id: Scalars['Float']['output'];
  maxBasketCount: Scalars['Float']['output'];
  offer?: Maybe<SOfferDto>;
  price: Scalars['Float']['output'];
  stock?: Maybe<Scalars['Float']['output']>;
  warehouse?: Maybe<SWarehouseDisplayDto>;
  warehouseId: Scalars['Float']['output'];
};

export type SVideoDto = {
  __typename?: 'SVideoDto';
  address: Scalars['String']['output'];
  basalamVideoId?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sort: Scalars['Float']['output'];
  thumbnail: Scalars['String']['output'];
};

export type SWarehouseDisplayDto = {
  __typename?: 'SWarehouseDisplayDto';
  cashDisplayName?: Maybe<Scalars['String']['output']>;
  creditDisplayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  shippingOriginLabel?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type SWarehouseShippingMethodDto = {
  __typename?: 'SWarehouseShippingMethodDto';
  cashOnDelivery: Scalars['Boolean']['output'];
  cashPrice: Scalars['Float']['output'];
  cities?: Maybe<Array<Scalars['String']['output']>>;
  creditPrice: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  warehouseId: Scalars['Float']['output'];
};

export type SalePriceCalculatorInput = {
  /** درصد افزایش قیمت اعتباری نسبت به نقد (پیش‌فرض ۱۶). جایگزین مدل قدیمی اقساط داخل قیمت. */
  creditUpliftPercent?: InputMaybe<Scalars['Float']['input']>;
  installmentPercentage?: InputMaybe<Scalars['Float']['input']>;
  /** حاشیه فروش هدف روی قیمت نقد: سود خالص ÷ قیمت فروش (نه درصد روی خرید). */
  profitPercentage: Scalars['Float']['input'];
  purchaseCost: Scalars['Float']['input'];
  /** حمل لحاظ‌شده در محاسبه قیمت نقد (پیش‌فرض انبار ۵۰۰۰) */
  shippingCost?: InputMaybe<Scalars['Float']['input']>;
  taxPercentage?: InputMaybe<Scalars['Float']['input']>;
};

export enum SalesChannelEnum {
  Affiliate = 'AFFILIATE',
  Website = 'WEBSITE'
}

export enum SearchSort {
  Highprice = 'highprice',
  Lowprice = 'lowprice',
  New = 'new',
  Rate = 'rate',
  Related = 'related',
  Sale = 'sale',
  View = 'view'
}

export type SearchTermRequestInput = {
  query: Scalars['String']['input'];
};

export type SearchTermResultDto = {
  __typename?: 'SearchTermResultDto';
  categories: Array<SimpleCategoryWithSlugPathDto>;
  products: Array<SimpleProductWithCategoryDto>;
};

export type SettingItemDto = {
  __typename?: 'SettingItemDto';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ShippingAddressDto = {
  __typename?: 'ShippingAddressDto';
  address: Scalars['String']['output'];
  city?: Maybe<CityDto>;
  cityName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<ProvinceDto>;
  provinceName?: Maybe<Scalars['String']['output']>;
  recipientFirstName: Scalars['String']['output'];
  recipientLastName: Scalars['String']['output'];
  recipientPhoneNumber: Scalars['String']['output'];
};

export type ShippingMethodDto = {
  __typename?: 'ShippingMethodDto';
  active: Scalars['Boolean']['output'];
  cashOnDelivery: Scalars['Boolean']['output'];
  cities?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  warehouses?: Maybe<Array<Scalars['Float']['output']>>;
};

export type SimpleCategoryDto = {
  __typename?: 'SimpleCategoryDto';
  /** id field */
  id: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  title_en: Scalars['String']['output'];
};

export type SimpleCategoryWithSlugPathDto = {
  __typename?: 'SimpleCategoryWithSlugPathDto';
  /** id field */
  id: Scalars['Int']['output'];
  parentTitle: Scalars['String']['output'];
  path: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  title_en: Scalars['String']['output'];
};

export type SimpleOrderItemDto = {
  __typename?: 'SimpleOrderItemDto';
  discountPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  productId: Scalars['String']['output'];
  productTitle: Scalars['String']['output'];
  productTitleEn?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  unitPurchasePrice?: Maybe<Scalars['Float']['output']>;
  variantAttrs?: Maybe<Array<VariantAttrDto>>;
  variantGuaranteeId?: Maybe<Scalars['Float']['output']>;
  variantGuaranteeTitle?: Maybe<Scalars['String']['output']>;
  warehouse: WarehouseDto;
  warehouseId: Scalars['Float']['output'];
  warehouseTargetDescription?: Maybe<Scalars['String']['output']>;
  warehouseTargetProductId?: Maybe<Scalars['String']['output']>;
  warehouseTargetProductVariantId?: Maybe<Scalars['String']['output']>;
};

export type SimpleProductDto = {
  __typename?: 'SimpleProductDto';
  /** leaf category id */
  categoryId?: Maybe<Scalars['Int']['output']>;
  /** code field */
  code: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  mainImage?: Maybe<SImageDto>;
  /** title field */
  title: Scalars['String']['output'];
  /** title_en field */
  title_en?: Maybe<Scalars['String']['output']>;
};

export type SimpleProductWithCategoryDto = {
  __typename?: 'SimpleProductWithCategoryDto';
  category: SimpleCategoryDto;
  /** leaf category id */
  categoryId?: Maybe<Scalars['Int']['output']>;
  /** code field */
  code: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  mainImage?: Maybe<SImageDto>;
  /** title field */
  title: Scalars['String']['output'];
  /** title_en field */
  title_en?: Maybe<Scalars['String']['output']>;
};

export type SinglePost = {
  __typename?: 'SinglePost';
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  category: SinglePostCategoryDto;
  content: Scalars['String']['output'];
  coverImage?: Maybe<ImageDto>;
  excerpt?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  indexable: Scalars['Boolean']['output'];
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  productSectionTitle?: Maybe<Scalars['String']['output']>;
  products: Array<SProduct>;
  publishedAt?: Maybe<Scalars['Date']['output']>;
  readingTime: Scalars['Float']['output'];
  relatedPosts: Array<PostSummaryDto>;
  seoKeywords?: Maybe<Array<Scalars['String']['output']>>;
  slug: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  titleEn?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type SinglePostCategoryDto = {
  __typename?: 'SinglePostCategoryDto';
  id: Scalars['Int']['output'];
  seo_url: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  title_en: Scalars['String']['output'];
};

export type SingleProduct = {
  __typename?: 'SingleProduct';
  brand: SBrandDto;
  brandId: Scalars['Float']['output'];
  category: CategoryDto;
  /** code field */
  code: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  features: Array<Scalars['String']['output']>;
  /** id field */
  id: Scalars['String']['output'];
  images: Array<ProductImage>;
  keywords: Array<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  specifications: Array<SSpecificationDto>;
  tags: Array<STagDto>;
  /** title field */
  title: Scalars['String']['output'];
  /** title_en field */
  title_en?: Maybe<Scalars['String']['output']>;
  variants: Array<SVariantDto>;
  videos: Array<SVideoDto>;
};

export type SingleRowProductDto = {
  __typename?: 'SingleRowProductDto';
  active: Scalars['Boolean']['output'];
  aiContentGenerated: Scalars['Boolean']['output'];
  brand: BrandDto;
  category: CategoryDto;
  code: Scalars['Float']['output'];
  created_at: Scalars['Date']['output'];
  hasStock?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  mainImage?: Maybe<ProductImage>;
  title: Scalars['String']['output'];
  title_en?: Maybe<Scalars['String']['output']>;
  totalSales?: Maybe<Scalars['Float']['output']>;
  updated_at: Scalars['Date']['output'];
  warehouse?: Maybe<WarehouseDto>;
};

export type SnappInstallmentEligibilityDetails = {
  __typename?: 'SnappInstallmentEligibilityDetails';
  description: Scalars['String']['output'];
  eligible: Scalars['Boolean']['output'];
  title_message: Scalars['String']['output'];
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Specification = {
  __typename?: 'Specification';
  checked?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  product: Product;
  sort: Scalars['Int']['output'];
  text?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: SpecificationType;
};

export enum SpecificationType {
  Boolean = 'Boolean',
  Text = 'Text'
}

export type TagDto = {
  __typename?: 'TagDto';
  created_at: Scalars['Date']['output'];
  id: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['Date']['output'];
};

export type TfIdfTermDto = {
  __typename?: 'TfIdfTermDto';
  score: Scalars['Float']['output'];
  term: Scalars['String']['output'];
};

export type TimeSeriesDto = {
  __typename?: 'TimeSeriesDto';
  /** تاریخ روز */
  date: Scalars['String']['output'];
  /** تعداد کاربران یکتا در این روز */
  unique: Scalars['Int']['output'];
  /** تعداد بازدید در این روز */
  views: Scalars['Int']['output'];
};

export type TokenResult = {
  __typename?: 'TokenResult';
  refresh: Scalars['String']['output'];
  token: Scalars['String']['output'];
  user: User;
};

export enum TopBannerAction {
  Dialog = 'DIALOG',
  Link = 'LINK',
  None = 'NONE'
}

export type TopBannerAdminDto = {
  __typename?: 'TopBannerAdminDto';
  action: TopBannerAction;
  backgroundColor: Scalars['String']['output'];
  dialogBody: Scalars['String']['output'];
  dialogButtonLabel: Scalars['String']['output'];
  dialogButtonUrl?: Maybe<Scalars['String']['output']>;
  dialogImageAlt: Scalars['String']['output'];
  dialogImageId?: Maybe<Scalars['ID']['output']>;
  dialogImageUrl?: Maybe<Scalars['String']['output']>;
  dialogTitle: Scalars['String']['output'];
  endsAt?: Maybe<Scalars['Date']['output']>;
  imageAlt: Scalars['String']['output'];
  imageHeight?: Maybe<Scalars['Int']['output']>;
  imageUrl: Scalars['String']['output'];
  imageWidth?: Maybe<Scalars['Int']['output']>;
  isActive: Scalars['Boolean']['output'];
  kind: TopBannerKind;
  linkUrl?: Maybe<Scalars['String']['output']>;
  openInNewTab: Scalars['Boolean']['output'];
  startsAt?: Maybe<Scalars['Date']['output']>;
  textAnimation: TopBannerTextAnimation;
  textColor: Scalars['String']['output'];
  textLines: Array<Scalars['String']['output']>;
  updated_at: Scalars['Date']['output'];
  visible: Scalars['Boolean']['output'];
};

export type TopBannerGifUploadDto = {
  __typename?: 'TopBannerGifUploadDto';
  height: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export enum TopBannerKind {
  Gif = 'GIF',
  Text = 'TEXT'
}

export type TopBannerPublicDto = {
  __typename?: 'TopBannerPublicDto';
  action: TopBannerAction;
  backgroundColor: Scalars['String']['output'];
  dialogBody: Scalars['String']['output'];
  dialogButtonLabel: Scalars['String']['output'];
  dialogButtonUrl?: Maybe<Scalars['String']['output']>;
  dialogImageAlt: Scalars['String']['output'];
  dialogImageUrl?: Maybe<Scalars['String']['output']>;
  dialogTitle: Scalars['String']['output'];
  imageAlt: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  kind: TopBannerKind;
  linkUrl?: Maybe<Scalars['String']['output']>;
  openInNewTab: Scalars['Boolean']['output'];
  textAnimation: TopBannerTextAnimation;
  textColor: Scalars['String']['output'];
  textLines: Array<Scalars['String']['output']>;
};

export enum TopBannerTextAnimation {
  Fade = 'FADE',
  Flip = 'FLIP',
  Slide = 'SLIDE',
  Type = 'TYPE',
  Zoom = 'ZOOM'
}

export type TorobPayInstallmentEligibilityDetails = {
  __typename?: 'TorobPayInstallmentEligibilityDetails';
  description: Scalars['String']['output'];
  eligible: Scalars['Boolean']['output'];
  title_message: Scalars['String']['output'];
};

export type UpdateBrandInput = {
  imageId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_en?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCategoryInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  basalamCategoryId?: InputMaybe<Scalars['Float']['input']>;
  bgColor?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** guideContent field */
  guideContent?: InputMaybe<Scalars['String']['input']>;
  /** guideTitle field */
  guideTitle?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  imageId?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  /** sort field */
  parentId?: InputMaybe<Scalars['Int']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  snappCommissionType?: InputMaybe<Scalars['Float']['input']>;
  /** sort field */
  sort?: InputMaybe<Scalars['Int']['input']>;
  /** svg icon */
  svg?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_en?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateColorInput = {
  /** hex field  */
  hex: Scalars['String']['input'];
  /** id field  */
  id: Scalars['Float']['input'];
  /** title field  */
  title: Scalars['String']['input'];
};

export type UpdateDiscountInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountCode?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minimumPurchase?: InputMaybe<Scalars['Float']['input']>;
  remainingUses?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateGuaranteeInput = {
  title: Scalars['String']['input'];
};

export type UpdateImageInput = {
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
};

export type UpdateOfferInput = {
  cashPrice: Scalars['Float']['input'];
  creditPrice: Scalars['Float']['input'];
  end_at: Scalars['Date']['input'];
  maxBasketCount: Scalars['Float']['input'];
  start_at: Scalars['Date']['input'];
  stock: Scalars['Float']['input'];
  variantId: Scalars['Float']['input'];
};

export type UpdateOfferTypeInput = {
  discount?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderInput = {
  shipmentSelections?: InputMaybe<Array<OrderShipmentMethodSelectionInput>>;
  shippingMethodId?: InputMaybe<Scalars['Float']['input']>;
  userAddressId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderShipmentStatusInput = {
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  status: OrderShipmentStatusEnum;
  trackingCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePaymentGatewayInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientOAuthUrl?: InputMaybe<Scalars['String']['input']>;
  clientPassword?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  clientUsername?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  installment?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  logoId?: InputMaybe<Scalars['String']['input']>;
  maxAmountToPayment?: InputMaybe<Scalars['Float']['input']>;
  minAmountToPayment?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Null clears the policy (public, no detection, no restriction). */
  sourcePolicy?: InputMaybe<GatewaySourcePolicyInput>;
};

export type UpdatePostCategoryInput = {
  /** Status indicating if the category is active */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  /** Ordering sequence number */
  sort?: InputMaybe<Scalars['Int']['input']>;
  /** The Persian title of the category */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The English title of the category */
  title_en?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePostInput = {
  /** Soft-switch to toggle display on the live site. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Canonical URL to prevent duplicate content indexing issues. */
  canonicalUrl?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the category this post belongs to. */
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  /** The full body of the blog post. */
  content?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the cover image from the central media library. */
  coverImageId?: InputMaybe<Scalars['String']['input']>;
  /** A short summary displayed in search results and blog listings. */
  excerpt?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier of the post to update. */
  id: Scalars['Float']['input'];
  /** Controls whether this page appears in search engine indexes. */
  indexable?: InputMaybe<Scalars['Boolean']['input']>;
  /** SEO description meta tag (max 160 chars). */
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  /** SEO title meta tag (max 70 chars). */
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  /** Which products to show beside this post, and how to order them. */
  productSettings?: InputMaybe<PostProductSettingsInput>;
  /** The date the post was officially made public. */
  publishedAt?: InputMaybe<Scalars['Date']['input']>;
  /** A list of SEO keywords injected into the meta tags. */
  seoKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The URL-friendly version of the title. Must be unique for SEO/routing. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Used for manual sorting in admin dashboards. */
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  /** Workflow status of the post. */
  status?: InputMaybe<PostStatus>;
  /** An array of tag names or slugs to be associated with this post. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Title shown to the user on the website. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** English title used for internal admin organization or unique identification. */
  titleEn?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductImageInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['Float']['input']>;
  syncWithExternal?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateProductImageSortInput = {
  firstImageId: Scalars['String']['input'];
  firstProductImageId: Scalars['String']['input'];
  firstProductImageSort?: InputMaybe<Scalars['Float']['input']>;
  productId: Scalars['String']['input'];
  secondImageId: Scalars['String']['input'];
  secondProductImageId: Scalars['String']['input'];
  secondProductImageSort?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateProductInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  aiContentGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  brandId?: InputMaybe<Scalars['Float']['input']>;
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<CreateTagInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_en?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePromptInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReduceOrderItemActionInput = {
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Float']['input'];
  isRefundProcessed?: InputMaybe<Scalars['Boolean']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSettingInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateShippingAddressInput = {
  address: Scalars['String']['input'];
};

export type UpdateShippingMethodInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  cashOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  cities?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  warehouses?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type UpdateSpecificationInput = {
  checked?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SpecificationType>;
};

export type UpdateSpecificationSortInput = {
  id1: Scalars['String']['input'];
  id2: Scalars['String']['input'];
  sort1: Scalars['Int']['input'];
  sort2: Scalars['Int']['input'];
};

export type UpdateTagInput = {
  title: Scalars['String']['input'];
};

export type UpdateTopBannerInput = {
  action: TopBannerAction;
  backgroundColor: Scalars['String']['input'];
  dialogBody: Scalars['String']['input'];
  dialogButtonLabel: Scalars['String']['input'];
  dialogButtonUrl?: InputMaybe<Scalars['String']['input']>;
  dialogImageAlt: Scalars['String']['input'];
  dialogImageId?: InputMaybe<Scalars['ID']['input']>;
  dialogImageUrl?: InputMaybe<Scalars['String']['input']>;
  dialogTitle: Scalars['String']['input'];
  endsAt?: InputMaybe<Scalars['Date']['input']>;
  imageAlt: Scalars['String']['input'];
  imageHeight?: InputMaybe<Scalars['Int']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  imageWidth?: InputMaybe<Scalars['Int']['input']>;
  isActive: Scalars['Boolean']['input'];
  kind: TopBannerKind;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  openInNewTab: Scalars['Boolean']['input'];
  startsAt?: InputMaybe<Scalars['Date']['input']>;
  textAnimation: TopBannerTextAnimation;
  textColor: Scalars['String']['input'];
  textLines: Array<Scalars['String']['input']>;
};

export type UpdateUserAddressInput = {
  address: Scalars['String']['input'];
  cityId: Scalars['String']['input'];
  isDefault: Scalars['Boolean']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  long?: InputMaybe<Scalars['Float']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId: Scalars['String']['input'];
  recipientFirstName: Scalars['String']['input'];
  recipientLastName: Scalars['String']['input'];
  recipientPhoneNumber: Scalars['String']['input'];
};

export type UpdateUserInput = {
  birth_date?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVariantInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  affiliatePrice?: InputMaybe<Scalars['Float']['input']>;
  allowAutoOffer?: InputMaybe<Scalars['Boolean']['input']>;
  attrs?: InputMaybe<Array<CreateVariantAttrInput>>;
  cashPrice?: InputMaybe<Scalars['Float']['input']>;
  creditPrice?: InputMaybe<Scalars['Float']['input']>;
  guaranteeId?: InputMaybe<Scalars['Float']['input']>;
  maxBasketCount?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  purchasePrice?: InputMaybe<Scalars['Float']['input']>;
  salesChannel?: InputMaybe<Array<SalesChannelEnum>>;
  stock?: InputMaybe<Scalars['Float']['input']>;
  warehouseId?: InputMaybe<Scalars['Float']['input']>;
  warehouseTargetDescription?: InputMaybe<Scalars['String']['input']>;
  warehouseTargetProductId?: InputMaybe<Scalars['String']['input']>;
  warehouseTargetProductVariantId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVideoInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateWarehouseInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  cashDisplayName?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  creditDisplayName?: InputMaybe<Scalars['String']['input']>;
  profitRanges?: InputMaybe<Array<ProfitRangeInput>>;
  shippingOriginLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWarehouseShippingMethodInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  cashOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  cashPrice?: InputMaybe<Scalars['Float']['input']>;
  cities?: InputMaybe<Array<Scalars['String']['input']>>;
  creditPrice?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWheelSettingsInput = {
  dailySpinLimit: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  minPaidAmountToUnlock: Scalars['Int']['input'];
  prizeExpiryHours: Scalars['Int']['input'];
  rules: Scalars['String']['input'];
  seoDescription: Scalars['String']['input'];
  seoKeywords: Scalars['String']['input'];
  seoTitle: Scalars['String']['input'];
  subtitle: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type UpsertWheelPrizeInput = {
  color: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  expiryHours?: InputMaybe<Scalars['Int']['input']>;
  isActive: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
  maxWins?: InputMaybe<Scalars['Int']['input']>;
  minimumPurchase?: InputMaybe<Scalars['Float']['input']>;
  sortOrder: Scalars['Int']['input'];
  type: WheelPrizeType;
  variantId?: InputMaybe<Scalars['Int']['input']>;
  weight: Scalars['Int']['input'];
};

export type User = {
  __typename?: 'User';
  birth_date?: Maybe<Scalars['Date']['output']>;
  created_at: Scalars['Date']['output'];
  deliveredOrdersCount?: Maybe<Scalars['Float']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** id field  */
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  locked: Scalars['Boolean']['output'];
  /** phoneNumber field */
  phoneNumber: Scalars['String']['output'];
  roles: Array<Roles>;
  updated_at: Scalars['Date']['output'];
  walletId: Scalars['Float']['output'];
};

export type UserAddressDto = {
  __typename?: 'UserAddressDto';
  address: Scalars['String']['output'];
  city: CityDto;
  cityId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province: ProvinceDto;
  provinceId: Scalars['String']['output'];
  recipientFirstName: Scalars['String']['output'];
  recipientLastName: Scalars['String']['output'];
  recipientPhoneNumber: Scalars['String']['output'];
};

export type UserOrderDto = {
  __typename?: 'UserOrderDto';
  created_at: Scalars['Date']['output'];
  deliveryTrackingCode?: Maybe<Scalars['String']['output']>;
  discountPrice?: Maybe<Scalars['Float']['output']>;
  history: Array<SOrderHistoryDto>;
  id: Scalars['Float']['output'];
  initialDate?: Maybe<Scalars['Date']['output']>;
  items: Array<SUserOrderItemDto>;
  memo?: Maybe<Scalars['String']['output']>;
  paymentGateway: SPaymentGatewayDto;
  paymentMethod: SPaymentMethodDto;
  shipments?: Maybe<Array<UserOrderShipmentDto>>;
  shippingAddress?: Maybe<SShippingAddressDto>;
  shippingMethod?: Maybe<SShippingMethodDto>;
  shippingPrice?: Maybe<Scalars['Float']['output']>;
  status: OrderStatusEnum;
  totalPrice: Scalars['Float']['output'];
};

export type UserOrderShipmentDto = {
  __typename?: 'UserOrderShipmentDto';
  cashOnDelivery: Scalars['Boolean']['output'];
  id: Scalars['Float']['output'];
  legacyShippingMethodId?: Maybe<Scalars['Float']['output']>;
  shippingMethodName?: Maybe<Scalars['String']['output']>;
  shippingOriginLabel?: Maybe<Scalars['String']['output']>;
  shippingPrice?: Maybe<Scalars['Float']['output']>;
  status: OrderShipmentStatusEnum;
  trackingCode?: Maybe<Scalars['String']['output']>;
  warehouseId: Scalars['Float']['output'];
  warehouseTitle: Scalars['String']['output'];
};

export type UserProductViewsPaginationOrdersInput = {
  created_at?: InputMaybe<SortOrder>;
};

export type UserProductViewsPaginationOrdersOutput = {
  __typename?: 'UserProductViewsPaginationOrdersOutput';
  created_at?: Maybe<SortOrder>;
};

export type VariantAttrDto = {
  __typename?: 'VariantAttrDto';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type VariantDto = {
  __typename?: 'VariantDto';
  active: Scalars['Boolean']['output'];
  affiliatePrice?: Maybe<Scalars['Float']['output']>;
  allowAutoOffer: Scalars['Boolean']['output'];
  attrs?: Maybe<Array<SVariantAttributeDto>>;
  cashPrice?: Maybe<Scalars['Float']['output']>;
  created_at: Scalars['Date']['output'];
  creditPrice?: Maybe<Scalars['Float']['output']>;
  guarantee: GuaranteeDto;
  guaranteeId: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  maxBasketCount: Scalars['Float']['output'];
  offers: Array<OfferDto>;
  price: Scalars['Float']['output'];
  product: Product;
  productId: Scalars['String']['output'];
  purchasePrice?: Maybe<Scalars['Float']['output']>;
  salesChannel: Array<SalesChannelEnum>;
  stock: Scalars['Float']['output'];
  updated_at: Scalars['Date']['output'];
  warehouse: WarehouseDto;
  warehouseTargetDescription?: Maybe<Scalars['String']['output']>;
  warehouseTargetProductId?: Maybe<Scalars['String']['output']>;
  warehouseTargetProductVariantId?: Maybe<Scalars['String']['output']>;
};

export type VariantIdsArgs = {
  variantIds: Array<Scalars['Float']['input']>;
};

export type VideoDto = {
  __typename?: 'VideoDto';
  active: Scalars['Boolean']['output'];
  address: Scalars['String']['output'];
  basalamVideoId?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  local: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sort: Scalars['Float']['output'];
  thumbnail: Scalars['String']['output'];
};

export type WarehouseDto = {
  __typename?: 'WarehouseDto';
  active: Scalars['Boolean']['output'];
  cashDisplayName?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  created_at: Scalars['Date']['output'];
  creditDisplayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  productUrlPatten?: Maybe<Scalars['String']['output']>;
  profitRanges: Array<ProfitRangeDto>;
  shippingOriginLabel?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updated_at: Scalars['Date']['output'];
};

export type WarehouseShippingMethodDto = {
  __typename?: 'WarehouseShippingMethodDto';
  active: Scalars['Boolean']['output'];
  cashOnDelivery: Scalars['Boolean']['output'];
  cashPrice: Scalars['Float']['output'];
  cities?: Maybe<Array<Scalars['String']['output']>>;
  created_at: Scalars['Date']['output'];
  creditPrice: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  legacyShippingMethodId?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  updated_at: Scalars['Date']['output'];
  warehouseId: Scalars['Float']['output'];
};

export type WheelActivePrizeDto = {
  __typename?: 'WheelActivePrizeDto';
  description?: Maybe<Scalars['String']['output']>;
  discountAmount: Scalars['Float']['output'];
  discountCode: Scalars['String']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  minimumPurchase?: Maybe<Scalars['Float']['output']>;
  prizeType: WheelPrizeType;
  productCode?: Maybe<Scalars['Int']['output']>;
  productTitle?: Maybe<Scalars['String']['output']>;
};

/** دلیل بسته‌بودن چرخش گردونه */
export enum WheelBlockReason {
  ActivePrize = 'ACTIVE_PRIZE',
  CampaignInactive = 'CAMPAIGN_INACTIVE',
  DailyLimit = 'DAILY_LIMIT',
  NeedPurchase = 'NEED_PURCHASE',
  NoPrize = 'NO_PRIZE'
}

export type WheelCampaignDto = {
  __typename?: 'WheelCampaignDto';
  dailySpinLimit: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  minPaidAmountToUnlock: Scalars['Int']['output'];
  prizeExpiryHours: Scalars['Int']['output'];
  prizes: Array<WheelPrizePublicDto>;
  rules: Scalars['String']['output'];
  seoDescription: Scalars['String']['output'];
  seoKeywords: Scalars['String']['output'];
  seoTitle: Scalars['String']['output'];
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type WheelPrizeAdminDto = {
  __typename?: 'WheelPrizeAdminDto';
  available: Scalars['Boolean']['output'];
  color: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  expiryHours?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  maxWins?: Maybe<Scalars['Int']['output']>;
  minimumPurchase?: Maybe<Scalars['Float']['output']>;
  productCode?: Maybe<Scalars['Int']['output']>;
  productTitle?: Maybe<Scalars['String']['output']>;
  sharePercent: Scalars['Float']['output'];
  sortOrder: Scalars['Int']['output'];
  type: WheelPrizeType;
  unavailableReason?: Maybe<Scalars['String']['output']>;
  variantId?: Maybe<Scalars['Int']['output']>;
  weight: Scalars['Int']['output'];
  winCount: Scalars['Int']['output'];
};

export type WheelPrizePublicDto = {
  __typename?: 'WheelPrizePublicDto';
  color: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  minimumPurchase?: Maybe<Scalars['Float']['output']>;
  productCode?: Maybe<Scalars['Int']['output']>;
  productTitle?: Maybe<Scalars['String']['output']>;
  type: WheelPrizeType;
};

/** نوع جایزه گردونه شانس */
export enum WheelPrizeType {
  FixedDiscount = 'FIXED_DISCOUNT',
  FreeShipping = 'FREE_SHIPPING',
  Product = 'PRODUCT'
}

export type WheelSettingsAdminDto = {
  __typename?: 'WheelSettingsAdminDto';
  dailySpinLimit: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  minPaidAmountToUnlock: Scalars['Int']['output'];
  prizeExpiryHours: Scalars['Int']['output'];
  rules: Scalars['String']['output'];
  seoDescription: Scalars['String']['output'];
  seoKeywords: Scalars['String']['output'];
  seoTitle: Scalars['String']['output'];
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type WheelSpinAdminDto = {
  __typename?: 'WheelSpinAdminDto';
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  prizeType: WheelPrizeType;
  productCode?: Maybe<Scalars['Int']['output']>;
  spunAt: Scalars['Date']['output'];
  used: Scalars['Boolean']['output'];
  userName?: Maybe<Scalars['String']['output']>;
  userPhone?: Maybe<Scalars['String']['output']>;
};

export type WheelSpinResultDto = {
  __typename?: 'WheelSpinResultDto';
  color: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discountAmount: Scalars['Float']['output'];
  discountCode: Scalars['String']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  minimumPurchase?: Maybe<Scalars['Float']['output']>;
  prizeId: Scalars['Int']['output'];
  prizeIndex: Scalars['Int']['output'];
  prizeType: WheelPrizeType;
  productCode?: Maybe<Scalars['Int']['output']>;
  productTitle?: Maybe<Scalars['String']['output']>;
  segments: Array<WheelSpinSegmentDto>;
};

export type WheelSpinSegmentDto = {
  __typename?: 'WheelSpinSegmentDto';
  color: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type WheelStatsDto = {
  __typename?: 'WheelStatsDto';
  activePrizeCount: Scalars['Int']['output'];
  expectedCost: Scalars['Float']['output'];
  redeemedSpins: Scalars['Int']['output'];
  spinsToday: Scalars['Int']['output'];
  totalSpins: Scalars['Int']['output'];
};

export type WheelStatusDto = {
  __typename?: 'WheelStatusDto';
  activePrize?: Maybe<WheelActivePrizeDto>;
  blockReason?: Maybe<WheelBlockReason>;
  canSpin: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  nextSpinAt?: Maybe<Scalars['Date']['output']>;
};

export type WheelVariantOptionDto = {
  __typename?: 'WheelVariantOptionDto';
  active: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  productCode: Scalars['Int']['output'];
  stock: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type SearchQueryVariables = Exact<{
  filter?: InputMaybe<ProductsPaginationFiltersInput>;
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<SearchSort>;
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchQuery = { __typename?: 'Query', search: { __typename?: 'PaginatedProductsDto', limit: number, page: number, hasNextPage: boolean, sort?: SearchSort | null, search?: string | null, totalCount: number, totalPages: number, meta?: { __typename?: 'ProductsPaginationMetaOutput', colors?: Array<{ __typename?: 'Color', id: number, hex: string, title: string }> | null, brands?: Array<{ __typename?: 'SBrandDto', id: number, title: string, title_en: string }> | null, targetCategory?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, description?: string | null, shortDescription?: string | null, keywords: Array<string>, svg?: string | null, bgColor?: string | null, image?: { __typename?: 'ImageDto', address: string } | null, children?: Array<{ __typename?: 'CategoryDto', id: number, svg?: string | null, title: string, title_en: string, slug: string, bgColor?: string | null, image?: { __typename?: 'ImageDto', address: string } | null }> | null } | null, categoriesInPath?: Array<{ __typename?: 'SimpleCategoryDto', id: number, slug: string, title: string, title_en: string }> | null, oneLevelUpCategories?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, bgColor?: string | null, image?: { __typename?: 'ImageDto', address: string } | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, bgColor?: string | null, image?: { __typename?: 'ImageDto', address: string } | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, bgColor?: string | null, image?: { __typename?: 'ImageDto', address: string } | null }> | null }> | null }> | null } | null, filter?: { __typename?: 'ProductsPaginationFiltersOutput', colors?: Array<number> | null, brands?: Array<number> | null, hasOffer?: boolean | null, inStock?: boolean | null, maxPrice?: number | null, minPrice?: number | null } | null, items?: Array<{ __typename?: 'SProduct', id: string, title: string, title_en?: string | null, code: number, shortDescription?: string | null, video?: string | null, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null } | null, colors: Array<{ __typename?: 'Color', hex: string, title: string }>, variant?: { __typename?: 'SVariantDto', id: number, stock?: number | null, maxBasketCount: number, price: number, cashPrice?: number | null, creditPrice?: number | null, attrs?: Array<{ __typename?: 'SVariantAttributeDto', name: string, value: string, key: string }> | null, offer?: { __typename?: 'SOfferDto', id: number, end_at: any, maxBasketCount: number, stock?: number | null, percentage: number, price: number, cashPrice?: number | null, creditPrice?: number | null, offerTypeId: number, offerType: { __typename?: 'SOfferTypeDto', title: string } } | null } | null }> | null } };

export type SearchFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchFiltersQuery = { __typename?: 'Query', colors: Array<{ __typename?: 'Color', hex: string, id: number, title: string }>, brands: Array<{ __typename?: 'SBrandDto', id: number, title: string, title_en: string }> };

export type PostWithSlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type PostWithSlugQuery = { __typename?: 'Query', post: { __typename?: 'SinglePost', id: number, title: string, titleEn?: string | null, slug: string, excerpt?: string | null, content: string, readingTime: number, publishedAt?: any | null, tags: Array<string>, seoKeywords?: Array<string> | null, metaTitle?: string | null, metaDescription?: string | null, updatedAt: any, canonicalUrl?: string | null, indexable: boolean, productSectionTitle?: string | null, category: { __typename?: 'SinglePostCategoryDto', id: number, title: string, seo_url: string, slug: string }, coverImage?: { __typename?: 'ImageDto', id: string, address: string, name: string, alt?: string | null } | null, products: Array<{ __typename?: 'SProduct', code: number, video?: string | null, id: string, shortDescription?: string | null, title: string, title_en?: string | null, colors: Array<{ __typename?: 'Color', hex: string, id: number, title: string }>, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null, variant?: { __typename?: 'SVariantDto', guaranteeId: number, id: number, maxBasketCount: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null, attrs?: Array<{ __typename?: 'SVariantAttributeDto', key: string, value: string, name: string }> | null } | null }>, relatedPosts: Array<{ __typename?: 'PostSummaryDto', id: number, title: string, titleEn?: string | null, slug: string, publishedAt?: any | null, category: { __typename?: 'SinglePostCategoryDto', id: number, title: string, seo_url: string, slug: string }, coverImage?: { __typename?: 'ImageDto', id: string, address: string, name: string, alt?: string | null } | null }> } };

export type SearchPostsQueryVariables = Exact<{
  filter?: InputMaybe<PostsPaginationFiltersInput>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<PostSearchSort>;
}>;


export type SearchPostsQuery = { __typename?: 'Query', searchPosts: { __typename?: 'PaginatedPostsDto', hasNextPage: boolean, limit: number, page: number, search?: string | null, sort?: PostSearchSort | null, totalCount: number, totalPages: number, filter?: { __typename?: 'PostsPaginationFiltersOutput', categorySlug?: string | null } | null, meta?: { __typename?: 'PostPaginationMetaOutput', categories: Array<{ __typename?: 'PostCategoryDto', id: number, title: string, title_en: string, slug: string, seo_url: string }> } | null, items?: Array<{ __typename?: 'PostSummaryDto', id: number, publishedAt?: any | null, slug: string, title: string, titleEn?: string | null, updatedAt: any, category: { __typename?: 'SinglePostCategoryDto', id: number, slug: string, title: string, title_en: string }, coverImage?: { __typename?: 'ImageDto', address: string, alt?: string | null, id: string, name: string } | null }> | null } };

export type PaymentResultQueryVariables = Exact<{
  orderId: Scalars['Float']['input'];
  trackId: Scalars['String']['input'];
}>;


export type PaymentResultQuery = { __typename?: 'Query', paymentResult: { __typename?: 'PaymentResultStatusDto', orderId: number, seen: boolean, status: string, trackId: string, refNumber?: string | null, canRetry: boolean, order?: { __typename?: 'UserOrderDto', created_at: any, deliveryTrackingCode?: string | null, discountPrice?: number | null, id: number, initialDate?: any | null, memo?: string | null, shippingPrice?: number | null, status: OrderStatusEnum, totalPrice: number, history: Array<{ __typename?: 'SOrderHistoryDto', created_at: any, id: number, newStatus: OrderStatusEnum, oldStatus: OrderStatusEnum }>, items: Array<{ __typename?: 'SUserOrderItemDto', discountPrice?: number | null, id: number, productTitle: string, productTitleEn?: string | null, quantity: number, totalPrice: number, unitPrice: number, variantGuaranteeId?: number | null, variantGuaranteeTitle?: string | null, product: { __typename?: 'SimpleProductDto', code: number, id: string, title: string, title_en?: string | null, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null }, variantAttrs?: Array<{ __typename?: 'VariantAttrDto', value: string, key: string, name: string }> | null }>, paymentGateway: { __typename?: 'SPaymentGatewayDto', code: string, description?: string | null, id: string, installment: boolean, logoId?: string | null, name: string, logo?: { __typename?: 'ImageDto', address: string, alt?: string | null, id: string, name: string } | null }, paymentMethod: { __typename?: 'SPaymentMethodDto', code: PaymentMethodEnum, description?: string | null, id: string, name: string }, shippingAddress?: { __typename?: 'SShippingAddressDto', address: string, id: string, lat?: number | null, long?: number | null, postalCode?: string | null, recipientFirstName: string, recipientLastName: string, recipientPhoneNumber: string, city?: { __typename?: 'CityDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null } | null, province?: { __typename?: 'ProvinceDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null } | null } | null, shippingMethod?: { __typename?: 'SShippingMethodDto', cashOnDelivery: boolean, cities?: Array<string> | null, description?: string | null, id: number, name: string, price: number } | null } | null } };

export type SCurrentOrderDtoFragmentFragment = { __typename?: 'SCurrentOrderDto', id: number, shippingPrice?: number | null, totalPrice: number, userAddressId?: string | null, shippingMethodId?: number | null, paymentMethodId: string, paymentGatewayId?: string | null, cashOnDelivery: boolean, memo?: string | null, pricingMode?: CartPricingMode | null, shipments?: Array<{ __typename?: 'SOrderShipmentDto', id: number, warehouseId: number, warehouseShippingMethodId?: number | null, shippingPrice?: number | null, status: OrderShipmentStatusEnum, trackingCode?: string | null, warehouseShippingMethod?: { __typename?: 'SWarehouseShippingMethodDto', id: number, warehouseId: number, name: string, description?: string | null, cashOnDelivery: boolean, cashPrice: number, creditPrice: number, price?: number | null, cities?: Array<string> | null } | null }> | null, discount?: { __typename?: 'SDiscountDto', discountAmount: number, discountCode: string } | null, cart: { __typename?: 'SCartDto', discountAmount: number, id: string, pricingMode: CartPricingMode, subtotal: number, totalPrice: number, cartItems: Array<{ __typename?: 'SCartItemDto', discountPrice?: number | null, id: number, offerId?: number | null, productId: string, quantity: number, totalPrice: number, unitPrice: number, variantId: number, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null, product: { __typename?: 'SimpleProductDto', code: number, id: string, title: string, title_en?: string | null, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null }, variant: { __typename?: 'SVariantDto', warehouseId: number, guaranteeId: number, id: number, maxBasketCount: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, attrs?: Array<{ __typename?: 'SVariantAttributeDto', value: string, name: string, key: string }> | null, warehouse?: { __typename?: 'SWarehouseDisplayDto', id: number, title: string, cashDisplayName?: string | null, creditDisplayName?: string | null, shippingOriginLabel?: string | null } | null, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null } }> } };

export type AddDiscountToUserCurrentOrderMutationVariables = Exact<{
  code: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
}>;


export type AddDiscountToUserCurrentOrderMutation = { __typename?: 'Mutation', addDiscountToUserCurrentOrder: { __typename?: 'SCurrentOrderDto', id: number, shippingPrice?: number | null, totalPrice: number, userAddressId?: string | null, shippingMethodId?: number | null, paymentMethodId: string, paymentGatewayId?: string | null, cashOnDelivery: boolean, memo?: string | null, pricingMode?: CartPricingMode | null, shipments?: Array<{ __typename?: 'SOrderShipmentDto', id: number, warehouseId: number, warehouseShippingMethodId?: number | null, shippingPrice?: number | null, status: OrderShipmentStatusEnum, trackingCode?: string | null, warehouseShippingMethod?: { __typename?: 'SWarehouseShippingMethodDto', id: number, warehouseId: number, name: string, description?: string | null, cashOnDelivery: boolean, cashPrice: number, creditPrice: number, price?: number | null, cities?: Array<string> | null } | null }> | null, discount?: { __typename?: 'SDiscountDto', discountAmount: number, discountCode: string } | null, cart: { __typename?: 'SCartDto', discountAmount: number, id: string, pricingMode: CartPricingMode, subtotal: number, totalPrice: number, cartItems: Array<{ __typename?: 'SCartItemDto', discountPrice?: number | null, id: number, offerId?: number | null, productId: string, quantity: number, totalPrice: number, unitPrice: number, variantId: number, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null, product: { __typename?: 'SimpleProductDto', code: number, id: string, title: string, title_en?: string | null, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null }, variant: { __typename?: 'SVariantDto', warehouseId: number, guaranteeId: number, id: number, maxBasketCount: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, attrs?: Array<{ __typename?: 'SVariantAttributeDto', value: string, name: string, key: string }> | null, warehouse?: { __typename?: 'SWarehouseDisplayDto', id: number, title: string, cashDisplayName?: string | null, creditDisplayName?: string | null, shippingOriginLabel?: string | null } | null, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null } }> } } };

export type ConvertCurrentOrderPricingModeMutationVariables = Exact<{
  pricingMode: CartPricingMode;
}>;


export type ConvertCurrentOrderPricingModeMutation = { __typename?: 'Mutation', order: { __typename?: 'SCurrentOrderDto', id: number, shippingPrice?: number | null, totalPrice: number, userAddressId?: string | null, shippingMethodId?: number | null, paymentMethodId: string, paymentGatewayId?: string | null, cashOnDelivery: boolean, memo?: string | null, pricingMode?: CartPricingMode | null, shipments?: Array<{ __typename?: 'SOrderShipmentDto', id: number, warehouseId: number, warehouseShippingMethodId?: number | null, shippingPrice?: number | null, status: OrderShipmentStatusEnum, trackingCode?: string | null, warehouseShippingMethod?: { __typename?: 'SWarehouseShippingMethodDto', id: number, warehouseId: number, name: string, description?: string | null, cashOnDelivery: boolean, cashPrice: number, creditPrice: number, price?: number | null, cities?: Array<string> | null } | null }> | null, discount?: { __typename?: 'SDiscountDto', discountAmount: number, discountCode: string } | null, cart: { __typename?: 'SCartDto', discountAmount: number, id: string, pricingMode: CartPricingMode, subtotal: number, totalPrice: number, cartItems: Array<{ __typename?: 'SCartItemDto', discountPrice?: number | null, id: number, offerId?: number | null, productId: string, quantity: number, totalPrice: number, unitPrice: number, variantId: number, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null, product: { __typename?: 'SimpleProductDto', code: number, id: string, title: string, title_en?: string | null, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null }, variant: { __typename?: 'SVariantDto', warehouseId: number, guaranteeId: number, id: number, maxBasketCount: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, attrs?: Array<{ __typename?: 'SVariantAttributeDto', value: string, name: string, key: string }> | null, warehouse?: { __typename?: 'SWarehouseDisplayDto', id: number, title: string, cashDisplayName?: string | null, creditDisplayName?: string | null, shippingOriginLabel?: string | null } | null, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null } }> } } };

export type GetApoloanEligibilityQueryVariables = Exact<{
  amount: Scalars['Float']['input'];
}>;


export type GetApoloanEligibilityQuery = { __typename?: 'Query', getApoloanEligibility: { __typename?: 'ApoloanInstallmentEligibilityDetails', description: string, eligible: boolean, title_message: string } };

export type GetCheckoutRequirementsQueryVariables = Exact<{
  source?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCheckoutRequirementsQuery = { __typename?: 'Query', paymentMethods: Array<{ __typename?: 'SPaymentMethodDto', id: string, code: PaymentMethodEnum, description?: string | null, name: string }>, shippingMethods: Array<{ __typename?: 'SShippingMethodDto', id: number, name: string, description?: string | null, price: number, cashOnDelivery: boolean, cities?: Array<string> | null, warehouses?: Array<number> | null }>, paymentGateways: Array<{ __typename?: 'SPaymentGatewayDto', description?: string | null, installment: boolean, minAmountToPayment?: number | null, maxAmountToPayment?: number | null, code: string, id: string, logoId?: string | null, name: string, logo?: { __typename?: 'ImageDto', address: string, alt?: string | null } | null }> };

export type GetSnapPayEligibilityQueryVariables = Exact<{
  amount: Scalars['Float']['input'];
}>;


export type GetSnapPayEligibilityQuery = { __typename?: 'Query', getSnapPayEligibility: { __typename?: 'SnappInstallmentEligibilityDetails', description: string, eligible: boolean, title_message: string } };

export type GetTorobPayEligibilityQueryVariables = Exact<{
  amount: Scalars['Float']['input'];
}>;


export type GetTorobPayEligibilityQuery = { __typename?: 'Query', getTorobPayEligibility: { __typename?: 'TorobPayInstallmentEligibilityDetails', description: string, eligible: boolean, title_message: string } };

export type GetUserCurrentOrderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserCurrentOrderQuery = { __typename?: 'Query', order: { __typename?: 'SCurrentOrderDto', id: number, shippingPrice?: number | null, totalPrice: number, userAddressId?: string | null, shippingMethodId?: number | null, paymentMethodId: string, paymentGatewayId?: string | null, cashOnDelivery: boolean, memo?: string | null, pricingMode?: CartPricingMode | null, shipments?: Array<{ __typename?: 'SOrderShipmentDto', id: number, warehouseId: number, warehouseShippingMethodId?: number | null, shippingPrice?: number | null, status: OrderShipmentStatusEnum, trackingCode?: string | null, warehouseShippingMethod?: { __typename?: 'SWarehouseShippingMethodDto', id: number, warehouseId: number, name: string, description?: string | null, cashOnDelivery: boolean, cashPrice: number, creditPrice: number, price?: number | null, cities?: Array<string> | null } | null }> | null, discount?: { __typename?: 'SDiscountDto', discountAmount: number, discountCode: string } | null, cart: { __typename?: 'SCartDto', discountAmount: number, id: string, pricingMode: CartPricingMode, subtotal: number, totalPrice: number, cartItems: Array<{ __typename?: 'SCartItemDto', discountPrice?: number | null, id: number, offerId?: number | null, productId: string, quantity: number, totalPrice: number, unitPrice: number, variantId: number, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null, product: { __typename?: 'SimpleProductDto', code: number, id: string, title: string, title_en?: string | null, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null }, variant: { __typename?: 'SVariantDto', warehouseId: number, guaranteeId: number, id: number, maxBasketCount: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, attrs?: Array<{ __typename?: 'SVariantAttributeDto', value: string, name: string, key: string }> | null, warehouse?: { __typename?: 'SWarehouseDisplayDto', id: number, title: string, cashDisplayName?: string | null, creditDisplayName?: string | null, shippingOriginLabel?: string | null } | null, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null } }> } } };

export type GetWarehouseShippingMethodsQueryVariables = Exact<{
  warehouseId: Scalars['Int']['input'];
  cityId?: InputMaybe<Scalars['String']['input']>;
  pricingMode?: InputMaybe<CartPricingMode>;
}>;


export type GetWarehouseShippingMethodsQuery = { __typename?: 'Query', warehouseShippingMethods: Array<{ __typename?: 'SWarehouseShippingMethodDto', id: number, warehouseId: number, name: string, description?: string | null, cashOnDelivery: boolean, cashPrice: number, creditPrice: number, price?: number | null, cities?: Array<string> | null }> };

export type PayMutationVariables = Exact<{
  orderPayInput: OrderPayInput;
}>;


export type PayMutation = { __typename?: 'Mutation', pay: { __typename?: 'PaymentRequest', payUrl: string } };

export type RemoveDiscountFromUserCurrentOrderMutationVariables = Exact<{
  orderId: Scalars['Float']['input'];
}>;


export type RemoveDiscountFromUserCurrentOrderMutation = { __typename?: 'Mutation', removeDiscountFromUserCurrentOrder: { __typename?: 'SCurrentOrderDto', id: number, shippingPrice?: number | null, totalPrice: number, userAddressId?: string | null, shippingMethodId?: number | null, paymentMethodId: string, paymentGatewayId?: string | null, cashOnDelivery: boolean, memo?: string | null, pricingMode?: CartPricingMode | null, shipments?: Array<{ __typename?: 'SOrderShipmentDto', id: number, warehouseId: number, warehouseShippingMethodId?: number | null, shippingPrice?: number | null, status: OrderShipmentStatusEnum, trackingCode?: string | null, warehouseShippingMethod?: { __typename?: 'SWarehouseShippingMethodDto', id: number, warehouseId: number, name: string, description?: string | null, cashOnDelivery: boolean, cashPrice: number, creditPrice: number, price?: number | null, cities?: Array<string> | null } | null }> | null, discount?: { __typename?: 'SDiscountDto', discountAmount: number, discountCode: string } | null, cart: { __typename?: 'SCartDto', discountAmount: number, id: string, pricingMode: CartPricingMode, subtotal: number, totalPrice: number, cartItems: Array<{ __typename?: 'SCartItemDto', discountPrice?: number | null, id: number, offerId?: number | null, productId: string, quantity: number, totalPrice: number, unitPrice: number, variantId: number, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null, product: { __typename?: 'SimpleProductDto', code: number, id: string, title: string, title_en?: string | null, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null }, variant: { __typename?: 'SVariantDto', warehouseId: number, guaranteeId: number, id: number, maxBasketCount: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, attrs?: Array<{ __typename?: 'SVariantAttributeDto', value: string, name: string, key: string }> | null, warehouse?: { __typename?: 'SWarehouseDisplayDto', id: number, title: string, cashDisplayName?: string | null, creditDisplayName?: string | null, shippingOriginLabel?: string | null } | null, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null } }> } } };

export type UpdateUserCurrentOrderMutationVariables = Exact<{
  orderId: Scalars['Float']['input'];
  updateOrderInput: UpdateOrderInput;
}>;


export type UpdateUserCurrentOrderMutation = { __typename?: 'Mutation', order: { __typename?: 'SCurrentOrderDto', id: number, shippingPrice?: number | null, totalPrice: number, userAddressId?: string | null, shippingMethodId?: number | null, paymentMethodId: string, paymentGatewayId?: string | null, cashOnDelivery: boolean, memo?: string | null, pricingMode?: CartPricingMode | null, shipments?: Array<{ __typename?: 'SOrderShipmentDto', id: number, warehouseId: number, warehouseShippingMethodId?: number | null, shippingPrice?: number | null, status: OrderShipmentStatusEnum, trackingCode?: string | null, warehouseShippingMethod?: { __typename?: 'SWarehouseShippingMethodDto', id: number, warehouseId: number, name: string, description?: string | null, cashOnDelivery: boolean, cashPrice: number, creditPrice: number, price?: number | null, cities?: Array<string> | null } | null }> | null, discount?: { __typename?: 'SDiscountDto', discountAmount: number, discountCode: string } | null, cart: { __typename?: 'SCartDto', discountAmount: number, id: string, pricingMode: CartPricingMode, subtotal: number, totalPrice: number, cartItems: Array<{ __typename?: 'SCartItemDto', discountPrice?: number | null, id: number, offerId?: number | null, productId: string, quantity: number, totalPrice: number, unitPrice: number, variantId: number, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null, product: { __typename?: 'SimpleProductDto', code: number, id: string, title: string, title_en?: string | null, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null }, variant: { __typename?: 'SVariantDto', warehouseId: number, guaranteeId: number, id: number, maxBasketCount: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, attrs?: Array<{ __typename?: 'SVariantAttributeDto', value: string, name: string, key: string }> | null, warehouse?: { __typename?: 'SWarehouseDisplayDto', id: number, title: string, cashDisplayName?: string | null, creditDisplayName?: string | null, shippingOriginLabel?: string | null } | null, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null } }> } } };

export type CartRecommendationsQueryVariables = Exact<{
  input: CartRecommendationsInput;
}>;


export type CartRecommendationsQuery = { __typename?: 'Query', cartRecommendations: { __typename?: 'CartRecommendationsDto', completeTheLook: Array<{ __typename?: 'SProduct', code: number, video?: string | null, id: string, shortDescription?: string | null, title: string, title_en?: string | null, colors: Array<{ __typename?: 'Color', hex: string, id: number, title: string }>, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null, variant?: { __typename?: 'SVariantDto', guaranteeId: number, id: number, maxBasketCount: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null, attrs?: Array<{ __typename?: 'SVariantAttributeDto', key: string, value: string, name: string }> | null } | null }>, offers: Array<{ __typename?: 'SProduct', code: number, video?: string | null, id: string, shortDescription?: string | null, title: string, title_en?: string | null, colors: Array<{ __typename?: 'Color', hex: string, id: number, title: string }>, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null, variant?: { __typename?: 'SVariantDto', guaranteeId: number, id: number, maxBasketCount: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null, attrs?: Array<{ __typename?: 'SVariantAttributeDto', key: string, value: string, name: string }> | null } | null }> } };

export type MyWheelStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type MyWheelStatusQuery = { __typename?: 'Query', myWheelStatus: { __typename?: 'WheelStatusDto', canSpin: boolean, blockReason?: WheelBlockReason | null, message: string, nextSpinAt?: any | null, activePrize?: { __typename?: 'WheelActivePrizeDto', description?: string | null, discountAmount: number, discountCode: string, endDate?: any | null, imageUrl?: string | null, label: string, minimumPurchase?: number | null, prizeType: WheelPrizeType, productCode?: number | null, productTitle?: string | null } | null } };

export type SpinWheelMutationVariables = Exact<{ [key: string]: never; }>;


export type SpinWheelMutation = { __typename?: 'Mutation', spinWheel: { __typename?: 'WheelSpinResultDto', color: string, description?: string | null, discountAmount: number, discountCode: string, endDate?: any | null, imageUrl?: string | null, label: string, minimumPurchase?: number | null, prizeId: number, prizeIndex: number, prizeType: WheelPrizeType, productCode?: number | null, productTitle?: string | null, segments: Array<{ __typename?: 'WheelSpinSegmentDto', color: string, id: number, label: string }> } };

export type WheelCampaignQueryVariables = Exact<{ [key: string]: never; }>;


export type WheelCampaignQuery = { __typename?: 'Query', wheelCampaign: { __typename?: 'WheelCampaignDto', dailySpinLimit: number, isActive: boolean, minPaidAmountToUnlock: number, prizeExpiryHours: number, rules: string, seoDescription: string, seoKeywords: string, seoTitle: string, subtitle: string, title: string, prizes: Array<{ __typename?: 'WheelPrizePublicDto', color: string, description?: string | null, discountAmount?: number | null, id: number, imageUrl?: string | null, label: string, minimumPurchase?: number | null, productCode?: number | null, productTitle?: string | null, type: WheelPrizeType }> } };

export type ConvertCartPricingModeMutationVariables = Exact<{
  pricingMode: CartPricingMode;
}>;


export type ConvertCartPricingModeMutation = { __typename?: 'Mutation', convertCartPricingMode: { __typename?: 'SCartDto', id: string, pricingMode: CartPricingMode } };

export type SearchRelatedProductsQueryVariables = Exact<{
  searchRelatedProductsId: Scalars['String']['input'];
}>;


export type SearchRelatedProductsQuery = { __typename?: 'Query', searchRelatedProducts: Array<{ __typename?: 'SProduct', code: number, video?: string | null, id: string, shortDescription?: string | null, title: string, title_en?: string | null, colors: Array<{ __typename?: 'Color', hex: string, id: number, title: string }>, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null, variant?: { __typename?: 'SVariantDto', guaranteeId: number, id: number, maxBasketCount: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, attrs?: Array<{ __typename?: 'SVariantAttributeDto', key: string, value: string, name: string }> | null, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null } | null }> };

export type SearchRelatedProductsByCodeQueryVariables = Exact<{
  code: Scalars['Float']['input'];
}>;


export type SearchRelatedProductsByCodeQuery = { __typename?: 'Query', searchRelatedProductsByCode: Array<{ __typename?: 'SProduct', code: number, video?: string | null, id: string, shortDescription?: string | null, title: string, title_en?: string | null, colors: Array<{ __typename?: 'Color', hex: string, id: number, title: string }>, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null, variant?: { __typename?: 'SVariantDto', guaranteeId: number, id: number, maxBasketCount: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null, attrs?: Array<{ __typename?: 'SVariantAttributeDto', key: string, value: string, name: string }> | null } | null }> };

export type SingleProductQueryVariables = Exact<{
  code: Scalars['Float']['input'];
}>;


export type SingleProductQuery = { __typename?: 'Query', product: { __typename?: 'SingleProduct', id: string, title: string, code: number, title_en?: string | null, brandId: number, shortDescription?: string | null, description?: string | null, features: Array<string>, keywords: Array<string>, videos: Array<{ __typename?: 'SVideoDto', address: string, id: string, sort: number, thumbnail: string }>, category: { __typename?: 'CategoryDto', slug: string, title: string, guideTitle?: string | null, guideContent?: string | null, parent?: { __typename?: 'CategoryDto', title: string, slug: string, parent?: { __typename?: 'CategoryDto', title: string, slug: string, parent?: { __typename?: 'CategoryDto', title: string, slug: string, parent?: { __typename?: 'CategoryDto', title: string, slug: string, parent?: { __typename?: 'CategoryDto', title: string, slug: string, parent?: { __typename?: 'CategoryDto', title: string, slug: string, parent?: { __typename?: 'CategoryDto', title: string, slug: string, parent?: { __typename?: 'CategoryDto', title: string, slug: string, parent?: { __typename?: 'CategoryDto', title: string, slug: string, parent?: { __typename?: 'CategoryDto', title: string, slug: string } | null } | null } | null } | null } | null } | null } | null } | null } | null } | null }, brand: { __typename?: 'SBrandDto', id: number, title: string, title_en: string, image?: { __typename?: 'SImageDto', address: string, alt?: string | null } | null }, specifications: Array<{ __typename?: 'SSpecificationDto', id: string, title: string, type: SpecificationType, text?: string | null, checked?: boolean | null, sort: number }>, tags: Array<{ __typename?: 'STagDto', id: number, title: string }>, images: Array<{ __typename?: 'ProductImage', address: string, alt?: string | null, id: string, name: string, isMain: boolean }>, variants: Array<{ __typename?: 'SVariantDto', hasStock: boolean, guaranteeId: number, id: number, stock?: number | null, price: number, cashPrice?: number | null, creditPrice?: number | null, warehouseId: number, maxBasketCount: number, attrs?: Array<{ __typename?: 'SVariantAttributeDto', name: string, value: string, key: string }> | null, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, warehouse?: { __typename?: 'SWarehouseDisplayDto', id: number, title: string, cashDisplayName?: string | null, creditDisplayName?: string | null, shippingOriginLabel?: string | null } | null, offer?: { __typename?: 'SOfferDto', id: number, end_at: any, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, maxBasketCount: number, percentage: number, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null }> } };

export type CitiesQueryVariables = Exact<{
  provinceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CitiesQuery = { __typename?: 'Query', cities: Array<{ __typename?: 'CityDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null }> };

export type CreateUserAddressMutationVariables = Exact<{
  createUserAddressInput: CreateUserAddressInput;
}>;


export type CreateUserAddressMutation = { __typename?: 'Mutation', createUserAddress: { __typename?: 'UserAddressDto', address: string, cityId: string, id: string, isDefault: boolean, lat?: number | null, long?: number | null, postalCode?: string | null, provinceId: string, recipientFirstName: string, recipientLastName: string, recipientPhoneNumber: string, city: { __typename?: 'CityDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null }, province: { __typename?: 'ProvinceDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null } } };

export type ProvincesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProvincesQuery = { __typename?: 'Query', provinces: Array<{ __typename?: 'ProvinceDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null }> };

export type RemoveUserAddressMutationVariables = Exact<{
  removeUserAddressId: Scalars['String']['input'];
}>;


export type RemoveUserAddressMutation = { __typename?: 'Mutation', removeUserAddress: { __typename?: 'UserAddressDto', address: string, cityId: string, id: string, isDefault: boolean, lat?: number | null, long?: number | null, postalCode?: string | null, provinceId: string, recipientFirstName: string, recipientLastName: string, recipientPhoneNumber: string, city: { __typename?: 'CityDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null }, province: { __typename?: 'ProvinceDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null } } };

export type ToggleUserAddressIsDefaultMutationVariables = Exact<{
  toggleUserAddressIsDefaultId: Scalars['String']['input'];
}>;


export type ToggleUserAddressIsDefaultMutation = { __typename?: 'Mutation', toggleUserAddressIsDefault: { __typename?: 'UserAddressDto', address: string, cityId: string, id: string, isDefault: boolean, lat?: number | null, long?: number | null, postalCode?: string | null, provinceId: string, recipientFirstName: string, recipientLastName: string, recipientPhoneNumber: string, city: { __typename?: 'CityDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null }, province: { __typename?: 'ProvinceDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null } } };

export type UpdateUserAddressMutationVariables = Exact<{
  updateUserAddressId: Scalars['String']['input'];
  updateUserAddressInput: UpdateUserAddressInput;
}>;


export type UpdateUserAddressMutation = { __typename?: 'Mutation', updateUserAddress: { __typename?: 'UserAddressDto', address: string, cityId: string, id: string, isDefault: boolean, lat?: number | null, long?: number | null, postalCode?: string | null, provinceId: string, recipientFirstName: string, recipientLastName: string, recipientPhoneNumber: string, city: { __typename?: 'CityDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null }, province: { __typename?: 'ProvinceDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null } } };

export type UserAddressQueryVariables = Exact<{
  userAddressId: Scalars['String']['input'];
}>;


export type UserAddressQuery = { __typename?: 'Query', userAddress: { __typename?: 'UserAddressDto', address: string, cityId: string, id: string, isDefault: boolean, lat?: number | null, long?: number | null, postalCode?: string | null, provinceId: string, recipientFirstName: string, recipientLastName: string, recipientPhoneNumber: string, city: { __typename?: 'CityDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null }, province: { __typename?: 'ProvinceDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null } } };

export type UserAddressesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserAddressesQuery = { __typename?: 'Query', userAddresses: Array<{ __typename?: 'UserAddressDto', address: string, cityId: string, id: string, isDefault: boolean, lat?: number | null, long?: number | null, postalCode?: string | null, provinceId: string, recipientFirstName: string, recipientLastName: string, recipientPhoneNumber: string, city: { __typename?: 'CityDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null }, province: { __typename?: 'ProvinceDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null } }> };

export type UpdateMeMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateMeMutation = { __typename?: 'Mutation', updateMe: { __typename?: 'User', id: number, birth_date?: any | null, firstName?: string | null, lastName?: string | null, phoneNumber: string } };

export type UserOrderQueryVariables = Exact<{
  userOrderId: Scalars['Float']['input'];
}>;


export type UserOrderQuery = { __typename?: 'Query', userOrder: { __typename?: 'UserOrderDto', created_at: any, deliveryTrackingCode?: string | null, discountPrice?: number | null, id: number, initialDate?: any | null, memo?: string | null, shippingPrice?: number | null, status: OrderStatusEnum, totalPrice: number, history: Array<{ __typename?: 'SOrderHistoryDto', created_at: any, id: number, newStatus: OrderStatusEnum, oldStatus: OrderStatusEnum }>, items: Array<{ __typename?: 'SUserOrderItemDto', discountPrice?: number | null, id: number, warehouseId: number, productTitle: string, productTitleEn?: string | null, quantity: number, totalPrice: number, unitPrice: number, variantGuaranteeId?: number | null, variantGuaranteeTitle?: string | null, product: { __typename?: 'SimpleProductDto', code: number, id: string, title: string, title_en?: string | null, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null } | null }, variantAttrs?: Array<{ __typename?: 'VariantAttrDto', value: string, name: string, key: string }> | null }>, paymentGateway: { __typename?: 'SPaymentGatewayDto', description?: string | null, id: string, installment: boolean, logoId?: string | null, name: string, logo?: { __typename?: 'ImageDto', address: string, alt?: string | null } | null }, paymentMethod: { __typename?: 'SPaymentMethodDto', code: PaymentMethodEnum, description?: string | null, id: string, name: string }, shippingAddress?: { __typename?: 'SShippingAddressDto', address: string, id: string, lat?: number | null, long?: number | null, postalCode?: string | null, cityName?: string | null, provinceName?: string | null, recipientFirstName: string, recipientLastName: string, recipientPhoneNumber: string, city?: { __typename?: 'CityDto', name: string } | null, province?: { __typename?: 'ProvinceDto', name: string } | null } | null, shippingMethod?: { __typename?: 'SShippingMethodDto', id: number, cashOnDelivery: boolean, name: string } | null, shipments?: Array<{ __typename?: 'UserOrderShipmentDto', id: number, warehouseId: number, warehouseTitle: string, shippingOriginLabel?: string | null, shippingMethodName?: string | null, cashOnDelivery: boolean, shippingPrice?: number | null, status: OrderShipmentStatusEnum, trackingCode?: string | null, legacyShippingMethodId?: number | null }> | null } };

export type UserOrdersQueryVariables = Exact<{
  filter?: InputMaybe<SOrdersPaginationFiltersInput>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
}>;


export type UserOrdersQuery = { __typename?: 'Query', userOrders: { __typename?: 'PaginatedSOrdersDto', hasNextPage: boolean, limit: number, page: number, totalCount: number, totalPages: number, filter?: { __typename?: 'SOrdersPaginationFiltersOutput', status?: OrderFilterStatusEnum | null } | null, items?: Array<{ __typename?: 'SOrderDto', id: number, totalPrice: number, created_at: any, initialDate?: any | null, status: OrderStatusEnum, items: Array<{ __typename?: 'SOrderItemDto', id: number, quantity: number, productTitle: string, productTitleEn?: string | null, product: { __typename?: 'SimpleProductDto', id: string, code: number, title: string, title_en?: string | null, mainImage?: { __typename?: 'SImageDto', address: string } | null } }> }> | null, meta: { __typename?: 'SOrdersPaginationMeta', cancelled: number, delivered: number, inprogress: number, returned: number } } };

export type UserProductViewsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  orderBy?: InputMaybe<UserProductViewsPaginationOrdersInput>;
  page: Scalars['Int']['input'];
}>;


export type UserProductViewsQuery = { __typename?: 'Query', userProductViews: { __typename?: 'PaginatedUserProductViewsDto', hasNextPage: boolean, limit: number, page: number, totalCount: number, totalPages: number, items?: Array<{ __typename?: 'SProduct', id: string, code: number, video?: string | null, shortDescription?: string | null, title: string, title_en?: string | null, mainImage?: { __typename?: 'SImageDto', address: string } | null, variant?: { __typename?: 'SVariantDto', guaranteeId: number, id: number, maxBasketCount: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null, attrs?: Array<{ __typename?: 'SVariantAttributeDto', key: string, value: string, name: string }> | null } | null }> | null, orderBy?: { __typename?: 'UserProductViewsPaginationOrdersOutput', created_at?: SortOrder | null } | null } };

export type UserOrdersMetaQueryVariables = Exact<{ [key: string]: never; }>;


export type UserOrdersMetaQuery = { __typename?: 'Query', userOrdersMeta: { __typename?: 'SOrdersPaginationMeta', cancelled: number, delivered: number, inprogress: number, returned: number } };

export type HomePageDataQueryVariables = Exact<{
  categoryId: Scalars['Int']['input'];
}>;


export type HomePageDataQuery = { __typename?: 'Query', homePageData: { __typename?: 'HomePageDataDto', mostOfferProducts: Array<{ __typename?: 'SProduct', code: number, shortDescription?: string | null, video?: string | null, id: string, title: string, title_en?: string | null, colors: Array<{ __typename?: 'Color', hex: string, id: number, title: string }>, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null, variant?: { __typename?: 'SVariantDto', guaranteeId: number, id: number, hasStock: boolean, maxBasketCount: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null } | null }>, mostSaleProducts: Array<{ __typename?: 'SProduct', code: number, shortDescription?: string | null, video?: string | null, id: string, title: string, title_en?: string | null, colors: Array<{ __typename?: 'Color', hex: string, id: number, title: string }>, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null, variant?: { __typename?: 'SVariantDto', guaranteeId: number, id: number, hasStock: boolean, maxBasketCount: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null } | null }>, categoryFilteredProducts: Array<{ __typename?: 'SProduct', code: number, shortDescription?: string | null, video?: string | null, id: string, title: string, title_en?: string | null, colors: Array<{ __typename?: 'Color', hex: string, id: number, title: string }>, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null, variant?: { __typename?: 'SVariantDto', guaranteeId: number, id: number, hasStock: boolean, maxBasketCount: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null } | null }> } };

export type ProductFragment = { __typename?: 'SProduct', code: number, shortDescription?: string | null, video?: string | null, id: string, title: string, title_en?: string | null, colors: Array<{ __typename?: 'Color', hex: string, id: number, title: string }>, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null, variant?: { __typename?: 'SVariantDto', guaranteeId: number, id: number, hasStock: boolean, maxBasketCount: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null } | null };

export type SearchByCategoryIdQueryVariables = Exact<{
  searchByCategoryId: Scalars['Int']['input'];
}>;


export type SearchByCategoryIdQuery = { __typename?: 'Query', products: Array<{ __typename?: 'SProduct', code: number, shortDescription?: string | null, video?: string | null, id: string, title: string, title_en?: string | null, colors: Array<{ __typename?: 'Color', hex: string, id: number, title: string }>, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null, variant?: { __typename?: 'SVariantDto', hasStock: boolean, guaranteeId: number, id: number, maxBasketCount: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null } | null }> };

export type SearchMostOfferQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchMostOfferQuery = { __typename?: 'Query', products: Array<{ __typename?: 'SProduct', code: number, shortDescription?: string | null, video?: string | null, id: string, title: string, title_en?: string | null, colors: Array<{ __typename?: 'Color', hex: string, id: number, title: string }>, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null, variant?: { __typename?: 'SVariantDto', guaranteeId: number, id: number, maxBasketCount: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null } | null }> };

export type SearchMostSaleQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchMostSaleQuery = { __typename?: 'Query', products: Array<{ __typename?: 'SProduct', code: number, shortDescription?: string | null, video?: string | null, id: string, title: string, title_en?: string | null, colors: Array<{ __typename?: 'Color', hex: string, id: number, title: string }>, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null, variant?: { __typename?: 'SVariantDto', guaranteeId: number, id: number, maxBasketCount: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, guarantee: { __typename?: 'SGuaranteeDto', id: number, title: string }, offer?: { __typename?: 'SOfferDto', end_at: any, id: number, maxBasketCount: number, offerTypeId: number, percentage: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock?: number | null, offerType: { __typename?: 'SOfferTypeDto', id: number, title: string } } | null } | null }> };

export type GetPaymentGatewaysOfProductQueryVariables = Exact<{
  source?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPaymentGatewaysOfProductQuery = { __typename?: 'Query', paymentGateways: Array<{ __typename?: 'SPaymentGatewayDto', installment: boolean, name: string, logo?: { __typename?: 'ImageDto', address: string } | null }> };

export type CategoryFieldNameFragment = { __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, bgColor?: string | null, image?: { __typename?: 'ImageDto', address: string } | null };

export type CategoriesRecursiveItemsFragment = { __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, bgColor?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, bgColor?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, bgColor?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, bgColor?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, bgColor?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, bgColor?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, bgColor?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, bgColor?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, bgColor?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, bgColor?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, bgColor?: string | null, image?: { __typename?: 'ImageDto', address: string } | null }> | null, image?: { __typename?: 'ImageDto', address: string } | null }> | null, image?: { __typename?: 'ImageDto', address: string } | null }> | null, image?: { __typename?: 'ImageDto', address: string } | null }> | null, image?: { __typename?: 'ImageDto', address: string } | null }> | null, image?: { __typename?: 'ImageDto', address: string } | null }> | null, image?: { __typename?: 'ImageDto', address: string } | null }> | null, image?: { __typename?: 'ImageDto', address: string } | null }> | null, image?: { __typename?: 'ImageDto', address: string } | null }> | null, image?: { __typename?: 'ImageDto', address: string } | null }> | null, image?: { __typename?: 'ImageDto', address: string } | null };

export type MenuQueryVariables = Exact<{ [key: string]: never; }>;


export type MenuQuery = { __typename?: 'Query', menu: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, bgColor?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, bgColor?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, bgColor?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, bgColor?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, bgColor?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, bgColor?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, bgColor?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, bgColor?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, bgColor?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, bgColor?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, slug: string, svg?: string | null, bgColor?: string | null, image?: { __typename?: 'ImageDto', address: string } | null }> | null, image?: { __typename?: 'ImageDto', address: string } | null }> | null, image?: { __typename?: 'ImageDto', address: string } | null }> | null, image?: { __typename?: 'ImageDto', address: string } | null }> | null, image?: { __typename?: 'ImageDto', address: string } | null }> | null, image?: { __typename?: 'ImageDto', address: string } | null }> | null, image?: { __typename?: 'ImageDto', address: string } | null }> | null, image?: { __typename?: 'ImageDto', address: string } | null }> | null, image?: { __typename?: 'ImageDto', address: string } | null }> | null, image?: { __typename?: 'ImageDto', address: string } | null }> | null, image?: { __typename?: 'ImageDto', address: string } | null }> };

export type SearchTermQueryVariables = Exact<{
  input: SearchTermRequestInput;
}>;


export type SearchTermQuery = { __typename?: 'Query', searchTerm: { __typename?: 'SearchTermResultDto', categories: Array<{ __typename?: 'SimpleCategoryWithSlugPathDto', id: number, path: string, slug: string, title: string, title_en: string, parentTitle: string }>, products: Array<{ __typename?: 'SimpleProductWithCategoryDto', code: number, id: string, title: string, title_en?: string | null, category: { __typename?: 'SimpleCategoryDto', id: number, slug: string, title: string, title_en: string }, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null }> } };

export type TopBannerQueryVariables = Exact<{ [key: string]: never; }>;


export type TopBannerQuery = { __typename?: 'Query', topBanner?: { __typename?: 'TopBannerPublicDto', action: TopBannerAction, backgroundColor: string, dialogBody: string, dialogButtonLabel: string, dialogButtonUrl?: string | null, dialogImageAlt: string, dialogImageUrl?: string | null, dialogTitle: string, imageAlt: string, imageUrl: string, kind: TopBannerKind, linkUrl?: string | null, openInNewTab: boolean, textAnimation: TopBannerTextAnimation, textColor: string, textLines: Array<string> } | null };

export type CreateImageMutationVariables = Exact<{
  input: CreateImageInput;
}>;


export type CreateImageMutation = { __typename?: 'Mutation', createImage: { __typename?: 'ImageDto', id: string, address: string, alt?: string | null, name: string } };

export type UpdateImageMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateImageInput;
}>;


export type UpdateImageMutation = { __typename?: 'Mutation', updateImage: { __typename?: 'ImageDto', id: string, address: string, alt?: string | null, name: string } };

export type AiImageGenerationJobQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AiImageGenerationJobQuery = { __typename?: 'Query', aiImageGenerationJob?: { __typename?: 'AiImageGenerationJobDto', id: string, prompt: string, productId: string, imageUrls?: Array<string> | null, imageIds?: Array<string> | null, generatedImageIds?: Array<string> | null, status: AiImageGenerationJobStatus, progress: number, message?: string | null, error?: string | null, errorCode?: string | null, model?: string | null, inputTokens?: number | null, outputTokens?: number | null, totalTokens?: number | null, inputImageTokens?: number | null, inputTextTokens?: number | null, estimatedCostUsd?: number | null, createdAt: any, updatedAt: any } | null };

export type AiImageGenerationJobByProductIdQueryVariables = Exact<{
  productId: Scalars['String']['input'];
}>;


export type AiImageGenerationJobByProductIdQuery = { __typename?: 'Query', aiImageGenerationJobByProductId?: { __typename?: 'AiImageGenerationJobDto', id: string, prompt: string, productId: string, imageUrls?: Array<string> | null, imageIds?: Array<string> | null, generatedImageIds?: Array<string> | null, status: AiImageGenerationJobStatus, progress: number, message?: string | null, error?: string | null, errorCode?: string | null, model?: string | null, inputTokens?: number | null, outputTokens?: number | null, totalTokens?: number | null, inputImageTokens?: number | null, inputTextTokens?: number | null, estimatedCostUsd?: number | null, createdAt: any, updatedAt: any } | null };

export type AiImageGenerationJobsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AiImageGenerationJobsQuery = { __typename?: 'Query', aiImageGenerationJobs: { __typename?: 'PaginatedAdminAiImageGenerationJobsDto', page: number, limit: number, totalCount: number, totalPages: number, hasNextPage: boolean, items: Array<{ __typename?: 'AiImageGenerationJobDto', id: string, prompt: string, productId: string, imageUrls?: Array<string> | null, imageIds?: Array<string> | null, generatedImageIds?: Array<string> | null, status: AiImageGenerationJobStatus, progress: number, message?: string | null, error?: string | null, errorCode?: string | null, model?: string | null, inputTokens?: number | null, outputTokens?: number | null, totalTokens?: number | null, inputImageTokens?: number | null, inputTextTokens?: number | null, estimatedCostUsd?: number | null, createdAt: any, updatedAt: any }> } };

export type CreateAiImageGenerationJobMutationVariables = Exact<{
  input: CreateAiImageGenerationJobInput;
}>;


export type CreateAiImageGenerationJobMutation = { __typename?: 'Mutation', createAiImageGenerationJob: { __typename?: 'AiImageGenerationJobDto', id: string, prompt: string, productId: string, status: AiImageGenerationJobStatus, createdAt: any, updatedAt: any } };

export type ReloadAiImageGenerationJobMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ReloadAiImageGenerationJobMutation = { __typename?: 'Mutation', reloadAiImageGenerationJob: boolean };

export type RemoveAiImageGenerationJobMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RemoveAiImageGenerationJobMutation = { __typename?: 'Mutation', removeAiImageGenerationJob: boolean };

export type AdminBrandsQueryVariables = Exact<{
  orderBy?: InputMaybe<AdminBrandsPaginationOrdersInput>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminBrandsQuery = { __typename?: 'Query', brands: { __typename?: 'PaginatedAdminBrandsDto', limit: number, hasNextPage: boolean, page: number, search?: string | null, totalCount: number, totalPages: number, orderBy?: { __typename?: 'AdminBrandsPaginationOrdersOutput', title?: SortOrder | null, title_en?: SortOrder | null, created_at?: SortOrder | null, updated_at?: SortOrder | null } | null, items?: Array<{ __typename?: 'BrandDto', id: number, title: string, title_en: string, imageId?: string | null, created_at: any, updated_at: any, image?: { __typename?: 'ImageDto', address: string, alt?: string | null, id: string } | null }> | null } };

export type CreateBrandMutationVariables = Exact<{
  input: CreateBrandInput;
}>;


export type CreateBrandMutation = { __typename?: 'Mutation', createBrand: { __typename?: 'BrandDto', title: string, id: number, title_en: string, created_at: any, updated_at: any } };

export type RemoveBrandMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveBrandMutation = { __typename?: 'Mutation', removeBrand: { __typename?: 'BrandDto', title: string, id: number, created_at: any, updated_at: any, title_en: string } };

export type UpdateBrandMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateBrandInput;
}>;


export type UpdateBrandMutation = { __typename?: 'Mutation', updateBrand: { __typename?: 'BrandDto', title: string, title_en: string, id: number, created_at: any, updated_at: any } };

export type CategoryFieldsFragment = { __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, basalamCategoryId?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, bgColor?: string | null, imageId?: string | null, image?: { __typename?: 'ImageDto', address: string, id: string, alt?: string | null, name: string, local: boolean } | null };

export type CategoriesRecursiveFragment = { __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, basalamCategoryId?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, bgColor?: string | null, imageId?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, basalamCategoryId?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, bgColor?: string | null, imageId?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, basalamCategoryId?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, bgColor?: string | null, imageId?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, basalamCategoryId?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, bgColor?: string | null, imageId?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, basalamCategoryId?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, bgColor?: string | null, imageId?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, basalamCategoryId?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, bgColor?: string | null, imageId?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, basalamCategoryId?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, bgColor?: string | null, imageId?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, basalamCategoryId?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, bgColor?: string | null, imageId?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, basalamCategoryId?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, bgColor?: string | null, imageId?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, basalamCategoryId?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, bgColor?: string | null, imageId?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, basalamCategoryId?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, bgColor?: string | null, imageId?: string | null, image?: { __typename?: 'ImageDto', address: string, id: string, alt?: string | null, name: string, local: boolean } | null }> | null, image?: { __typename?: 'ImageDto', address: string, id: string, alt?: string | null, name: string, local: boolean } | null }> | null, image?: { __typename?: 'ImageDto', address: string, id: string, alt?: string | null, name: string, local: boolean } | null }> | null, image?: { __typename?: 'ImageDto', address: string, id: string, alt?: string | null, name: string, local: boolean } | null }> | null, image?: { __typename?: 'ImageDto', address: string, id: string, alt?: string | null, name: string, local: boolean } | null }> | null, image?: { __typename?: 'ImageDto', address: string, id: string, alt?: string | null, name: string, local: boolean } | null }> | null, image?: { __typename?: 'ImageDto', address: string, id: string, alt?: string | null, name: string, local: boolean } | null }> | null, image?: { __typename?: 'ImageDto', address: string, id: string, alt?: string | null, name: string, local: boolean } | null }> | null, image?: { __typename?: 'ImageDto', address: string, id: string, alt?: string | null, name: string, local: boolean } | null }> | null, image?: { __typename?: 'ImageDto', address: string, id: string, alt?: string | null, name: string, local: boolean } | null }> | null, image?: { __typename?: 'ImageDto', address: string, id: string, alt?: string | null, name: string, local: boolean } | null };

export type CategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, basalamCategoryId?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, bgColor?: string | null, imageId?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, basalamCategoryId?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, bgColor?: string | null, imageId?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, basalamCategoryId?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, bgColor?: string | null, imageId?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, basalamCategoryId?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, bgColor?: string | null, imageId?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, basalamCategoryId?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, bgColor?: string | null, imageId?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, basalamCategoryId?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, bgColor?: string | null, imageId?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, basalamCategoryId?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, bgColor?: string | null, imageId?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, basalamCategoryId?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, bgColor?: string | null, imageId?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, basalamCategoryId?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, bgColor?: string | null, imageId?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, basalamCategoryId?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, bgColor?: string | null, imageId?: string | null, children?: Array<{ __typename?: 'CategoryDto', id: number, title: string, title_en: string, snappCommissionType?: number | null, basalamCategoryId?: number | null, active: boolean, sort?: number | null, svg?: string | null, slug: string, guideContent?: string | null, guideTitle?: string | null, bgColor?: string | null, imageId?: string | null, image?: { __typename?: 'ImageDto', address: string, id: string, alt?: string | null, name: string, local: boolean } | null }> | null, image?: { __typename?: 'ImageDto', address: string, id: string, alt?: string | null, name: string, local: boolean } | null }> | null, image?: { __typename?: 'ImageDto', address: string, id: string, alt?: string | null, name: string, local: boolean } | null }> | null, image?: { __typename?: 'ImageDto', address: string, id: string, alt?: string | null, name: string, local: boolean } | null }> | null, image?: { __typename?: 'ImageDto', address: string, id: string, alt?: string | null, name: string, local: boolean } | null }> | null, image?: { __typename?: 'ImageDto', address: string, id: string, alt?: string | null, name: string, local: boolean } | null }> | null, image?: { __typename?: 'ImageDto', address: string, id: string, alt?: string | null, name: string, local: boolean } | null }> | null, image?: { __typename?: 'ImageDto', address: string, id: string, alt?: string | null, name: string, local: boolean } | null }> | null, image?: { __typename?: 'ImageDto', address: string, id: string, alt?: string | null, name: string, local: boolean } | null }> | null, image?: { __typename?: 'ImageDto', address: string, id: string, alt?: string | null, name: string, local: boolean } | null }> | null, image?: { __typename?: 'ImageDto', address: string, id: string, alt?: string | null, name: string, local: boolean } | null }> };

export type CategoryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type CategoryQuery = { __typename?: 'Query', category: { __typename?: 'CategoryDto', id: number, slug: string, sort?: number | null, svg?: string | null, title: string, title_en: string, description?: string | null, shortDescription?: string | null, snappCommissionType?: number | null, basalamCategoryId?: number | null, keywords: Array<string>, active: boolean, guideContent?: string | null, guideTitle?: string | null, bgColor?: string | null, imageId?: string | null, image?: { __typename?: 'ImageDto', address: string, id: string, alt?: string | null, name: string, local: boolean } | null } };

export type CreateCategoryMutationVariables = Exact<{
  input: CreateCategoryInput;
}>;


export type CreateCategoryMutation = { __typename?: 'Mutation', createCategory: { __typename?: 'CategoryDto', id: number } };

export type GetBasalamCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBasalamCategoriesQuery = { __typename?: 'Query', categories: { __typename?: 'BasalamCategoriesResponse', data: Array<{ __typename?: 'BasalamCategoryLV12Response', id: number, max_preparation_days?: number | null, title: string, unit_type?: { __typename?: 'BasalamUnitTypeResponse', id: number, name?: string | null, title: string, value?: number | null } | null, children?: Array<{ __typename?: 'BasalamCategoryLV12Response', id: number, max_preparation_days?: number | null, title: string, unit_type?: { __typename?: 'BasalamUnitTypeResponse', id: number, name?: string | null, title: string, value?: number | null } | null, children?: Array<{ __typename?: 'BasalamCategoryLV12Response', id: number, max_preparation_days?: number | null, title: string, unit_type?: { __typename?: 'BasalamUnitTypeResponse', id: number, name?: string | null, title: string, value?: number | null } | null, children?: Array<{ __typename?: 'BasalamCategoryLV12Response', id: number, max_preparation_days?: number | null, title: string, unit_type?: { __typename?: 'BasalamUnitTypeResponse', id: number, name?: string | null, title: string, value?: number | null } | null, children?: Array<{ __typename?: 'BasalamCategoryLV12Response', id: number, max_preparation_days?: number | null, title: string, unit_type?: { __typename?: 'BasalamUnitTypeResponse', id: number, name?: string | null, title: string, value?: number | null } | null }> | null }> | null }> | null }> | null }> } };

export type MoveCategoryMutationVariables = Exact<{
  input: MoveCategoryInput;
}>;


export type MoveCategoryMutation = { __typename?: 'Mutation', moveCategory: { __typename?: 'CategoryDto', id: number } };

export type RemoveCategoryMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveCategoryMutation = { __typename?: 'Mutation', removeCategory: { __typename?: 'AppMessage', success: boolean } };

export type UpdateCategoryMutationVariables = Exact<{
  input: UpdateCategoryInput;
}>;


export type UpdateCategoryMutation = { __typename?: 'Mutation', updateCategory: { __typename?: 'CategoryDto', id: number } };

export type ColorsQueryVariables = Exact<{ [key: string]: never; }>;


export type ColorsQuery = { __typename?: 'Query', colors: Array<{ __typename?: 'Color', id: number, hex: string, title: string }> };

export type CreateColorMutationVariables = Exact<{
  input: CreateColorInput;
}>;


export type CreateColorMutation = { __typename?: 'Mutation', createColor: { __typename?: 'Color', title: string, hex: string, id: number } };

export type RemoveColorMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveColorMutation = { __typename?: 'Mutation', removeColor: { __typename?: 'RemoveColorOutput', hex: string, title: string } };

export type UpdateColorMutationVariables = Exact<{
  input: UpdateColorInput;
}>;


export type UpdateColorMutation = { __typename?: 'Mutation', updateColor: { __typename?: 'Color', title: string, hex: string, id: number } };

export type AdminDiscountQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type AdminDiscountQuery = { __typename?: 'Query', discount: { __typename?: 'DiscountDto', description?: string | null, discountAmount: number, discountCode: string, startDate?: any | null, endDate?: any | null, id: number, isActive: boolean, minimumPurchase?: number | null, remainingUses?: number | null, userId?: number | null, user?: { __typename?: 'AdminUserDto', birth_date?: any | null, firstName?: string | null, id: number, lastName?: string | null, phoneNumber: string } | null } };

export type AdminDiscountsQueryVariables = Exact<{
  filter?: InputMaybe<AdminDiscountsPaginationFiltersInput>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<AdminDiscountsPaginationOrdersInput>;
}>;


export type AdminDiscountsQuery = { __typename?: 'Query', discounts: { __typename?: 'PaginatedAdminDiscountsDto', hasNextPage: boolean, limit: number, page: number, search?: string | null, totalCount: number, totalPages: number, items?: Array<{ __typename?: 'DiscountDto', description?: string | null, discountAmount: number, discountCode: string, id: number, startDate?: any | null, endDate?: any | null, created_at: any, updated_at: any, isActive: boolean, minimumPurchase?: number | null, remainingUses?: number | null, userId?: number | null, user?: { __typename?: 'AdminUserDto', birth_date?: any | null, firstName?: string | null, id: number, lastName?: string | null, phoneNumber: string } | null }> | null, orderBy?: { __typename?: 'AdminDiscountsPaginationOrdersOutput', created_at?: SortOrder | null, discountAmount?: SortOrder | null, discountCode?: SortOrder | null, endDate?: SortOrder | null, isActive?: SortOrder | null, minimumPurchase?: SortOrder | null, remainingUses?: SortOrder | null, startDate?: SortOrder | null, updated_at?: SortOrder | null } | null, filter?: { __typename?: 'AdminDiscountsPaginationFiltersOutput', isActive?: boolean | null } | null } };

export type CreateDiscountMutationVariables = Exact<{
  createDiscountInput: CreateDiscountInput;
}>;


export type CreateDiscountMutation = { __typename?: 'Mutation', createDiscount: { __typename?: 'DiscountDto', description?: string | null, discountAmount: number, discountCode: string, id: number, startDate?: any | null, endDate?: any | null, isActive: boolean, minimumPurchase?: number | null, remainingUses?: number | null, userId?: number | null, user?: { __typename?: 'AdminUserDto', birth_date?: any | null, firstName?: string | null, id: number, lastName?: string | null, phoneNumber: string } | null } };

export type GetUsersByHintQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUsersByHintQuery = { __typename?: 'Query', getUsersByHint: Array<{ __typename?: 'AdminUserDto', birth_date?: any | null, firstName?: string | null, id: number, lastName?: string | null, phoneNumber: string }> };

export type RemoveDiscountMutationVariables = Exact<{
  removeDiscountId: Scalars['Float']['input'];
}>;


export type RemoveDiscountMutation = { __typename?: 'Mutation', removeDiscount: { __typename?: 'DiscountDto', description?: string | null, discountAmount: number, discountCode: string, id: number, startDate?: any | null, endDate?: any | null, isActive: boolean, minimumPurchase?: number | null, remainingUses?: number | null, userId?: number | null, user?: { __typename?: 'AdminUserDto', birth_date?: any | null, firstName?: string | null, id: number, lastName?: string | null, phoneNumber: string } | null } };

export type UpdateDiscountMutationVariables = Exact<{
  updateDiscountId: Scalars['Float']['input'];
  updateDiscountInput: UpdateDiscountInput;
}>;


export type UpdateDiscountMutation = { __typename?: 'Mutation', updateDiscount: { __typename?: 'DiscountDto', description?: string | null, discountAmount: number, discountCode: string, id: number, startDate?: any | null, endDate?: any | null, isActive: boolean, minimumPurchase?: number | null, remainingUses?: number | null, userId?: number | null, user?: { __typename?: 'AdminUserDto', birth_date?: any | null, firstName?: string | null, id: number, lastName?: string | null, phoneNumber: string } | null } };

export type AdminOrdersProfitQueryVariables = Exact<{
  filter?: InputMaybe<AdminOrdersProfitFilterInput>;
  limit: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminOrdersProfitOrderByInput>;
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminOrdersProfitQuery = { __typename?: 'Query', adminOrdersProfit: { __typename?: 'PaginatedAdminOrdersProfitDto', hasNextPage: boolean, limit: number, page: number, search?: string | null, totalCount: number, totalPages: number, summary: { __typename?: 'AdminOrdersProfitSummaryDto', calculatedOrderCount: number, gatewayFee: number, orderCount: number, profit?: number | null, profitMargin?: number | null, purchaseCost: number, salesAmount: number, unknownOrderCount: number, unknownSalesAmount: number }, items?: Array<{ __typename?: 'AdminOrderProfitDto', couponDiscount: number, gatewayFeeAmount: number, id: number, initialDate?: any | null, itemsWithoutPurchasePrice: number, paymentGatewayFee?: number | null, productRevenue: number, profit?: number | null, profitMargin?: number | null, purchaseCost: number, shippingPrice?: number | null, status: OrderStatusEnum, totalPrice: number, paymentGateway?: { __typename?: 'AdminOrderProfitGatewayDto', code: string, id: string, name: string } | null }> | null } };

export type AdminGuaranteesQueryVariables = Exact<{
  orderBy?: InputMaybe<AdminGuaranteesPaginationOrdersInput>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminGuaranteesQuery = { __typename?: 'Query', guarantees: { __typename?: 'PaginatedAdminGuaranteesDto', limit: number, hasNextPage: boolean, page: number, search?: string | null, totalCount: number, totalPages: number, orderBy?: { __typename?: 'AdminGuaranteesPaginationOrdersOutput', title?: SortOrder | null, created_at?: SortOrder | null, updated_at?: SortOrder | null } | null, items?: Array<{ __typename?: 'GuaranteeDto', id: number, title: string, created_at: any, updated_at: any }> | null } };

export type CreateGuaranteeMutationVariables = Exact<{
  input: CreateGuaranteeInput;
}>;


export type CreateGuaranteeMutation = { __typename?: 'Mutation', createGuarantee: { __typename?: 'GuaranteeDto', title: string, id: number, created_at: any, updated_at: any } };

export type RemoveGuaranteeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveGuaranteeMutation = { __typename?: 'Mutation', removeGuarantee: { __typename?: 'GuaranteeDto', title: string, id: number, created_at: any, updated_at: any } };

export type UpdateGuaranteeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateGuaranteeInput;
}>;


export type UpdateGuaranteeMutation = { __typename?: 'Mutation', updateGuarantee: { __typename?: 'GuaranteeDto', title: string, id: number, created_at: any, updated_at: any } };

export type AddVarinatToBarcodePerPrintListMutationVariables = Exact<{
  input: BarcodeLabelInput;
}>;


export type AddVarinatToBarcodePerPrintListMutation = { __typename?: 'Mutation', label: { __typename?: 'BarcodeLabelDto', count: number, name: string, productCode: number, variantId: number } };

export type GetBarcodeLabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBarcodeLabelsQuery = { __typename?: 'Query', labels: Array<{ __typename?: 'BarcodeLabelDto', count: number, name: string, productCode: number, variantId: number }> };

export type RemoveAllBarcodeLabelsMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveAllBarcodeLabelsMutation = { __typename?: 'Mutation', labels: Array<{ __typename?: 'BarcodeLabelDto', productCode: number, variantId: number, count: number, name: string }> };

export type AdminOfferTypesQueryVariables = Exact<{
  orderBy?: InputMaybe<AdminOfferTypesPaginationOrdersInput>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminOfferTypesQuery = { __typename?: 'Query', offerTypes: { __typename?: 'PaginatedAdminOfferTypesDto', limit: number, hasNextPage: boolean, page: number, search?: string | null, totalCount: number, totalPages: number, orderBy?: { __typename?: 'AdminOfferTypesPaginationOrdersOutput', title?: SortOrder | null, created_at?: SortOrder | null, updated_at?: SortOrder | null, discount?: SortOrder | null } | null, items?: Array<{ __typename?: 'OfferTypeDto', id: number, discount: number, title: string, created_at: any, updated_at: any }> | null } };

export type CreateOfferTypeMutationVariables = Exact<{
  input: CreateOfferTypeInput;
}>;


export type CreateOfferTypeMutation = { __typename?: 'Mutation', createOfferType: { __typename?: 'OfferTypeDto', discount: number, title: string, id: number, created_at: any, updated_at: any } };

export type RemoveOfferTypeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveOfferTypeMutation = { __typename?: 'Mutation', removeOfferType: { __typename?: 'OfferTypeDto', id: number, title: string, discount: number, created_at: any, updated_at: any } };

export type UpdateOfferTypeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateOfferTypeInput;
}>;


export type UpdateOfferTypeMutation = { __typename?: 'Mutation', updateOfferType: { __typename?: 'OfferTypeDto', title: string, id: number, discount: number, created_at: any, updated_at: any } };

export type AdminOffersQueryVariables = Exact<{
  orderBy?: InputMaybe<AdminOffersPaginationOrdersInput>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminOffersQuery = { __typename?: 'Query', offers: { __typename?: 'PaginatedAdminOffersDto', page: number, limit: number, hasNextPage: boolean, totalCount: number, totalPages: number, orderBy?: { __typename?: 'AdminOffersPaginationOrdersOutput', updated_at?: SortOrder | null, created_at?: SortOrder | null } | null, items?: Array<{ __typename?: 'OfferDto', id: number, variantId: number, stock: number, maxBasketCount: number, percentage: number, price: number, cashPrice?: number | null, creditPrice?: number | null, active: boolean, start_at: any, end_at: any, created_at: any, updated_at: any, variant: { __typename?: 'VariantDto', active: boolean, id: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock: number, maxBasketCount: number, purchasePrice?: number | null, productId: string, attrs?: Array<{ __typename?: 'SVariantAttributeDto', value: string, key: string, name: string }> | null, product: { __typename?: 'Product', code: number, title: string, title_en?: string | null, mainImage?: { __typename?: 'ProductImage', address: string, alt?: string | null, id: string, name: string } | null } } }> | null } };

export type CreateRangeOfferMutationVariables = Exact<{
  createOfferRangeInput: CreateOfferRangeInput;
}>;


export type CreateRangeOfferMutation = { __typename?: 'Mutation', createRangeOffer: Array<{ __typename?: 'OfferDto', id: number }> };

export type RemoveOfferMutationVariables = Exact<{
  removeOfferId: Scalars['Float']['input'];
}>;


export type RemoveOfferMutation = { __typename?: 'Mutation', removeOffer: { __typename?: 'OfferDto', id: number } };

export type UpdateOfferMutationVariables = Exact<{
  updateOfferId: Scalars['Float']['input'];
  updateOfferInput: UpdateOfferInput;
}>;


export type UpdateOfferMutation = { __typename?: 'Mutation', updateOffer: { __typename?: 'OfferDto', id: number } };

export type AdminOrdersLocationDistributionQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
}>;


export type AdminOrdersLocationDistributionQuery = { __typename?: 'Query', adminOrdersLocationDistribution: { __typename?: 'AdminOrdersLocationDistributionDto', totalOrders: number, totalSale: number, unknownLocationOrders: number, provinces: Array<{ __typename?: 'AdminOrdersProvinceDistributionDto', name: string, orderCount: number, totalSale: number, cities: Array<{ __typename?: 'AdminOrdersCityDistributionDto', name: string, orderCount: number, totalSale: number }> }> } };

export type AdminOrderQueryVariables = Exact<{
  orderId: Scalars['Float']['input'];
}>;


export type AdminOrderQuery = { __typename?: 'Query', order: { __typename?: 'AdminOrderDto', created_at: any, itemsWarehouse?: string | null, deliveryTrackingCode?: string | null, discountPrice?: number | null, id: number, initialDate?: any | null, memo?: string | null, isOffline: boolean, paymentSeen: boolean, shippingPrice?: number | null, status: OrderStatusEnum, totalPrice: number, updated_at: any, cart?: { __typename?: 'CartDto', discountAmount: number, id: string, subtotal: number, totalPrice: number, cartItems: Array<{ __typename?: 'CartItemDto', discountPrice?: number | null, id: number, offerId?: number | null, productId: string, quantity: number, totalPrice: number, unitPrice: number, variantId: number, offer?: { __typename?: 'OfferDto', id: number, percentage: number, price: number } | null, product: { __typename?: 'SimpleProductDto', code: number, id: string, title: string, title_en?: string | null, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null }, variant: { __typename?: 'VariantDto', id: number, price: number, guarantee: { __typename?: 'GuaranteeDto', title: string }, attrs?: Array<{ __typename?: 'SVariantAttributeDto', key: string, name: string, value: string }> | null } }> } | null, orderItemActions: Array<{ __typename?: 'OrderItemActionDto', id: number, orderItemActionType: OrderItemActionTypeEnum, additionReason?: string | null, cancellationReason?: string | null, created_at: any, updated_at: any, transactionId?: string | null, refundAmount?: number | null, isRefundProcessed?: boolean | null, oldQuantity: number, newQuantity: number, orderItem: { __typename?: 'OrderItemDto', discountPrice?: number | null, id: number, productTitle: string, productTitleEn?: string | null, quantity: number, totalPrice: number, unitPrice: number, variantGuaranteeId?: number | null, variantGuaranteeTitle?: string | null, product: { __typename?: 'SimpleProductDto', code: number, id: string, title: string, title_en?: string | null, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null }, variantAttrs?: Array<{ __typename?: 'VariantAttrDto', key: string, name: string, value: string }> | null } }>, discount?: { __typename?: 'DiscountDto', id: number, description?: string | null, discountAmount: number, discountCode: string } | null, history: Array<{ __typename?: 'OrderHistoryDto', created_at: any, id: number, newStatus: OrderStatusEnum, oldStatus: OrderStatusEnum, note?: string | null }>, items: Array<{ __typename?: 'OrderItemDto', warehouseTargetDescription?: string | null, warehouseTargetProductId?: string | null, warehouseTargetProductVariantId?: string | null, warehouseId: number, discountPrice?: number | null, id: number, productTitle: string, productTitleEn?: string | null, quantity: number, totalPrice: number, unitPrice: number, variantId: number, variantGuaranteeId?: number | null, variantGuaranteeTitle?: string | null, warehouse: { __typename?: 'WarehouseDto', id: number, title: string, code: string, productUrlPatten?: string | null }, product: { __typename?: 'SimpleProductDto', code: number, id: string, title: string, title_en?: string | null, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null }, variantAttrs?: Array<{ __typename?: 'VariantAttrDto', key: string, name: string, value: string }> | null }>, paymentGateway?: { __typename?: 'PaymentGatewayDto', id: string, code: string, name: string, installment: boolean, logo?: { __typename?: 'ImageDto', address: string, alt?: string | null } | null } | null, paymentMethod?: { __typename?: 'PaymentMethodDto', id: string, name: string, code: PaymentMethodEnum } | null, payments: Array<{ __typename?: 'PaymentDto', id: number, amount: number, created_at: any, failedDate?: any | null, failedReason?: string | null, gatewayEntryTime?: any | null, paymentDate?: any | null, status: PaymentStatusEnum, transactionId?: string | null, refNumber?: string | null, cardNumber?: string | null, bankName?: string | null, paymentToken?: string | null, gateWayPayStatus?: string | null, gateway?: { __typename?: 'PaymentGatewayDto', id: string, name: string, code: string, installment: boolean } | null, paymentMethod?: { __typename?: 'PaymentMethodDto', id: string, name: string, code: PaymentMethodEnum } | null }>, shippingAddress?: { __typename?: 'ShippingAddressDto', address: string, cityName?: string | null, provinceName?: string | null, id: string, lat?: number | null, long?: number | null, postalCode?: string | null, recipientFirstName: string, recipientLastName: string, recipientPhoneNumber: string, city?: { __typename?: 'CityDto', id: string, name: string } | null, province?: { __typename?: 'ProvinceDto', id: string, name: string } | null } | null, shippingMethod?: { __typename?: 'ShippingMethodDto', name: string, cashOnDelivery: boolean, id: number, price: number } | null, user?: { __typename?: 'AdminUserDto', phoneNumber: string, firstName?: string | null, id: number, lastName?: string | null } | null } };

export type AdminOrderCartQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type AdminOrderCartQuery = { __typename?: 'Query', cart?: { __typename?: 'CartDto', discountAmount: number, id: string, subtotal: number, totalPrice: number, cartItems: Array<{ __typename?: 'CartItemDto', discountPrice?: number | null, id: number, offerId?: number | null, productId: string, quantity: number, totalPrice: number, unitPrice: number, variantId: number, offer?: { __typename?: 'OfferDto', id: number, percentage: number, price: number } | null, product: { __typename?: 'SimpleProductDto', code: number, id: string, title: string, title_en?: string | null, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null }, variant: { __typename?: 'VariantDto', id: number, price: number, guarantee: { __typename?: 'GuaranteeDto', title: string }, attrs?: Array<{ __typename?: 'SVariantAttributeDto', key: string, name: string, value: string }> | null } }> } | null };

export type GetOrderHistoryByOrderIdQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type GetOrderHistoryByOrderIdQuery = { __typename?: 'Query', history: Array<{ __typename?: 'OrderHistoryDto', created_at: any, id: number, newStatus: OrderStatusEnum, oldStatus: OrderStatusEnum, note?: string | null }> };

export type GetOrderItemActionsByOrderIdQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type GetOrderItemActionsByOrderIdQuery = { __typename?: 'Query', actions: Array<{ __typename?: 'OrderItemActionDto', id: number, orderItemActionType: OrderItemActionTypeEnum, additionReason?: string | null, cancellationReason?: string | null, created_at: any, updated_at: any, transactionId?: string | null, refundAmount?: number | null, isRefundProcessed?: boolean | null, oldQuantity: number, newQuantity: number, orderItem: { __typename?: 'OrderItemDto', discountPrice?: number | null, id: number, productTitle: string, productTitleEn?: string | null, quantity: number, totalPrice: number, unitPrice: number, variantGuaranteeId?: number | null, variantGuaranteeTitle?: string | null, product: { __typename?: 'SimpleProductDto', code: number, id: string, title: string, title_en?: string | null, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null }, variantAttrs?: Array<{ __typename?: 'VariantAttrDto', key: string, name: string, value: string }> | null } }> };

export type GetOrderPaymentsByOrderIdQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type GetOrderPaymentsByOrderIdQuery = { __typename?: 'Query', payments: Array<{ __typename?: 'PaymentDto', id: number, amount: number, created_at: any, failedDate?: any | null, failedReason?: string | null, gatewayEntryTime?: any | null, paymentDate?: any | null, status: PaymentStatusEnum, transactionId?: string | null, refNumber?: string | null, cardNumber?: string | null, bankName?: string | null, paymentToken?: string | null, gateWayPayStatus?: string | null, gateway?: { __typename?: 'PaymentGatewayDto', id: string, name: string, code: string, installment: boolean } | null, paymentMethod?: { __typename?: 'PaymentMethodDto', id: string, name: string, code: PaymentMethodEnum } | null }> };

export type AdminOrderV2QueryVariables = Exact<{
  orderId: Scalars['Float']['input'];
}>;


export type AdminOrderV2Query = { __typename?: 'Query', order: { __typename?: 'AdminOrderDto', created_at: any, itemsWarehouse?: string | null, deliveryTrackingCode?: string | null, discountPrice?: number | null, id: number, initialDate?: any | null, memo?: string | null, isOffline: boolean, paymentSeen: boolean, shippingPrice?: number | null, pricingMode?: CartPricingMode | null, status: OrderStatusEnum, totalPrice: number, updated_at: any, discount?: { __typename?: 'DiscountDto', id: number, description?: string | null, discountAmount: number, discountCode: string } | null, items: Array<{ __typename?: 'OrderItemDto', warehouseTargetDescription?: string | null, warehouseTargetProductId?: string | null, warehouseTargetProductVariantId?: string | null, warehouseId: number, discountPrice?: number | null, id: number, productTitle: string, productTitleEn?: string | null, quantity: number, totalPrice: number, unitPrice: number, variantId: number, variantGuaranteeId?: number | null, variantGuaranteeTitle?: string | null, warehouse: { __typename?: 'WarehouseDto', id: number, title: string, code: string, productUrlPatten?: string | null }, product: { __typename?: 'SimpleProductDto', code: number, id: string, title: string, title_en?: string | null, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null }, variantAttrs?: Array<{ __typename?: 'VariantAttrDto', key: string, name: string, value: string }> | null }>, paymentGateway?: { __typename?: 'PaymentGatewayDto', id: string, code: string, name: string, installment: boolean, logo?: { __typename?: 'ImageDto', address: string, alt?: string | null } | null } | null, paymentMethod?: { __typename?: 'PaymentMethodDto', id: string, name: string, code: PaymentMethodEnum } | null, shippingAddress?: { __typename?: 'ShippingAddressDto', address: string, cityName?: string | null, provinceName?: string | null, id: string, lat?: number | null, long?: number | null, postalCode?: string | null, recipientFirstName: string, recipientLastName: string, recipientPhoneNumber: string, city?: { __typename?: 'CityDto', id: string, name: string } | null, province?: { __typename?: 'ProvinceDto', id: string, name: string } | null } | null, shippingMethod?: { __typename?: 'ShippingMethodDto', name: string, cashOnDelivery: boolean, id: number, price: number } | null, shipments?: Array<{ __typename?: 'OrderShipmentDto', id: number, orderId: number, warehouseId: number, warehouseShippingMethodId?: number | null, shippingPrice?: number | null, status: OrderShipmentStatusEnum, trackingCode?: string | null, created_at: any, updated_at: any, warehouse?: { __typename?: 'WarehouseDto', id: number, title: string, code: string, shippingOriginLabel?: string | null } | null, warehouseShippingMethod?: { __typename?: 'WarehouseShippingMethodDto', id: number, name: string, cashOnDelivery: boolean, cashPrice: number, creditPrice: number } | null }> | null, user?: { __typename?: 'AdminUserDto', phoneNumber: string, firstName?: string | null, id: number, lastName?: string | null } | null } };

export type ProcessOrderItemPartialCancellationMutationVariables = Exact<{
  input: CreateReduceOrderItemActionInput;
}>;


export type ProcessOrderItemPartialCancellationMutation = { __typename?: 'Mutation', orderItem: { __typename?: 'SimpleOrderItemDto', discountPrice?: number | null, id: number, productId: string, productTitle: string, productTitleEn?: string | null, quantity: number, totalPrice: number, unitPrice: number, variantGuaranteeId?: number | null, variantGuaranteeTitle?: string | null, variantAttrs?: Array<{ __typename?: 'VariantAttrDto', name: string, value: string, key: string }> | null } };

export type UpdateAdminOrderMutationVariables = Exact<{
  updateAdminOrderId: Scalars['Float']['input'];
  input: AdminUpdateOrderInput;
}>;


export type UpdateAdminOrderMutation = { __typename?: 'Mutation', updateAdminOrder: { __typename?: 'AdminOrderDto', id: number, memo?: string | null } };

export type UpdateAdminOrderShippingAddressMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateShippingAddressInput;
}>;


export type UpdateAdminOrderShippingAddressMutation = { __typename?: 'Mutation', updateShippingAddresses: { __typename?: 'ShippingAddressDto', id: string } };

export type UpdateAdminOrderStatusMutationVariables = Exact<{
  updateAdminOrderStatusId: Scalars['Float']['input'];
  input: AdminUpdateOrderStatusInput;
}>;


export type UpdateAdminOrderStatusMutation = { __typename?: 'Mutation', updateAdminOrderStatus: { __typename?: 'AppMessage', success: boolean } };

export type UpdateAdminOrderStatusToCancelledMutationVariables = Exact<{
  updateAdminOrderStatusToCancelledId: Scalars['Float']['input'];
  input: AdminUpdateOrderStatusToCancelledInput;
}>;


export type UpdateAdminOrderStatusToCancelledMutation = { __typename?: 'Mutation', updateAdminOrderStatusToCancelled: { __typename?: 'AppMessage', success: boolean } };

export type UpdateOrderItemPartialCancellationMutationVariables = Exact<{
  input: UpdateReduceOrderItemActionInput;
}>;


export type UpdateOrderItemPartialCancellationMutation = { __typename?: 'Mutation', updateOrderItemPartialCancellation: { __typename?: 'OrderItemActionDto', additionReason?: string | null, cancellationReason?: string | null, created_at: any, id: number, isRefundProcessed?: boolean | null, newQuantity: number, oldQuantity: number, orderItemActionType: OrderItemActionTypeEnum, orderItemId: number, refundAmount?: number | null, transactionId?: string | null, updated_at: any, orderItem: { __typename?: 'OrderItemDto', discountPrice?: number | null, id: number, productTitle: string, productTitleEn?: string | null, quantity: number, totalPrice: number, unitPrice: number, variantGuaranteeId?: number | null, variantGuaranteeTitle?: string | null, variantId: number, product: { __typename?: 'SimpleProductDto', code: number, id: string, title: string, title_en?: string | null, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null, id: string, name: string } | null }, variantAttrs?: Array<{ __typename?: 'VariantAttrDto', name: string, value: string, key: string }> | null } } };

export type UpdateOrderShipmentStatusMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateOrderShipmentStatusInput;
}>;


export type UpdateOrderShipmentStatusMutation = { __typename?: 'Mutation', updateOrderShipmentStatus: { __typename?: 'OrderShipmentDto', id: number, orderId: number, status: OrderShipmentStatusEnum, trackingCode?: string | null, updated_at: any } };

export type AdminOrdersQueryVariables = Exact<{
  filter?: InputMaybe<AdminOrdersPaginationFilterInput>;
  limit: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminOrdersPaginationOrdersInput>;
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminOrdersQuery = { __typename?: 'Query', orders: { __typename?: 'PaginatedAdminOrdersDto', hasNextPage: boolean, limit: number, page: number, search?: string | null, totalCount: number, totalPages: number, filter?: { __typename?: 'AdminOrdersPaginationFilterOutput', maxInitialDate?: any | null, minInitialDate?: any | null, paymentGateway_code?: string | null, paymentGateway_installment?: boolean | null, paymentMethod?: PaymentMethodEnum | null, status?: OrderStatusEnum | null, isOffline?: boolean | null } | null, items?: Array<{ __typename?: 'OrderDto', itemsWarehouse?: string | null, created_at: any, id: number, initialDate?: any | null, deliveryTrackingCode?: string | null, isOffline: boolean, shippingPrice?: number | null, status: OrderStatusEnum, totalPrice: number, updated_at: any, user_fullname?: string | null, user_phoneNumber?: string | null, shippingMethod?: { __typename?: 'ShippingMethodDto', cashOnDelivery: boolean, cities?: Array<string> | null, description?: string | null, id: number, name: string, price: number } | null, paymentGateway?: { __typename?: 'PaymentGatewayDto', active: boolean, code: string, created_at: any, description?: string | null, id: string, installment: boolean, key: string, logoId?: string | null, name: string, updated_at: any, logo?: { __typename?: 'ImageDto', address: string, alt?: string | null, id: string, name: string } | null } | null, paymentMethod?: { __typename?: 'PaymentMethodDto', code: PaymentMethodEnum, description?: string | null, id: string, name: string } | null, shippingAddress?: { __typename?: 'ShippingAddressDto', address: string, cityName?: string | null, provinceName?: string | null, id: string, lat?: number | null, long?: number | null, postalCode?: string | null, recipientFirstName: string, recipientLastName: string, recipientPhoneNumber: string, city?: { __typename?: 'CityDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null } | null, province?: { __typename?: 'ProvinceDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null } | null } | null }> | null, orderBy?: { __typename?: 'AdminOrdersPaginationOrdersOutput', created_at?: SortOrder | null, id?: SortOrder | null, initialDate?: SortOrder | null, paymentGateway_installment?: SortOrder | null, paymentGateway_name?: SortOrder | null, paymentMethod_name?: SortOrder | null, shippingAddresses_city_name?: SortOrder | null, shippingAddresses_province_name?: SortOrder | null, shippingAddresses_recipient_fullName?: SortOrder | null, shippingAddresses_recipient_phoneNumber?: SortOrder | null, shippingMethod_name?: SortOrder | null, shippingPrice?: SortOrder | null, status?: SortOrder | null, totalPrice?: SortOrder | null, updated_at?: SortOrder | null, user_fullname?: SortOrder | null, user_phoneNumber?: SortOrder | null } | null } };

export type GetPaymentGatewaysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentGatewaysQuery = { __typename?: 'Query', paymentGateways: Array<{ __typename?: 'PaymentGatewayDto', id: string, code: string, key: string, clientId?: string | null, clientSecret?: string | null, clientUsername?: string | null, clientPassword?: string | null, clientOAuthUrl?: string | null, name: string, active: boolean, installment: boolean, description?: string | null, minAmountToPayment?: number | null, maxAmountToPayment?: number | null, created_at: any, updated_at: any, logoId?: string | null, sourcePolicy?: { __typename?: 'GatewaySourcePolicyDto', visibility: GatewayVisibility, detectEnabled: boolean, matchKeys: Array<string>, restrictionEnabled: boolean, allowSelf: boolean, allowNonInstallment: boolean, allowOtherInstallment: boolean, allowGatewayCodes?: Array<string> | null, denyGatewayCodes?: Array<string> | null, sourcePriority?: number | null } | null, logo?: { __typename?: 'ImageDto', id: string, name: string, address: string, alt?: string | null } | null }> };

export type UpdatePaymentGatewayMutationVariables = Exact<{
  updatePaymentGatewayId: Scalars['String']['input'];
  updatePaymentGatewayInput: UpdatePaymentGatewayInput;
}>;


export type UpdatePaymentGatewayMutation = { __typename?: 'Mutation', updatePaymentGateway: { __typename?: 'PaymentGatewayDto', id: string } };

export type AdminPaymentsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminPaymentsPaginationOrdersInput>;
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminPaymentsQuery = { __typename?: 'Query', payments: { __typename?: 'PaginatedAdminPaymentsDto', hasNextPage: boolean, limit: number, page: number, search?: string | null, totalCount: number, totalPages: number, items?: Array<{ __typename?: 'PaymentDto', amount: number, created_at: any, failedDate?: any | null, failedReason?: string | null, gatewayEntryTime?: any | null, gatewayId?: string | null, id: number, orderId: number, paymentDate?: any | null, paymentMethodId?: string | null, status: PaymentStatusEnum, transactionId?: string | null, gateway?: { __typename?: 'PaymentGatewayDto', active: boolean, code: string, created_at: any, description?: string | null, id: string, logoId?: string | null, name: string, updated_at: any, logo?: { __typename?: 'ImageDto', address: string, alt?: string | null, id: string, name: string } | null } | null, paymentMethod?: { __typename?: 'PaymentMethodDto', code: PaymentMethodEnum, description?: string | null, id: string, name: string } | null }> | null, orderBy?: { __typename?: 'AdminPaymentsPaginationOrdersOutput', amount?: SortOrder | null, created_at?: SortOrder | null, gatewayEntryTime?: SortOrder | null, gateway_name?: SortOrder | null, id?: SortOrder | null, orderId?: SortOrder | null, paymentDate?: SortOrder | null, paymentMethod_name?: SortOrder | null, status?: SortOrder | null, transactionId?: SortOrder | null } | null } };

export type AdminProductImagesQueryVariables = Exact<{
  filter?: InputMaybe<AdminProductImagesPaginationFiltersInput>;
  limit: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminProductImagesPaginationOrdersInput>;
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminProductImagesQuery = { __typename?: 'Query', productImages: { __typename?: 'PaginatedAdminProductImagesDto', hasNextPage: boolean, limit: number, page: number, search?: string | null, totalCount: number, totalPages: number, filter?: { __typename?: 'AdminProductImagesPaginationFiltersOutput', aiGenerated?: boolean | null, brandId?: number | null, categoryId?: number | null, hasAlt?: boolean | null, isActive?: boolean | null, isMain?: boolean | null, local?: boolean | null, productActive?: boolean | null, productHasStock?: boolean | null, productId?: string | null, syncWithExternal?: boolean | null } | null, items?: Array<{ __typename?: 'AdminGalleryProductImage', address: string, aiGenerated: boolean, alt?: string | null, basalamImageId?: number | null, created_at: any, id: string, imageId: string, isActive: boolean, isMain: boolean, local: boolean, name: string, productActive?: boolean | null, productCode?: number | null, productId?: string | null, productImageId: string, productTitle?: string | null, sort: number, syncWithExternal: boolean, updated_at: any }> | null, orderBy?: { __typename?: 'AdminProductImagesPaginationOrdersOutput', created_at?: SortOrder | null, isActive?: SortOrder | null, isMain?: SortOrder | null, product_code?: SortOrder | null, product_title?: SortOrder | null, sort?: SortOrder | null, updated_at?: SortOrder | null } | null } };

export type AdminProductStatsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AdminProductStatsQuery = { __typename?: 'Query', adminProductStats: { __typename?: 'AdminProductStatsDto', viewCount: number, pageViewCount: number, soldQuantity: number } };

export type AdminProductQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AdminProductQuery = { __typename?: 'Query', product: { __typename?: 'Product', basedOnExternalProductId?: string | null, basedOnExternalProductUrl?: string | null, id: string, title: string, title_en?: string | null, code: number, active: boolean, aiContentGenerated: boolean, created_at: any, updated_at: any, description?: string | null, shortDescription?: string | null, keywords: Array<string>, features: Array<string>, brandId: number, videos: Array<{ __typename?: 'VideoDto', active: boolean, address: string, id: string, local: boolean, name: string, sort: number, thumbnail: string } | null>, warehouse?: { __typename?: 'WarehouseDto', productUrlPatten?: string | null, active: boolean, title: string, id: number, code: string } | null, images: Array<{ __typename?: 'ProductImage', address: string, alt?: string | null, id: string, imageId: string, isActive: boolean, syncWithExternal: boolean, isMain: boolean, sort: number, aiGenerated: boolean } | null>, brand: { __typename?: 'BrandDto', id: number, title_en: string, title: string, image?: { __typename?: 'ImageDto', id: string, address: string, alt?: string | null } | null }, category: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string } | null } | null } | null } | null } | null } | null } | null } | null } | null } | null }, specifications: Array<{ __typename?: 'Specification', id: string, title: string, checked?: boolean | null, text?: string | null, type: SpecificationType, sort: number }>, tags: Array<{ __typename?: 'TagDto', id: number, title: string } | null> } };

export type CategoryItemFragment = { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string };

export type CategoryItemRecursiveFragment = { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string, parent?: { __typename?: 'CategoryDto', id: number, title: string, title_en: string, active: boolean, slug: string } | null } | null } | null } | null } | null } | null } | null } | null } | null } | null };

export type AdminProductsQueryVariables = Exact<{
  orderBy?: InputMaybe<AdminProductsPaginationOrdersInput>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AdminProductsPaginationFiltersInput>;
}>;


export type AdminProductsQuery = { __typename?: 'Query', products: { __typename?: 'PaginatedAdminProductsDto', limit: number, hasNextPage: boolean, page: number, search?: string | null, totalCount: number, totalPages: number, orderBy?: { __typename?: 'AdminProductsPaginationOrdersOutput', code?: SortOrder | null, active?: SortOrder | null, title?: SortOrder | null, brand_title?: SortOrder | null, title_en?: SortOrder | null, created_at?: SortOrder | null, updated_at?: SortOrder | null } | null, filter?: { __typename?: 'AdminProductsPaginationFiltersOutput', active?: boolean | null, aiContentGenerated?: boolean | null, categoryId?: number | null, warehouseId?: number | null, hasStock?: boolean | null } | null, items?: Array<{ __typename?: 'SingleRowProductDto', id: string, title: string, title_en?: string | null, code: number, active: boolean, aiContentGenerated: boolean, totalSales?: number | null, hasStock?: boolean | null, created_at: any, updated_at: any, warehouse?: { __typename?: 'WarehouseDto', productUrlPatten?: string | null, active: boolean, title: string, id: number, code: string } | null, category: { __typename?: 'CategoryDto', active: boolean, title: string, id: number }, mainImage?: { __typename?: 'ProductImage', address: string, alt?: string | null, id: string } | null, brand: { __typename?: 'BrandDto', id: number, title_en: string, title: string } }> | null } };

export type ChangeProductImageSortMutationVariables = Exact<{
  updateProductImageSortInput: UpdateProductImageSortInput;
}>;


export type ChangeProductImageSortMutation = { __typename?: 'Mutation', updateProductImageSort: { __typename?: 'AppMessage', code?: number | null, message?: string | null, success: boolean } };

export type ChangeSpecificationSortMutationVariables = Exact<{
  productId: Scalars['String']['input'];
  updateSpecificationSortInput: UpdateSpecificationSortInput;
}>;


export type ChangeSpecificationSortMutation = { __typename?: 'Mutation', updateSpecificationSorts: { __typename?: 'AppMessage', success: boolean, message?: string | null, code?: number | null } };

export type CreateProductMutationVariables = Exact<{
  createProductInput: CreateProductInput;
}>;


export type CreateProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'Product', id: string, code: number } };

export type CreateSpecificationMutationVariables = Exact<{
  createSpecificationInput: CreateSpecificationInput;
  productId: Scalars['String']['input'];
}>;


export type CreateSpecificationMutation = { __typename?: 'Mutation', createSpecification: { __typename?: 'Specification', id: string } };

export type RemoveProductImageMutationVariables = Exact<{
  removeProductImageId: Scalars['String']['input'];
  imageId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;


export type RemoveProductImageMutation = { __typename?: 'Mutation', removeProductImage: { __typename?: 'ProductImage', id: string } };

export type RemoveSpecificationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;


export type RemoveSpecificationMutation = { __typename?: 'Mutation', removeSpecification: { __typename?: 'AppMessage', success: boolean } };

export type UpdateProductMutationVariables = Exact<{
  id: Scalars['String']['input'];
  updateProductInput: UpdateProductInput;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'Product', id: string, code: number } };

export type UpdateProductImageMutationVariables = Exact<{
  updateProductImageId: Scalars['String']['input'];
  imageId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  updateProductImageInput: UpdateProductImageInput;
}>;


export type UpdateProductImageMutation = { __typename?: 'Mutation', updateProductImage: { __typename?: 'ProductImage', address: string, alt?: string | null, id: string, imageId: string, isActive: boolean, isMain: boolean, name: string, sort: number } };

export type UpdateSpecificationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  updateSpecificationInput: UpdateSpecificationInput;
  productId: Scalars['String']['input'];
}>;


export type UpdateSpecificationMutation = { __typename?: 'Mutation', updateSpecification: { __typename?: 'Specification', id: string } };

export type CreateProductImageMutationVariables = Exact<{
  createProductImageInput: ProductImageInput;
  productId: Scalars['String']['input'];
}>;


export type CreateProductImageMutation = { __typename?: 'Mutation', createProductImage: { __typename?: 'ProductImage', id: string, address: string, alt?: string | null } };

export type CreateSpecificationRangeMutationVariables = Exact<{
  createSpecificationInput: CreateSpecificationRangeInput;
  productId: Scalars['String']['input'];
}>;


export type CreateSpecificationRangeMutation = { __typename?: 'Mutation', createSpecificationRange: Array<{ __typename?: 'Specification', id: string }> };

export type DeleteVideoMutationVariables = Exact<{
  deleteVideoId: Scalars['String']['input'];
}>;


export type DeleteVideoMutation = { __typename?: 'Mutation', deleteVideo: { __typename?: 'VideoDto', id: string } };

export type UpdateVideoMutationVariables = Exact<{
  updateVideoId: Scalars['String']['input'];
  updateVideoInput: UpdateVideoInput;
}>;


export type UpdateVideoMutation = { __typename?: 'Mutation', video: { __typename?: 'VideoDto', id: string } };

export type UploadVideoMutationVariables = Exact<{
  createVideoInput: CreateVideoInput;
}>;


export type UploadVideoMutation = { __typename?: 'Mutation', video: { __typename?: 'VideoDto', active: boolean, address: string, id: string, local: boolean, name: string, sort: number, thumbnail: string } };

export type AdminPromptsQueryVariables = Exact<{
  orderBy?: InputMaybe<AdminPromptsPaginationOrdersInput>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminPromptsQuery = { __typename?: 'Query', prompts: { __typename?: 'PaginatedAdminPromptsDto', limit: number, hasNextPage: boolean, page: number, search?: string | null, totalCount: number, totalPages: number, orderBy?: { __typename?: 'AdminPromptsPaginationOrdersOutput', title?: SortOrder | null, created_at?: SortOrder | null, updated_at?: SortOrder | null } | null, items?: Array<{ __typename?: 'PromptDto', id: number, title: string, content: string, created_at: any, updated_at: any }> | null } };

export type CreatePromptMutationVariables = Exact<{
  input: CreatePromptInput;
}>;


export type CreatePromptMutation = { __typename?: 'Mutation', createPrompt: { __typename?: 'PromptDto', title: string, id: number, content: string, created_at: any, updated_at: any } };

export type RemovePromptMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemovePromptMutation = { __typename?: 'Mutation', removePrompt: { __typename?: 'PromptDto', title: string, id: number, content: string, created_at: any, updated_at: any } };

export type UpdatePromptMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdatePromptInput;
}>;


export type UpdatePromptMutation = { __typename?: 'Mutation', updatePrompt: { __typename?: 'PromptDto', title: string, id: number, content: string, created_at: any, updated_at: any } };

export type SalePriceCalculatorQueryVariables = Exact<{
  input: SalePriceCalculatorInput;
}>;


export type SalePriceCalculatorQuery = { __typename?: 'Query', result: { __typename?: 'PriceProfitDetailsDto', purchaseCost: number, sellingPrice: number, cashPrice?: number | null, creditPrice?: number | null, creditUpliftPercent?: number | null, torobFee: number, tax: number, snapFee: number, bankFee: number, netProfit: number, grossProfit: number, finalAmount: number } };

export type GetAllSettingItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSettingItemsQuery = { __typename?: 'Query', items: Array<{ __typename?: 'SettingItemDto', id: number, key: string, label?: string | null, description?: string | null, value?: string | null }> };

export type SetSettingItemMutationVariables = Exact<{
  id: Scalars['Float']['input'];
  updateSettingInput: UpdateSettingInput;
}>;


export type SetSettingItemMutation = { __typename?: 'Mutation', item: { __typename?: 'SettingItemDto', id: number, key: string, label?: string | null, description?: string | null, value?: string | null } };

export type GetMeliPayamakCreditQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeliPayamakCreditQuery = { __typename?: 'Query', count: number };

export type GetMeliPayamakSmsListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeliPayamakSmsListQuery = { __typename?: 'Query', list: Array<{ __typename?: 'MeliPayampakMsg', Body: string, Credit: number, CurrentLocation: number, FirstLocation: number, IsFlash: boolean, IsMoneyBack: boolean, IsRead: boolean, IsUnicode: boolean, LinkID: number, Module: number, MoneyBackCount: number, MoneyBackLevel: number, MsgID: string, MsgType: string, NumberID: number, Parts: number, RecCount: number, RecFailed: number, RecSuccess: number, Receiver: string, SendDate: any, Sender: string, Tariff: number, Udh: string, UserID: number, UserMaster: number, UserStepedMaster: number }> };

export type SendSmsByMeliPayamakMutationVariables = Exact<{
  input: MeliPayampakMsgInput;
}>;


export type SendSmsByMeliPayamakMutation = { __typename?: 'Mutation', result: { __typename?: 'AppMessage', code?: number | null, message?: string | null, success: boolean } };

export type AdminAllTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminAllTagsQuery = { __typename?: 'Query', allTags: Array<{ __typename?: 'TagDto', id: number, title: string, created_at: any, updated_at: any }> };

export type AdminTagsQueryVariables = Exact<{
  orderBy?: InputMaybe<AdminTagsPaginationOrdersInput>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminTagsQuery = { __typename?: 'Query', tags: { __typename?: 'PaginatedAdminTagsDto', limit: number, hasNextPage: boolean, page: number, search?: string | null, totalCount: number, totalPages: number, orderBy?: { __typename?: 'AdminTagsPaginationOrdersOutput', title?: SortOrder | null, created_at?: SortOrder | null, updated_at?: SortOrder | null } | null, items?: Array<{ __typename?: 'TagDto', id: number, title: string, created_at: any, updated_at: any }> | null } };

export type CreateTagMutationVariables = Exact<{
  input: CreateTagInput;
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTag: { __typename?: 'TagDto', title: string, id: number, created_at: any, updated_at: any } };

export type RemoveTagMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveTagMutation = { __typename?: 'Mutation', removeTag: { __typename?: 'TagDto', title: string, id: number, created_at: any, updated_at: any } };

export type UpdateTagMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateTagInput;
}>;


export type UpdateTagMutation = { __typename?: 'Mutation', updateTag: { __typename?: 'TagDto', title: string, id: number, created_at: any, updated_at: any } };

export type AdminTopBannerQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminTopBannerQuery = { __typename?: 'Query', adminTopBanner: { __typename?: 'TopBannerAdminDto', action: TopBannerAction, backgroundColor: string, dialogBody: string, dialogButtonLabel: string, dialogButtonUrl?: string | null, dialogImageAlt: string, dialogImageId?: string | null, dialogImageUrl?: string | null, dialogTitle: string, endsAt?: any | null, imageAlt: string, imageHeight?: number | null, imageUrl: string, imageWidth?: number | null, isActive: boolean, kind: TopBannerKind, linkUrl?: string | null, openInNewTab: boolean, startsAt?: any | null, textAnimation: TopBannerTextAnimation, textColor: string, textLines: Array<string>, updated_at: any, visible: boolean } };

export type UpdateTopBannerMutationVariables = Exact<{
  input: UpdateTopBannerInput;
}>;


export type UpdateTopBannerMutation = { __typename?: 'Mutation', updateTopBanner: { __typename?: 'TopBannerAdminDto', action: TopBannerAction, backgroundColor: string, dialogBody: string, dialogButtonLabel: string, dialogButtonUrl?: string | null, dialogImageAlt: string, dialogImageId?: string | null, dialogImageUrl?: string | null, dialogTitle: string, endsAt?: any | null, imageAlt: string, imageHeight?: number | null, imageUrl: string, imageWidth?: number | null, isActive: boolean, kind: TopBannerKind, linkUrl?: string | null, openInNewTab: boolean, startsAt?: any | null, textAnimation: TopBannerTextAnimation, textColor: string, textLines: Array<string>, updated_at: any, visible: boolean } };

export type AdminUserAddressesQueryVariables = Exact<{
  userId: Scalars['Float']['input'];
}>;


export type AdminUserAddressesQuery = { __typename?: 'Query', adminUserAddresses: Array<{ __typename?: 'AdminUserAddressDto', address: string, cityId: string, id: string, isDefault: boolean, lat?: number | null, long?: number | null, postalCode?: string | null, provinceId: string, recipientFirstName: string, recipientLastName: string, recipientPhoneNumber: string, createdAt: any, updatedAt: any, city: { __typename?: 'CityDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null }, province: { __typename?: 'ProvinceDto', id: string, lat?: number | null, long?: number | null, name: string, zoom?: number | null } }> };

export type AdminUserDetailsQueryVariables = Exact<{
  userId: Scalars['Float']['input'];
}>;


export type AdminUserDetailsQuery = { __typename?: 'Query', user: { __typename?: 'AdminUserDetailsDto', birth_date?: any | null, created_at: any, firstName?: string | null, id: number, lastName?: string | null, locked: boolean, phoneNumber: string, phoneNumberValidate: boolean, roles: Array<Roles>, updated_at: any, userAddressesCount: number, orderCounts: { __typename?: 'AdminUserOrdersCountDto', awaiting_payment_confirmation_count: number, cancelled_count: number, delivered_count: number, failed_count: number, on_hold_count: number, out_for_delivery_count: number, packed_count: number, paid_count: number, pending_count: number, processing_count: number, refunded_count: number, return_requested_count: number, returned_count: number, shipped_count: number }, wallet: { __typename?: 'AdminWalletDto', balance: number } } };

export type GetUserAuthTokensQueryVariables = Exact<{
  getUserAuthTokensId: Scalars['Float']['input'];
}>;


export type GetUserAuthTokensQuery = { __typename?: 'Query', tokens: Array<{ __typename?: 'AdminUserTokenDto', created_at?: any | null, id: number, locked?: boolean | null, refreshTokenHash?: string | null }> };

export type AdminUsersQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  orderBy?: InputMaybe<AdminUsersPaginationOrdersInput>;
  filter?: InputMaybe<AdminUsersPaginationFiltersInput>;
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminUsersQuery = { __typename?: 'Query', users: { __typename?: 'PaginatedAdminUsersDto', hasNextPage: boolean, limit: number, page: number, search?: string | null, totalCount: number, totalPages: number, items?: Array<{ __typename?: 'User', birth_date?: any | null, created_at: any, firstName?: string | null, id: number, lastName?: string | null, locked: boolean, phoneNumber: string, roles: Array<Roles>, updated_at: any, deliveredOrdersCount?: number | null }> | null, orderBy?: { __typename?: 'AdminUsersPaginationOrdersOutput', birth_date?: SortOrder | null, created_at?: SortOrder | null, firstName?: SortOrder | null, lastName?: SortOrder | null, locked?: SortOrder | null, phoneNumber?: SortOrder | null, id?: SortOrder | null, updated_at?: SortOrder | null, ordersCount?: SortOrder | null } | null } };

export type AdminCreateVariantRequirementsQueryVariables = Exact<{
  productId: Scalars['String']['input'];
}>;


export type AdminCreateVariantRequirementsQuery = { __typename?: 'Query', product: { __typename?: 'Product', id: string, title: string, title_en?: string | null, code: number } };

export type AdminProductSummaryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AdminProductSummaryQuery = { __typename?: 'Query', product: { __typename?: 'AdminProductSummaryDto', id: string, title: string, title_en?: string | null, code: number, active: boolean, created_at: any, updated_at: any, mainImage?: { __typename?: 'ProductImage', address: string, name: string, alt?: string | null } | null } };

export type AdminProductVariantsQueryVariables = Exact<{
  productId: Scalars['String']['input'];
  variantsPage: Scalars['Int']['input'];
  variantsLimit: Scalars['Int']['input'];
  variantsOrderBy?: InputMaybe<AdminVariantsPaginationOrdersInput>;
  variantsFilter?: InputMaybe<AdminVariantsPaginationFiltersInput>;
  variantSearch?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminProductVariantsQuery = { __typename?: 'Query', varinats: { __typename?: 'PaginatedAdminVariantsDto', page: number, limit: number, hasNextPage: boolean, totalCount: number, totalPages: number, filter?: { __typename?: 'AdminVariantsPaginationFiltersOutput', active?: boolean | null } | null, orderBy?: { __typename?: 'AdminVariantsPaginationOrdersOutput', updated_at?: SortOrder | null, created_at?: SortOrder | null, stock?: SortOrder | null, price?: SortOrder | null, active?: SortOrder | null, id?: SortOrder | null } | null, items?: Array<{ __typename?: 'VariantDto', id: number, warehouseTargetProductVariantId?: string | null, warehouseTargetProductId?: string | null, allowAutoOffer: boolean, warehouseTargetDescription?: string | null, guaranteeId: number, maxBasketCount: number, price: number, cashPrice?: number | null, creditPrice?: number | null, stock: number, purchasePrice?: number | null, active: boolean, productId: string, salesChannel: Array<SalesChannelEnum>, affiliatePrice?: number | null, created_at: any, updated_at: any, warehouse: { __typename?: 'WarehouseDto', title: string, code: string, active: boolean, id: number, productUrlPatten?: string | null }, attrs?: Array<{ __typename?: 'SVariantAttributeDto', value: string, name: string, key: string }> | null, guarantee: { __typename?: 'GuaranteeDto', id: number, title: string }, product: { __typename?: 'Product', code: number } }> | null } };

export type AdminProductsForVariantsSearchQueryVariables = Exact<{
  orderBy?: InputMaybe<AdminProductsPaginationOrdersInput>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AdminProductsPaginationFiltersInput>;
}>;


export type AdminProductsForVariantsSearchQuery = { __typename?: 'Query', products: { __typename?: 'PaginatedAdminProductsDto', limit: number, hasNextPage: boolean, page: number, search?: string | null, totalCount: number, totalPages: number, orderBy?: { __typename?: 'AdminProductsPaginationOrdersOutput', code?: SortOrder | null, active?: SortOrder | null, title?: SortOrder | null, title_en?: SortOrder | null, created_at?: SortOrder | null, updated_at?: SortOrder | null } | null, filter?: { __typename?: 'AdminProductsPaginationFiltersOutput', active?: boolean | null, categoryId?: number | null } | null, items?: Array<{ __typename?: 'SingleRowProductDto', id: string, title: string, title_en?: string | null, code: number, active: boolean, mainImage?: { __typename?: 'ProductImage', address: string, alt?: string | null } | null }> | null } };

export type AdminVariantQueryVariables = Exact<{
  variantId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;


export type AdminVariantQuery = { __typename?: 'Query', variant: { __typename?: 'VariantDto', id: number, productId: string, warehouseTargetProductVariantId?: string | null, warehouseTargetProductId?: string | null, warehouseTargetDescription?: string | null, salesChannel: Array<SalesChannelEnum>, affiliatePrice?: number | null, guaranteeId: number, stock: number, maxBasketCount: number, price: number, cashPrice?: number | null, creditPrice?: number | null, allowAutoOffer: boolean, purchasePrice?: number | null, active: boolean, warehouse: { __typename?: 'WarehouseDto', title: string, code: string, active: boolean, id: number, productUrlPatten?: string | null }, attrs?: Array<{ __typename?: 'SVariantAttributeDto', key: string, value: string, name: string }> | null, product: { __typename?: 'Product', id: string, title: string, title_en?: string | null, code: number }, guarantee: { __typename?: 'GuaranteeDto', id: number, title: string } } };

export type AdminVariantsQueryVariables = Exact<{
  orderBy?: InputMaybe<AdminVariantsPaginationOrdersInput>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AdminVariantsPaginationFiltersInput>;
}>;


export type AdminVariantsQuery = { __typename?: 'Query', variants: { __typename?: 'PaginatedAdminVariantsDto', page: number, limit: number, hasNextPage: boolean, totalCount: number, totalPages: number, filter?: { __typename?: 'AdminVariantsPaginationFiltersOutput', active?: boolean | null } | null, orderBy?: { __typename?: 'AdminVariantsPaginationOrdersOutput', updated_at?: SortOrder | null, created_at?: SortOrder | null, stock?: SortOrder | null, price?: SortOrder | null, active?: SortOrder | null, id?: SortOrder | null } | null, items?: Array<{ __typename?: 'VariantDto', id: number, productId: string, warehouseTargetProductVariantId?: string | null, warehouseTargetProductId?: string | null, warehouseTargetDescription?: string | null, salesChannel: Array<SalesChannelEnum>, affiliatePrice?: number | null, allowAutoOffer: boolean, guaranteeId: number, stock: number, maxBasketCount: number, price: number, cashPrice?: number | null, creditPrice?: number | null, purchasePrice?: number | null, active: boolean, created_at: any, updated_at: any, warehouse: { __typename?: 'WarehouseDto', title: string, code: string, active: boolean, productUrlPatten?: string | null, id: number }, attrs?: Array<{ __typename?: 'SVariantAttributeDto', name: string, value: string, key: string }> | null, product: { __typename?: 'Product', id: string, title: string, title_en?: string | null, code: number, mainImage?: { __typename?: 'ProductImage', alt?: string | null, name: string, address: string, id: string } | null }, guarantee: { __typename?: 'GuaranteeDto', id: number, title: string } }> | null } };

export type AdminVariantsByIdsQueryVariables = Exact<{
  input: VariantIdsArgs;
}>;


export type AdminVariantsByIdsQuery = { __typename?: 'Query', variantsByIds: Array<{ __typename?: 'VariantDto', id: number, productId: string, allowAutoOffer: boolean, warehouseTargetProductVariantId?: string | null, warehouseTargetProductId?: string | null, warehouseTargetDescription?: string | null, salesChannel: Array<SalesChannelEnum>, affiliatePrice?: number | null, guaranteeId: number, stock: number, maxBasketCount: number, price: number, cashPrice?: number | null, creditPrice?: number | null, purchasePrice?: number | null, active: boolean, created_at: any, updated_at: any, attrs?: Array<{ __typename?: 'SVariantAttributeDto', key: string, name: string, value: string }> | null, warehouse: { __typename?: 'WarehouseDto', title: string, code: string, active: boolean, productUrlPatten?: string | null, id: number }, product: { __typename?: 'Product', id: string, title: string, title_en?: string | null, code: number, mainImage?: { __typename?: 'ProductImage', alt?: string | null, name: string, address: string, id: string } | null }, guarantee: { __typename?: 'GuaranteeDto', id: number, title: string } }> };

export type CreateVariantMutationVariables = Exact<{
  input: CreateVariantInput;
}>;


export type CreateVariantMutation = { __typename?: 'Mutation', createVariant: { __typename?: 'VariantDto', active: boolean, id: number, productId: string, price: number, cashPrice?: number | null, creditPrice?: number | null, purchasePrice?: number | null, allowAutoOffer: boolean, stock: number, guaranteeId: number, maxBasketCount: number } };

export type RemoveVariantMutationVariables = Exact<{
  variantId: Scalars['Float']['input'];
}>;


export type RemoveVariantMutation = { __typename?: 'Mutation', removeVariant: { __typename?: 'VariantDto', id: number } };

export type UpdateVariantMutationVariables = Exact<{
  variantId: Scalars['Float']['input'];
  input: UpdateVariantInput;
}>;


export type UpdateVariantMutation = { __typename?: 'Mutation', updateVariant: { __typename?: 'VariantDto', active: boolean, id: number, productId: string, price: number, cashPrice?: number | null, creditPrice?: number | null, purchasePrice?: number | null, allowAutoOffer: boolean, stock: number, guaranteeId: number, maxBasketCount: number } };

export type CreateAdminOfflineOrderMutationVariables = Exact<{
  input: CreateAdminOfflineOrderInput;
}>;


export type CreateAdminOfflineOrderMutation = { __typename?: 'Mutation', createAdminOfflineOrder: { __typename?: 'AdminOrderDto', id: number, isOffline: boolean, status: OrderStatusEnum, totalPrice: number, memo?: string | null, initialDate?: any | null, created_at: any, user?: { __typename?: 'AdminUserDto', id: number, phoneNumber: string, firstName?: string | null, lastName?: string | null } | null } };

export type AdminWarehouseShippingMethodsQueryVariables = Exact<{
  warehouseId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminWarehouseShippingMethodsQuery = { __typename?: 'Query', getAdminWarehouseShippingMethods: Array<{ __typename?: 'WarehouseShippingMethodDto', id: number, warehouseId: number, name: string, description?: string | null, active: boolean, cashOnDelivery: boolean, cashPrice: number, creditPrice: number, cities?: Array<string> | null, legacyShippingMethodId?: number | null }> };

export type AdminWarehousesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminWarehousesQuery = { __typename?: 'Query', getWarehouses: Array<{ __typename?: 'WarehouseDto', active: boolean, code: string, id: number, title: string, cashDisplayName?: string | null, creditDisplayName?: string | null, shippingOriginLabel?: string | null, profitRanges: Array<{ __typename?: 'ProfitRangeDto', min: number, profit: number }> }> };

export type CreateWarehouseShippingMethodMutationVariables = Exact<{
  input: CreateWarehouseShippingMethodInput;
}>;


export type CreateWarehouseShippingMethodMutation = { __typename?: 'Mutation', createWarehouseShippingMethod: { __typename?: 'WarehouseShippingMethodDto', id: number, warehouseId: number, name: string, active: boolean, cashPrice: number, creditPrice: number } };

export type UpdateWarehouseMutationVariables = Exact<{
  id: Scalars['Float']['input'];
  input: UpdateWarehouseInput;
}>;


export type UpdateWarehouseMutation = { __typename?: 'Mutation', warehouse: { __typename?: 'WarehouseDto', active: boolean, code: string, id: number, title: string, cashDisplayName?: string | null, creditDisplayName?: string | null, shippingOriginLabel?: string | null, profitRanges: Array<{ __typename?: 'ProfitRangeDto', min: number, profit: number }> } };

export type UpdateWarehouseShippingMethodMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateWarehouseShippingMethodInput;
}>;


export type UpdateWarehouseShippingMethodMutation = { __typename?: 'Mutation', updateWarehouseShippingMethod: { __typename?: 'WarehouseShippingMethodDto', id: number, warehouseId: number, name: string, active: boolean, cashPrice: number, creditPrice: number } };

export type AdminWheelPrizesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminWheelPrizesQuery = { __typename?: 'Query', adminWheelPrizes: Array<{ __typename?: 'WheelPrizeAdminDto', available: boolean, color: string, description?: string | null, discountAmount?: number | null, expiryHours?: number | null, id: number, imageUrl?: string | null, isActive: boolean, label: string, maxWins?: number | null, minimumPurchase?: number | null, productCode?: number | null, productTitle?: string | null, sharePercent: number, sortOrder: number, type: WheelPrizeType, unavailableReason?: string | null, variantId?: number | null, weight: number, winCount: number }> };

export type AdminWheelSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminWheelSettingsQuery = { __typename?: 'Query', adminWheelSettings: { __typename?: 'WheelSettingsAdminDto', dailySpinLimit: number, isActive: boolean, minPaidAmountToUnlock: number, prizeExpiryHours: number, rules: string, seoDescription: string, seoKeywords: string, seoTitle: string, subtitle: string, title: string } };

export type AdminWheelSpinsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminWheelSpinsQuery = { __typename?: 'Query', adminWheelSpins: { __typename?: 'PaginatedWheelSpinsDto', hasNextPage: boolean, limit: number, page: number, totalCount: number, totalPages: number, items?: Array<{ __typename?: 'WheelSpinAdminDto', discountAmount?: number | null, discountCode?: string | null, id: number, label: string, prizeType: WheelPrizeType, productCode?: number | null, spunAt: any, used: boolean, userName?: string | null, userPhone?: string | null }> | null } };

export type AdminWheelStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminWheelStatsQuery = { __typename?: 'Query', adminWheelStats: { __typename?: 'WheelStatsDto', activePrizeCount: number, expectedCost: number, redeemedSpins: number, spinsToday: number, totalSpins: number } };

export type CreateWheelPrizeMutationVariables = Exact<{
  input: UpsertWheelPrizeInput;
}>;


export type CreateWheelPrizeMutation = { __typename?: 'Mutation', createWheelPrize: { __typename?: 'WheelPrizeAdminDto', id: number, label: string } };

export type DeleteWheelPrizeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteWheelPrizeMutation = { __typename?: 'Mutation', deleteWheelPrize: boolean };

export type UpdateWheelPrizeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpsertWheelPrizeInput;
}>;


export type UpdateWheelPrizeMutation = { __typename?: 'Mutation', updateWheelPrize: { __typename?: 'WheelPrizeAdminDto', id: number, label: string } };

export type UpdateWheelSettingsMutationVariables = Exact<{
  input: UpdateWheelSettingsInput;
}>;


export type UpdateWheelSettingsMutation = { __typename?: 'Mutation', updateWheelSettings: { __typename?: 'WheelSettingsAdminDto', dailySpinLimit: number, isActive: boolean, minPaidAmountToUnlock: number, prizeExpiryHours: number, rules: string, seoDescription: string, seoKeywords: string, seoTitle: string, subtitle: string, title: string } };

export type WheelVariantOptionsQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type WheelVariantOptionsQuery = { __typename?: 'Query', wheelVariantOptions: Array<{ __typename?: 'WheelVariantOptionDto', active: boolean, id: number, imageUrl?: string | null, price: number, productCode: number, stock: number, title: string }> };

export type AdminProductsViewsReportQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  top: Scalars['Int']['input'];
}>;


export type AdminProductsViewsReportQuery = { __typename?: 'Query', products: { __typename?: 'AdminProductsViewsReportDto', lessViewed: Array<{ __typename?: 'AdminReportProductViewDto', code: number, id: string, imageAddress?: string | null, title: string, viewsCount: number }>, mostViewed: Array<{ __typename?: 'AdminReportProductViewDto', code: number, id: string, imageAddress?: string | null, title: string, viewsCount: number }> } };

export type GetDashboardDataQueryVariables = Exact<{
  days: Scalars['Int']['input'];
}>;


export type GetDashboardDataQuery = { __typename?: 'Query', data: { __typename?: 'DashboardDataDto', kpis: { __typename?: 'KpiDataDto', totalViews: number, uniqueVisitors: number }, referrers: Array<{ __typename?: 'RefererChartDto', name: string, value: number }>, timeSeries: Array<{ __typename?: 'TimeSeriesDto', date: string, unique: number, views: number }> } };

export type OrdersCountQueryVariables = Exact<{ [key: string]: never; }>;


export type OrdersCountQuery = { __typename?: 'Query', ordersCount: { __typename?: 'AdminOrdersCountDto', awaitingPaymentConfirmationCount: number, cancelledCount: number, deliveredCount: number, failedCount: number, onHoldCount: number, outForDeliveryCount: number, paidCount: number, packedCount: number, pendingCount: number, processingCount: number, refundedCount: number, returnRequestedCount: number, returnedCount: number, shippedCount: number, totalCancelledCount: number, totalCancelledPrice: number, totalCount: number, totalPaidCount: number, totalPaidPrice: number, totalPendingCount: number, totalPendingPrice: number } };

export type OrdersSaleChartQueryVariables = Exact<{
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  interval: IntervalEnum;
}>;


export type OrdersSaleChartQuery = { __typename?: 'Query', chart: { __typename?: 'AdminOrdersSaleChart', gateways: Array<Array<{ __typename?: 'AdminOrdersPaymentGatewayChartDto', date: string, totalItems?: number | null, totalOrders?: number | null, totalSale?: number | null, code?: string | null }>>, sales: Array<{ __typename?: 'AdminOrdersSaleChartDto', date: string, totalItems?: number | null, totalOrders?: number | null, totalSale?: number | null }> } };

export type ProductsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductsCountQuery = { __typename?: 'Query', counts: { __typename?: 'AdminProductsCountDto', activeCount: number, notActiveCount: number, totalCount: number } };

export type RefererChartDataQueryVariables = Exact<{ [key: string]: never; }>;


export type RefererChartDataQuery = { __typename?: 'Query', refererChartData: Array<{ __typename?: 'RefererChartDto', name: string, value: number }> };

export type VariantsCountQueryVariables = Exact<{
  warehouseId?: InputMaybe<Scalars['Float']['input']>;
}>;


export type VariantsCountQuery = { __typename?: 'Query', counts: { __typename?: 'AdminVariantsCountDto', totalCount: number, notActiveCount: number, activeWithoutStockCount: number, activeWithStockCount: number, totalActiveItems: number, totalVariantsPriceWithoutOffers: number } };

export type AdminCreatePostCategoryMutationVariables = Exact<{
  input: CreatePostCategoryInput;
}>;


export type AdminCreatePostCategoryMutation = { __typename?: 'Mutation', adminCreatePostCategory: { __typename?: 'AdminPostCategoryDto', id: number, title: string, title_en: string, slug: string, active: boolean, sort?: number | null, seo_url: string, postCount: number } };

export type AdminDeletePostCategoryMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type AdminDeletePostCategoryMutation = { __typename?: 'Mutation', adminDeletePostCategory: boolean };

export type AdminPostCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminPostCategoriesQuery = { __typename?: 'Query', adminPostCategories: Array<{ __typename?: 'AdminPostCategoryDto', id: number, title: string, title_en: string, slug: string, active: boolean, sort?: number | null, seo_url: string, postCount: number }> };

export type AdminPostCategoryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type AdminPostCategoryQuery = { __typename?: 'Query', adminPostCategory: { __typename?: 'AdminPostCategoryDto', id: number, title: string, title_en: string, slug: string, active: boolean, sort?: number | null, seo_url: string, postCount: number } };

export type AdminUpdatePostCategoryMutationVariables = Exact<{
  input: UpdatePostCategoryInput;
}>;


export type AdminUpdatePostCategoryMutation = { __typename?: 'Mutation', adminUpdatePostCategory: { __typename?: 'AdminPostCategoryDto', id: number, title: string, title_en: string, slug: string, active: boolean, sort?: number | null, seo_url: string, postCount: number } };

export type CreatePostMutationVariables = Exact<{
  createPostInput: CreatePostInput;
}>;


export type CreatePostMutation = { __typename?: 'Mutation', createPost: { __typename?: 'AdminPost', id: number, title: string, slug: string, status: PostStatus, createdAt: any } };

export type GetAdminPostByIdQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type GetAdminPostByIdQuery = { __typename?: 'Query', adminPostById: { __typename?: 'AdminPost', id: number, title: string, titleEn?: string | null, slug: string, excerpt?: string | null, content: string, readingTime: number, status: PostStatus, active: boolean, publishedAt?: any | null, viewCount: number, sortOrder: number, categoryId?: number | null, categoryName?: string | null, tags: Array<string>, seoKeywords?: Array<string> | null, metaTitle?: string | null, metaDescription?: string | null, canonicalUrl?: string | null, indexable: boolean, createdAt: any, updatedAt: any, coverImageId?: string | null, coverImage?: { __typename?: 'ImageDto', id: string, address: string, name: string, alt?: string | null } | null, productSettings?: { __typename?: 'PostProductSettingsDto', enabled: boolean, sort: PostProductSort, limit: number, sectionTitle?: string | null, brandIds: Array<number>, categoryIds: Array<number>, includeChildCategories: boolean, usePostTags: boolean, tagIds: Array<number>, productCodes: Array<number>, hasOfferOnly: boolean } | null, productBrands: Array<{ __typename?: 'AdminPostLabeledIdDto', id: number, title: string }>, productCategories: Array<{ __typename?: 'AdminPostLabeledIdDto', id: number, title: string }>, productTags: Array<{ __typename?: 'AdminPostLabeledIdDto', id: number, title: string }>, productPicks: Array<{ __typename?: 'AdminPostProductPickDto', code: number, title: string, image?: string | null, inStock: boolean, active: boolean }> } };

export type GetAdminPostBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetAdminPostBySlugQuery = { __typename?: 'Query', adminPostBySlug: { __typename?: 'AdminPost', id: number, title: string, titleEn?: string | null, slug: string, excerpt?: string | null, content: string, readingTime: number, status: PostStatus, active: boolean, publishedAt?: any | null, viewCount: number, sortOrder: number, categoryId?: number | null, categoryName?: string | null, tags: Array<string>, seoKeywords?: Array<string> | null, metaTitle?: string | null, metaDescription?: string | null, canonicalUrl?: string | null, indexable: boolean, createdAt: any, updatedAt: any, coverImageId?: string | null, coverImage?: { __typename?: 'ImageDto', id: string, address: string, name: string, alt?: string | null } | null, productSettings?: { __typename?: 'PostProductSettingsDto', enabled: boolean, sort: PostProductSort, limit: number, sectionTitle?: string | null, brandIds: Array<number>, categoryIds: Array<number>, includeChildCategories: boolean, usePostTags: boolean, tagIds: Array<number>, productCodes: Array<number>, hasOfferOnly: boolean } | null, productBrands: Array<{ __typename?: 'AdminPostLabeledIdDto', id: number, title: string }>, productCategories: Array<{ __typename?: 'AdminPostLabeledIdDto', id: number, title: string }>, productTags: Array<{ __typename?: 'AdminPostLabeledIdDto', id: number, title: string }>, productPicks: Array<{ __typename?: 'AdminPostProductPickDto', code: number, title: string, image?: string | null, inStock: boolean, active: boolean }> } };

export type GetAdminPostsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<AdminPostsPaginationOrdersInput>;
  filter?: InputMaybe<AdminPostsPaginationFiltersInput>;
}>;


export type GetAdminPostsQuery = { __typename?: 'Query', adminPosts: { __typename?: 'PaginatedAdminPostsDto', totalCount: number, hasNextPage: boolean, search?: string | null, items?: Array<{ __typename?: 'AdminPostRowDto', id: number, title: string, slug: string, status: PostStatus, categoryName?: string | null, viewCount?: number | null, publishedAt?: any | null, createdAt: any, updatedAt: any, active: boolean }> | null, orderBy?: { __typename?: 'AdminPostsPaginationOrdersOutput', updatedAt?: SortOrder | null, createdAt?: SortOrder | null, title?: SortOrder | null, viewCount?: SortOrder | null, status?: SortOrder | null, publishedAt?: SortOrder | null, category_title?: SortOrder | null } | null, filter?: { __typename?: 'AdminPostsPaginationFiltersOutput', status?: PostStatus | null, active?: boolean | null, categoryId?: number | null } | null } };

export type UpdatePostMutationVariables = Exact<{
  updatePostInput: UpdatePostInput;
}>;


export type UpdatePostMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'AdminPost', id: number, title: string, slug: string, status: PostStatus, updatedAt: any } };

export type AdminBlogDashboardQueryVariables = Exact<{
  days: Scalars['Int']['input'];
}>;


export type AdminBlogDashboardQuery = { __typename?: 'Query', adminBlogDashboard: { __typename?: 'BlogDashboardDto', days: number, overview: { __typename?: 'BlogDashboardOverviewDto', totalPosts: number, publishedPosts: number, draftPosts: number, archivedPosts: number, activePosts: number, totalViews: number, viewsInRange: number, uniqueVisitors: number, loggedInViews: number, guestViews: number, viewsToday: number, viewsYesterday: number, categoryCount: number, taggedPosts: number, avgReadingTime: number, publishedInRange: number, createdInRange: number, uncategorizedPosts: number }, seo: { __typename?: 'BlogDashboardSeoDto', missingMetaTitle: number, missingMetaDescription: number, missingExcerpt: number, missingCover: number, notIndexable: number, missingKeywords: number, healthyPosts: number }, daily: Array<{ __typename?: 'BlogDashboardDayDto', date: string, views: number, uniqueVisitors: number, published: number }>, hourly: Array<{ __typename?: 'BlogDashboardHourDto', hour: number, views: number }>, topPosts: Array<{ __typename?: 'BlogDashboardTopPostDto', id: number, title: string, slug: string, categoryName?: string | null, viewCount: number, viewsInRange: number, status: PostStatus, readingTime: number, publishedAt?: any | null }>, categories: Array<{ __typename?: 'BlogDashboardCategoryDto', id: number, title: string, postCount: number, viewCount: number }>, topTags: Array<{ __typename?: 'BlogDashboardTagDto', title: string, postCount: number }>, recentPosts: Array<{ __typename?: 'BlogDashboardRecentPostDto', id: number, title: string, slug: string, status: PostStatus, updatedAt: any, viewCount: number }>, traffic: { __typename?: 'BlogDashboardTrafficDto', visits: number, uniqueVisitors: number, sources: Array<{ __typename?: 'BlogDashboardSourceDto', source: string, kind: string, visits: number, uniqueVisitors: number }> } } };

export type PostsSiteMapQueryVariables = Exact<{
  limit: Scalars['Float']['input'];
  skip: Scalars['Float']['input'];
}>;


export type PostsSiteMapQuery = { __typename?: 'Query', postsSiteMap: Array<{ __typename?: 'PostSiteMapDto', slug: string, updatedAt: any }> };

export type PostsSiteMapCountQueryVariables = Exact<{ [key: string]: never; }>;


export type PostsSiteMapCountQuery = { __typename?: 'Query', postsSiteMapCount: number };

export type ProductsSiteMapQueryVariables = Exact<{
  limit: Scalars['Float']['input'];
  skip: Scalars['Float']['input'];
}>;


export type ProductsSiteMapQuery = { __typename?: 'Query', productsSiteMap: Array<{ __typename?: 'ProductSiteMapDto', code: number, title: string, updated_at: any }> };

export type ProductsSiteMapCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductsSiteMapCountQuery = { __typename?: 'Query', productsSiteMapCount: number };

export type GetPaymentSourceDetectorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentSourceDetectorsQuery = { __typename?: 'Query', getPaymentSourceDetectors: Array<{ __typename?: 'PaymentSourceDetectorDto', code: string, matchKeys: Array<string>, sourcePriority: number }> };

export type AddToCartMutationVariables = Exact<{
  createCartInput: CreateCartInput;
}>;


export type AddToCartMutation = { __typename?: 'Mutation', addToCart: { __typename?: 'SCartDto', id: string, pricingMode: CartPricingMode, subtotal: number, discountAmount: number, totalPrice: number, cartItems: Array<{ __typename?: 'SCartItemDto', id: number, quantity: number, unitPrice: number, totalPrice: number, discountPrice?: number | null, productId: string, variantId: number, offerId?: number | null, product: { __typename?: 'SimpleProductDto', id: string, code: number, title: string, title_en?: string | null, categoryId?: number | null, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null } | null }, variant: { __typename?: 'SVariantDto', id: number, maxBasketCount: number, stock?: number | null, price: number, cashPrice?: number | null, creditPrice?: number | null, warehouseId: number, guarantee: { __typename?: 'SGuaranteeDto', title: string }, attrs?: Array<{ __typename?: 'SVariantAttributeDto', name: string, value: string, key: string }> | null, warehouse?: { __typename?: 'SWarehouseDisplayDto', id: number, title: string, cashDisplayName?: string | null, creditDisplayName?: string | null, shippingOriginLabel?: string | null } | null }, changeHistories?: Array<{ __typename?: 'SCartItemChangeHistoryDto', id: number, available?: boolean | null, newOfferId?: number | null, oldOfferId?: number | null, oldUnitPrice?: number | null, newUnitPrice?: number | null, newQuantity?: number | null, oldQuantity?: number | null, newDiscountPrice?: number | null, oldDiscountPrice?: number | null }> | null, offer?: { __typename?: 'SOfferDto', id: number, stock?: number | null, maxBasketCount: number, price: number, percentage: number, end_at: any, offerType: { __typename?: 'SOfferTypeDto', title: string } } | null }> } };

export type GetCartQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCartQuery = { __typename?: 'Query', getCart: { __typename?: 'SCartDto', id: string, pricingMode: CartPricingMode, subtotal: number, discountAmount: number, totalPrice: number, cartItems: Array<{ __typename?: 'SCartItemDto', id: number, quantity: number, unitPrice: number, totalPrice: number, discountPrice?: number | null, productId: string, variantId: number, offerId?: number | null, product: { __typename?: 'SimpleProductDto', id: string, code: number, title: string, title_en?: string | null, categoryId?: number | null, mainImage?: { __typename?: 'SImageDto', address: string, alt?: string | null } | null }, variant: { __typename?: 'SVariantDto', id: number, maxBasketCount: number, stock?: number | null, price: number, cashPrice?: number | null, creditPrice?: number | null, warehouseId: number, guarantee: { __typename?: 'SGuaranteeDto', title: string }, warehouse?: { __typename?: 'SWarehouseDisplayDto', id: number, title: string, cashDisplayName?: string | null, creditDisplayName?: string | null, shippingOriginLabel?: string | null } | null, attrs?: Array<{ __typename?: 'SVariantAttributeDto', key: string, value: string, name: string }> | null }, offer?: { __typename?: 'SOfferDto', id: number, stock?: number | null, maxBasketCount: number, price: number, percentage: number, end_at: any, offerType: { __typename?: 'SOfferTypeDto', title: string } } | null, changeHistories?: Array<{ __typename?: 'SCartItemChangeHistoryDto', id: number, available?: boolean | null, newOfferId?: number | null, oldOfferId?: number | null, oldUnitPrice?: number | null, newUnitPrice?: number | null, newQuantity?: number | null, oldQuantity?: number | null, newDiscountPrice?: number | null, oldDiscountPrice?: number | null }> | null }> } };

export type CreateUserLogMutationVariables = Exact<{
  createUserLogInput: CreateUserLogInput;
}>;


export type CreateUserLogMutation = { __typename?: 'Mutation', createUserLog: string };

export type LoginReqMutationVariables = Exact<{
  input: LoginUserInput;
}>;


export type LoginReqMutation = { __typename?: 'Mutation', login: { __typename: 'CodeSentResult', phoneNumber: string, sent: boolean, deadline: number } | { __typename: 'TokenResult', token: string, refresh: string } };

export type ProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileQuery = { __typename?: 'Query', me: { __typename?: 'User', roles: Array<Roles>, phoneNumber: string, birth_date?: any | null, firstName?: string | null, lastName?: string | null, id: number } };

export type PingQueryVariables = Exact<{ [key: string]: never; }>;


export type PingQuery = { __typename?: 'Query', ping: string };

export type RefreshMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshMutation = { __typename?: 'Mutation', refreshToken: { __typename?: 'TokenResult', refresh: string, token: string } };

export const SCurrentOrderDtoFragmentFragmentDoc = gql`
    fragment SCurrentOrderDtoFragment on SCurrentOrderDto {
  id
  shippingPrice
  totalPrice
  userAddressId
  shippingMethodId
  paymentMethodId
  paymentGatewayId
  cashOnDelivery
  memo
  pricingMode
  shipments {
    id
    warehouseId
    warehouseShippingMethodId
    shippingPrice
    status
    trackingCode
    warehouseShippingMethod {
      id
      warehouseId
      name
      description
      cashOnDelivery
      cashPrice
      creditPrice
      price
      cities
    }
  }
  discount {
    discountAmount
    discountCode
  }
  cart {
    cartItems {
      discountPrice
      id
      offer {
        end_at
        id
        maxBasketCount
        offerType {
          id
          title
        }
        offerTypeId
        percentage
        price
        cashPrice
        creditPrice
        stock
      }
      offerId
      product {
        code
        id
        mainImage {
          address
          alt
          id
          name
        }
        title
        title_en
      }
      productId
      quantity
      totalPrice
      unitPrice
      variant {
        attrs {
          value
          name
          key
        }
        warehouseId
        warehouse {
          id
          title
          cashDisplayName
          creditDisplayName
          shippingOriginLabel
        }
        guarantee {
          id
          title
        }
        guaranteeId
        id
        maxBasketCount
        offer {
          end_at
          id
          maxBasketCount
          offerType {
            id
            title
          }
          offerTypeId
          percentage
          price
          cashPrice
          creditPrice
          stock
        }
        price
        cashPrice
        creditPrice
        stock
      }
      variantId
    }
    discountAmount
    id
    pricingMode
    subtotal
    totalPrice
  }
}
    `;
export const ProductFragmentDoc = gql`
    fragment product on SProduct {
  code
  shortDescription
  video
  colors {
    hex
    id
    title
  }
  id
  mainImage {
    address
    alt
    id
    name
  }
  title
  title_en
  variant {
    guarantee {
      id
      title
    }
    guaranteeId
    id
    hasStock
    maxBasketCount
    offer {
      end_at
      id
      maxBasketCount
      offerType {
        id
        title
      }
      offerTypeId
      percentage
      price
      cashPrice
      creditPrice
      stock
    }
    price
    cashPrice
    creditPrice
    stock
  }
}
    `;
export const CategoryFieldNameFragmentDoc = gql`
    fragment CategoryFieldName on CategoryDto {
  id
  title
  title_en
  slug
  svg
  image {
    address
  }
  bgColor
}
    `;
export const CategoriesRecursiveItemsFragmentDoc = gql`
    fragment CategoriesRecursiveItems on CategoryDto {
  ...CategoryFieldName
  children {
    ...CategoryFieldName
    children {
      ...CategoryFieldName
      children {
        ...CategoryFieldName
        children {
          ...CategoryFieldName
          children {
            ...CategoryFieldName
            children {
              ...CategoryFieldName
              children {
                ...CategoryFieldName
                children {
                  ...CategoryFieldName
                  children {
                    ...CategoryFieldName
                    children {
                      ...CategoryFieldName
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${CategoryFieldNameFragmentDoc}`;
export const CategoryFieldsFragmentDoc = gql`
    fragment CategoryFields on CategoryDto {
  id
  title
  title_en
  snappCommissionType
  basalamCategoryId
  active
  sort
  svg
  slug
  guideContent
  guideTitle
  bgColor
  imageId
  image {
    address
    id
    alt
    name
    local
  }
}
    `;
export const CategoriesRecursiveFragmentDoc = gql`
    fragment CategoriesRecursive on CategoryDto {
  ...CategoryFields
  children {
    ...CategoryFields
    children {
      ...CategoryFields
      children {
        ...CategoryFields
        children {
          ...CategoryFields
          children {
            ...CategoryFields
            children {
              ...CategoryFields
              children {
                ...CategoryFields
                children {
                  ...CategoryFields
                  children {
                    ...CategoryFields
                    children {
                      ...CategoryFields
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${CategoryFieldsFragmentDoc}`;
export const CategoryItemFragmentDoc = gql`
    fragment CategoryItem on CategoryDto {
  id
  title
  title_en
  active
  slug
}
    `;
export const CategoryItemRecursiveFragmentDoc = gql`
    fragment CategoryItemRecursive on CategoryDto {
  ...CategoryItem
  parent {
    ...CategoryItem
    parent {
      ...CategoryItem
      parent {
        ...CategoryItem
        parent {
          ...CategoryItem
          parent {
            ...CategoryItem
            parent {
              ...CategoryItem
              parent {
                ...CategoryItem
                parent {
                  ...CategoryItem
                  parent {
                    ...CategoryItem
                    parent {
                      ...CategoryItem
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${CategoryItemFragmentDoc}`;
export const SearchDocument = gql`
    query Search($filter: ProductsPaginationFiltersInput, $limit: Int!, $sort: SearchSort, $page: Int!, $search: String) {
  search(
    filter: $filter
    limit: $limit
    sort: $sort
    page: $page
    search: $search
  ) {
    meta {
      colors {
        id
        hex
        title
      }
      brands {
        id
        title
        title_en
      }
      targetCategory {
        id
        title
        title_en
        slug
        description
        shortDescription
        keywords
        svg
        image {
          address
        }
        bgColor
        children {
          id
          svg
          title
          title_en
          slug
          image {
            address
          }
          bgColor
        }
      }
      categoriesInPath {
        id
        slug
        title
        title_en
      }
      oneLevelUpCategories {
        id
        title
        title_en
        slug
        image {
          address
        }
        bgColor
        children {
          id
          title
          title_en
          slug
          image {
            address
          }
          bgColor
          children {
            id
            title
            title_en
            slug
            image {
              address
            }
            bgColor
          }
        }
      }
    }
    filter {
      colors
      brands
      hasOffer
      inStock
      maxPrice
      minPrice
    }
    limit
    page
    hasNextPage
    sort
    search
    totalCount
    totalPages
    items {
      id
      title
      title_en
      code
      shortDescription
      video
      mainImage {
        address
        alt
      }
      colors {
        hex
        title
      }
      variant {
        attrs {
          name
          value
          key
        }
        id
        stock
        maxBasketCount
        price
        cashPrice
        creditPrice
        offer {
          id
          end_at
          maxBasketCount
          stock
          percentage
          price
          cashPrice
          creditPrice
          offerTypeId
          offerType {
            title
          }
        }
      }
    }
  }
}
    `;
export const SearchFiltersDocument = gql`
    query searchFilters {
  colors {
    hex
    id
    title
  }
  brands: brandsForFilter {
    id
    title
    title_en
  }
}
    `;
export const PostWithSlugDocument = gql`
    query postWithSlug($slug: String!) {
  post: postWithSlug(slug: $slug) {
    id
    title
    titleEn
    slug
    excerpt
    content
    readingTime
    publishedAt
    category {
      id
      title
      seo_url
      slug
    }
    tags
    seoKeywords
    metaTitle
    metaDescription
    updatedAt
    canonicalUrl
    indexable
    coverImage {
      id
      address
      name
      alt
    }
    productSectionTitle
    products {
      code
      video
      colors {
        hex
        id
        title
      }
      id
      mainImage {
        address
        alt
        id
        name
      }
      shortDescription
      title
      title_en
      variant {
        guarantee {
          id
          title
        }
        guaranteeId
        id
        maxBasketCount
        offer {
          end_at
          id
          maxBasketCount
          offerType {
            id
            title
          }
          offerTypeId
          percentage
          price
          cashPrice
          creditPrice
          stock
        }
        price
        cashPrice
        creditPrice
        stock
        attrs {
          key
          value
          name
        }
      }
    }
    relatedPosts {
      id
      title
      titleEn
      slug
      publishedAt
      category {
        id
        title
        seo_url
        slug
      }
      coverImage {
        id
        address
        name
        alt
      }
    }
  }
}
    `;
export const SearchPostsDocument = gql`
    query searchPosts($filter: PostsPaginationFiltersInput, $limit: Int!, $page: Int!, $search: String, $sort: PostSearchSort) {
  searchPosts(
    filter: $filter
    limit: $limit
    page: $page
    search: $search
    sort: $sort
  ) {
    filter {
      categorySlug
    }
    hasNextPage
    meta {
      categories {
        id
        title
        title_en
        slug
        seo_url
      }
    }
    items {
      category {
        id
        slug
        title
        title_en
      }
      coverImage {
        address
        alt
        id
        name
      }
      id
      publishedAt
      slug
      title
      titleEn
      updatedAt
    }
    limit
    page
    search
    sort
    totalCount
    totalPages
  }
}
    `;
export const PaymentResultDocument = gql`
    query paymentResult($orderId: Float!, $trackId: String!) {
  paymentResult(orderId: $orderId, trackId: $trackId) {
    orderId
    seen
    status
    trackId
    refNumber
    canRetry
    order {
      created_at
      deliveryTrackingCode
      discountPrice
      history {
        created_at
        id
        newStatus
        oldStatus
      }
      id
      initialDate
      items {
        discountPrice
        id
        product {
          code
          id
          mainImage {
            address
            alt
            id
            name
          }
          title
          title_en
        }
        productTitle
        productTitleEn
        quantity
        totalPrice
        unitPrice
        variantGuaranteeId
        variantGuaranteeTitle
        variantAttrs {
          value
          key
          name
        }
      }
      memo
      paymentGateway {
        code
        description
        id
        installment
        logo {
          address
          alt
          id
          name
        }
        logoId
        name
      }
      paymentMethod {
        code
        description
        id
        name
      }
      shippingAddress {
        address
        city {
          id
          lat
          long
          name
          zoom
        }
        id
        lat
        long
        postalCode
        province {
          id
          lat
          long
          name
          zoom
        }
        recipientFirstName
        recipientLastName
        recipientPhoneNumber
      }
      shippingMethod {
        cashOnDelivery
        cities
        description
        id
        name
        price
      }
      shippingPrice
      status
      totalPrice
    }
  }
}
    `;
export const AddDiscountToUserCurrentOrderDocument = gql`
    mutation addDiscountToUserCurrentOrder($code: String!, $orderId: Float!) {
  addDiscountToUserCurrentOrder(code: $code, orderId: $orderId) {
    ...SCurrentOrderDtoFragment
  }
}
    ${SCurrentOrderDtoFragmentFragmentDoc}`;
export const ConvertCurrentOrderPricingModeDocument = gql`
    mutation convertCurrentOrderPricingMode($pricingMode: CartPricingMode!) {
  order: convertCurrentOrderPricingMode(pricingMode: $pricingMode) {
    ...SCurrentOrderDtoFragment
  }
}
    ${SCurrentOrderDtoFragmentFragmentDoc}`;
export const GetApoloanEligibilityDocument = gql`
    query getApoloanEligibility($amount: Float!) {
  getApoloanEligibility(amount: $amount) {
    description
    eligible
    title_message
  }
}
    `;
export const GetCheckoutRequirementsDocument = gql`
    query getCheckoutRequirements($source: String) {
  paymentMethods: getPaymentMethods {
    id
    code
    description
    name
  }
  shippingMethods: getShippingMethods {
    id
    name
    description
    price
    cashOnDelivery
    cities
    warehouses
  }
  paymentGateways: getPaymentGateways(source: $source) {
    description
    installment
    minAmountToPayment
    maxAmountToPayment
    code
    id
    logo {
      address
      alt
    }
    logoId
    name
  }
}
    `;
export const GetSnapPayEligibilityDocument = gql`
    query getSnapPayEligibility($amount: Float!) {
  getSnapPayEligibility(amount: $amount) {
    description
    eligible
    title_message
  }
}
    `;
export const GetTorobPayEligibilityDocument = gql`
    query getTorobPayEligibility($amount: Float!) {
  getTorobPayEligibility(amount: $amount) {
    description
    eligible
    title_message
  }
}
    `;
export const GetUserCurrentOrderDocument = gql`
    query getUserCurrentOrder {
  order: getUserCurrentOrder {
    ...SCurrentOrderDtoFragment
  }
}
    ${SCurrentOrderDtoFragmentFragmentDoc}`;
export const GetWarehouseShippingMethodsDocument = gql`
    query getWarehouseShippingMethods($warehouseId: Int!, $cityId: String, $pricingMode: CartPricingMode) {
  warehouseShippingMethods: getWarehouseShippingMethods(
    warehouseId: $warehouseId
    cityId: $cityId
    pricingMode: $pricingMode
  ) {
    id
    warehouseId
    name
    description
    cashOnDelivery
    cashPrice
    creditPrice
    price
    cities
  }
}
    `;
export const PayDocument = gql`
    mutation pay($orderPayInput: OrderPayInput!) {
  pay(orderPayInput: $orderPayInput) {
    payUrl
  }
}
    `;
export const RemoveDiscountFromUserCurrentOrderDocument = gql`
    mutation removeDiscountFromUserCurrentOrder($orderId: Float!) {
  removeDiscountFromUserCurrentOrder(orderId: $orderId) {
    ...SCurrentOrderDtoFragment
  }
}
    ${SCurrentOrderDtoFragmentFragmentDoc}`;
export const UpdateUserCurrentOrderDocument = gql`
    mutation updateUserCurrentOrder($orderId: Float!, $updateOrderInput: UpdateOrderInput!) {
  order: updateUserCurrentOrder(id: $orderId, updateOrderInput: $updateOrderInput) {
    ...SCurrentOrderDtoFragment
  }
}
    ${SCurrentOrderDtoFragmentFragmentDoc}`;
export const CartRecommendationsDocument = gql`
    query cartRecommendations($input: CartRecommendationsInput!) {
  cartRecommendations(input: $input) {
    completeTheLook {
      code
      video
      colors {
        hex
        id
        title
      }
      id
      mainImage {
        address
        alt
        id
        name
      }
      shortDescription
      title
      title_en
      variant {
        guarantee {
          id
          title
        }
        guaranteeId
        id
        maxBasketCount
        offer {
          end_at
          id
          maxBasketCount
          offerType {
            id
            title
          }
          offerTypeId
          percentage
          price
          cashPrice
          creditPrice
          stock
        }
        price
        cashPrice
        creditPrice
        stock
        attrs {
          key
          value
          name
        }
      }
    }
    offers {
      code
      video
      colors {
        hex
        id
        title
      }
      id
      mainImage {
        address
        alt
        id
        name
      }
      shortDescription
      title
      title_en
      variant {
        guarantee {
          id
          title
        }
        guaranteeId
        id
        maxBasketCount
        offer {
          end_at
          id
          maxBasketCount
          offerType {
            id
            title
          }
          offerTypeId
          percentage
          price
          cashPrice
          creditPrice
          stock
        }
        price
        cashPrice
        creditPrice
        stock
        attrs {
          key
          value
          name
        }
      }
    }
  }
}
    `;
export const MyWheelStatusDocument = gql`
    query myWheelStatus {
  myWheelStatus {
    canSpin
    blockReason
    message
    nextSpinAt
    activePrize {
      description
      discountAmount
      discountCode
      endDate
      imageUrl
      label
      minimumPurchase
      prizeType
      productCode
      productTitle
    }
  }
}
    `;
export const SpinWheelDocument = gql`
    mutation spinWheel {
  spinWheel {
    color
    description
    discountAmount
    discountCode
    endDate
    imageUrl
    label
    minimumPurchase
    prizeId
    prizeIndex
    prizeType
    productCode
    productTitle
    segments {
      color
      id
      label
    }
  }
}
    `;
export const WheelCampaignDocument = gql`
    query wheelCampaign {
  wheelCampaign {
    dailySpinLimit
    isActive
    minPaidAmountToUnlock
    prizeExpiryHours
    rules
    seoDescription
    seoKeywords
    seoTitle
    subtitle
    title
    prizes {
      color
      description
      discountAmount
      id
      imageUrl
      label
      minimumPurchase
      productCode
      productTitle
      type
    }
  }
}
    `;
export const ConvertCartPricingModeDocument = gql`
    mutation ConvertCartPricingMode($pricingMode: CartPricingMode!) {
  convertCartPricingMode(pricingMode: $pricingMode) {
    id
    pricingMode
  }
}
    `;
export const SearchRelatedProductsDocument = gql`
    query searchRelatedProducts($searchRelatedProductsId: String!) {
  searchRelatedProducts(id: $searchRelatedProductsId) {
    code
    video
    colors {
      hex
      id
      title
    }
    id
    mainImage {
      address
      alt
      id
      name
    }
    shortDescription
    title
    title_en
    variant {
      attrs {
        key
        value
        name
      }
      guarantee {
        id
        title
      }
      guaranteeId
      id
      maxBasketCount
      offer {
        end_at
        id
        maxBasketCount
        offerType {
          id
          title
        }
        offerTypeId
        percentage
        price
        cashPrice
        creditPrice
        stock
      }
      price
      cashPrice
      creditPrice
      stock
    }
  }
}
    `;
export const SearchRelatedProductsByCodeDocument = gql`
    query searchRelatedProductsByCode($code: Float!) {
  searchRelatedProductsByCode(code: $code) {
    code
    video
    colors {
      hex
      id
      title
    }
    id
    mainImage {
      address
      alt
      id
      name
    }
    shortDescription
    title
    title_en
    variant {
      guarantee {
        id
        title
      }
      guaranteeId
      id
      maxBasketCount
      offer {
        end_at
        id
        maxBasketCount
        offerType {
          id
          title
        }
        offerTypeId
        percentage
        price
        cashPrice
        creditPrice
        stock
      }
      price
      cashPrice
      creditPrice
      stock
      attrs {
        key
        value
        name
      }
    }
  }
}
    `;
export const SingleProductDocument = gql`
    query SingleProduct($code: Float!) {
  product: productWithCode(code: $code) {
    id
    videos {
      address
      id
      sort
      thumbnail
    }
    category {
      slug
      title
      guideTitle
      guideContent
      parent {
        title
        slug
        parent {
          title
          slug
          parent {
            title
            slug
            parent {
              title
              slug
              parent {
                title
                slug
                parent {
                  title
                  slug
                  parent {
                    title
                    slug
                    parent {
                      title
                      slug
                      parent {
                        title
                        slug
                        parent {
                          title
                          slug
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    title
    code
    title_en
    brandId
    brand {
      id
      title
      title_en
      image {
        address
        alt
      }
    }
    shortDescription
    description
    features
    keywords
    specifications {
      id
      title
      type
      text
      checked
      sort
    }
    tags {
      id
      title
    }
    images {
      address
      alt
      id
      name
      isMain
    }
    variants {
      attrs {
        name
        value
        key
      }
      hasStock
      guarantee {
        id
        title
      }
      guaranteeId
      id
      stock
      price
      cashPrice
      creditPrice
      warehouseId
      warehouse {
        id
        title
        cashDisplayName
        creditDisplayName
        shippingOriginLabel
      }
      maxBasketCount
      offer {
        id
        end_at
        price
        cashPrice
        creditPrice
        stock
        maxBasketCount
        percentage
        offerType {
          id
          title
        }
      }
    }
  }
}
    `;
export const CitiesDocument = gql`
    query cities($provinceId: String) {
  cities(provinceId: $provinceId) {
    id
    lat
    long
    name
    zoom
  }
}
    `;
export const CreateUserAddressDocument = gql`
    mutation createUserAddress($createUserAddressInput: CreateUserAddressInput!) {
  createUserAddress(createUserAddressInput: $createUserAddressInput) {
    address
    city {
      id
      lat
      long
      name
      zoom
    }
    cityId
    id
    isDefault
    lat
    long
    postalCode
    province {
      id
      lat
      long
      name
      zoom
    }
    provinceId
    recipientFirstName
    recipientLastName
    recipientPhoneNumber
  }
}
    `;
export const ProvincesDocument = gql`
    query provinces {
  provinces {
    id
    lat
    long
    name
    zoom
  }
}
    `;
export const RemoveUserAddressDocument = gql`
    mutation removeUserAddress($removeUserAddressId: String!) {
  removeUserAddress(id: $removeUserAddressId) {
    address
    city {
      id
      lat
      long
      name
      zoom
    }
    cityId
    id
    isDefault
    lat
    long
    postalCode
    province {
      id
      lat
      long
      name
      zoom
    }
    provinceId
    recipientFirstName
    recipientLastName
    recipientPhoneNumber
  }
}
    `;
export const ToggleUserAddressIsDefaultDocument = gql`
    mutation toggleUserAddressIsDefault($toggleUserAddressIsDefaultId: String!) {
  toggleUserAddressIsDefault(id: $toggleUserAddressIsDefaultId) {
    address
    city {
      id
      lat
      long
      name
      zoom
    }
    cityId
    id
    isDefault
    lat
    long
    postalCode
    province {
      id
      lat
      long
      name
      zoom
    }
    provinceId
    recipientFirstName
    recipientLastName
    recipientPhoneNumber
  }
}
    `;
export const UpdateUserAddressDocument = gql`
    mutation updateUserAddress($updateUserAddressId: String!, $updateUserAddressInput: UpdateUserAddressInput!) {
  updateUserAddress(
    id: $updateUserAddressId
    updateUserAddressInput: $updateUserAddressInput
  ) {
    address
    city {
      id
      lat
      long
      name
      zoom
    }
    cityId
    id
    isDefault
    lat
    long
    postalCode
    province {
      id
      lat
      long
      name
      zoom
    }
    provinceId
    recipientFirstName
    recipientLastName
    recipientPhoneNumber
  }
}
    `;
export const UserAddressDocument = gql`
    query userAddress($userAddressId: String!) {
  userAddress(id: $userAddressId) {
    address
    city {
      id
      lat
      long
      name
      zoom
    }
    cityId
    id
    isDefault
    lat
    long
    postalCode
    province {
      id
      lat
      long
      name
      zoom
    }
    provinceId
    recipientFirstName
    recipientLastName
    recipientPhoneNumber
  }
}
    `;
export const UserAddressesDocument = gql`
    query userAddresses {
  userAddresses {
    address
    city {
      id
      lat
      long
      name
      zoom
    }
    cityId
    id
    isDefault
    lat
    long
    postalCode
    province {
      id
      lat
      long
      name
      zoom
    }
    provinceId
    recipientFirstName
    recipientLastName
    recipientPhoneNumber
  }
}
    `;
export const UpdateMeDocument = gql`
    mutation updateMe($input: UpdateUserInput!) {
  updateMe(updateUserInput: $input) {
    id
    birth_date
    firstName
    lastName
    phoneNumber
  }
}
    `;
export const UserOrderDocument = gql`
    query userOrder($userOrderId: Float!) {
  userOrder(id: $userOrderId) {
    created_at
    deliveryTrackingCode
    discountPrice
    history {
      created_at
      id
      newStatus
      oldStatus
    }
    id
    initialDate
    items {
      discountPrice
      id
      warehouseId
      product {
        code
        id
        mainImage {
          address
          alt
        }
        title
        title_en
      }
      productTitle
      productTitleEn
      quantity
      totalPrice
      unitPrice
      variantGuaranteeId
      variantGuaranteeTitle
      variantAttrs {
        value
        name
        key
      }
    }
    memo
    paymentGateway {
      description
      id
      installment
      logo {
        address
        alt
      }
      logoId
      name
    }
    paymentMethod {
      code
      description
      id
      name
    }
    shippingAddress {
      address
      city {
        name
      }
      id
      lat
      long
      postalCode
      cityName
      provinceName
      province {
        name
      }
      recipientFirstName
      recipientLastName
      recipientPhoneNumber
    }
    shippingMethod {
      id
      cashOnDelivery
      name
    }
    shippingPrice
    shipments {
      id
      warehouseId
      warehouseTitle
      shippingOriginLabel
      shippingMethodName
      cashOnDelivery
      shippingPrice
      status
      trackingCode
      legacyShippingMethodId
    }
    status
    totalPrice
  }
}
    `;
export const UserOrdersDocument = gql`
    query userOrders($filter: SOrdersPaginationFiltersInput, $limit: Int!, $page: Int!) {
  userOrders(filter: $filter, limit: $limit, page: $page) {
    filter {
      status
    }
    hasNextPage
    items {
      id
      totalPrice
      created_at
      initialDate
      status
      items {
        id
        quantity
        productTitle
        productTitleEn
        product {
          id
          code
          title
          title_en
          mainImage {
            address
          }
        }
      }
    }
    limit
    meta {
      cancelled
      delivered
      inprogress
      returned
    }
    page
    totalCount
    totalPages
  }
}
    `;
export const UserProductViewsDocument = gql`
    query userProductViews($limit: Int!, $orderBy: UserProductViewsPaginationOrdersInput, $page: Int!) {
  userProductViews(limit: $limit, orderBy: $orderBy, page: $page) {
    items {
      id
      code
      video
      mainImage {
        address
      }
      shortDescription
      title
      title_en
      variant {
        guarantee {
          id
          title
        }
        guaranteeId
        id
        maxBasketCount
        offer {
          end_at
          id
          maxBasketCount
          offerType {
            id
            title
          }
          offerTypeId
          percentage
          price
          cashPrice
          creditPrice
          stock
        }
        price
        cashPrice
        creditPrice
        stock
        attrs {
          key
          value
          name
        }
      }
    }
    hasNextPage
    limit
    orderBy {
      created_at
    }
    page
    totalCount
    totalPages
  }
}
    `;
export const UserOrdersMetaDocument = gql`
    query userOrdersMeta {
  userOrdersMeta {
    cancelled
    delivered
    inprogress
    returned
  }
}
    `;
export const HomePageDataDocument = gql`
    query HomePageData($categoryId: Int!) {
  homePageData(categoryId: $categoryId) {
    mostOfferProducts {
      ...product
    }
    mostSaleProducts {
      ...product
    }
    categoryFilteredProducts {
      ...product
    }
  }
}
    ${ProductFragmentDoc}`;
export const SearchByCategoryIdDocument = gql`
    query SearchByCategoryId($searchByCategoryId: Int!) {
  products: searchByCategoryId(id: $searchByCategoryId) {
    code
    shortDescription
    video
    colors {
      hex
      id
      title
    }
    id
    mainImage {
      address
      alt
      id
      name
    }
    title
    title_en
    variant {
      guarantee {
        id
        title
      }
      hasStock
      guaranteeId
      id
      maxBasketCount
      offer {
        end_at
        id
        maxBasketCount
        offerType {
          id
          title
        }
        offerTypeId
        percentage
        price
        cashPrice
        creditPrice
        stock
      }
      price
      cashPrice
      creditPrice
      stock
    }
  }
}
    `;
export const SearchMostOfferDocument = gql`
    query SearchMostOffer {
  products: searchMostOffer {
    code
    shortDescription
    video
    colors {
      hex
      id
      title
    }
    id
    mainImage {
      address
      alt
      id
      name
    }
    title
    title_en
    variant {
      guarantee {
        id
        title
      }
      guaranteeId
      id
      maxBasketCount
      offer {
        end_at
        id
        maxBasketCount
        offerType {
          id
          title
        }
        offerTypeId
        percentage
        price
        cashPrice
        creditPrice
        stock
      }
      price
      cashPrice
      creditPrice
      stock
    }
  }
}
    `;
export const SearchMostSaleDocument = gql`
    query SearchMostSale {
  products: searchMostSale {
    code
    shortDescription
    video
    colors {
      hex
      id
      title
    }
    id
    mainImage {
      address
      alt
      id
      name
    }
    title
    title_en
    variant {
      guarantee {
        id
        title
      }
      guaranteeId
      id
      maxBasketCount
      offer {
        end_at
        id
        maxBasketCount
        offerType {
          id
          title
        }
        offerTypeId
        percentage
        price
        cashPrice
        creditPrice
        stock
      }
      price
      cashPrice
      creditPrice
      stock
    }
  }
}
    `;
export const GetPaymentGatewaysOfProductDocument = gql`
    query getPaymentGatewaysOfProduct($source: String) {
  paymentGateways: getPaymentGateways(source: $source) {
    installment
    logo {
      address
    }
    name
  }
}
    `;
export const MenuDocument = gql`
    query menu {
  menu {
    ...CategoriesRecursiveItems
  }
}
    ${CategoriesRecursiveItemsFragmentDoc}`;
export const SearchTermDocument = gql`
    query searchTerm($input: SearchTermRequestInput!) {
  searchTerm(input: $input) {
    categories {
      id
      path
      slug
      title
      title_en
      parentTitle
    }
    products {
      category {
        id
        slug
        title
        title_en
      }
      code
      id
      mainImage {
        address
        alt
        id
        name
      }
      title
      title_en
    }
  }
}
    `;
export const TopBannerDocument = gql`
    query topBanner {
  topBanner {
    action
    backgroundColor
    dialogBody
    dialogButtonLabel
    dialogButtonUrl
    dialogImageAlt
    dialogImageUrl
    dialogTitle
    imageAlt
    imageUrl
    kind
    linkUrl
    openInNewTab
    textAnimation
    textColor
    textLines
  }
}
    `;
export const CreateImageDocument = gql`
    mutation createImage($input: CreateImageInput!) {
  createImage(createImageInput: $input) {
    id
    address
    alt
    name
  }
}
    `;
export const UpdateImageDocument = gql`
    mutation updateImage($id: String!, $input: UpdateImageInput!) {
  updateImage(id: $id, updateImageInput: $input) {
    id
    address
    alt
    name
  }
}
    `;
export const AiImageGenerationJobDocument = gql`
    query AiImageGenerationJob($id: String!) {
  aiImageGenerationJob(id: $id) {
    id
    prompt
    productId
    imageUrls
    imageIds
    generatedImageIds
    status
    progress
    message
    error
    errorCode
    model
    inputTokens
    outputTokens
    totalTokens
    inputImageTokens
    inputTextTokens
    estimatedCostUsd
    createdAt
    updatedAt
  }
}
    `;
export const AiImageGenerationJobByProductIdDocument = gql`
    query AiImageGenerationJobByProductId($productId: String!) {
  aiImageGenerationJobByProductId(productId: $productId) {
    id
    prompt
    productId
    imageUrls
    imageIds
    generatedImageIds
    status
    progress
    message
    error
    errorCode
    model
    inputTokens
    outputTokens
    totalTokens
    inputImageTokens
    inputTextTokens
    estimatedCostUsd
    createdAt
    updatedAt
  }
}
    `;
export const AiImageGenerationJobsDocument = gql`
    query AiImageGenerationJobs($page: Int!, $limit: Int!, $search: String) {
  aiImageGenerationJobs(page: $page, limit: $limit, search: $search) {
    page
    limit
    totalCount
    totalPages
    hasNextPage
    items {
      id
      prompt
      productId
      imageUrls
      imageIds
      generatedImageIds
      status
      progress
      message
      error
      errorCode
      model
      inputTokens
      outputTokens
      totalTokens
      inputImageTokens
      inputTextTokens
      estimatedCostUsd
      createdAt
      updatedAt
    }
  }
}
    `;
export const CreateAiImageGenerationJobDocument = gql`
    mutation CreateAiImageGenerationJob($input: CreateAiImageGenerationJobInput!) {
  createAiImageGenerationJob(input: $input) {
    id
    prompt
    productId
    status
    createdAt
    updatedAt
  }
}
    `;
export const ReloadAiImageGenerationJobDocument = gql`
    mutation ReloadAiImageGenerationJob($id: String!) {
  reloadAiImageGenerationJob(id: $id)
}
    `;
export const RemoveAiImageGenerationJobDocument = gql`
    mutation RemoveAiImageGenerationJob($id: String!) {
  removeAiImageGenerationJob(id: $id)
}
    `;
export const AdminBrandsDocument = gql`
    query AdminBrands($orderBy: AdminBrandsPaginationOrdersInput, $page: Int!, $limit: Int!, $search: String) {
  brands(orderBy: $orderBy, page: $page, limit: $limit, search: $search) {
    orderBy {
      title
      title_en
      created_at
      updated_at
    }
    items {
      id
      title
      title_en
      imageId
      image {
        address
        alt
        id
      }
      created_at
      updated_at
    }
    limit
    hasNextPage
    page
    search
    totalCount
    totalPages
  }
}
    `;
export const CreateBrandDocument = gql`
    mutation createBrand($input: CreateBrandInput!) {
  createBrand(createBrandInput: $input) {
    title
    id
    title_en
    created_at
    updated_at
  }
}
    `;
export const RemoveBrandDocument = gql`
    mutation removeBrand($id: Int!) {
  removeBrand(id: $id) {
    title
    id
    title
    created_at
    updated_at
    title_en
  }
}
    `;
export const UpdateBrandDocument = gql`
    mutation updateBrand($id: Int!, $input: UpdateBrandInput!) {
  updateBrand(id: $id, updateBrandInput: $input) {
    title
    title_en
    id
    created_at
    updated_at
  }
}
    `;
export const CategoriesDocument = gql`
    query categories {
  categories {
    ...CategoriesRecursive
  }
}
    ${CategoriesRecursiveFragmentDoc}`;
export const CategoryDocument = gql`
    query category($id: Int!) {
  category(id: $id) {
    id
    slug
    sort
    svg
    title
    title_en
    description
    shortDescription
    snappCommissionType
    basalamCategoryId
    keywords
    active
    guideContent
    guideTitle
    bgColor
    imageId
    image {
      address
      id
      alt
      name
      local
    }
  }
}
    `;
export const CreateCategoryDocument = gql`
    mutation createCategory($input: CreateCategoryInput!) {
  createCategory(createCategoryInput: $input) {
    id
  }
}
    `;
export const GetBasalamCategoriesDocument = gql`
    query getBasalamCategories {
  categories: getBasalamCategories {
    data {
      id
      max_preparation_days
      title
      unit_type {
        id
        name
        title
        value
      }
      children {
        id
        max_preparation_days
        title
        unit_type {
          id
          name
          title
          value
        }
        children {
          id
          max_preparation_days
          title
          unit_type {
            id
            name
            title
            value
          }
          children {
            id
            max_preparation_days
            title
            unit_type {
              id
              name
              title
              value
            }
            children {
              id
              max_preparation_days
              title
              unit_type {
                id
                name
                title
                value
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const MoveCategoryDocument = gql`
    mutation moveCategory($input: MoveCategoryInput!) {
  moveCategory(moveCategoryInput: $input) {
    id
  }
}
    `;
export const RemoveCategoryDocument = gql`
    mutation removeCategory($id: Int!) {
  removeCategory(id: $id) {
    success
  }
}
    `;
export const UpdateCategoryDocument = gql`
    mutation updateCategory($input: UpdateCategoryInput!) {
  updateCategory(updateCategoryInput: $input) {
    id
  }
}
    `;
export const ColorsDocument = gql`
    query colors {
  colors {
    id
    hex
    title
  }
}
    `;
export const CreateColorDocument = gql`
    mutation createColor($input: CreateColorInput!) {
  createColor(createColorInput: $input) {
    title
    hex
    id
  }
}
    `;
export const RemoveColorDocument = gql`
    mutation removeColor($id: Int!) {
  removeColor(id: $id) {
    hex
    title
  }
}
    `;
export const UpdateColorDocument = gql`
    mutation updateColor($input: UpdateColorInput!) {
  updateColor(updateColorInput: $input) {
    title
    hex
    id
  }
}
    `;
export const AdminDiscountDocument = gql`
    query adminDiscount($id: Float!) {
  discount(id: $id) {
    description
    discountAmount
    discountCode
    startDate
    endDate
    id
    isActive
    minimumPurchase
    remainingUses
    user {
      birth_date
      firstName
      id
      lastName
      phoneNumber
    }
    userId
  }
}
    `;
export const AdminDiscountsDocument = gql`
    query adminDiscounts($filter: AdminDiscountsPaginationFiltersInput, $limit: Int!, $page: Int!, $search: String, $orderBy: AdminDiscountsPaginationOrdersInput) {
  discounts(
    filter: $filter
    limit: $limit
    page: $page
    search: $search
    orderBy: $orderBy
  ) {
    hasNextPage
    items {
      description
      discountAmount
      discountCode
      id
      startDate
      endDate
      created_at
      updated_at
      isActive
      minimumPurchase
      remainingUses
      user {
        birth_date
        firstName
        id
        lastName
        phoneNumber
      }
      userId
    }
    limit
    orderBy {
      created_at
      discountAmount
      discountCode
      endDate
      isActive
      minimumPurchase
      remainingUses
      startDate
      updated_at
    }
    filter {
      isActive
    }
    page
    search
    totalCount
    totalPages
  }
}
    `;
export const CreateDiscountDocument = gql`
    mutation createDiscount($createDiscountInput: CreateDiscountInput!) {
  createDiscount(createDiscountInput: $createDiscountInput) {
    description
    discountAmount
    discountCode
    id
    startDate
    endDate
    isActive
    minimumPurchase
    remainingUses
    user {
      birth_date
      firstName
      id
      lastName
      phoneNumber
    }
    userId
  }
}
    `;
export const GetUsersByHintDocument = gql`
    query getUsersByHint($search: String) {
  getUsersByHint(search: $search) {
    birth_date
    firstName
    id
    lastName
    phoneNumber
  }
}
    `;
export const RemoveDiscountDocument = gql`
    mutation removeDiscount($removeDiscountId: Float!) {
  removeDiscount(id: $removeDiscountId) {
    description
    discountAmount
    discountCode
    id
    startDate
    endDate
    isActive
    minimumPurchase
    remainingUses
    user {
      birth_date
      firstName
      id
      lastName
      phoneNumber
    }
    userId
  }
}
    `;
export const UpdateDiscountDocument = gql`
    mutation updateDiscount($updateDiscountId: Float!, $updateDiscountInput: UpdateDiscountInput!) {
  updateDiscount(id: $updateDiscountId, updateDiscountInput: $updateDiscountInput) {
    description
    discountAmount
    discountCode
    id
    startDate
    endDate
    isActive
    minimumPurchase
    remainingUses
    user {
      birth_date
      firstName
      id
      lastName
      phoneNumber
    }
    userId
  }
}
    `;
export const AdminOrdersProfitDocument = gql`
    query AdminOrdersProfit($filter: AdminOrdersProfitFilterInput, $limit: Int!, $orderBy: AdminOrdersProfitOrderByInput, $page: Int!, $search: String) {
  adminOrdersProfit(
    filter: $filter
    limit: $limit
    orderBy: $orderBy
    page: $page
    search: $search
  ) {
    hasNextPage
    limit
    page
    search
    totalCount
    totalPages
    summary {
      calculatedOrderCount
      gatewayFee
      orderCount
      profit
      profitMargin
      purchaseCost
      salesAmount
      unknownOrderCount
      unknownSalesAmount
    }
    items {
      couponDiscount
      gatewayFeeAmount
      id
      initialDate
      itemsWithoutPurchasePrice
      paymentGatewayFee
      productRevenue
      profit
      profitMargin
      purchaseCost
      shippingPrice
      status
      totalPrice
      paymentGateway {
        code
        id
        name
      }
    }
  }
}
    `;
export const AdminGuaranteesDocument = gql`
    query AdminGuarantees($orderBy: AdminGuaranteesPaginationOrdersInput, $page: Int!, $limit: Int!, $search: String) {
  guarantees(orderBy: $orderBy, page: $page, limit: $limit, search: $search) {
    orderBy {
      title
      created_at
      updated_at
    }
    items {
      id
      title
      created_at
      updated_at
    }
    limit
    hasNextPage
    page
    search
    totalCount
    totalPages
  }
}
    `;
export const CreateGuaranteeDocument = gql`
    mutation createGuarantee($input: CreateGuaranteeInput!) {
  createGuarantee(createGuaranteeInput: $input) {
    title
    id
    created_at
    updated_at
  }
}
    `;
export const RemoveGuaranteeDocument = gql`
    mutation removeGuarantee($id: Int!) {
  removeGuarantee(id: $id) {
    title
    id
    title
    created_at
    updated_at
  }
}
    `;
export const UpdateGuaranteeDocument = gql`
    mutation updateGuarantee($id: Int!, $input: UpdateGuaranteeInput!) {
  updateGuarantee(id: $id, updateGuaranteeInput: $input) {
    title
    id
    created_at
    updated_at
  }
}
    `;
export const AddVarinatToBarcodePerPrintListDocument = gql`
    mutation addVarinatToBarcodePerPrintList($input: BarcodeLabelInput!) {
  label: addVarinatToBarcodePerPrintList(input: $input) {
    count
    name
    productCode
    variantId
  }
}
    `;
export const GetBarcodeLabelsDocument = gql`
    query getBarcodeLabels {
  labels: getAllBarcodeLabels {
    count
    name
    productCode
    variantId
  }
}
    `;
export const RemoveAllBarcodeLabelsDocument = gql`
    mutation removeAllBarcodeLabels {
  labels: removeAllBarcodeLabels {
    productCode
    variantId
    count
    name
  }
}
    `;
export const AdminOfferTypesDocument = gql`
    query AdminOfferTypes($orderBy: AdminOfferTypesPaginationOrdersInput, $page: Int!, $limit: Int!, $search: String) {
  offerTypes(orderBy: $orderBy, page: $page, limit: $limit, search: $search) {
    orderBy {
      title
      created_at
      updated_at
      discount
    }
    items {
      id
      discount
      title
      created_at
      updated_at
    }
    limit
    hasNextPage
    page
    search
    totalCount
    totalPages
  }
}
    `;
export const CreateOfferTypeDocument = gql`
    mutation createOfferType($input: CreateOfferTypeInput!) {
  createOfferType(createOfferTypeInput: $input) {
    discount
    title
    id
    created_at
    updated_at
  }
}
    `;
export const RemoveOfferTypeDocument = gql`
    mutation removeOfferType($id: Int!) {
  removeOfferType(id: $id) {
    id
    title
    discount
    created_at
    updated_at
  }
}
    `;
export const UpdateOfferTypeDocument = gql`
    mutation updateOfferType($id: Int!, $input: UpdateOfferTypeInput!) {
  updateOfferType(id: $id, updateOfferTypeInput: $input) {
    title
    id
    discount
    created_at
    updated_at
  }
}
    `;
export const AdminOffersDocument = gql`
    query AdminOffers($orderBy: AdminOffersPaginationOrdersInput, $page: Int!, $limit: Int!, $search: String) {
  offers(orderBy: $orderBy, page: $page, limit: $limit, search: $search) {
    page
    limit
    orderBy {
      updated_at
      created_at
    }
    hasNextPage
    totalCount
    totalPages
    items {
      id
      variantId
      variant {
        active
        id
        price
        cashPrice
        creditPrice
        stock
        maxBasketCount
        purchasePrice
        attrs {
          value
          key
          name
        }
        productId
        product {
          code
          title
          title_en
          mainImage {
            address
            alt
            id
            name
          }
        }
      }
      stock
      maxBasketCount
      percentage
      price
      cashPrice
      creditPrice
      active
      start_at
      end_at
      created_at
      updated_at
    }
  }
}
    `;
export const CreateRangeOfferDocument = gql`
    mutation createRangeOffer($createOfferRangeInput: CreateOfferRangeInput!) {
  createRangeOffer(createOfferRangeInput: $createOfferRangeInput) {
    id
  }
}
    `;
export const RemoveOfferDocument = gql`
    mutation removeOffer($removeOfferId: Float!) {
  removeOffer(id: $removeOfferId) {
    id
  }
}
    `;
export const UpdateOfferDocument = gql`
    mutation updateOffer($updateOfferId: Float!, $updateOfferInput: UpdateOfferInput!) {
  updateOffer(id: $updateOfferId, updateOfferInput: $updateOfferInput) {
    id
  }
}
    `;
export const AdminOrdersLocationDistributionDocument = gql`
    query adminOrdersLocationDistribution($from: Date, $to: Date) {
  adminOrdersLocationDistribution(from: $from, to: $to) {
    totalOrders
    totalSale
    unknownLocationOrders
    provinces {
      name
      orderCount
      totalSale
      cities {
        name
        orderCount
        totalSale
      }
    }
  }
}
    `;
export const AdminOrderDocument = gql`
    query AdminOrder($orderId: Float!) {
  order(id: $orderId) {
    created_at
    itemsWarehouse
    cart {
      cartItems {
        discountPrice
        id
        offer {
          id
          percentage
          price
        }
        offerId
        product {
          code
          id
          mainImage {
            address
            alt
            id
            name
          }
          title
          title_en
        }
        productId
        quantity
        totalPrice
        unitPrice
        variant {
          guarantee {
            title
          }
          id
          price
          attrs {
            key
            name
            value
          }
        }
        variantId
      }
      discountAmount
      id
      subtotal
      totalPrice
    }
    deliveryTrackingCode
    orderItemActions {
      id
      orderItemActionType
      additionReason
      cancellationReason
      created_at
      updated_at
      transactionId
      refundAmount
      isRefundProcessed
      oldQuantity
      newQuantity
      orderItem {
        discountPrice
        id
        product {
          code
          id
          mainImage {
            address
            alt
            id
            name
          }
          title
          title_en
        }
        productTitle
        productTitleEn
        quantity
        totalPrice
        unitPrice
        variantAttrs {
          key
          name
          value
        }
        variantGuaranteeId
        variantGuaranteeTitle
      }
    }
    discount {
      id
      description
      discountAmount
      discountCode
    }
    discountPrice
    history {
      created_at
      id
      newStatus
      oldStatus
      note
    }
    id
    initialDate
    items {
      warehouseTargetDescription
      warehouseTargetProductId
      warehouseTargetProductVariantId
      warehouseId
      warehouse {
        id
        title
        code
        productUrlPatten
      }
      discountPrice
      id
      product {
        code
        id
        mainImage {
          address
          alt
          id
          name
        }
        title
        title_en
      }
      productTitle
      productTitleEn
      quantity
      totalPrice
      unitPrice
      variantId
      variantAttrs {
        key
        name
        value
      }
      variantGuaranteeId
      variantGuaranteeTitle
    }
    memo
    isOffline
    paymentGateway {
      id
      code
      name
      installment
      logo {
        address
        alt
      }
    }
    paymentMethod {
      id
      name
      code
    }
    paymentSeen
    payments {
      id
      amount
      created_at
      failedDate
      failedReason
      gateway {
        id
        name
        code
        installment
      }
      gatewayEntryTime
      paymentDate
      paymentMethod {
        id
        name
        code
      }
      status
      transactionId
      refNumber
      cardNumber
      bankName
      paymentToken
      gateWayPayStatus
    }
    shippingAddress {
      address
      cityName
      provinceName
      city {
        id
        name
      }
      id
      lat
      long
      postalCode
      province {
        id
        name
      }
      recipientFirstName
      recipientLastName
      recipientPhoneNumber
    }
    shippingMethod {
      name
      cashOnDelivery
      id
      price
    }
    shippingPrice
    status
    totalPrice
    updated_at
    user {
      phoneNumber
      firstName
      id
      lastName
    }
  }
}
    `;
export const AdminOrderCartDocument = gql`
    query AdminOrderCart($id: Float!) {
  cart: orderCart(id: $id) {
    cartItems {
      discountPrice
      id
      offer {
        id
        percentage
        price
      }
      offerId
      product {
        code
        id
        mainImage {
          address
          alt
          id
          name
        }
        title
        title_en
      }
      productId
      quantity
      totalPrice
      unitPrice
      variant {
        guarantee {
          title
        }
        id
        price
        attrs {
          key
          name
          value
        }
      }
      variantId
    }
    discountAmount
    id
    subtotal
    totalPrice
  }
}
    `;
export const GetOrderHistoryByOrderIdDocument = gql`
    query getOrderHistoryByOrderId($id: Float!) {
  history: getOrderHistoryByOrderId(id: $id) {
    created_at
    id
    newStatus
    oldStatus
    note
  }
}
    `;
export const GetOrderItemActionsByOrderIdDocument = gql`
    query getOrderItemActionsByOrderId($id: Float!) {
  actions: getOrderItemActionsByOrderId(id: $id) {
    id
    orderItemActionType
    additionReason
    cancellationReason
    created_at
    updated_at
    transactionId
    refundAmount
    isRefundProcessed
    oldQuantity
    newQuantity
    orderItem {
      discountPrice
      id
      product {
        code
        id
        mainImage {
          address
          alt
          id
          name
        }
        title
        title_en
      }
      productTitle
      productTitleEn
      quantity
      totalPrice
      unitPrice
      variantAttrs {
        key
        name
        value
      }
      variantGuaranteeId
      variantGuaranteeTitle
    }
  }
}
    `;
export const GetOrderPaymentsByOrderIdDocument = gql`
    query getOrderPaymentsByOrderId($id: Float!) {
  payments: getOrderPaymentsByOrderId(id: $id) {
    id
    amount
    created_at
    failedDate
    failedReason
    gateway {
      id
      name
      code
      installment
    }
    gatewayEntryTime
    paymentDate
    paymentMethod {
      id
      name
      code
    }
    status
    transactionId
    refNumber
    cardNumber
    bankName
    paymentToken
    gateWayPayStatus
  }
}
    `;
export const AdminOrderV2Document = gql`
    query AdminOrderV2($orderId: Float!) {
  order: orderV2(id: $orderId) {
    created_at
    itemsWarehouse
    deliveryTrackingCode
    discount {
      id
      description
      discountAmount
      discountCode
    }
    discountPrice
    id
    initialDate
    items {
      warehouseTargetDescription
      warehouseTargetProductId
      warehouseTargetProductVariantId
      warehouseId
      warehouse {
        id
        title
        code
        productUrlPatten
      }
      discountPrice
      id
      product {
        code
        id
        mainImage {
          address
          alt
          id
          name
        }
        title
        title_en
      }
      productTitle
      productTitleEn
      quantity
      totalPrice
      unitPrice
      variantId
      variantAttrs {
        key
        name
        value
      }
      variantGuaranteeId
      variantGuaranteeTitle
    }
    memo
    isOffline
    paymentGateway {
      id
      code
      name
      installment
      logo {
        address
        alt
      }
    }
    paymentMethod {
      id
      name
      code
    }
    paymentSeen
    shippingAddress {
      address
      cityName
      provinceName
      city {
        id
        name
      }
      id
      lat
      long
      postalCode
      province {
        id
        name
      }
      recipientFirstName
      recipientLastName
      recipientPhoneNumber
    }
    shippingMethod {
      name
      cashOnDelivery
      id
      price
    }
    shippingPrice
    pricingMode
    shipments {
      id
      orderId
      warehouseId
      warehouse {
        id
        title
        code
        shippingOriginLabel
      }
      warehouseShippingMethodId
      warehouseShippingMethod {
        id
        name
        cashOnDelivery
        cashPrice
        creditPrice
      }
      shippingPrice
      status
      trackingCode
      created_at
      updated_at
    }
    status
    totalPrice
    updated_at
    user {
      phoneNumber
      firstName
      id
      lastName
    }
  }
}
    `;
export const ProcessOrderItemPartialCancellationDocument = gql`
    mutation processOrderItemPartialCancellation($input: CreateReduceOrderItemActionInput!) {
  orderItem: processOrderItemPartialCancellation(input: $input) {
    discountPrice
    id
    productId
    productTitle
    productTitleEn
    quantity
    totalPrice
    unitPrice
    variantGuaranteeId
    variantGuaranteeTitle
    variantAttrs {
      name
      value
      key
    }
  }
}
    `;
export const UpdateAdminOrderDocument = gql`
    mutation updateAdminOrder($updateAdminOrderId: Float!, $input: AdminUpdateOrderInput!) {
  updateAdminOrder(id: $updateAdminOrderId, input: $input) {
    id
    memo
  }
}
    `;
export const UpdateAdminOrderShippingAddressDocument = gql`
    mutation updateAdminOrderShippingAddress($id: String!, $input: UpdateShippingAddressInput!) {
  updateShippingAddresses(id: $id, input: $input) {
    id
  }
}
    `;
export const UpdateAdminOrderStatusDocument = gql`
    mutation updateAdminOrderStatus($updateAdminOrderStatusId: Float!, $input: AdminUpdateOrderStatusInput!) {
  updateAdminOrderStatus(id: $updateAdminOrderStatusId, input: $input) {
    success
  }
}
    `;
export const UpdateAdminOrderStatusToCancelledDocument = gql`
    mutation updateAdminOrderStatusToCancelled($updateAdminOrderStatusToCancelledId: Float!, $input: AdminUpdateOrderStatusToCancelledInput!) {
  updateAdminOrderStatusToCancelled(
    id: $updateAdminOrderStatusToCancelledId
    input: $input
  ) {
    success
  }
}
    `;
export const UpdateOrderItemPartialCancellationDocument = gql`
    mutation updateOrderItemPartialCancellation($input: UpdateReduceOrderItemActionInput!) {
  updateOrderItemPartialCancellation(input: $input) {
    additionReason
    cancellationReason
    created_at
    id
    isRefundProcessed
    newQuantity
    oldQuantity
    orderItem {
      discountPrice
      id
      product {
        code
        id
        mainImage {
          address
          alt
          id
          name
        }
        title
        title_en
      }
      productTitle
      productTitleEn
      quantity
      totalPrice
      unitPrice
      variantAttrs {
        name
        value
        key
      }
      variantGuaranteeId
      variantGuaranteeTitle
      variantId
    }
    orderItemActionType
    orderItemId
    refundAmount
    transactionId
    updated_at
  }
}
    `;
export const UpdateOrderShipmentStatusDocument = gql`
    mutation updateOrderShipmentStatus($id: Int!, $input: UpdateOrderShipmentStatusInput!) {
  updateOrderShipmentStatus(id: $id, input: $input) {
    id
    orderId
    status
    trackingCode
    updated_at
  }
}
    `;
export const AdminOrdersDocument = gql`
    query AdminOrders($filter: AdminOrdersPaginationFilterInput, $limit: Int!, $orderBy: AdminOrdersPaginationOrdersInput, $page: Int!, $search: String) {
  orders(
    filter: $filter
    limit: $limit
    orderBy: $orderBy
    page: $page
    search: $search
  ) {
    filter {
      maxInitialDate
      minInitialDate
      paymentGateway_code
      paymentGateway_installment
      paymentMethod
      status
      isOffline
    }
    hasNextPage
    items {
      itemsWarehouse
      created_at
      id
      initialDate
      deliveryTrackingCode
      isOffline
      shippingMethod {
        cashOnDelivery
        cities
        description
        id
        name
        price
      }
      shippingPrice
      status
      totalPrice
      updated_at
      user_fullname
      user_phoneNumber
      paymentGateway {
        active
        code
        created_at
        description
        id
        installment
        key
        logo {
          address
          alt
          id
          name
        }
        logoId
        name
        updated_at
      }
      paymentMethod {
        code
        description
        id
        name
      }
      shippingAddress {
        address
        cityName
        provinceName
        city {
          id
          lat
          long
          name
          zoom
        }
        id
        lat
        long
        postalCode
        province {
          id
          lat
          long
          name
          zoom
        }
        recipientFirstName
        recipientLastName
        recipientPhoneNumber
      }
    }
    limit
    orderBy {
      created_at
      id
      initialDate
      paymentGateway_installment
      paymentGateway_name
      paymentMethod_name
      shippingAddresses_city_name
      shippingAddresses_province_name
      shippingAddresses_recipient_fullName
      shippingAddresses_recipient_phoneNumber
      shippingMethod_name
      shippingPrice
      status
      totalPrice
      updated_at
      user_fullname
      user_phoneNumber
    }
    page
    search
    totalCount
    totalPages
  }
}
    `;
export const GetPaymentGatewaysDocument = gql`
    query getPaymentGateways {
  paymentGateways {
    id
    code
    key
    clientId
    clientSecret
    clientUsername
    clientPassword
    clientOAuthUrl
    name
    active
    installment
    description
    minAmountToPayment
    maxAmountToPayment
    sourcePolicy {
      visibility
      detectEnabled
      matchKeys
      restrictionEnabled
      allowSelf
      allowNonInstallment
      allowOtherInstallment
      allowGatewayCodes
      denyGatewayCodes
      sourcePriority
    }
    created_at
    updated_at
    logoId
    logo {
      id
      name
      address
      alt
    }
  }
}
    `;
export const UpdatePaymentGatewayDocument = gql`
    mutation updatePaymentGateway($updatePaymentGatewayId: String!, $updatePaymentGatewayInput: UpdatePaymentGatewayInput!) {
  updatePaymentGateway(
    id: $updatePaymentGatewayId
    updatePaymentGatewayInput: $updatePaymentGatewayInput
  ) {
    id
  }
}
    `;
export const AdminPaymentsDocument = gql`
    query AdminPayments($limit: Int!, $orderBy: AdminPaymentsPaginationOrdersInput, $page: Int!, $search: String) {
  payments(limit: $limit, orderBy: $orderBy, page: $page, search: $search) {
    hasNextPage
    items {
      amount
      created_at
      failedDate
      failedReason
      gateway {
        active
        code
        created_at
        description
        id
        logo {
          address
          alt
          id
          name
        }
        logoId
        name
        updated_at
      }
      gatewayEntryTime
      gatewayId
      id
      orderId
      paymentDate
      paymentMethod {
        code
        description
        id
        name
      }
      paymentMethodId
      status
      transactionId
    }
    limit
    orderBy {
      amount
      created_at
      gatewayEntryTime
      gateway_name
      id
      orderId
      paymentDate
      paymentMethod_name
      status
      transactionId
    }
    page
    search
    totalCount
    totalPages
  }
}
    `;
export const AdminProductImagesDocument = gql`
    query AdminProductImages($filter: AdminProductImagesPaginationFiltersInput, $limit: Int!, $orderBy: AdminProductImagesPaginationOrdersInput, $page: Int!, $search: String) {
  productImages(
    filter: $filter
    limit: $limit
    orderBy: $orderBy
    page: $page
    search: $search
  ) {
    filter {
      aiGenerated
      brandId
      categoryId
      hasAlt
      isActive
      isMain
      local
      productActive
      productHasStock
      productId
      syncWithExternal
    }
    hasNextPage
    items {
      address
      aiGenerated
      alt
      basalamImageId
      created_at
      id
      imageId
      isActive
      isMain
      local
      name
      productActive
      productCode
      productId
      productImageId
      productTitle
      sort
      syncWithExternal
      updated_at
    }
    limit
    orderBy {
      created_at
      isActive
      isMain
      product_code
      product_title
      sort
      updated_at
    }
    page
    search
    totalCount
    totalPages
  }
}
    `;
export const AdminProductStatsDocument = gql`
    query AdminProductStats($id: String!) {
  adminProductStats(id: $id) {
    viewCount
    pageViewCount
    soldQuantity
  }
}
    `;
export const AdminProductDocument = gql`
    query AdminProduct($id: String!) {
  product(id: $id) {
    videos {
      active
      address
      id
      local
      name
      sort
      thumbnail
    }
    basedOnExternalProductId
    basedOnExternalProductUrl
    warehouse {
      productUrlPatten
      active
      title
      id
      code
    }
    id
    title
    title_en
    code
    active
    aiContentGenerated
    created_at
    updated_at
    description
    shortDescription
    keywords
    features
    images {
      address
      alt
      id
      imageId
      isActive
      syncWithExternal
      isMain
      sort
      aiGenerated
    }
    brandId
    brand {
      id
      title_en
      title
      image {
        id
        address
        alt
      }
    }
    category {
      ...CategoryItemRecursive
    }
    specifications {
      id
      title
      checked
      text
      type
      sort
    }
    tags {
      id
      title
    }
  }
}
    ${CategoryItemRecursiveFragmentDoc}`;
export const AdminProductsDocument = gql`
    query AdminProducts($orderBy: AdminProductsPaginationOrdersInput, $page: Int!, $limit: Int!, $search: String, $filter: AdminProductsPaginationFiltersInput) {
  products(
    orderBy: $orderBy
    page: $page
    limit: $limit
    search: $search
    filter: $filter
  ) {
    orderBy {
      code
      active
      title
      brand_title
      title_en
      created_at
      updated_at
    }
    filter {
      active
      aiContentGenerated
      categoryId
      warehouseId
      hasStock
    }
    items {
      warehouse {
        productUrlPatten
        active
        title
        id
        code
      }
      id
      title
      title_en
      code
      active
      aiContentGenerated
      category {
        active
        title
        id
      }
      totalSales
      hasStock
      created_at
      updated_at
      mainImage {
        address
        alt
        id
      }
      brand {
        id
        title_en
        title
      }
    }
    limit
    hasNextPage
    page
    search
    totalCount
    totalPages
  }
}
    `;
export const ChangeProductImageSortDocument = gql`
    mutation ChangeProductImageSort($updateProductImageSortInput: UpdateProductImageSortInput!) {
  updateProductImageSort(
    updateProductImageSortInput: $updateProductImageSortInput
  ) {
    code
    message
    success
  }
}
    `;
export const ChangeSpecificationSortDocument = gql`
    mutation ChangeSpecificationSort($productId: String!, $updateSpecificationSortInput: UpdateSpecificationSortInput!) {
  updateSpecificationSorts(
    productId: $productId
    updateSpecificationSortInput: $updateSpecificationSortInput
  ) {
    success
    message
    code
  }
}
    `;
export const CreateProductDocument = gql`
    mutation CreateProduct($createProductInput: CreateProductInput!) {
  createProduct(createProductInput: $createProductInput) {
    id
    code
  }
}
    `;
export const CreateSpecificationDocument = gql`
    mutation CreateSpecification($createSpecificationInput: CreateSpecificationInput!, $productId: String!) {
  createSpecification(
    productId: $productId
    createSpecificationInput: $createSpecificationInput
  ) {
    id
  }
}
    `;
export const RemoveProductImageDocument = gql`
    mutation removeProductImage($removeProductImageId: String!, $imageId: String!, $productId: String!) {
  removeProductImage(
    id: $removeProductImageId
    imageId: $imageId
    productId: $productId
  ) {
    id
  }
}
    `;
export const RemoveSpecificationDocument = gql`
    mutation RemoveSpecification($id: String!, $productId: String!) {
  removeSpecification(id: $id, productId: $productId) {
    success
  }
}
    `;
export const UpdateProductDocument = gql`
    mutation UpdateProduct($id: String!, $updateProductInput: UpdateProductInput!) {
  updateProduct(id: $id, updateProductInput: $updateProductInput) {
    id
    code
  }
}
    `;
export const UpdateProductImageDocument = gql`
    mutation updateProductImage($updateProductImageId: String!, $imageId: String!, $productId: String!, $updateProductImageInput: UpdateProductImageInput!) {
  updateProductImage(
    id: $updateProductImageId
    imageId: $imageId
    productId: $productId
    updateProductImageInput: $updateProductImageInput
  ) {
    address
    alt
    id
    imageId
    isActive
    isMain
    name
    sort
  }
}
    `;
export const UpdateSpecificationDocument = gql`
    mutation UpdateSpecification($id: String!, $updateSpecificationInput: UpdateSpecificationInput!, $productId: String!) {
  updateSpecification(
    id: $id
    productId: $productId
    updateSpecificationInput: $updateSpecificationInput
  ) {
    id
  }
}
    `;
export const CreateProductImageDocument = gql`
    mutation createProductImage($createProductImageInput: ProductImageInput!, $productId: String!) {
  createProductImage(
    createProductImageInput: $createProductImageInput
    productId: $productId
  ) {
    id
    address
    alt
  }
}
    `;
export const CreateSpecificationRangeDocument = gql`
    mutation createSpecificationRange($createSpecificationInput: CreateSpecificationRangeInput!, $productId: String!) {
  createSpecificationRange(
    createSpecificationInput: $createSpecificationInput
    productId: $productId
  ) {
    id
  }
}
    `;
export const DeleteVideoDocument = gql`
    mutation deleteVideo($deleteVideoId: String!) {
  deleteVideo(id: $deleteVideoId) {
    id
  }
}
    `;
export const UpdateVideoDocument = gql`
    mutation updateVideo($updateVideoId: String!, $updateVideoInput: UpdateVideoInput!) {
  video: updateVideo(id: $updateVideoId, updateVideoInput: $updateVideoInput) {
    id
  }
}
    `;
export const UploadVideoDocument = gql`
    mutation uploadVideo($createVideoInput: CreateVideoInput!) {
  video: createVideo(createVideoInput: $createVideoInput) {
    active
    address
    id
    local
    name
    sort
    thumbnail
  }
}
    `;
export const AdminPromptsDocument = gql`
    query AdminPrompts($orderBy: AdminPromptsPaginationOrdersInput, $page: Int!, $limit: Int!, $search: String) {
  prompts(orderBy: $orderBy, page: $page, limit: $limit, search: $search) {
    orderBy {
      title
      created_at
      updated_at
    }
    items {
      id
      title
      content
      created_at
      updated_at
    }
    limit
    hasNextPage
    page
    search
    totalCount
    totalPages
  }
}
    `;
export const CreatePromptDocument = gql`
    mutation createPrompt($input: CreatePromptInput!) {
  createPrompt(createPromptInput: $input) {
    title
    id
    content
    created_at
    updated_at
  }
}
    `;
export const RemovePromptDocument = gql`
    mutation removePrompt($id: Int!) {
  removePrompt(id: $id) {
    title
    id
    content
    created_at
    updated_at
  }
}
    `;
export const UpdatePromptDocument = gql`
    mutation updatePrompt($id: Int!, $input: UpdatePromptInput!) {
  updatePrompt(id: $id, updatePromptInput: $input) {
    title
    id
    content
    created_at
    updated_at
  }
}
    `;
export const SalePriceCalculatorDocument = gql`
    query salePriceCalculator($input: SalePriceCalculatorInput!) {
  result: salePriceCalculator(input: $input) {
    purchaseCost
    sellingPrice
    cashPrice
    creditPrice
    creditUpliftPercent
    torobFee
    tax
    snapFee
    bankFee
    netProfit
    grossProfit
    finalAmount
  }
}
    `;
export const GetAllSettingItemsDocument = gql`
    query getAllSettingItems {
  items: getAllSettingItems {
    id
    key
    label
    description
    value
  }
}
    `;
export const SetSettingItemDocument = gql`
    mutation setSettingItem($id: Float!, $updateSettingInput: UpdateSettingInput!) {
  item: setSettingItem(id: $id, updateSettingInput: $updateSettingInput) {
    id
    key
    label
    description
    value
  }
}
    `;
export const GetMeliPayamakCreditDocument = gql`
    query getMeliPayamakCredit {
  count: getMeliPayamakCredit
}
    `;
export const GetMeliPayamakSmsListDocument = gql`
    query getMeliPayamakSmsList {
  list: getMeliPayamakSmsList {
    Body
    Credit
    CurrentLocation
    FirstLocation
    IsFlash
    IsMoneyBack
    IsRead
    IsUnicode
    LinkID
    Module
    MoneyBackCount
    MoneyBackLevel
    MsgID
    MsgType
    NumberID
    Parts
    RecCount
    RecFailed
    RecSuccess
    Receiver
    SendDate
    Sender
    Tariff
    Udh
    UserID
    UserMaster
    UserStepedMaster
  }
}
    `;
export const SendSmsByMeliPayamakDocument = gql`
    mutation sendSmsByMeliPayamak($input: MeliPayampakMsgInput!) {
  result: sendSmsByMeliPayamak(MeliPayampakMsgInput: $input) {
    code
    message
    success
  }
}
    `;
export const AdminAllTagsDocument = gql`
    query AdminAllTags {
  allTags {
    id
    title
    created_at
    updated_at
  }
}
    `;
export const AdminTagsDocument = gql`
    query AdminTags($orderBy: AdminTagsPaginationOrdersInput, $page: Int!, $limit: Int!, $search: String) {
  tags(orderBy: $orderBy, page: $page, limit: $limit, search: $search) {
    orderBy {
      title
      created_at
      updated_at
    }
    items {
      id
      title
      created_at
      updated_at
    }
    limit
    hasNextPage
    page
    search
    totalCount
    totalPages
  }
}
    `;
export const CreateTagDocument = gql`
    mutation createTag($input: CreateTagInput!) {
  createTag(createTagInput: $input) {
    title
    id
    created_at
    updated_at
  }
}
    `;
export const RemoveTagDocument = gql`
    mutation removeTag($id: Int!) {
  removeTag(id: $id) {
    title
    id
    title
    created_at
    updated_at
  }
}
    `;
export const UpdateTagDocument = gql`
    mutation updateTag($id: Int!, $input: UpdateTagInput!) {
  updateTag(id: $id, updateTagInput: $input) {
    title
    id
    created_at
    updated_at
  }
}
    `;
export const AdminTopBannerDocument = gql`
    query adminTopBanner {
  adminTopBanner {
    action
    backgroundColor
    dialogBody
    dialogButtonLabel
    dialogButtonUrl
    dialogImageAlt
    dialogImageId
    dialogImageUrl
    dialogTitle
    endsAt
    imageAlt
    imageHeight
    imageUrl
    imageWidth
    isActive
    kind
    linkUrl
    openInNewTab
    startsAt
    textAnimation
    textColor
    textLines
    updated_at
    visible
  }
}
    `;
export const UpdateTopBannerDocument = gql`
    mutation updateTopBanner($input: UpdateTopBannerInput!) {
  updateTopBanner(input: $input) {
    action
    backgroundColor
    dialogBody
    dialogButtonLabel
    dialogButtonUrl
    dialogImageAlt
    dialogImageId
    dialogImageUrl
    dialogTitle
    endsAt
    imageAlt
    imageHeight
    imageUrl
    imageWidth
    isActive
    kind
    linkUrl
    openInNewTab
    startsAt
    textAnimation
    textColor
    textLines
    updated_at
    visible
  }
}
    `;
export const AdminUserAddressesDocument = gql`
    query adminUserAddresses($userId: Float!) {
  adminUserAddresses(userId: $userId) {
    address
    city {
      id
      lat
      long
      name
      zoom
    }
    cityId
    id
    isDefault
    lat
    long
    postalCode
    province {
      id
      lat
      long
      name
      zoom
    }
    provinceId
    recipientFirstName
    recipientLastName
    recipientPhoneNumber
    createdAt
    updatedAt
  }
}
    `;
export const AdminUserDetailsDocument = gql`
    query adminUserDetails($userId: Float!) {
  user: userDetails(userId: $userId) {
    birth_date
    created_at
    firstName
    id
    lastName
    locked
    orderCounts {
      awaiting_payment_confirmation_count
      cancelled_count
      delivered_count
      failed_count
      on_hold_count
      out_for_delivery_count
      packed_count
      paid_count
      pending_count
      processing_count
      refunded_count
      return_requested_count
      returned_count
      shipped_count
    }
    phoneNumber
    phoneNumberValidate
    roles
    updated_at
    userAddressesCount
    wallet {
      balance
    }
  }
}
    `;
export const GetUserAuthTokensDocument = gql`
    query getUserAuthTokens($getUserAuthTokensId: Float!) {
  tokens: getUserAuthTokens(id: $getUserAuthTokensId) {
    created_at
    id
    locked
    refreshTokenHash
  }
}
    `;
export const AdminUsersDocument = gql`
    query AdminUsers($limit: Int!, $orderBy: AdminUsersPaginationOrdersInput, $filter: AdminUsersPaginationFiltersInput, $page: Int!, $search: String) {
  users(
    limit: $limit
    orderBy: $orderBy
    page: $page
    search: $search
    filter: $filter
  ) {
    items {
      birth_date
      created_at
      firstName
      id
      lastName
      locked
      phoneNumber
      roles
      updated_at
      deliveredOrdersCount
    }
    hasNextPage
    limit
    orderBy {
      birth_date
      created_at
      firstName
      lastName
      locked
      phoneNumber
      id
      updated_at
      ordersCount
    }
    page
    search
    totalCount
    totalPages
  }
}
    `;
export const AdminCreateVariantRequirementsDocument = gql`
    query AdminCreateVariantRequirements($productId: String!) {
  product(id: $productId) {
    id
    title
    title_en
    code
  }
}
    `;
export const AdminProductSummaryDocument = gql`
    query adminProductSummary($id: String!) {
  product: productSummaryById(id: $id) {
    id
    title
    title_en
    code
    active
    created_at
    updated_at
    mainImage {
      address
      name
      alt
    }
  }
}
    `;
export const AdminProductVariantsDocument = gql`
    query AdminProductVariants($productId: String!, $variantsPage: Int!, $variantsLimit: Int!, $variantsOrderBy: AdminVariantsPaginationOrdersInput, $variantsFilter: AdminVariantsPaginationFiltersInput, $variantSearch: String) {
  varinats: productVariants(
    productId: $productId
    page: $variantsPage
    limit: $variantsLimit
    orderBy: $variantsOrderBy
    filter: $variantsFilter
    search: $variantSearch
  ) {
    page
    limit
    filter {
      active
    }
    orderBy {
      updated_at
      created_at
      stock
      price
      active
      id
    }
    hasNextPage
    totalCount
    totalPages
    items {
      id
      warehouseTargetProductVariantId
      warehouseTargetProductId
      allowAutoOffer
      warehouseTargetDescription
      warehouse {
        title
        code
        active
        id
        productUrlPatten
      }
      attrs {
        value
        name
        key
      }
      guaranteeId
      guarantee {
        id
        title
      }
      maxBasketCount
      price
      cashPrice
      creditPrice
      stock
      purchasePrice
      active
      productId
      salesChannel
      affiliatePrice
      product {
        code
      }
      created_at
      updated_at
    }
  }
}
    `;
export const AdminProductsForVariantsSearchDocument = gql`
    query AdminProductsForVariantsSearch($orderBy: AdminProductsPaginationOrdersInput, $page: Int!, $limit: Int!, $search: String, $filter: AdminProductsPaginationFiltersInput) {
  products(
    orderBy: $orderBy
    page: $page
    limit: $limit
    search: $search
    filter: $filter
  ) {
    orderBy {
      code
      active
      title
      title_en
      created_at
      updated_at
    }
    filter {
      active
      categoryId
    }
    items {
      mainImage {
        address
        alt
      }
      id
      title
      title_en
      code
      active
    }
    limit
    hasNextPage
    page
    search
    totalCount
    totalPages
  }
}
    `;
export const AdminVariantDocument = gql`
    query AdminVariant($variantId: String!, $productId: String!) {
  variant(productId: $productId, variantId: $variantId) {
    id
    productId
    warehouseTargetProductVariantId
    warehouseTargetProductId
    warehouseTargetDescription
    salesChannel
    affiliatePrice
    warehouse {
      title
      code
      active
      id
      productUrlPatten
    }
    attrs {
      key
      value
      name
    }
    product {
      id
      title
      title_en
      code
    }
    guarantee {
      id
      title
    }
    guaranteeId
    stock
    maxBasketCount
    price
    cashPrice
    creditPrice
    allowAutoOffer
    purchasePrice
    active
  }
}
    `;
export const AdminVariantsDocument = gql`
    query AdminVariants($orderBy: AdminVariantsPaginationOrdersInput, $page: Int!, $limit: Int!, $search: String, $filter: AdminVariantsPaginationFiltersInput) {
  variants(
    orderBy: $orderBy
    page: $page
    limit: $limit
    search: $search
    filter: $filter
  ) {
    page
    limit
    filter {
      active
    }
    orderBy {
      updated_at
      created_at
      stock
      price
      active
      id
    }
    hasNextPage
    totalCount
    totalPages
    items {
      id
      productId
      warehouseTargetProductVariantId
      warehouseTargetProductId
      warehouseTargetDescription
      salesChannel
      affiliatePrice
      warehouse {
        title
        code
        active
        productUrlPatten
        id
      }
      allowAutoOffer
      attrs {
        name
        value
        key
      }
      product {
        id
        title
        title_en
        code
        mainImage {
          alt
          name
          address
          id
        }
      }
      guarantee {
        id
        title
      }
      guaranteeId
      stock
      maxBasketCount
      price
      cashPrice
      creditPrice
      purchasePrice
      active
      created_at
      updated_at
    }
  }
}
    `;
export const AdminVariantsByIdsDocument = gql`
    query AdminVariantsByIds($input: VariantIdsArgs!) {
  variantsByIds(variantIdsArgs: $input) {
    id
    productId
    allowAutoOffer
    warehouseTargetProductVariantId
    warehouseTargetProductId
    warehouseTargetDescription
    salesChannel
    affiliatePrice
    attrs {
      key
      name
      value
    }
    warehouse {
      title
      code
      active
      productUrlPatten
      id
    }
    product {
      id
      title
      title_en
      code
      mainImage {
        alt
        name
        address
        id
      }
    }
    guarantee {
      id
      title
    }
    guaranteeId
    stock
    maxBasketCount
    price
    cashPrice
    creditPrice
    purchasePrice
    active
    created_at
    updated_at
  }
}
    `;
export const CreateVariantDocument = gql`
    mutation CreateVariant($input: CreateVariantInput!) {
  createVariant(createVariantInput: $input) {
    active
    id
    productId
    price
    cashPrice
    creditPrice
    purchasePrice
    allowAutoOffer
    stock
    guaranteeId
    maxBasketCount
  }
}
    `;
export const RemoveVariantDocument = gql`
    mutation RemoveVariant($variantId: Float!) {
  removeVariant(id: $variantId) {
    id
  }
}
    `;
export const UpdateVariantDocument = gql`
    mutation UpdateVariant($variantId: Float!, $input: UpdateVariantInput!) {
  updateVariant(id: $variantId, updateVariantInput: $input) {
    active
    id
    productId
    price
    cashPrice
    creditPrice
    purchasePrice
    allowAutoOffer
    stock
    guaranteeId
    maxBasketCount
  }
}
    `;
export const CreateAdminOfflineOrderDocument = gql`
    mutation CreateAdminOfflineOrder($input: CreateAdminOfflineOrderInput!) {
  createAdminOfflineOrder(input: $input) {
    id
    isOffline
    status
    totalPrice
    memo
    initialDate
    created_at
    user {
      id
      phoneNumber
      firstName
      lastName
    }
  }
}
    `;
export const AdminWarehouseShippingMethodsDocument = gql`
    query AdminWarehouseShippingMethods($warehouseId: Int) {
  getAdminWarehouseShippingMethods(warehouseId: $warehouseId) {
    id
    warehouseId
    name
    description
    active
    cashOnDelivery
    cashPrice
    creditPrice
    cities
    legacyShippingMethodId
  }
}
    `;
export const AdminWarehousesDocument = gql`
    query AdminWarehouses {
  getWarehouses {
    active
    code
    id
    title
    cashDisplayName
    creditDisplayName
    shippingOriginLabel
    profitRanges {
      min
      profit
    }
  }
}
    `;
export const CreateWarehouseShippingMethodDocument = gql`
    mutation createWarehouseShippingMethod($input: CreateWarehouseShippingMethodInput!) {
  createWarehouseShippingMethod(input: $input) {
    id
    warehouseId
    name
    active
    cashPrice
    creditPrice
  }
}
    `;
export const UpdateWarehouseDocument = gql`
    mutation updateWarehouse($id: Float!, $input: UpdateWarehouseInput!) {
  warehouse: updateWarehouse(id: $id, input: $input) {
    active
    code
    id
    title
    cashDisplayName
    creditDisplayName
    shippingOriginLabel
    profitRanges {
      min
      profit
    }
  }
}
    `;
export const UpdateWarehouseShippingMethodDocument = gql`
    mutation updateWarehouseShippingMethod($id: Int!, $input: UpdateWarehouseShippingMethodInput!) {
  updateWarehouseShippingMethod(id: $id, input: $input) {
    id
    warehouseId
    name
    active
    cashPrice
    creditPrice
  }
}
    `;
export const AdminWheelPrizesDocument = gql`
    query adminWheelPrizes {
  adminWheelPrizes {
    available
    color
    description
    discountAmount
    expiryHours
    id
    imageUrl
    isActive
    label
    maxWins
    minimumPurchase
    productCode
    productTitle
    sharePercent
    sortOrder
    type
    unavailableReason
    variantId
    weight
    winCount
  }
}
    `;
export const AdminWheelSettingsDocument = gql`
    query adminWheelSettings {
  adminWheelSettings {
    dailySpinLimit
    isActive
    minPaidAmountToUnlock
    prizeExpiryHours
    rules
    seoDescription
    seoKeywords
    seoTitle
    subtitle
    title
  }
}
    `;
export const AdminWheelSpinsDocument = gql`
    query adminWheelSpins($limit: Int!, $page: Int!, $search: String) {
  adminWheelSpins(limit: $limit, page: $page, search: $search) {
    hasNextPage
    limit
    page
    totalCount
    totalPages
    items {
      discountAmount
      discountCode
      id
      label
      prizeType
      productCode
      spunAt
      used
      userName
      userPhone
    }
  }
}
    `;
export const AdminWheelStatsDocument = gql`
    query adminWheelStats {
  adminWheelStats {
    activePrizeCount
    expectedCost
    redeemedSpins
    spinsToday
    totalSpins
  }
}
    `;
export const CreateWheelPrizeDocument = gql`
    mutation createWheelPrize($input: UpsertWheelPrizeInput!) {
  createWheelPrize(input: $input) {
    id
    label
  }
}
    `;
export const DeleteWheelPrizeDocument = gql`
    mutation deleteWheelPrize($id: Int!) {
  deleteWheelPrize(id: $id)
}
    `;
export const UpdateWheelPrizeDocument = gql`
    mutation updateWheelPrize($id: Int!, $input: UpsertWheelPrizeInput!) {
  updateWheelPrize(id: $id, input: $input) {
    id
    label
  }
}
    `;
export const UpdateWheelSettingsDocument = gql`
    mutation updateWheelSettings($input: UpdateWheelSettingsInput!) {
  updateWheelSettings(input: $input) {
    dailySpinLimit
    isActive
    minPaidAmountToUnlock
    prizeExpiryHours
    rules
    seoDescription
    seoKeywords
    seoTitle
    subtitle
    title
  }
}
    `;
export const WheelVariantOptionsDocument = gql`
    query wheelVariantOptions($search: String!) {
  wheelVariantOptions(search: $search) {
    active
    id
    imageUrl
    price
    productCode
    stock
    title
  }
}
    `;
export const AdminProductsViewsReportDocument = gql`
    query adminProductsViewsReport($from: Date, $to: Date, $top: Int!) {
  products: productsViewsReport(from: $from, to: $to, top: $top) {
    lessViewed: lessViewedProducts {
      code
      id
      imageAddress
      title
      viewsCount
    }
    mostViewed: mostViewedProducts {
      code
      id
      imageAddress
      title
      viewsCount
    }
  }
}
    `;
export const GetDashboardDataDocument = gql`
    query getDashboardData($days: Int!) {
  data: getDashboardData(days: $days) {
    kpis {
      totalViews
      uniqueVisitors
    }
    referrers {
      name
      value
    }
    timeSeries {
      date
      unique
      views
    }
  }
}
    `;
export const OrdersCountDocument = gql`
    query ordersCount {
  ordersCount {
    awaitingPaymentConfirmationCount
    cancelledCount
    deliveredCount
    failedCount
    onHoldCount
    outForDeliveryCount
    paidCount
    packedCount
    pendingCount
    processingCount
    refundedCount
    returnRequestedCount
    returnedCount
    shippedCount
    totalCancelledCount
    totalCancelledPrice
    totalCount
    totalPaidCount
    totalPaidPrice
    totalPendingCount
    totalPendingPrice
  }
}
    `;
export const OrdersSaleChartDocument = gql`
    query ordersSaleChart($from: Date!, $to: Date!, $interval: IntervalEnum!) {
  chart: ordersSaleChart(from: $from, to: $to, interval: $interval) {
    gateways {
      date
      totalItems
      totalOrders
      totalSale
      code
    }
    sales {
      date
      totalItems
      totalOrders
      totalSale
    }
  }
}
    `;
export const ProductsCountDocument = gql`
    query productsCount {
  counts: productsCount {
    activeCount
    notActiveCount
    totalCount
  }
}
    `;
export const RefererChartDataDocument = gql`
    query refererChartData {
  refererChartData {
    name
    value
  }
}
    `;
export const VariantsCountDocument = gql`
    query variantsCount($warehouseId: Float) {
  counts: variantsCount(warehouseId: $warehouseId) {
    totalCount
    notActiveCount
    activeWithoutStockCount
    activeWithStockCount
    totalActiveItems
    totalVariantsPriceWithoutOffers
  }
}
    `;
export const AdminCreatePostCategoryDocument = gql`
    mutation AdminCreatePostCategory($input: CreatePostCategoryInput!) {
  adminCreatePostCategory(input: $input) {
    id
    title
    title_en
    slug
    active
    sort
    seo_url
    postCount
  }
}
    `;
export const AdminDeletePostCategoryDocument = gql`
    mutation AdminDeletePostCategory($id: Int!) {
  adminDeletePostCategory(id: $id)
}
    `;
export const AdminPostCategoriesDocument = gql`
    query AdminPostCategories {
  adminPostCategories {
    id
    title
    title_en
    slug
    active
    sort
    seo_url
    postCount
  }
}
    `;
export const AdminPostCategoryDocument = gql`
    query AdminPostCategory($id: Int!) {
  adminPostCategory(id: $id) {
    id
    title
    title_en
    slug
    active
    sort
    seo_url
    postCount
  }
}
    `;
export const AdminUpdatePostCategoryDocument = gql`
    mutation AdminUpdatePostCategory($input: UpdatePostCategoryInput!) {
  adminUpdatePostCategory(input: $input) {
    id
    title
    title_en
    slug
    active
    sort
    seo_url
    postCount
  }
}
    `;
export const CreatePostDocument = gql`
    mutation CreatePost($createPostInput: CreatePostInput!) {
  createPost(createPostInput: $createPostInput) {
    id
    title
    slug
    status
    createdAt
  }
}
    `;
export const GetAdminPostByIdDocument = gql`
    query GetAdminPostById($id: Float!) {
  adminPostById(id: $id) {
    id
    title
    titleEn
    slug
    excerpt
    content
    readingTime
    status
    active
    publishedAt
    viewCount
    sortOrder
    categoryId
    categoryName
    tags
    seoKeywords
    metaTitle
    metaDescription
    canonicalUrl
    indexable
    createdAt
    updatedAt
    coverImageId
    coverImage {
      id
      address
      name
      alt
    }
    productSettings {
      enabled
      sort
      limit
      sectionTitle
      brandIds
      categoryIds
      includeChildCategories
      usePostTags
      tagIds
      productCodes
      hasOfferOnly
    }
    productBrands {
      id
      title
    }
    productCategories {
      id
      title
    }
    productTags {
      id
      title
    }
    productPicks {
      code
      title
      image
      inStock
      active
    }
  }
}
    `;
export const GetAdminPostBySlugDocument = gql`
    query GetAdminPostBySlug($slug: String!) {
  adminPostBySlug(slug: $slug) {
    id
    title
    titleEn
    slug
    excerpt
    content
    readingTime
    status
    active
    publishedAt
    viewCount
    sortOrder
    categoryId
    categoryName
    tags
    seoKeywords
    metaTitle
    metaDescription
    canonicalUrl
    indexable
    createdAt
    updatedAt
    coverImageId
    coverImage {
      id
      address
      name
      alt
    }
    productSettings {
      enabled
      sort
      limit
      sectionTitle
      brandIds
      categoryIds
      includeChildCategories
      usePostTags
      tagIds
      productCodes
      hasOfferOnly
    }
    productBrands {
      id
      title
    }
    productCategories {
      id
      title
    }
    productTags {
      id
      title
    }
    productPicks {
      code
      title
      image
      inStock
      active
    }
  }
}
    `;
export const GetAdminPostsDocument = gql`
    query GetAdminPosts($page: Int!, $limit: Int!, $search: String, $orderBy: AdminPostsPaginationOrdersInput, $filter: AdminPostsPaginationFiltersInput) {
  adminPosts(
    search: $search
    orderBy: $orderBy
    filter: $filter
    page: $page
    limit: $limit
  ) {
    items {
      id
      title
      slug
      status
      categoryName
      viewCount
      publishedAt
      createdAt
      updatedAt
      active
    }
    totalCount
    hasNextPage
    orderBy {
      updatedAt
      createdAt
      title
      viewCount
      status
      publishedAt
      category_title
    }
    search
    filter {
      status
      active
      categoryId
    }
  }
}
    `;
export const UpdatePostDocument = gql`
    mutation UpdatePost($updatePostInput: UpdatePostInput!) {
  updatePost(updatePostInput: $updatePostInput) {
    id
    title
    slug
    status
    updatedAt
  }
}
    `;
export const AdminBlogDashboardDocument = gql`
    query AdminBlogDashboard($days: Int!) {
  adminBlogDashboard(days: $days) {
    days
    overview {
      totalPosts
      publishedPosts
      draftPosts
      archivedPosts
      activePosts
      totalViews
      viewsInRange
      uniqueVisitors
      loggedInViews
      guestViews
      viewsToday
      viewsYesterday
      categoryCount
      taggedPosts
      avgReadingTime
      publishedInRange
      createdInRange
      uncategorizedPosts
    }
    seo {
      missingMetaTitle
      missingMetaDescription
      missingExcerpt
      missingCover
      notIndexable
      missingKeywords
      healthyPosts
    }
    daily {
      date
      views
      uniqueVisitors
      published
    }
    hourly {
      hour
      views
    }
    topPosts {
      id
      title
      slug
      categoryName
      viewCount
      viewsInRange
      status
      readingTime
      publishedAt
    }
    categories {
      id
      title
      postCount
      viewCount
    }
    topTags {
      title
      postCount
    }
    recentPosts {
      id
      title
      slug
      status
      updatedAt
      viewCount
    }
    traffic {
      visits
      uniqueVisitors
      sources {
        source
        kind
        visits
        uniqueVisitors
      }
    }
  }
}
    `;
export const PostsSiteMapDocument = gql`
    query postsSiteMap($limit: Float!, $skip: Float!) {
  postsSiteMap(limit: $limit, skip: $skip) {
    slug
    updatedAt
  }
}
    `;
export const PostsSiteMapCountDocument = gql`
    query postsSiteMapCount {
  postsSiteMapCount
}
    `;
export const ProductsSiteMapDocument = gql`
    query productsSiteMap($limit: Float!, $skip: Float!) {
  productsSiteMap(limit: $limit, skip: $skip) {
    code
    title
    updated_at
  }
}
    `;
export const ProductsSiteMapCountDocument = gql`
    query productsSiteMapCount {
  productsSiteMapCount
}
    `;
export const GetPaymentSourceDetectorsDocument = gql`
    query getPaymentSourceDetectors {
  getPaymentSourceDetectors {
    code
    matchKeys
    sourcePriority
  }
}
    `;
export const AddToCartDocument = gql`
    mutation AddToCart($createCartInput: CreateCartInput!) {
  addToCart(createCartInput: $createCartInput) {
    id
    pricingMode
    subtotal
    discountAmount
    totalPrice
    cartItems {
      id
      quantity
      unitPrice
      totalPrice
      discountPrice
      productId
      product {
        id
        code
        title
        title_en
        categoryId
        mainImage {
          address
          alt
        }
      }
      variantId
      variant {
        id
        guarantee {
          title
        }
        attrs {
          name
          value
          key
        }
        maxBasketCount
        stock
        price
        cashPrice
        creditPrice
        warehouseId
        warehouse {
          id
          title
          cashDisplayName
          creditDisplayName
          shippingOriginLabel
        }
      }
      offerId
      changeHistories {
        id
        available
        newOfferId
        oldOfferId
        oldUnitPrice
        newUnitPrice
        newQuantity
        oldQuantity
        newDiscountPrice
        oldDiscountPrice
      }
      offer {
        id
        stock
        maxBasketCount
        price
        percentage
        end_at
        offerType {
          title
        }
      }
    }
  }
}
    `;
export const GetCartDocument = gql`
    query GetCart {
  getCart {
    id
    pricingMode
    subtotal
    discountAmount
    totalPrice
    cartItems {
      id
      quantity
      unitPrice
      totalPrice
      discountPrice
      productId
      product {
        id
        code
        title
        title_en
        categoryId
        mainImage {
          address
          alt
        }
      }
      variantId
      variant {
        id
        guarantee {
          title
        }
        maxBasketCount
        stock
        price
        cashPrice
        creditPrice
        warehouseId
        warehouse {
          id
          title
          cashDisplayName
          creditDisplayName
          shippingOriginLabel
        }
        attrs {
          key
          value
          name
        }
      }
      offerId
      offer {
        id
        stock
        maxBasketCount
        price
        percentage
        end_at
        offerType {
          title
        }
      }
      changeHistories {
        id
        available
        newOfferId
        oldOfferId
        oldUnitPrice
        newUnitPrice
        newQuantity
        oldQuantity
        newDiscountPrice
        oldDiscountPrice
      }
    }
  }
}
    `;
export const CreateUserLogDocument = gql`
    mutation createUserLog($createUserLogInput: CreateUserLogInput!) {
  createUserLog(createUserLogInput: $createUserLogInput)
}
    `;
export const LoginReqDocument = gql`
    mutation loginReq($input: LoginUserInput!) {
  login(loginUserInput: $input) {
    __typename
    ... on CodeSentResult {
      phoneNumber
      sent
      deadline
    }
    ... on TokenResult {
      token
      refresh
    }
  }
}
    `;
export const ProfileDocument = gql`
    query profile {
  me {
    roles
    phoneNumber
    birth_date
    firstName
    lastName
    id
  }
}
    `;
export const PingDocument = gql`
    query ping {
  ping
}
    `;
export const RefreshDocument = gql`
    mutation Refresh {
  refreshToken {
    refresh
    token
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    Search(variables: SearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchQuery>(SearchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Search', 'query', variables);
    },
    searchFilters(variables?: SearchFiltersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SearchFiltersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchFiltersQuery>(SearchFiltersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'searchFilters', 'query', variables);
    },
    postWithSlug(variables: PostWithSlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PostWithSlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PostWithSlugQuery>(PostWithSlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'postWithSlug', 'query', variables);
    },
    searchPosts(variables: SearchPostsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SearchPostsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchPostsQuery>(SearchPostsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'searchPosts', 'query', variables);
    },
    paymentResult(variables: PaymentResultQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaymentResultQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentResultQuery>(PaymentResultDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paymentResult', 'query', variables);
    },
    addDiscountToUserCurrentOrder(variables: AddDiscountToUserCurrentOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddDiscountToUserCurrentOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddDiscountToUserCurrentOrderMutation>(AddDiscountToUserCurrentOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addDiscountToUserCurrentOrder', 'mutation', variables);
    },
    convertCurrentOrderPricingMode(variables: ConvertCurrentOrderPricingModeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ConvertCurrentOrderPricingModeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConvertCurrentOrderPricingModeMutation>(ConvertCurrentOrderPricingModeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'convertCurrentOrderPricingMode', 'mutation', variables);
    },
    getApoloanEligibility(variables: GetApoloanEligibilityQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetApoloanEligibilityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetApoloanEligibilityQuery>(GetApoloanEligibilityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getApoloanEligibility', 'query', variables);
    },
    getCheckoutRequirements(variables?: GetCheckoutRequirementsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCheckoutRequirementsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCheckoutRequirementsQuery>(GetCheckoutRequirementsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCheckoutRequirements', 'query', variables);
    },
    getSnapPayEligibility(variables: GetSnapPayEligibilityQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSnapPayEligibilityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSnapPayEligibilityQuery>(GetSnapPayEligibilityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSnapPayEligibility', 'query', variables);
    },
    getTorobPayEligibility(variables: GetTorobPayEligibilityQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetTorobPayEligibilityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTorobPayEligibilityQuery>(GetTorobPayEligibilityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getTorobPayEligibility', 'query', variables);
    },
    getUserCurrentOrder(variables?: GetUserCurrentOrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetUserCurrentOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserCurrentOrderQuery>(GetUserCurrentOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUserCurrentOrder', 'query', variables);
    },
    getWarehouseShippingMethods(variables: GetWarehouseShippingMethodsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetWarehouseShippingMethodsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetWarehouseShippingMethodsQuery>(GetWarehouseShippingMethodsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getWarehouseShippingMethods', 'query', variables);
    },
    pay(variables: PayMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PayMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PayMutation>(PayDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'pay', 'mutation', variables);
    },
    removeDiscountFromUserCurrentOrder(variables: RemoveDiscountFromUserCurrentOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveDiscountFromUserCurrentOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveDiscountFromUserCurrentOrderMutation>(RemoveDiscountFromUserCurrentOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeDiscountFromUserCurrentOrder', 'mutation', variables);
    },
    updateUserCurrentOrder(variables: UpdateUserCurrentOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateUserCurrentOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserCurrentOrderMutation>(UpdateUserCurrentOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUserCurrentOrder', 'mutation', variables);
    },
    cartRecommendations(variables: CartRecommendationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CartRecommendationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CartRecommendationsQuery>(CartRecommendationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'cartRecommendations', 'query', variables);
    },
    myWheelStatus(variables?: MyWheelStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MyWheelStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MyWheelStatusQuery>(MyWheelStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'myWheelStatus', 'query', variables);
    },
    spinWheel(variables?: SpinWheelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SpinWheelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SpinWheelMutation>(SpinWheelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'spinWheel', 'mutation', variables);
    },
    wheelCampaign(variables?: WheelCampaignQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WheelCampaignQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WheelCampaignQuery>(WheelCampaignDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'wheelCampaign', 'query', variables);
    },
    ConvertCartPricingMode(variables: ConvertCartPricingModeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ConvertCartPricingModeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConvertCartPricingModeMutation>(ConvertCartPricingModeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ConvertCartPricingMode', 'mutation', variables);
    },
    searchRelatedProducts(variables: SearchRelatedProductsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SearchRelatedProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchRelatedProductsQuery>(SearchRelatedProductsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'searchRelatedProducts', 'query', variables);
    },
    searchRelatedProductsByCode(variables: SearchRelatedProductsByCodeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SearchRelatedProductsByCodeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchRelatedProductsByCodeQuery>(SearchRelatedProductsByCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'searchRelatedProductsByCode', 'query', variables);
    },
    SingleProduct(variables: SingleProductQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SingleProductQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SingleProductQuery>(SingleProductDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SingleProduct', 'query', variables);
    },
    cities(variables?: CitiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CitiesQuery>(CitiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'cities', 'query', variables);
    },
    createUserAddress(variables: CreateUserAddressMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateUserAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateUserAddressMutation>(CreateUserAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createUserAddress', 'mutation', variables);
    },
    provinces(variables?: ProvincesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProvincesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProvincesQuery>(ProvincesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'provinces', 'query', variables);
    },
    removeUserAddress(variables: RemoveUserAddressMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveUserAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveUserAddressMutation>(RemoveUserAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeUserAddress', 'mutation', variables);
    },
    toggleUserAddressIsDefault(variables: ToggleUserAddressIsDefaultMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ToggleUserAddressIsDefaultMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ToggleUserAddressIsDefaultMutation>(ToggleUserAddressIsDefaultDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'toggleUserAddressIsDefault', 'mutation', variables);
    },
    updateUserAddress(variables: UpdateUserAddressMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateUserAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserAddressMutation>(UpdateUserAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUserAddress', 'mutation', variables);
    },
    userAddress(variables: UserAddressQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserAddressQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserAddressQuery>(UserAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userAddress', 'query', variables);
    },
    userAddresses(variables?: UserAddressesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserAddressesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserAddressesQuery>(UserAddressesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userAddresses', 'query', variables);
    },
    updateMe(variables: UpdateMeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateMeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMeMutation>(UpdateMeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateMe', 'mutation', variables);
    },
    userOrder(variables: UserOrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserOrderQuery>(UserOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userOrder', 'query', variables);
    },
    userOrders(variables: UserOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserOrdersQuery>(UserOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userOrders', 'query', variables);
    },
    userProductViews(variables: UserProductViewsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserProductViewsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserProductViewsQuery>(UserProductViewsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userProductViews', 'query', variables);
    },
    userOrdersMeta(variables?: UserOrdersMetaQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserOrdersMetaQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserOrdersMetaQuery>(UserOrdersMetaDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userOrdersMeta', 'query', variables);
    },
    HomePageData(variables: HomePageDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<HomePageDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<HomePageDataQuery>(HomePageDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'HomePageData', 'query', variables);
    },
    SearchByCategoryId(variables: SearchByCategoryIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SearchByCategoryIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchByCategoryIdQuery>(SearchByCategoryIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SearchByCategoryId', 'query', variables);
    },
    SearchMostOffer(variables?: SearchMostOfferQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SearchMostOfferQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchMostOfferQuery>(SearchMostOfferDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SearchMostOffer', 'query', variables);
    },
    SearchMostSale(variables?: SearchMostSaleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SearchMostSaleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchMostSaleQuery>(SearchMostSaleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SearchMostSale', 'query', variables);
    },
    getPaymentGatewaysOfProduct(variables?: GetPaymentGatewaysOfProductQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPaymentGatewaysOfProductQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPaymentGatewaysOfProductQuery>(GetPaymentGatewaysOfProductDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPaymentGatewaysOfProduct', 'query', variables);
    },
    menu(variables?: MenuQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MenuQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MenuQuery>(MenuDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'menu', 'query', variables);
    },
    searchTerm(variables: SearchTermQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SearchTermQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchTermQuery>(SearchTermDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'searchTerm', 'query', variables);
    },
    topBanner(variables?: TopBannerQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TopBannerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TopBannerQuery>(TopBannerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'topBanner', 'query', variables);
    },
    createImage(variables: CreateImageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateImageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateImageMutation>(CreateImageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createImage', 'mutation', variables);
    },
    updateImage(variables: UpdateImageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateImageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateImageMutation>(UpdateImageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateImage', 'mutation', variables);
    },
    AiImageGenerationJob(variables: AiImageGenerationJobQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AiImageGenerationJobQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AiImageGenerationJobQuery>(AiImageGenerationJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AiImageGenerationJob', 'query', variables);
    },
    AiImageGenerationJobByProductId(variables: AiImageGenerationJobByProductIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AiImageGenerationJobByProductIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AiImageGenerationJobByProductIdQuery>(AiImageGenerationJobByProductIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AiImageGenerationJobByProductId', 'query', variables);
    },
    AiImageGenerationJobs(variables: AiImageGenerationJobsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AiImageGenerationJobsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AiImageGenerationJobsQuery>(AiImageGenerationJobsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AiImageGenerationJobs', 'query', variables);
    },
    CreateAiImageGenerationJob(variables: CreateAiImageGenerationJobMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateAiImageGenerationJobMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAiImageGenerationJobMutation>(CreateAiImageGenerationJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateAiImageGenerationJob', 'mutation', variables);
    },
    ReloadAiImageGenerationJob(variables: ReloadAiImageGenerationJobMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReloadAiImageGenerationJobMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReloadAiImageGenerationJobMutation>(ReloadAiImageGenerationJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ReloadAiImageGenerationJob', 'mutation', variables);
    },
    RemoveAiImageGenerationJob(variables: RemoveAiImageGenerationJobMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveAiImageGenerationJobMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveAiImageGenerationJobMutation>(RemoveAiImageGenerationJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemoveAiImageGenerationJob', 'mutation', variables);
    },
    AdminBrands(variables: AdminBrandsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminBrandsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminBrandsQuery>(AdminBrandsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminBrands', 'query', variables);
    },
    createBrand(variables: CreateBrandMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateBrandMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateBrandMutation>(CreateBrandDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createBrand', 'mutation', variables);
    },
    removeBrand(variables: RemoveBrandMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveBrandMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveBrandMutation>(RemoveBrandDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeBrand', 'mutation', variables);
    },
    updateBrand(variables: UpdateBrandMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateBrandMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateBrandMutation>(UpdateBrandDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateBrand', 'mutation', variables);
    },
    categories(variables?: CategoriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CategoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CategoriesQuery>(CategoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'categories', 'query', variables);
    },
    category(variables: CategoryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CategoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CategoryQuery>(CategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'category', 'query', variables);
    },
    createCategory(variables: CreateCategoryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateCategoryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCategoryMutation>(CreateCategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createCategory', 'mutation', variables);
    },
    getBasalamCategories(variables?: GetBasalamCategoriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetBasalamCategoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBasalamCategoriesQuery>(GetBasalamCategoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBasalamCategories', 'query', variables);
    },
    moveCategory(variables: MoveCategoryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MoveCategoryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MoveCategoryMutation>(MoveCategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'moveCategory', 'mutation', variables);
    },
    removeCategory(variables: RemoveCategoryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveCategoryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveCategoryMutation>(RemoveCategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeCategory', 'mutation', variables);
    },
    updateCategory(variables: UpdateCategoryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCategoryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCategoryMutation>(UpdateCategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCategory', 'mutation', variables);
    },
    colors(variables?: ColorsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ColorsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ColorsQuery>(ColorsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'colors', 'query', variables);
    },
    createColor(variables: CreateColorMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateColorMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateColorMutation>(CreateColorDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createColor', 'mutation', variables);
    },
    removeColor(variables: RemoveColorMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveColorMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveColorMutation>(RemoveColorDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeColor', 'mutation', variables);
    },
    updateColor(variables: UpdateColorMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateColorMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateColorMutation>(UpdateColorDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateColor', 'mutation', variables);
    },
    adminDiscount(variables: AdminDiscountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminDiscountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDiscountQuery>(AdminDiscountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'adminDiscount', 'query', variables);
    },
    adminDiscounts(variables: AdminDiscountsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminDiscountsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDiscountsQuery>(AdminDiscountsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'adminDiscounts', 'query', variables);
    },
    createDiscount(variables: CreateDiscountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateDiscountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateDiscountMutation>(CreateDiscountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createDiscount', 'mutation', variables);
    },
    getUsersByHint(variables?: GetUsersByHintQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetUsersByHintQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUsersByHintQuery>(GetUsersByHintDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUsersByHint', 'query', variables);
    },
    removeDiscount(variables: RemoveDiscountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveDiscountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveDiscountMutation>(RemoveDiscountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeDiscount', 'mutation', variables);
    },
    updateDiscount(variables: UpdateDiscountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateDiscountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDiscountMutation>(UpdateDiscountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateDiscount', 'mutation', variables);
    },
    AdminOrdersProfit(variables: AdminOrdersProfitQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminOrdersProfitQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOrdersProfitQuery>(AdminOrdersProfitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOrdersProfit', 'query', variables);
    },
    AdminGuarantees(variables: AdminGuaranteesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminGuaranteesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminGuaranteesQuery>(AdminGuaranteesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminGuarantees', 'query', variables);
    },
    createGuarantee(variables: CreateGuaranteeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateGuaranteeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateGuaranteeMutation>(CreateGuaranteeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createGuarantee', 'mutation', variables);
    },
    removeGuarantee(variables: RemoveGuaranteeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveGuaranteeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveGuaranteeMutation>(RemoveGuaranteeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeGuarantee', 'mutation', variables);
    },
    updateGuarantee(variables: UpdateGuaranteeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateGuaranteeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateGuaranteeMutation>(UpdateGuaranteeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateGuarantee', 'mutation', variables);
    },
    addVarinatToBarcodePerPrintList(variables: AddVarinatToBarcodePerPrintListMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddVarinatToBarcodePerPrintListMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddVarinatToBarcodePerPrintListMutation>(AddVarinatToBarcodePerPrintListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addVarinatToBarcodePerPrintList', 'mutation', variables);
    },
    getBarcodeLabels(variables?: GetBarcodeLabelsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetBarcodeLabelsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBarcodeLabelsQuery>(GetBarcodeLabelsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBarcodeLabels', 'query', variables);
    },
    removeAllBarcodeLabels(variables?: RemoveAllBarcodeLabelsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveAllBarcodeLabelsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveAllBarcodeLabelsMutation>(RemoveAllBarcodeLabelsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeAllBarcodeLabels', 'mutation', variables);
    },
    AdminOfferTypes(variables: AdminOfferTypesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminOfferTypesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOfferTypesQuery>(AdminOfferTypesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOfferTypes', 'query', variables);
    },
    createOfferType(variables: CreateOfferTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateOfferTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOfferTypeMutation>(CreateOfferTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOfferType', 'mutation', variables);
    },
    removeOfferType(variables: RemoveOfferTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveOfferTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveOfferTypeMutation>(RemoveOfferTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeOfferType', 'mutation', variables);
    },
    updateOfferType(variables: UpdateOfferTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateOfferTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOfferTypeMutation>(UpdateOfferTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOfferType', 'mutation', variables);
    },
    AdminOffers(variables: AdminOffersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminOffersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOffersQuery>(AdminOffersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOffers', 'query', variables);
    },
    createRangeOffer(variables: CreateRangeOfferMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateRangeOfferMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateRangeOfferMutation>(CreateRangeOfferDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createRangeOffer', 'mutation', variables);
    },
    removeOffer(variables: RemoveOfferMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveOfferMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveOfferMutation>(RemoveOfferDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeOffer', 'mutation', variables);
    },
    updateOffer(variables: UpdateOfferMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateOfferMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOfferMutation>(UpdateOfferDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOffer', 'mutation', variables);
    },
    adminOrdersLocationDistribution(variables?: AdminOrdersLocationDistributionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminOrdersLocationDistributionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOrdersLocationDistributionQuery>(AdminOrdersLocationDistributionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'adminOrdersLocationDistribution', 'query', variables);
    },
    AdminOrder(variables: AdminOrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOrderQuery>(AdminOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOrder', 'query', variables);
    },
    AdminOrderCart(variables: AdminOrderCartQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminOrderCartQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOrderCartQuery>(AdminOrderCartDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOrderCart', 'query', variables);
    },
    getOrderHistoryByOrderId(variables: GetOrderHistoryByOrderIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOrderHistoryByOrderIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrderHistoryByOrderIdQuery>(GetOrderHistoryByOrderIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOrderHistoryByOrderId', 'query', variables);
    },
    getOrderItemActionsByOrderId(variables: GetOrderItemActionsByOrderIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOrderItemActionsByOrderIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrderItemActionsByOrderIdQuery>(GetOrderItemActionsByOrderIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOrderItemActionsByOrderId', 'query', variables);
    },
    getOrderPaymentsByOrderId(variables: GetOrderPaymentsByOrderIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOrderPaymentsByOrderIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrderPaymentsByOrderIdQuery>(GetOrderPaymentsByOrderIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOrderPaymentsByOrderId', 'query', variables);
    },
    AdminOrderV2(variables: AdminOrderV2QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminOrderV2Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOrderV2Query>(AdminOrderV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOrderV2', 'query', variables);
    },
    processOrderItemPartialCancellation(variables: ProcessOrderItemPartialCancellationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProcessOrderItemPartialCancellationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProcessOrderItemPartialCancellationMutation>(ProcessOrderItemPartialCancellationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'processOrderItemPartialCancellation', 'mutation', variables);
    },
    updateAdminOrder(variables: UpdateAdminOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateAdminOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAdminOrderMutation>(UpdateAdminOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAdminOrder', 'mutation', variables);
    },
    updateAdminOrderShippingAddress(variables: UpdateAdminOrderShippingAddressMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateAdminOrderShippingAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAdminOrderShippingAddressMutation>(UpdateAdminOrderShippingAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAdminOrderShippingAddress', 'mutation', variables);
    },
    updateAdminOrderStatus(variables: UpdateAdminOrderStatusMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateAdminOrderStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAdminOrderStatusMutation>(UpdateAdminOrderStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAdminOrderStatus', 'mutation', variables);
    },
    updateAdminOrderStatusToCancelled(variables: UpdateAdminOrderStatusToCancelledMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateAdminOrderStatusToCancelledMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAdminOrderStatusToCancelledMutation>(UpdateAdminOrderStatusToCancelledDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAdminOrderStatusToCancelled', 'mutation', variables);
    },
    updateOrderItemPartialCancellation(variables: UpdateOrderItemPartialCancellationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateOrderItemPartialCancellationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOrderItemPartialCancellationMutation>(UpdateOrderItemPartialCancellationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOrderItemPartialCancellation', 'mutation', variables);
    },
    updateOrderShipmentStatus(variables: UpdateOrderShipmentStatusMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateOrderShipmentStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOrderShipmentStatusMutation>(UpdateOrderShipmentStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOrderShipmentStatus', 'mutation', variables);
    },
    AdminOrders(variables: AdminOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminOrdersQuery>(AdminOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminOrders', 'query', variables);
    },
    getPaymentGateways(variables?: GetPaymentGatewaysQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPaymentGatewaysQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPaymentGatewaysQuery>(GetPaymentGatewaysDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPaymentGateways', 'query', variables);
    },
    updatePaymentGateway(variables: UpdatePaymentGatewayMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePaymentGatewayMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePaymentGatewayMutation>(UpdatePaymentGatewayDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePaymentGateway', 'mutation', variables);
    },
    AdminPayments(variables: AdminPaymentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminPaymentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPaymentsQuery>(AdminPaymentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPayments', 'query', variables);
    },
    AdminProductImages(variables: AdminProductImagesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminProductImagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminProductImagesQuery>(AdminProductImagesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminProductImages', 'query', variables);
    },
    AdminProductStats(variables: AdminProductStatsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminProductStatsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminProductStatsQuery>(AdminProductStatsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminProductStats', 'query', variables);
    },
    AdminProduct(variables: AdminProductQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminProductQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminProductQuery>(AdminProductDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminProduct', 'query', variables);
    },
    AdminProducts(variables: AdminProductsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminProductsQuery>(AdminProductsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminProducts', 'query', variables);
    },
    ChangeProductImageSort(variables: ChangeProductImageSortMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ChangeProductImageSortMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChangeProductImageSortMutation>(ChangeProductImageSortDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ChangeProductImageSort', 'mutation', variables);
    },
    ChangeSpecificationSort(variables: ChangeSpecificationSortMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ChangeSpecificationSortMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChangeSpecificationSortMutation>(ChangeSpecificationSortDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ChangeSpecificationSort', 'mutation', variables);
    },
    CreateProduct(variables: CreateProductMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateProductMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateProductMutation>(CreateProductDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateProduct', 'mutation', variables);
    },
    CreateSpecification(variables: CreateSpecificationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateSpecificationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSpecificationMutation>(CreateSpecificationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateSpecification', 'mutation', variables);
    },
    removeProductImage(variables: RemoveProductImageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveProductImageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveProductImageMutation>(RemoveProductImageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeProductImage', 'mutation', variables);
    },
    RemoveSpecification(variables: RemoveSpecificationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveSpecificationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveSpecificationMutation>(RemoveSpecificationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemoveSpecification', 'mutation', variables);
    },
    UpdateProduct(variables: UpdateProductMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateProductMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateProductMutation>(UpdateProductDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateProduct', 'mutation', variables);
    },
    updateProductImage(variables: UpdateProductImageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateProductImageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateProductImageMutation>(UpdateProductImageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateProductImage', 'mutation', variables);
    },
    UpdateSpecification(variables: UpdateSpecificationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateSpecificationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSpecificationMutation>(UpdateSpecificationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateSpecification', 'mutation', variables);
    },
    createProductImage(variables: CreateProductImageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateProductImageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateProductImageMutation>(CreateProductImageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createProductImage', 'mutation', variables);
    },
    createSpecificationRange(variables: CreateSpecificationRangeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateSpecificationRangeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSpecificationRangeMutation>(CreateSpecificationRangeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createSpecificationRange', 'mutation', variables);
    },
    deleteVideo(variables: DeleteVideoMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteVideoMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteVideoMutation>(DeleteVideoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteVideo', 'mutation', variables);
    },
    updateVideo(variables: UpdateVideoMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateVideoMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateVideoMutation>(UpdateVideoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateVideo', 'mutation', variables);
    },
    uploadVideo(variables: UploadVideoMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UploadVideoMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UploadVideoMutation>(UploadVideoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'uploadVideo', 'mutation', variables);
    },
    AdminPrompts(variables: AdminPromptsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminPromptsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPromptsQuery>(AdminPromptsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPrompts', 'query', variables);
    },
    createPrompt(variables: CreatePromptMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreatePromptMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePromptMutation>(CreatePromptDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createPrompt', 'mutation', variables);
    },
    removePrompt(variables: RemovePromptMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemovePromptMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemovePromptMutation>(RemovePromptDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removePrompt', 'mutation', variables);
    },
    updatePrompt(variables: UpdatePromptMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePromptMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePromptMutation>(UpdatePromptDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePrompt', 'mutation', variables);
    },
    salePriceCalculator(variables: SalePriceCalculatorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SalePriceCalculatorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SalePriceCalculatorQuery>(SalePriceCalculatorDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'salePriceCalculator', 'query', variables);
    },
    getAllSettingItems(variables?: GetAllSettingItemsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAllSettingItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAllSettingItemsQuery>(GetAllSettingItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAllSettingItems', 'query', variables);
    },
    setSettingItem(variables: SetSettingItemMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetSettingItemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetSettingItemMutation>(SetSettingItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setSettingItem', 'mutation', variables);
    },
    getMeliPayamakCredit(variables?: GetMeliPayamakCreditQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetMeliPayamakCreditQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMeliPayamakCreditQuery>(GetMeliPayamakCreditDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getMeliPayamakCredit', 'query', variables);
    },
    getMeliPayamakSmsList(variables?: GetMeliPayamakSmsListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetMeliPayamakSmsListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMeliPayamakSmsListQuery>(GetMeliPayamakSmsListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getMeliPayamakSmsList', 'query', variables);
    },
    sendSmsByMeliPayamak(variables: SendSmsByMeliPayamakMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SendSmsByMeliPayamakMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendSmsByMeliPayamakMutation>(SendSmsByMeliPayamakDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sendSmsByMeliPayamak', 'mutation', variables);
    },
    AdminAllTags(variables?: AdminAllTagsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminAllTagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminAllTagsQuery>(AdminAllTagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminAllTags', 'query', variables);
    },
    AdminTags(variables: AdminTagsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminTagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminTagsQuery>(AdminTagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminTags', 'query', variables);
    },
    createTag(variables: CreateTagMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateTagMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateTagMutation>(CreateTagDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createTag', 'mutation', variables);
    },
    removeTag(variables: RemoveTagMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveTagMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveTagMutation>(RemoveTagDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeTag', 'mutation', variables);
    },
    updateTag(variables: UpdateTagMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateTagMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateTagMutation>(UpdateTagDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateTag', 'mutation', variables);
    },
    adminTopBanner(variables?: AdminTopBannerQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminTopBannerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminTopBannerQuery>(AdminTopBannerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'adminTopBanner', 'query', variables);
    },
    updateTopBanner(variables: UpdateTopBannerMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateTopBannerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateTopBannerMutation>(UpdateTopBannerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateTopBanner', 'mutation', variables);
    },
    adminUserAddresses(variables: AdminUserAddressesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUserAddressesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUserAddressesQuery>(AdminUserAddressesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'adminUserAddresses', 'query', variables);
    },
    adminUserDetails(variables: AdminUserDetailsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUserDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUserDetailsQuery>(AdminUserDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'adminUserDetails', 'query', variables);
    },
    getUserAuthTokens(variables: GetUserAuthTokensQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetUserAuthTokensQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserAuthTokensQuery>(GetUserAuthTokensDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUserAuthTokens', 'query', variables);
    },
    AdminUsers(variables: AdminUsersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUsersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUsersQuery>(AdminUsersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUsers', 'query', variables);
    },
    AdminCreateVariantRequirements(variables: AdminCreateVariantRequirementsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminCreateVariantRequirementsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminCreateVariantRequirementsQuery>(AdminCreateVariantRequirementsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminCreateVariantRequirements', 'query', variables);
    },
    adminProductSummary(variables: AdminProductSummaryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminProductSummaryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminProductSummaryQuery>(AdminProductSummaryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'adminProductSummary', 'query', variables);
    },
    AdminProductVariants(variables: AdminProductVariantsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminProductVariantsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminProductVariantsQuery>(AdminProductVariantsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminProductVariants', 'query', variables);
    },
    AdminProductsForVariantsSearch(variables: AdminProductsForVariantsSearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminProductsForVariantsSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminProductsForVariantsSearchQuery>(AdminProductsForVariantsSearchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminProductsForVariantsSearch', 'query', variables);
    },
    AdminVariant(variables: AdminVariantQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminVariantQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminVariantQuery>(AdminVariantDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminVariant', 'query', variables);
    },
    AdminVariants(variables: AdminVariantsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminVariantsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminVariantsQuery>(AdminVariantsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminVariants', 'query', variables);
    },
    AdminVariantsByIds(variables: AdminVariantsByIdsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminVariantsByIdsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminVariantsByIdsQuery>(AdminVariantsByIdsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminVariantsByIds', 'query', variables);
    },
    CreateVariant(variables: CreateVariantMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateVariantMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateVariantMutation>(CreateVariantDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateVariant', 'mutation', variables);
    },
    RemoveVariant(variables: RemoveVariantMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveVariantMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveVariantMutation>(RemoveVariantDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemoveVariant', 'mutation', variables);
    },
    UpdateVariant(variables: UpdateVariantMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateVariantMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateVariantMutation>(UpdateVariantDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateVariant', 'mutation', variables);
    },
    CreateAdminOfflineOrder(variables: CreateAdminOfflineOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateAdminOfflineOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAdminOfflineOrderMutation>(CreateAdminOfflineOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateAdminOfflineOrder', 'mutation', variables);
    },
    AdminWarehouseShippingMethods(variables?: AdminWarehouseShippingMethodsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminWarehouseShippingMethodsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminWarehouseShippingMethodsQuery>(AdminWarehouseShippingMethodsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminWarehouseShippingMethods', 'query', variables);
    },
    AdminWarehouses(variables?: AdminWarehousesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminWarehousesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminWarehousesQuery>(AdminWarehousesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminWarehouses', 'query', variables);
    },
    createWarehouseShippingMethod(variables: CreateWarehouseShippingMethodMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateWarehouseShippingMethodMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateWarehouseShippingMethodMutation>(CreateWarehouseShippingMethodDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createWarehouseShippingMethod', 'mutation', variables);
    },
    updateWarehouse(variables: UpdateWarehouseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateWarehouseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateWarehouseMutation>(UpdateWarehouseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateWarehouse', 'mutation', variables);
    },
    updateWarehouseShippingMethod(variables: UpdateWarehouseShippingMethodMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateWarehouseShippingMethodMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateWarehouseShippingMethodMutation>(UpdateWarehouseShippingMethodDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateWarehouseShippingMethod', 'mutation', variables);
    },
    adminWheelPrizes(variables?: AdminWheelPrizesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminWheelPrizesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminWheelPrizesQuery>(AdminWheelPrizesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'adminWheelPrizes', 'query', variables);
    },
    adminWheelSettings(variables?: AdminWheelSettingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminWheelSettingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminWheelSettingsQuery>(AdminWheelSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'adminWheelSettings', 'query', variables);
    },
    adminWheelSpins(variables: AdminWheelSpinsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminWheelSpinsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminWheelSpinsQuery>(AdminWheelSpinsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'adminWheelSpins', 'query', variables);
    },
    adminWheelStats(variables?: AdminWheelStatsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminWheelStatsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminWheelStatsQuery>(AdminWheelStatsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'adminWheelStats', 'query', variables);
    },
    createWheelPrize(variables: CreateWheelPrizeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateWheelPrizeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateWheelPrizeMutation>(CreateWheelPrizeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createWheelPrize', 'mutation', variables);
    },
    deleteWheelPrize(variables: DeleteWheelPrizeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteWheelPrizeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteWheelPrizeMutation>(DeleteWheelPrizeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteWheelPrize', 'mutation', variables);
    },
    updateWheelPrize(variables: UpdateWheelPrizeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateWheelPrizeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateWheelPrizeMutation>(UpdateWheelPrizeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateWheelPrize', 'mutation', variables);
    },
    updateWheelSettings(variables: UpdateWheelSettingsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateWheelSettingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateWheelSettingsMutation>(UpdateWheelSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateWheelSettings', 'mutation', variables);
    },
    wheelVariantOptions(variables: WheelVariantOptionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WheelVariantOptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WheelVariantOptionsQuery>(WheelVariantOptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'wheelVariantOptions', 'query', variables);
    },
    adminProductsViewsReport(variables: AdminProductsViewsReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminProductsViewsReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminProductsViewsReportQuery>(AdminProductsViewsReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'adminProductsViewsReport', 'query', variables);
    },
    getDashboardData(variables: GetDashboardDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetDashboardDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDashboardDataQuery>(GetDashboardDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getDashboardData', 'query', variables);
    },
    ordersCount(variables?: OrdersCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersCountQuery>(OrdersCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ordersCount', 'query', variables);
    },
    ordersSaleChart(variables: OrdersSaleChartQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersSaleChartQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersSaleChartQuery>(OrdersSaleChartDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ordersSaleChart', 'query', variables);
    },
    productsCount(variables?: ProductsCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProductsCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductsCountQuery>(ProductsCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'productsCount', 'query', variables);
    },
    refererChartData(variables?: RefererChartDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RefererChartDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RefererChartDataQuery>(RefererChartDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'refererChartData', 'query', variables);
    },
    variantsCount(variables?: VariantsCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VariantsCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VariantsCountQuery>(VariantsCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'variantsCount', 'query', variables);
    },
    AdminCreatePostCategory(variables: AdminCreatePostCategoryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminCreatePostCategoryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminCreatePostCategoryMutation>(AdminCreatePostCategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminCreatePostCategory', 'mutation', variables);
    },
    AdminDeletePostCategory(variables: AdminDeletePostCategoryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminDeletePostCategoryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDeletePostCategoryMutation>(AdminDeletePostCategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminDeletePostCategory', 'mutation', variables);
    },
    AdminPostCategories(variables?: AdminPostCategoriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminPostCategoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPostCategoriesQuery>(AdminPostCategoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPostCategories', 'query', variables);
    },
    AdminPostCategory(variables: AdminPostCategoryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminPostCategoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminPostCategoryQuery>(AdminPostCategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminPostCategory', 'query', variables);
    },
    AdminUpdatePostCategory(variables: AdminUpdatePostCategoryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminUpdatePostCategoryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUpdatePostCategoryMutation>(AdminUpdatePostCategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminUpdatePostCategory', 'mutation', variables);
    },
    CreatePost(variables: CreatePostMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreatePostMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePostMutation>(CreatePostDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreatePost', 'mutation', variables);
    },
    GetAdminPostById(variables: GetAdminPostByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAdminPostByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAdminPostByIdQuery>(GetAdminPostByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetAdminPostById', 'query', variables);
    },
    GetAdminPostBySlug(variables: GetAdminPostBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAdminPostBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAdminPostBySlugQuery>(GetAdminPostBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetAdminPostBySlug', 'query', variables);
    },
    GetAdminPosts(variables: GetAdminPostsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAdminPostsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAdminPostsQuery>(GetAdminPostsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetAdminPosts', 'query', variables);
    },
    UpdatePost(variables: UpdatePostMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePostMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePostMutation>(UpdatePostDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdatePost', 'mutation', variables);
    },
    AdminBlogDashboard(variables: AdminBlogDashboardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AdminBlogDashboardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminBlogDashboardQuery>(AdminBlogDashboardDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AdminBlogDashboard', 'query', variables);
    },
    postsSiteMap(variables: PostsSiteMapQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PostsSiteMapQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PostsSiteMapQuery>(PostsSiteMapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'postsSiteMap', 'query', variables);
    },
    postsSiteMapCount(variables?: PostsSiteMapCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PostsSiteMapCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PostsSiteMapCountQuery>(PostsSiteMapCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'postsSiteMapCount', 'query', variables);
    },
    productsSiteMap(variables: ProductsSiteMapQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProductsSiteMapQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductsSiteMapQuery>(ProductsSiteMapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'productsSiteMap', 'query', variables);
    },
    productsSiteMapCount(variables?: ProductsSiteMapCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProductsSiteMapCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductsSiteMapCountQuery>(ProductsSiteMapCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'productsSiteMapCount', 'query', variables);
    },
    getPaymentSourceDetectors(variables?: GetPaymentSourceDetectorsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPaymentSourceDetectorsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPaymentSourceDetectorsQuery>(GetPaymentSourceDetectorsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPaymentSourceDetectors', 'query', variables);
    },
    AddToCart(variables: AddToCartMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddToCartMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddToCartMutation>(AddToCartDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AddToCart', 'mutation', variables);
    },
    GetCart(variables?: GetCartQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCartQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCartQuery>(GetCartDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetCart', 'query', variables);
    },
    createUserLog(variables: CreateUserLogMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateUserLogMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateUserLogMutation>(CreateUserLogDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createUserLog', 'mutation', variables);
    },
    loginReq(variables: LoginReqMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LoginReqMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoginReqMutation>(LoginReqDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'loginReq', 'mutation', variables);
    },
    profile(variables?: ProfileQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileQuery>(ProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profile', 'query', variables);
    },
    ping(variables?: PingQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PingQuery>(PingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ping', 'query', variables);
    },
    Refresh(variables?: RefreshMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RefreshMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RefreshMutation>(RefreshDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Refresh', 'mutation', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;